(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire567f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire567f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fK8O3", function(module, exports) {

$parcel$export(module.exports, "$", function () { return $; });
$parcel$export(module.exports, "addClass", function () { return addClass; });
$parcel$export(module.exports, "removeClass", function () { return removeClass; });
$parcel$export(module.exports, "toggleClass", function () { return toggleClass; });
$parcel$export(module.exports, "hasClass", function () { return hasClass; });
$parcel$export(module.exports, "attr", function () { return attr; });
$parcel$export(module.exports, "removeAttr", function () { return removeAttr; });
$parcel$export(module.exports, "transform", function () { return transform; });
$parcel$export(module.exports, "transition", function () { return transition; });
$parcel$export(module.exports, "on", function () { return on; });
$parcel$export(module.exports, "off", function () { return off; });
$parcel$export(module.exports, "trigger", function () { return trigger; });
$parcel$export(module.exports, "transitionEnd", function () { return transitionEnd; });
$parcel$export(module.exports, "outerWidth", function () { return outerWidth; });
$parcel$export(module.exports, "outerHeight", function () { return outerHeight; });
$parcel$export(module.exports, "offset", function () { return offset; });
$parcel$export(module.exports, "styles", function () { return styles; });
$parcel$export(module.exports, "css", function () { return css; });
$parcel$export(module.exports, "each", function () { return each; });
$parcel$export(module.exports, "filter", function () { return filter; });
$parcel$export(module.exports, "html", function () { return html; });
$parcel$export(module.exports, "text", function () { return text; });
$parcel$export(module.exports, "is", function () { return is; });
$parcel$export(module.exports, "index", function () { return index; });
$parcel$export(module.exports, "eq", function () { return eq; });
$parcel$export(module.exports, "append", function () { return append; });
$parcel$export(module.exports, "prepend", function () { return prepend; });
$parcel$export(module.exports, "next", function () { return next; });
$parcel$export(module.exports, "nextAll", function () { return nextAll; });
$parcel$export(module.exports, "prev", function () { return prev; });
$parcel$export(module.exports, "prevAll", function () { return prevAll; });
$parcel$export(module.exports, "parent", function () { return parent; });
$parcel$export(module.exports, "parents", function () { return parents; });
$parcel$export(module.exports, "closest", function () { return closest; });
$parcel$export(module.exports, "find", function () { return find; });
$parcel$export(module.exports, "children", function () { return children; });
$parcel$export(module.exports, "remove", function () { return remove; });
/**
 * Dom7 3.0.0
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */ 
var $98WL7 = parcelRequire("98WL7");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct;
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
/* eslint-disable no-proto */ function makeReactive(obj) {
    var proto = obj.__proto__;
    Object.defineProperty(obj, '__proto__', {
        get: function get() {
            return proto;
        },
        set: function set(value) {
            proto.__proto__ = value;
        }
    });
}
var Dom7 = /*#__PURE__*/ function(_Array) {
    _inheritsLoose(Dom7, _Array);
    function Dom7(items) {
        var _this;
        _this = _Array.call.apply(_Array, [
            this
        ].concat(items)) || this;
        makeReactive(_assertThisInitialized(_this));
        return _this;
    }
    return Dom7;
}(/*#__PURE__*/ _wrapNativeSuper(Array));
function arrayFlat(arr) {
    if (arr === void 0) arr = [];
    var res = [];
    arr.forEach(function(el) {
        if (Array.isArray(el)) res.push.apply(res, arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    var uniqueArray = [];
    for(var i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, function(match, group) {
        return group.toUpperCase();
    });
}
function qsa(selector, context) {
    if (typeof selector !== 'string') return [
        selector
    ];
    var a = [];
    var res = context.querySelectorAll(selector);
    for(var i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    var window = (0, $98WL7.getWindow)();
    var document = (0, $98WL7.getDocument)();
    var arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === 'string') {
        var html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
            var toCreate = 'div';
            if (html.indexOf('<li') === 0) toCreate = 'ul';
            if (html.indexOf('<tr') === 0) toCreate = 'tbody';
            if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
            if (html.indexOf('<tbody') === 0) toCreate = 'table';
            if (html.indexOf('<option') === 0) toCreate = 'select';
            var tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(var i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
function addClass() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++)classes[_key] = arguments[_key];
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(' ');
    }));
    this.forEach(function(el) {
        var _el$classList;
        (_el$classList = el.classList).add.apply(_el$classList, classNames);
    });
    return this;
}
function removeClass() {
    for(var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)classes[_key2] = arguments[_key2];
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(' ');
    }));
    this.forEach(function(el) {
        var _el$classList2;
        (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
    });
    return this;
}
function toggleClass() {
    for(var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)classes[_key3] = arguments[_key3];
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(' ');
    }));
    this.forEach(function(el) {
        classNames.forEach(function(className) {
            el.classList.toggle(className);
        });
    });
}
function hasClass() {
    for(var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)classes[_key4] = arguments[_key4];
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(' ');
    }));
    return arrayFilter(this, function(el) {
        return classNames.filter(function(className) {
            return el.classList.contains(className);
        }).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === 'string') {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(var i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(var attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(var i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === 'string') {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(var i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(var propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    var el;
    if (typeof value === 'undefined') {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        var dataKey = el.getAttribute("data-" + key);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(var i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    var el = this[0];
    if (!el) return undefined;
    var dataset = {}; // eslint-disable-line
    if (el.dataset) for(var dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(var i = 0; i < el.attributes.length; i += 1){
        var _attr = el.attributes[i];
        if (_attr.name.indexOf('data-') >= 0) dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
    }
    for(var key in dataset){
        if (dataset[key] === 'false') dataset[key] = false;
        else if (dataset[key] === 'true') dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === 'undefined') {
        // get value
        var el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === 'select') {
            var values = [];
            for(var i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(var _i = 0; _i < this.length; _i += 1){
        var _el = this[_i];
        if (Array.isArray(value) && _el.multiple && _el.nodeName.toLowerCase() === 'select') for(var j = 0; j < _el.options.length; j += 1)_el.options[j].selected = value.indexOf(_el.options[j].value) >= 0;
        else _el.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(var i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(var i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
    return this;
}
function on() {
    for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
    var eventType = args[0], targetSelector = args[1], listener = args[2], capture = args[3];
    if (typeof args[1] === 'function') {
        eventType = args[0];
        listener = args[1];
        capture = args[2];
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        var target = e.target;
        if (!target) return;
        var eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            var _parents = $(target).parents(); // eslint-disable-line
            for(var k = 0; k < _parents.length; k += 1)if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
        }
    }
    function handleEvent(e) {
        var eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    var events = eventType.split(' ');
    var j;
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            var event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            var _event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];
            el.dom7LiveListeners[_event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(_event, handleLiveEvent, capture);
        }
    }
    return this;
}
function off() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    var eventType = args[0], targetSelector = args[1], listener = args[2], capture = args[3];
    if (typeof args[1] === 'function') {
        eventType = args[0];
        listener = args[1];
        capture = args[2];
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    var events = eventType.split(' ');
    for(var i = 0; i < events.length; i += 1){
        var event = events[i];
        for(var j = 0; j < this.length; j += 1){
            var el = this[j];
            var handlers = void 0;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(var k = handlers.length - 1; k >= 0; k -= 1){
                var handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once() {
    var dom = this;
    for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
    var eventName = args[0], targetSelector = args[1], listener = args[2], capture = args[3];
    if (typeof args[1] === 'function') {
        eventName = args[0];
        listener = args[1];
        capture = args[2];
        targetSelector = undefined;
    }
    function onceHandler() {
        for(var _len8 = arguments.length, eventArgs = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)eventArgs[_key8] = arguments[_key8];
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger() {
    var window = (0, $98WL7.getWindow)();
    for(var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++)args[_key9] = arguments[_key9];
    var events = args[0].split(' ');
    var eventData = args[1];
    for(var i = 0; i < events.length; i += 1){
        var event = events[i];
        for(var j = 0; j < this.length; j += 1){
            var el = this[j];
            if (window.CustomEvent) {
                var evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter(function(data, dataIndex) {
                    return dataIndex > 0;
                });
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionEnd(callback) {
    var dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionend', fireCallBack);
    }
    if (callback) dom.on('transitionend', fireCallBack);
    return this;
}
function animationEnd(callback) {
    var dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('animationend', fireCallBack);
    }
    if (callback) dom.on('animationend', fireCallBack);
    return this;
}
function width() {
    var window = (0, $98WL7.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css('width'));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            var _styles = this.styles();
            return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    var window = (0, $98WL7.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css('height'));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            var _styles2 = this.styles();
            return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        var window = (0, $98WL7.getWindow)();
        var document = (0, $98WL7.getDocument)();
        var el = this[0];
        var box = el.getBoundingClientRect();
        var body = document.body;
        var clientTop = el.clientTop || body.clientTop || 0;
        var clientLeft = el.clientLeft || body.clientLeft || 0;
        var scrollTop = el === window ? window.scrollY : el.scrollTop;
        var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(var i = 0; i < this.length; i += 1)this[i].style.display = 'none';
    return this;
}
function show() {
    var window = (0, $98WL7.getWindow)();
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.style.display === 'none') el.style.display = '';
        if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') // Still not visible
        el.style.display = 'block';
    }
    return this;
}
function styles() {
    var window = (0, $98WL7.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    var window = (0, $98WL7.getWindow)();
    var i;
    if (arguments.length === 1) {
        if (typeof props === 'string') {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(var _prop in props)this[i].style[_prop] = props[_prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === 'string') {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach(function(el, index) {
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    var result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === 'undefined') return this[0] ? this[0].innerHTML : null;
    for(var i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === 'undefined') return this[0] ? this[0].textContent.trim() : null;
    for(var i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    var window = (0, $98WL7.getWindow)();
    var document = (0, $98WL7.getDocument)();
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') return false;
    if (typeof selector === 'string') {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    var child = this[0];
    var i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === 'undefined') return this;
    var length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        var returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append() {
    var newChild;
    var document = (0, $98WL7.getDocument)();
    for(var k = 0; k < arguments.length; k += 1){
        newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];
        for(var i = 0; i < this.length; i += 1){
            if (typeof newChild === 'string') {
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(var j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    var document = (0, $98WL7.getDocument)();
    var i;
    var j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === 'string') {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    var before = $(selector);
    for(var i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(var j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    var after = $(selector);
    for(var i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(var j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        var _next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(_next).is(selector)) nextEls.push(_next);
        } else nextEls.push(_next);
        el = _next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        var el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        var _prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(_prev).is(selector)) prevEls.push(_prev);
        } else prevEls.push(_prev);
        el = _prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    var parents = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    var parents = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1){
        var _parent = this[i].parentNode; // eslint-disable-line
        while(_parent){
            if (selector) {
                if ($(_parent).is(selector)) parents.push(_parent);
            } else parents.push(_parent);
            _parent = _parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    var foundElements = [];
    for(var i = 0; i < this.length; i += 1){
        var found = this[i].querySelectorAll(selector);
        for(var j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    var children = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1){
        var childNodes = this[i].children;
        for(var j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(var i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add() {
    var dom = this;
    var i;
    var j;
    for(var _len10 = arguments.length, els = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++)els[_key10] = arguments[_key10];
    for(i = 0; i < els.length; i += 1){
        var toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.nodeType === 1) {
            for(var j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = '';
        }
    }
    return this;
}
function scrollTo() {
    var window = (0, $98WL7.getWindow)();
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var left = args[0], top = args[1], duration = args[2], easing = args[3], callback = args[4];
    if (args.length === 4 && typeof easing === 'function') {
        callback = easing;
        left = args[0];
        top = args[1];
        duration = args[2];
        callback = args[3];
        easing = args[4];
    }
    if (typeof easing === 'undefined') easing = 'swing';
    return this.each(function animate() {
        var el = this;
        var currentTop;
        var currentLeft;
        var maxTop;
        var maxLeft;
        var newTop;
        var newLeft;
        var scrollTop; // eslint-disable-line
        var scrollLeft; // eslint-disable-line
        var animateTop = top > 0 || top === 0;
        var animateLeft = left > 0 || left === 0;
        if (typeof easing === 'undefined') easing = 'swing';
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        var startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time) {
            if (time === void 0) time = new Date().getTime();
            if (startTime === null) startTime = time;
            var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            var easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            var done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var top = args[0], duration = args[1], easing = args[2], callback = args[3];
    if (args.length === 3 && typeof easing === 'function') {
        top = args[0];
        duration = args[1];
        callback = args[2];
        easing = args[3];
    }
    var dom = this;
    if (typeof top === 'undefined') {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    var left = args[0], duration = args[1], easing = args[2], callback = args[3];
    if (args.length === 3 && typeof easing === 'function') {
        left = args[0];
        duration = args[1];
        callback = args[2];
        easing = args[3];
    }
    var dom = this;
    if (typeof left === 'undefined') {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
function animate(initialProps, initialParams) {
    var window = (0, $98WL7.getWindow)();
    var els = this;
    var a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: 'swing' // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress: function easingProgress(easing, progress) {
            if (easing === 'swing') return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === 'function') return easing(progress);
            return progress;
        },
        stop: function stop() {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each(function(el) {
                var element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done: function done(complete) {
            a.animating = false;
            a.elements.each(function(el) {
                var element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                var que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate: function animate(props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            var elements = []; // Define & Cache Initials & Units
            a.elements.each(function(el, index) {
                var initialFullValue;
                var initialValue;
                var unit;
                var finalValue;
                var finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach(function(prop) {
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, '');
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            var startTime = null;
            var time;
            var elementsDone = 0;
            var propsDone = 0;
            var done;
            var began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                var progress;
                var easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach(function(element) {
                    var el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach(function(prop) {
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        var _el$prop = el[prop], initialValue = _el$prop.initialValue, finalValue = _el$prop.finalValue, unit = _el$prop.unit;
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        var currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    var animateInstance;
    for(var i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === 'stop') animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    var els = this;
    for(var i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
var noTrigger = 'resize scroll'.split(' ');
function shortcut(name) {
    function eventHandler() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'undefined') {
            for(var i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on.apply(this, [
            name
        ].concat(args));
    }
    return eventHandler;
}
var click = shortcut('click');
var blur = shortcut('blur');
var focus = shortcut('focus');
var focusin = shortcut('focusin');
var focusout = shortcut('focusout');
var keyup = shortcut('keyup');
var keydown = shortcut('keydown');
var keypress = shortcut('keypress');
var submit = shortcut('submit');
var change = shortcut('change');
var mousedown = shortcut('mousedown');
var mousemove = shortcut('mousemove');
var mouseup = shortcut('mouseup');
var mouseenter = shortcut('mouseenter');
var mouseleave = shortcut('mouseleave');
var mouseout = shortcut('mouseout');
var mouseover = shortcut('mouseover');
var touchstart = shortcut('touchstart');
var touchend = shortcut('touchend');
var touchmove = shortcut('touchmove');
var resize = shortcut('resize');
var scroll = shortcut('scroll');
var $b761fbab206790eb$export$2e2bcd8739ae039 = $;

});
parcelRegister("98WL7", function(module, exports) {

$parcel$export(module.exports, "getDocument", function () { return $6a8270b7390be8cd$export$f65ca476c09acec0; });
$parcel$export(module.exports, "getWindow", function () { return $6a8270b7390be8cd$export$38b2d434cce3ea22; });
/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */ /* eslint-disable no-param-reassign */ 
var $j2WbH = parcelRequire("j2WbH");
function $6a8270b7390be8cd$var$isObject(obj) {
    return obj !== null && (typeof obj === "undefined" ? "undefined" : (0, $j2WbH._)(obj)) === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $6a8270b7390be8cd$export$8b58be045bf06082(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach(function(key) {
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($6a8270b7390be8cd$var$isObject(src[key]) && $6a8270b7390be8cd$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $6a8270b7390be8cd$export$8b58be045bf06082(target[key], src[key]);
    });
}
var $6a8270b7390be8cd$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
        blur: function blur() {},
        nodeName: ''
    },
    querySelector: function querySelector() {
        return null;
    },
    querySelectorAll: function querySelectorAll() {
        return [];
    },
    getElementById: function getElementById() {
        return null;
    },
    createEvent: function createEvent() {
        return {
            initEvent: function initEvent() {}
        };
    },
    createElement: function createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function setAttribute() {},
            getElementsByTagName: function getElementsByTagName() {
                return [];
            }
        };
    },
    createElementNS: function createElementNS() {
        return {};
    },
    importNode: function importNode() {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $6a8270b7390be8cd$export$f65ca476c09acec0() {
    var doc = typeof document !== 'undefined' ? document : {};
    $6a8270b7390be8cd$export$8b58be045bf06082(doc, $6a8270b7390be8cd$export$3fdcb9b4d81368d8);
    return doc;
}
var $6a8270b7390be8cd$export$8582633f185c62bb = {
    document: $6a8270b7390be8cd$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState: function replaceState() {},
        pushState: function pushState() {},
        go: function go() {},
        back: function back() {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
        return {
            getPropertyValue: function getPropertyValue() {
                return '';
            }
        };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout1() {},
    clearTimeout: function clearTimeout1() {},
    matchMedia: function matchMedia() {
        return {};
    },
    requestAnimationFrame: function requestAnimationFrame(callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function cancelAnimationFrame(id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $6a8270b7390be8cd$export$38b2d434cce3ea22() {
    var win = typeof window !== 'undefined' ? window : {};
    $6a8270b7390be8cd$export$8b58be045bf06082(win, $6a8270b7390be8cd$export$8582633f185c62bb);
    return win;
}

});
parcelRegister("j2WbH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $dddb5712ecd4207b$export$71511d61b312f219; });
function $dddb5712ecd4207b$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});









var $2f4f2d88bb880910$exports = {};
(function(root, factory) {
    if (typeof define === 'function' && define.amd) define([], function() {
        return factory(root);
    });
    else $2f4f2d88bb880910$exports = factory(root);
})(typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : $2f4f2d88bb880910$exports, function(window1) {
    'use strict';
    //
    // Defaults
    //
    var defaults = {
        // Active classes
        navClass: 'active',
        contentClass: 'active',
        // Nested navigation
        nested: false,
        nestedClass: 'active',
        // Offset & reflow
        offset: 0,
        reflow: false,
        // Event support
        events: true
    };
    //
    // Methods
    //
    /**
	 * Merge two or more objects together.
	 * @param   {Object}   objects  The objects to merge together
	 * @returns {Object}            Merged values of defaults and options
	 */ var extend = function extend() {
        var merged = {};
        Array.prototype.forEach.call(arguments, function(obj) {
            for(var key in obj){
                if (!obj.hasOwnProperty(key)) return;
                merged[key] = obj[key];
            }
        });
        return merged;
    };
    /**
	 * Emit a custom event
	 * @param  {String} type   The event type
	 * @param  {Node}   elem   The element to attach the event to
	 * @param  {Object} detail Any details to pass along with the event
	 */ var emitEvent = function emitEvent(type, elem, detail) {
        // Make sure events are enabled
        if (!detail.settings.events) return;
        // Create a new event
        var event = new CustomEvent(type, {
            bubbles: true,
            cancelable: true,
            detail: detail
        });
        // Dispatch the event
        elem.dispatchEvent(event);
    };
    /**
	 * Get an element's distance from the top of the Document.
	 * @param  {Node} elem The element
	 * @return {Number}    Distance from the top in pixels
	 */ var getOffsetTop = function getOffsetTop(elem) {
        var location = 0;
        if (elem.offsetParent) while(elem){
            location += elem.offsetTop;
            elem = elem.offsetParent;
        }
        return location >= 0 ? location : 0;
    };
    /**
	 * Sort content from first to last in the DOM
	 * @param  {Array} contents The content areas
	 */ var sortContents = function sortContents(contents) {
        if (contents) contents.sort(function(item1, item2) {
            var offset1 = getOffsetTop(item1.content);
            var offset2 = getOffsetTop(item2.content);
            if (offset1 < offset2) return -1;
            return 1;
        });
    };
    /**
	 * Get the offset to use for calculating position
	 * @param  {Object} settings The settings for this instantiation
	 * @return {Float}           The number of pixels to offset the calculations
	 */ var getOffset = function getOffset(settings) {
        // if the offset is a function run it
        if (typeof settings.offset === 'function') return parseFloat(settings.offset());
        // Otherwise, return it as-is
        return parseFloat(settings.offset);
    };
    /**
	 * Get the document element's height
	 * @private
	 * @returns {Number}
	 */ var getDocumentHeight = function getDocumentHeight() {
        return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
    };
    /**
	 * Determine if an element is in view
	 * @param  {Node}    elem     The element
	 * @param  {Object}  settings The settings for this instantiation
	 * @param  {Boolean} bottom   If true, check if element is above bottom of viewport instead
	 * @return {Boolean}          Returns true if element is in the viewport
	 */ var isInView = function isInView(elem, settings, bottom) {
        var bounds = elem.getBoundingClientRect();
        var offset = getOffset(settings);
        if (bottom) return parseInt(bounds.bottom, 10) < (window1.innerHeight || document.documentElement.clientHeight);
        return parseInt(bounds.top, 10) <= offset;
    };
    /**
	 * Check if at the bottom of the viewport
	 * @return {Boolean} If true, page is at the bottom of the viewport
	 */ var isAtBottom = function isAtBottom() {
        if (window1.innerHeight + window1.pageYOffset >= getDocumentHeight()) return true;
        return false;
    };
    /**
	 * Check if the last item should be used (even if not at the top of the page)
	 * @param  {Object} item     The last item
	 * @param  {Object} settings The settings for this instantiation
	 * @return {Boolean}         If true, use the last item
	 */ var useLastItem = function useLastItem(item, settings) {
        if (isAtBottom() && isInView(item.content, settings, true)) return true;
        return false;
    };
    /**
	 * Get the active content
	 * @param  {Array}  contents The content areas
	 * @param  {Object} settings The settings for this instantiation
	 * @return {Object}          The content area and matching navigation link
	 */ var getActive = function getActive(contents, settings) {
        var last = contents[contents.length - 1];
        if (useLastItem(last, settings)) return last;
        for(var i = contents.length - 1; i >= 0; i--){
            if (isInView(contents[i].content, settings)) return contents[i];
        }
    };
    /**
	 * Deactivate parent navs in a nested navigation
	 * @param  {Node}   nav      The starting navigation element
	 * @param  {Object} settings The settings for this instantiation
	 */ var deactivateNested = function deactivateNested1(nav, settings) {
        // If nesting isn't activated, bail
        if (!settings.nested || !nav.parentNode) return;
        // Get the parent navigation
        var li = nav.parentNode.closest('li');
        if (!li) return;
        // Remove the active class
        li.classList.remove(settings.nestedClass);
        // Apply recursively to any parent navigation elements
        deactivateNested(li, settings);
    };
    /**
	 * Deactivate a nav and content area
	 * @param  {Object} items    The nav item and content to deactivate
	 * @param  {Object} settings The settings for this instantiation
	 */ var deactivate = function deactivate(items, settings) {
        // Make sure there are items to deactivate
        if (!items) return;
        // Get the parent list item
        var li = items.nav.closest('li');
        if (!li) return;
        // Remove the active class from the nav and content
        li.classList.remove(settings.navClass);
        items.content.classList.remove(settings.contentClass);
        // Deactivate any parent navs in a nested navigation
        deactivateNested(li, settings);
        // Emit a custom event
        emitEvent('gumshoeDeactivate', li, {
            link: items.nav,
            content: items.content,
            settings: settings
        });
    };
    /**
	 * Activate parent navs in a nested navigation
	 * @param  {Node}   nav      The starting navigation element
	 * @param  {Object} settings The settings for this instantiation
	 */ var activateNested = function activateNested1(nav, settings) {
        // If nesting isn't activated, bail
        if (!settings.nested) return;
        // Get the parent navigation
        var li = nav.parentNode.closest('li');
        if (!li) return;
        // Add the active class
        li.classList.add(settings.nestedClass);
        // Apply recursively to any parent navigation elements
        activateNested(li, settings);
    };
    /**
	 * Activate a nav and content area
	 * @param  {Object} items    The nav item and content to activate
	 * @param  {Object} settings The settings for this instantiation
	 */ var activate = function activate(items, settings) {
        // Make sure there are items to activate
        if (!items) return;
        // Get the parent list item
        var li = items.nav.closest('li');
        if (!li) return;
        // Add the active class to the nav and content
        li.classList.add(settings.navClass);
        items.content.classList.add(settings.contentClass);
        // Activate any parent navs in a nested navigation
        activateNested(li, settings);
        // Emit a custom event
        emitEvent('gumshoeActivate', li, {
            link: items.nav,
            content: items.content,
            settings: settings
        });
    };
    /**
	 * Create the Constructor object
	 * @param {String} selector The selector to use for navigation items
	 * @param {Object} options  User options and settings
	 */ var Constructor = function Constructor(selector, options) {
        //
        // Variables
        //
        var publicAPIs = {};
        var navItems, contents, current, timeout, settings;
        //
        // Methods
        //
        /**
		 * Set variables from DOM elements
		 */ publicAPIs.setup = function() {
            // Get all nav items
            navItems = document.querySelectorAll(selector);
            // Create contents array
            contents = [];
            // Loop through each item, get it's matching content, and push to the array
            Array.prototype.forEach.call(navItems, function(item) {
                // Get the content for the nav item
                var content = document.getElementById(decodeURIComponent(item.hash.substr(1)));
                if (!content) return;
                // Push to the contents array
                contents.push({
                    nav: item,
                    content: content
                });
            });
            // Sort contents by the order they appear in the DOM
            sortContents(contents);
        };
        /**
		 * Detect which content is currently active
		 */ publicAPIs.detect = function() {
            // Get the active content
            var active = getActive(contents, settings);
            // if there's no active content, deactivate and bail
            if (!active) {
                if (current) {
                    deactivate(current, settings);
                    current = null;
                }
                return;
            }
            // If the active content is the one currently active, do nothing
            if (current && active.content === current.content) return;
            // Deactivate the current content and activate the new content
            deactivate(current, settings);
            activate(active, settings);
            // Update the currently active content
            current = active;
        };
        /**
		 * Detect the active content on scroll
		 * Debounced for performance
		 */ var scrollHandler = function scrollHandler(event) {
            // If there's a timer, cancel it
            if (timeout) window1.cancelAnimationFrame(timeout);
            // Setup debounce callback
            timeout = window1.requestAnimationFrame(publicAPIs.detect);
        };
        /**
		 * Update content sorting on resize
		 * Debounced for performance
		 */ var resizeHandler = function resizeHandler(event) {
            // If there's a timer, cancel it
            if (timeout) window1.cancelAnimationFrame(timeout);
            // Setup debounce callback
            timeout = window1.requestAnimationFrame(function() {
                sortContents(contents);
                publicAPIs.detect();
            });
        };
        /**
		 * Destroy the current instantiation
		 */ publicAPIs.destroy = function() {
            // Undo DOM changes
            if (current) deactivate(current, settings);
            // Remove event listeners
            window1.removeEventListener('scroll', scrollHandler, false);
            if (settings.reflow) window1.removeEventListener('resize', resizeHandler, false);
            // Reset variables
            contents = null;
            navItems = null;
            current = null;
            timeout = null;
            settings = null;
        };
        /**
		 * Initialize the current instantiation
		 */ var init = function init() {
            // Merge user options into defaults
            settings = extend(defaults, options || {});
            // Setup variables based on the current DOM
            publicAPIs.setup();
            // Find the currently active content
            publicAPIs.detect();
            // Setup event listeners
            window1.addEventListener('scroll', scrollHandler, false);
            if (settings.reflow) window1.addEventListener('resize', resizeHandler, false);
        };
        //
        // Initialize and return the public APIs
        //
        init();
        return publicAPIs;
    };
    //
    // Return the Constructor
    //
    return Constructor;
});


/**
 * Swiper 6.8.4
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: August 23, 2021
 */ 
var $j2WbH = parcelRequire("j2WbH");

var $98WL7 = parcelRequire("98WL7");

var $fK8O3 = parcelRequire("fK8O3");
var $ac668c36e81824b6$var$Methods = {
    addClass: (0, $fK8O3.addClass),
    removeClass: (0, $fK8O3.removeClass),
    hasClass: (0, $fK8O3.hasClass),
    toggleClass: (0, $fK8O3.toggleClass),
    attr: (0, $fK8O3.attr),
    removeAttr: (0, $fK8O3.removeAttr),
    transform: (0, $fK8O3.transform),
    transition: (0, $fK8O3.transition),
    on: (0, $fK8O3.on),
    off: (0, $fK8O3.off),
    trigger: (0, $fK8O3.trigger),
    transitionEnd: (0, $fK8O3.transitionEnd),
    outerWidth: (0, $fK8O3.outerWidth),
    outerHeight: (0, $fK8O3.outerHeight),
    styles: (0, $fK8O3.styles),
    offset: (0, $fK8O3.offset),
    css: (0, $fK8O3.css),
    each: (0, $fK8O3.each),
    html: (0, $fK8O3.html),
    text: (0, $fK8O3.text),
    is: (0, $fK8O3.is),
    index: (0, $fK8O3.index),
    eq: (0, $fK8O3.eq),
    append: (0, $fK8O3.append),
    prepend: (0, $fK8O3.prepend),
    next: (0, $fK8O3.next),
    nextAll: (0, $fK8O3.nextAll),
    prev: (0, $fK8O3.prev),
    prevAll: (0, $fK8O3.prevAll),
    parent: (0, $fK8O3.parent),
    parents: (0, $fK8O3.parents),
    closest: (0, $fK8O3.closest),
    find: (0, $fK8O3.find),
    children: (0, $fK8O3.children),
    filter: (0, $fK8O3.filter),
    remove: (0, $fK8O3.remove)
};
Object.keys($ac668c36e81824b6$var$Methods).forEach(function(methodName) {
    Object.defineProperty((0, $fK8O3.$).fn, methodName, {
        value: $ac668c36e81824b6$var$Methods[methodName],
        writable: true
    });
});
var $ac668c36e81824b6$export$2e2bcd8739ae039 = (0, $fK8O3.$);



var $j2WbH = parcelRequire("j2WbH");

var $98WL7 = parcelRequire("98WL7");
function $60eca45f20c21def$export$8694e5c03a4df8e6(obj) {
    var object = obj;
    Object.keys(object).forEach(function(key) {
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $60eca45f20c21def$export$bdd553fddd433dcb(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $60eca45f20c21def$export$461939dd4422153() {
    return Date.now();
}
function $60eca45f20c21def$export$3735103072e4a80(el) {
    var window1 = (0, $98WL7.getWindow)();
    var style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $60eca45f20c21def$export$5ec402b7fcf74398(el, axis) {
    if (axis === void 0) axis = 'x';
    var window1 = (0, $98WL7.getWindow)();
    var matrix;
    var curTransform;
    var transformMatrix;
    var curStyle = $60eca45f20c21def$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map(function(a) {
            return a.replace(',', '.');
        }).join(', ');
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $60eca45f20c21def$export$a6cdc56e425d0d0a(o) {
    return (typeof o === "undefined" ? "undefined" : (0, $j2WbH._)(o)) === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $60eca45f20c21def$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $60eca45f20c21def$export$8b58be045bf06082() {
    var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    var noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(var i = 1; i < arguments.length; i += 1){
        var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$60eca45f20c21def$var$isNode(nextSource)) {
            var keysArray = Object.keys(Object(nextSource)).filter(function(key) {
                return noExtend.indexOf(key) < 0;
            });
            for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                var nextKey = keysArray[nextIndex];
                var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($60eca45f20c21def$export$a6cdc56e425d0d0a(to[nextKey]) && $60eca45f20c21def$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $60eca45f20c21def$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$60eca45f20c21def$export$a6cdc56e425d0d0a(to[nextKey]) && $60eca45f20c21def$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $60eca45f20c21def$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $60eca45f20c21def$export$d2651194ddf43b70(instance, obj) {
    Object.keys(obj).forEach(function(key) {
        if ($60eca45f20c21def$export$a6cdc56e425d0d0a(obj[key])) Object.keys(obj[key]).forEach(function(subKey) {
            if (typeof obj[key][subKey] === 'function') obj[key][subKey] = obj[key][subKey].bind(instance);
        });
        instance[key] = obj[key];
    });
}
function $60eca45f20c21def$export$730a8e2ed4fdbe02(classes) {
    if (classes === void 0) classes = '';
    return "." + classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.');
}
function $60eca45f20c21def$export$f4bbea1d7959d26b($container, params, createElements, checkProps) {
    var document = (0, $98WL7.getDocument)();
    if (createElements) Object.keys(checkProps).forEach(function(key) {
        if (!params[key] && params.auto === true) {
            var element = document.createElement('div');
            element.className = checkProps[key];
            $container.append(element);
            params[key] = element;
        }
    });
    return params;
}



var $98WL7 = parcelRequire("98WL7");
var $280c168d4fc5c5c5$var$support;
function $280c168d4fc5c5c5$var$calcSupport() {
    var window = (0, $98WL7.getWindow)();
    var document = (0, $98WL7.getDocument)();
    return {
        touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
        observer: function checkObserver() {
            return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
        }(),
        passiveListener: function checkPassiveListener() {
            var supportsPassive = false;
            try {
                var opts = Object.defineProperty({}, 'passive', {
                    // eslint-disable-next-line
                    get: function get() {
                        supportsPassive = true;
                    }
                });
                window.addEventListener('testPassiveListener', null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return 'ongesturestart' in window;
        }()
    };
}
function $280c168d4fc5c5c5$export$d61c7b85ff180578() {
    if (!$280c168d4fc5c5c5$var$support) $280c168d4fc5c5c5$var$support = $280c168d4fc5c5c5$var$calcSupport();
    return $280c168d4fc5c5c5$var$support;
}



var $98WL7 = parcelRequire("98WL7");

var $95873ecabc836cd2$var$device;
function $95873ecabc836cd2$var$calcDevice(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, userAgent = _ref.userAgent;
    var support = (0, $280c168d4fc5c5c5$export$d61c7b85ff180578)();
    var window = (0, $98WL7.getWindow)();
    var platform = window.navigator.platform;
    var ua = userAgent || window.navigator.userAgent;
    var device = {
        ios: false,
        android: false
    };
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var windows = platform === 'Win32';
    var macos = platform === 'MacIntel'; // iPadOs 13 fix
    var iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    } // Export object
    return device;
}
function $95873ecabc836cd2$export$30c823bc834d6ab4(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$95873ecabc836cd2$var$device) $95873ecabc836cd2$var$device = $95873ecabc836cd2$var$calcDevice(overrides);
    return $95873ecabc836cd2$var$device;
}



var $98WL7 = parcelRequire("98WL7");
var $dac9a46839482ff6$var$browser;
function $dac9a46839482ff6$var$calcBrowser() {
    var window = (0, $98WL7.getWindow)();
    function isSafari() {
        var ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    return {
        isEdge: !!window.navigator.userAgent.match(/Edge/g),
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $dac9a46839482ff6$export$89e15fc796a4a429() {
    if (!$dac9a46839482ff6$var$browser) $dac9a46839482ff6$var$browser = $dac9a46839482ff6$var$calcBrowser();
    return $dac9a46839482ff6$var$browser;
}



var $98WL7 = parcelRequire("98WL7");

var $41e99189fba40f7f$var$supportsResizeObserver = function supportsResizeObserver() {
    var window = (0, $98WL7.getWindow)();
    return typeof window.ResizeObserver !== 'undefined';
};
var $41e99189fba40f7f$export$2e2bcd8739ae039 = {
    name: 'resize',
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper, {
            resize: {
                observer: null,
                createObserver: function createObserver() {
                    if (!swiper || swiper.destroyed || !swiper.initialized) return;
                    swiper.resize.observer = new ResizeObserver(function(entries) {
                        var width = swiper.width, height = swiper.height;
                        var newWidth = width;
                        var newHeight = height;
                        entries.forEach(function(_ref) {
                            var contentBoxSize = _ref.contentBoxSize, contentRect = _ref.contentRect, target = _ref.target;
                            if (target && target !== swiper.el) return;
                            newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                            newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                        });
                        if (newWidth !== width || newHeight !== height) swiper.resize.resizeHandler();
                    });
                    swiper.resize.observer.observe(swiper.el);
                },
                removeObserver: function removeObserver() {
                    if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
                        swiper.resize.observer.unobserve(swiper.el);
                        swiper.resize.observer = null;
                    }
                },
                resizeHandler: function resizeHandler() {
                    if (!swiper || swiper.destroyed || !swiper.initialized) return;
                    swiper.emit('beforeResize');
                    swiper.emit('resize');
                },
                orientationChangeHandler: function orientationChangeHandler() {
                    if (!swiper || swiper.destroyed || !swiper.initialized) return;
                    swiper.emit('orientationchange');
                }
            }
        });
    },
    on: {
        init: function init(swiper) {
            var window = (0, $98WL7.getWindow)();
            if (swiper.params.resizeObserver && $41e99189fba40f7f$var$supportsResizeObserver()) {
                swiper.resize.createObserver();
                return;
            } // Emit resize
            window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange
            window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
        },
        destroy: function destroy(swiper) {
            var window = (0, $98WL7.getWindow)();
            swiper.resize.removeObserver();
            window.removeEventListener('resize', swiper.resize.resizeHandler);
            window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
        }
    }
};



var $98WL7 = parcelRequire("98WL7");

function $d332dbd3dcf38c14$var$_extends() {
    $d332dbd3dcf38c14$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d332dbd3dcf38c14$var$_extends.apply(this, arguments);
}
var $d332dbd3dcf38c14$var$Observer = {
    attach: function attach(target, options) {
        if (options === void 0) options = {};
        var window = (0, $98WL7.getWindow)();
        var swiper = this;
        var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        var observer = new ObserverFunc(function(mutations) {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                swiper.emit('observerUpdate', mutations[0]);
                return;
            }
            var observerUpdate = function observerUpdate() {
                swiper.emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: typeof options.childList === 'undefined' ? true : options.childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        swiper.observer.observers.push(observer);
    },
    init: function init() {
        var swiper = this;
        if (!swiper.support.observer || !swiper.params.observer) return;
        if (swiper.params.observeParents) {
            var containerParents = swiper.$el.parents();
            for(var i = 0; i < containerParents.length; i += 1)swiper.observer.attach(containerParents[i]);
        } // Observe container
        swiper.observer.attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        swiper.observer.attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    },
    destroy: function destroy() {
        var swiper = this;
        swiper.observer.observers.forEach(function(observer) {
            observer.disconnect();
        });
        swiper.observer.observers = [];
    }
};
var $d332dbd3dcf38c14$export$2e2bcd8739ae039 = {
    name: 'observer',
    params: {
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            observer: $d332dbd3dcf38c14$var$_extends({}, $d332dbd3dcf38c14$var$Observer, {
                observers: []
            })
        });
    },
    on: {
        init: function init(swiper) {
            swiper.observer.init();
        },
        destroy: function destroy(swiper) {
            swiper.observer.destroy();
        }
    }
};



var $e21afd2f5f6e17bb$export$2e2bcd8739ae039 = {
    useParams: function useParams(instanceParams) {
        var instance = this;
        if (!instance.modules) return;
        Object.keys(instance.modules).forEach(function(moduleName) {
            var module = instance.modules[moduleName]; // Extend params
            if (module.params) (0, $60eca45f20c21def$export$8b58be045bf06082)(instanceParams, module.params);
        });
    },
    useModules: function useModules(modulesParams) {
        if (modulesParams === void 0) modulesParams = {};
        var instance = this;
        if (!instance.modules) return;
        Object.keys(instance.modules).forEach(function(moduleName) {
            var module = instance.modules[moduleName];
            var moduleParams = modulesParams[moduleName] || {}; // Add event listeners
            if (module.on && instance.on) Object.keys(module.on).forEach(function(moduleEventName) {
                instance.on(moduleEventName, module.on[moduleEventName]);
            });
             // Module create callback
            if (module.create) module.create.bind(instance)(moduleParams);
        });
    }
};


/* eslint-disable no-underscore-dangle */ var $d18da0a8f6bac2f6$export$2e2bcd8739ae039 = {
    on: function on(events, handler, priority) {
        var self = this;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
        events.split(' ').forEach(function(event) {
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once: function once(events, handler, priority) {
        var self = this;
        if (typeof handler !== 'function') return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny: function onAny(handler, priority) {
        var self = this;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny: function offAny(handler) {
        var self = this;
        if (!self.eventsAnyListeners) return self;
        var index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off: function off(events, handler) {
        var self = this;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach(function(event) {
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler, index) {
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit: function emit() {
        var self = this;
        if (!self.eventsListeners) return self;
        var events;
        var data;
        var context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        var eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach(function(event) {
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach(function(eventHandler) {
                eventHandler.apply(context, [
                    event
                ].concat(data));
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler) {
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};



function $54c0812b12d95405$export$2e2bcd8739ae039() {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
    height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}



function $bc579ab0fb8c0fb9$export$2e2bcd8739ae039() {
    var swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl, swiperSize = swiper.size, rtl = swiper.rtlTranslate, wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children("." + swiper.params.slideClass);
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.slidesGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: '',
        marginBottom: '',
        marginTop: ''
    });
    else slides.css({
        marginRight: '',
        marginBottom: '',
        marginTop: ''
    });
    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
        if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
        if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    } // Calc slides
    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
    for(var i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        var slide = slides.eq(i);
        if (params.slidesPerColumn > 1) {
            // Set slides order
            var newSlideOrderIndex = void 0;
            var column = void 0;
            var row = void 0;
            if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
                var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
                var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
                var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
                row = Math.floor(slideIndexInGroup / columnsInGroup);
                column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
                newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
                slide.css({
                    '-webkit-box-ordinal-group': newSlideOrderIndex,
                    '-moz-box-ordinal-group': newSlideOrderIndex,
                    '-ms-flex-order': newSlideOrderIndex,
                    '-webkit-order': newSlideOrderIndex,
                    order: newSlideOrderIndex
                });
            } else if (params.slidesPerColumnFill === 'column') {
                column = Math.floor(i / slidesPerColumn);
                row = i - column * slidesPerColumn;
                if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
                    row += 1;
                    if (row >= slidesPerColumn) {
                        row = 0;
                        column += 1;
                    }
                }
            } else {
                row = Math.floor(i / slidesPerRow);
                column = i - row * slidesPerRow;
            }
            slide.css(getDirectionLabel('margin-top'), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : '');
        }
        if (slide.css('display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            var slideStyles = getComputedStyle(slide[0]);
            var currentTransform = slide[0].style.transform;
            var currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = 'none';
            if (currentWebKitTransform) slide[0].style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                var width = getDirectionPropertyValue(slideStyles, 'width');
                var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                var boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    var _slide$ = slide[0], clientWidth = _slide$.clientWidth, offsetWidth = _slide$.offsetWidth;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel('width')] = slideSize + "px";
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) $wrapperEl.css({
        width: swiper.virtualSize + params.spaceBetween + "px"
    });
    if (params.setWrapperSize) {
        var _$wrapperEl$css;
        $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
    }
    if (params.slidesPerColumn > 1) {
        var _$wrapperEl$css2;
        swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
        $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));
        if (params.centeredSlides) {
            newSlidesGrid = [];
            for(var _i = 0; _i < snapGrid.length; _i += 1){
                var slidesGridItem = snapGrid[_i];
                if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid = newSlidesGrid;
        }
    } // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        newSlidesGrid = [];
        for(var _i2 = 0; _i2 < snapGrid.length; _i2 += 1){
            var _slidesGridItem = snapGrid[_i2];
            if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);
            if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(_slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        var _slides$filter$css;
        var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
        slides.filter(function(_, slideIndex) {
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        var maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map(function(snap) {
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        var _allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        _allSlidesSize -= params.spaceBetween;
        if (_allSlidesSize < swiperSize) {
            var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
            snapGrid.forEach(function(snap, snapIndex) {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach(function(snap, snapIndex) {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress || params.watchSlidesVisibility) swiper.updateSlidesOffset();
}


function $ab193da54dc68888$export$2e2bcd8739ae039(speed) {
    var swiper = this;
    var activeSlides = [];
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    var getSlideByIndex = function getSlideByIndex(index) {
        if (isVirtual) return swiper.slides.filter(function(el) {
            return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
        })[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) swiper.visibleSlides.each(function(slide) {
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            var index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
}


function $14f5464bc7f4f9a6$export$2e2bcd8739ae039() {
    var swiper = this;
    var slides = swiper.slides;
    for(var i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}



function $0478a531479440c0$export$2e2bcd8739ae039(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides, rtl = swiper.rtlTranslate;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
            var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
            var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
            var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
            if (isVisible) {
                swiper.visibleSlides.push(slide);
                swiper.visibleSlidesIndexes.push(i);
                slides.eq(i).addClass(params.slideVisibleClass);
            }
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(swiper.visibleSlides);
}



function $9cd741cbe67ccf2d$export$2e2bcd8739ae039(translate) {
    var swiper = this;
    if (typeof translate === 'undefined') {
        var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress, isBeginning = swiper.isBeginning, isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}


function $ae35498857c65696$export$2e2bcd8739ae039() {
    var swiper = this;
    var slides = swiper.slides, params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex, realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
    var activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}



function $df25872be4d7b44a$export$2e2bcd8739ae039(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid, snapGrid = swiper.snapGrid, params = swiper.params, previousIndex = swiper.activeIndex, previousRealIndex = swiper.realIndex, previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === 'undefined') {
        for(var i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== 'undefined') {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    } // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
    (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit('slideChange');
}



function $ac7a18cd19d02048$export$2e2bcd8739ae039(e) {
    var swiper = this;
    var params = swiper.params;
    var slide = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(e.target).closest("." + params.slideClass)[0];
    var slideFound = false;
    var slideIndex;
    if (slide) {
        for(var i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $ac668c36e81824b6$export$2e2bcd8739ae039)(slide).attr('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}


var $f368f0aa33154ce2$export$2e2bcd8739ae039 = {
    updateSize: (0, $54c0812b12d95405$export$2e2bcd8739ae039),
    updateSlides: (0, $bc579ab0fb8c0fb9$export$2e2bcd8739ae039),
    updateAutoHeight: (0, $ab193da54dc68888$export$2e2bcd8739ae039),
    updateSlidesOffset: (0, $14f5464bc7f4f9a6$export$2e2bcd8739ae039),
    updateSlidesProgress: (0, $0478a531479440c0$export$2e2bcd8739ae039),
    updateProgress: (0, $9cd741cbe67ccf2d$export$2e2bcd8739ae039),
    updateSlidesClasses: (0, $ae35498857c65696$export$2e2bcd8739ae039),
    updateActiveIndex: (0, $df25872be4d7b44a$export$2e2bcd8739ae039),
    updateClickedSlide: (0, $ac7a18cd19d02048$export$2e2bcd8739ae039)
};



function $465f0623f6d01ac3$export$2e2bcd8739ae039(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? 'x' : 'y';
    var swiper = this;
    var params = swiper.params, rtl = swiper.rtlTranslate, translate = swiper.translate, $wrapperEl = swiper.$wrapperEl;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    var currentTranslate = (0, $60eca45f20c21def$export$5ec402b7fcf74398)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}


function $150012bb93ff86be$export$2e2bcd8739ae039(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate, params = swiper.params, $wrapperEl = swiper.$wrapperEl, wrapperEl = swiper.wrapperEl, progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}


function $de7ba143fd653a39$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}


function $62c561dbb46c83ec$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}


function $19c22392ef7782f5$export$2e2bcd8739ae039(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    var swiper = this;
    var params = swiper.params, wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    var minTranslate = swiper.minTranslate();
    var maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
            var _wrapperEl$scrollTo;
            wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
        } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}


var $d85fe82d632f33af$export$2e2bcd8739ae039 = {
    getTranslate: (0, $465f0623f6d01ac3$export$2e2bcd8739ae039),
    setTranslate: (0, $150012bb93ff86be$export$2e2bcd8739ae039),
    minTranslate: (0, $de7ba143fd653a39$export$2e2bcd8739ae039),
    maxTranslate: (0, $62c561dbb46c83ec$export$2e2bcd8739ae039),
    translateTo: (0, $19c22392ef7782f5$export$2e2bcd8739ae039)
};


function $55f2fe0f38a40af5$export$2e2bcd8739ae039(duration, byController) {
    var swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit('setTransition', duration, byController);
}


function $74db8986be7e821a$export$2e2bcd8739ae039(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var activeIndex = swiper.activeIndex, params = swiper.params, previousIndex = swiper.previousIndex;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit('transitionStart');
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit('slideResetTransitionStart');
            return;
        }
        swiper.emit('slideChangeTransitionStart');
        if (dir === 'next') swiper.emit('slideNextTransitionStart');
        else swiper.emit('slidePrevTransitionStart');
    }
}


function $0cd65f06d80a9345$export$2e2bcd8739ae039(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var activeIndex = swiper.activeIndex, previousIndex = swiper.previousIndex, params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit('transitionEnd');
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit('slideResetTransitionEnd');
            return;
        }
        swiper.emit('slideChangeTransitionEnd');
        if (dir === 'next') swiper.emit('slideNextTransitionEnd');
        else swiper.emit('slidePrevTransitionEnd');
    }
}


var $3b3a31204ce137bc$export$2e2bcd8739ae039 = {
    setTransition: (0, $55f2fe0f38a40af5$export$2e2bcd8739ae039),
    transitionStart: (0, $74db8986be7e821a$export$2e2bcd8739ae039),
    transitionEnd: (0, $0cd65f06d80a9345$export$2e2bcd8739ae039)
};



var $j2WbH = parcelRequire("j2WbH");
function $7ebb18e3e19bbc2d$export$2e2bcd8739ae039(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index !== 'number' && typeof index !== 'string') throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + (typeof index === "undefined" ? "undefined" : (0, $j2WbH._)(index)) + "] given.");
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ var indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ var isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate, wrapperEl = swiper.wrapperEl, enabled = swiper.enabled;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    var translate = -snapGrid[snapIndex]; // Update progress
    swiper.updateProgress(translate); // Normalize slideIndex
    if (params.normalizeSlideIndex) for(var i = 0; i < slidesGrid.length; i += 1){
        var normalizedTranslate = -Math.floor(translate * 100);
        var normalizedGird = Math.floor(slidesGrid[i] * 100);
        var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGird) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    var direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset'; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var t = -translate;
        if (rtl) t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        else // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
            var _wrapperEl$scrollTo;
            wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
        } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
                swiper.onSlideToWrapperTransitionEnd = null;
                delete swiper.onSlideToWrapperTransitionEnd;
                swiper.transitionEnd(runCallbacks, direction);
            };
            swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        }
    }
    return true;
}


function $4906a98382400bb3$export$2e2bcd8739ae039(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $e3d108f4aa1e24df$export$2e2bcd8739ae039(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params, animating = swiper.animating, enabled = swiper.enabled;
    if (!enabled) return swiper;
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $906cab6f19e5b02c$export$2e2bcd8739ae039(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params, animating = swiper.animating, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function(val) {
        return normalize(val);
    });
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) snapGrid.forEach(function(snap) {
        if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
    });
    var prevIndex;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $55dc263ac2f25e51$export$2e2bcd8739ae039(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $03cff3881b59c13b$export$2e2bcd8739ae039(speed, runCallbacks, internal, threshold) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    var swiper = this;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        var prevSnap = swiper.snapGrid[snapIndex - 1];
        var _currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}




function $404331db39a0ad16$export$2e2bcd8739ae039() {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl;
    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $ac668c36e81824b6$export$2e2bcd8739ae039)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
                (0, $60eca45f20c21def$export$bdd553fddd433dcb)(function() {
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
            (0, $60eca45f20c21def$export$bdd553fddd433dcb)(function() {
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}


var $ef984267d7c26b2f$export$2e2bcd8739ae039 = {
    slideTo: (0, $7ebb18e3e19bbc2d$export$2e2bcd8739ae039),
    slideToLoop: (0, $4906a98382400bb3$export$2e2bcd8739ae039),
    slideNext: (0, $e3d108f4aa1e24df$export$2e2bcd8739ae039),
    slidePrev: (0, $906cab6f19e5b02c$export$2e2bcd8739ae039),
    slideReset: (0, $55dc263ac2f25e51$export$2e2bcd8739ae039),
    slideToClosest: (0, $03cff3881b59c13b$export$2e2bcd8739ae039),
    slideToClickedSlide: (0, $404331db39a0ad16$export$2e2bcd8739ae039)
};



var $98WL7 = parcelRequire("98WL7");

function $c1ca78dde24d6f9a$export$2e2bcd8739ae039() {
    var swiper = this;
    var document = (0, $98WL7.getDocument)();
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides
    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
    var slides = $wrapperEl.children("." + params.slideClass);
    if (params.loopFillGroupWithBlank) {
        var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(var i = 0; i < blankSlidesNum; i += 1){
                var blankNode = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
                $wrapperEl.append(blankNode);
            }
            slides = $wrapperEl.children("." + params.slideClass);
        }
    }
    if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) swiper.loopedSlides = slides.length;
    var prependSlides = [];
    var appendSlides = [];
    slides.each(function(el, index) {
        var slide = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(el);
        if (index < swiper.loopedSlides) appendSlides.push(el);
        if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
        slide.attr('data-swiper-slide-index', index);
    });
    for(var _i = 0; _i < appendSlides.length; _i += 1)$wrapperEl.append((0, $ac668c36e81824b6$export$2e2bcd8739ae039)(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1)$wrapperEl.prepend((0, $ac668c36e81824b6$export$2e2bcd8739ae039)(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
}


function $de2f8f48a74ed76b$export$2e2bcd8739ae039() {
    var swiper = this;
    swiper.emit('beforeLoopFix');
    var activeIndex = swiper.activeIndex, slides = swiper.slides, loopedSlides = swiper.loopedSlides, allowSlidePrev = swiper.allowSlidePrev, allowSlideNext = swiper.allowSlideNext, snapGrid = swiper.snapGrid, rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        var slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        var _slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (_slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
}


function $de621479e56e0fef$export$2e2bcd8739ae039() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params, slides = swiper.slides;
    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
    slides.removeAttr('data-swiper-slide-index');
}


var $c804403d71a8957d$export$2e2bcd8739ae039 = {
    loopCreate: (0, $c1ca78dde24d6f9a$export$2e2bcd8739ae039),
    loopFix: (0, $de2f8f48a74ed76b$export$2e2bcd8739ae039),
    loopDestroy: (0, $de621479e56e0fef$export$2e2bcd8739ae039)
};


function $550ea777beb4bf69$export$2e2bcd8739ae039(moving) {
    var swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.el;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
}


function $dd41e771d2b94b75$export$2e2bcd8739ae039() {
    var swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper.el.style.cursor = '';
}


var $d5e28ba00a81d79e$export$2e2bcd8739ae039 = {
    setGrabCursor: (0, $550ea777beb4bf69$export$2e2bcd8739ae039),
    unsetGrabCursor: (0, $dd41e771d2b94b75$export$2e2bcd8739ae039)
};



var $j2WbH = parcelRequire("j2WbH");
function $dce068f09e4b8509$export$2e2bcd8739ae039(slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params;
    if (params.loop) swiper.loopDestroy();
    if ((typeof slides === "undefined" ? "undefined" : (0, $j2WbH._)(slides)) === 'object' && 'length' in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && swiper.support.observer)) swiper.update();
}



var $j2WbH = parcelRequire("j2WbH");
function $e00c0ee6ab62d55b$export$2e2bcd8739ae039(slides) {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex;
    if (params.loop) swiper.loopDestroy();
    var newActiveIndex = activeIndex + 1;
    if ((typeof slides === "undefined" ? "undefined" : (0, $j2WbH._)(slides)) === 'object' && 'length' in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && swiper.support.observer)) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}



var $j2WbH = parcelRequire("j2WbH");
function $bb9c310250fcc7b7$export$2e2bcd8739ae039(index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children("." + params.slideClass);
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];
    for(var i = baseLength - 1; i >= index; i -= 1){
        var currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if ((typeof slides === "undefined" ? "undefined" : (0, $j2WbH._)(slides)) === 'object' && 'length' in slides) {
        for(var _i = 0; _i < slides.length; _i += 1)if (slides[_i]) $wrapperEl.append(slides[_i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1)$wrapperEl.append(slidesBuffer[_i2]);
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && swiper.support.observer)) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}



var $j2WbH = parcelRequire("j2WbH");
function $b7a973515d70ebfa$export$2e2bcd8739ae039(slidesIndexes) {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children("." + params.slideClass);
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;
    if ((typeof slidesIndexes === "undefined" ? "undefined" : (0, $j2WbH._)(slidesIndexes)) === 'object' && 'length' in slidesIndexes) {
        for(var i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && swiper.support.observer)) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $39349947073e60b3$export$2e2bcd8739ae039() {
    var swiper = this;
    var slidesIndexes = [];
    for(var i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}


var $ba599310417f2937$export$2e2bcd8739ae039 = {
    appendSlide: (0, $dce068f09e4b8509$export$2e2bcd8739ae039),
    prependSlide: (0, $e00c0ee6ab62d55b$export$2e2bcd8739ae039),
    addSlide: (0, $bb9c310250fcc7b7$export$2e2bcd8739ae039),
    removeSlide: (0, $b7a973515d70ebfa$export$2e2bcd8739ae039),
    removeAllSlides: (0, $39349947073e60b3$export$2e2bcd8739ae039)
};



var $98WL7 = parcelRequire("98WL7");

var $98WL7 = parcelRequire("98WL7");


function $9f9d1213ff48fa8b$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $98WL7.getDocument)() || el === (0, $98WL7.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        var found = el.closest(selector);
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $9f9d1213ff48fa8b$export$2e2bcd8739ae039(event) {
    var swiper = this;
    var document = (0, $98WL7.getDocument)();
    var window = (0, $98WL7.getWindow)();
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, enabled = swiper.enabled;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var $targetEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(e.target);
    if (params.touchEventsTarget === 'wrapper') {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
    if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) $targetEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(event.path[0]);
    var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass;
    var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $9f9d1213ff48fa8b$var$closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') event.preventDefault();
        else return;
    }
    (0, $60eca45f20c21def$export$8b58be045bf06082)(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $60eca45f20c21def$export$461939dd4422153)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== 'touchstart') {
        var preventDefault = true;
        if ($targetEl.is(data.focusableElements)) preventDefault = false;
        if (document.activeElement && (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    swiper.emit('touchStart', e);
}



var $98WL7 = parcelRequire("98WL7");


function $a3f49624f57f693c$export$2e2bcd8739ae039(event) {
    var document = (0, $98WL7.getDocument)();
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    if (data.isTouchEvent && e.type !== 'touchmove') return;
    var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        // isMoved = true;
        swiper.allowClick = false;
        if (data.isTouched) {
            (0, $60eca45f20c21def$export$8b58be045bf06082)(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $60eca45f20c21def$export$461939dd4422153)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $60eca45f20c21def$export$461939dd4422153)()
        });
    } // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}



function $13a743f967172c67$export$2e2bcd8739ae039(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, $wrapperEl = swiper.$wrapperEl, slidesGrid = swiper.slidesGrid, snapGrid = swiper.snapGrid, enabled = swiper.enabled;
    if (!enabled) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    var touchEndTime = (0, $60eca45f20c21def$export$461939dd4422153)();
    var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        swiper.updateClickedSlide(e);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $60eca45f20c21def$export$461939dd4422153)();
    (0, $60eca45f20c21def$export$bdd553fddd433dcb)(function() {
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode) {
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeModeMomentum) {
            if (data.velocities.length > 1) {
                var lastMoveEvent = data.velocities.pop();
                var velocityEvent = data.velocities.pop();
                var distance = lastMoveEvent.position - velocityEvent.position;
                var time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $60eca45f20c21def$export$461939dd4422153)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeModeMomentumVelocityRatio;
            data.velocities.length = 0;
            var momentumDuration = 1000 * params.freeModeMomentumRatio;
            var momentumDistance = swiper.velocity * momentumDuration;
            var newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            var doBounce = false;
            var afterBouncePosition;
            var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
            var needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeModeMomentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeModeMomentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeModeSticky) {
                var nextSlide;
                for(var j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) swiper.once('transitionEnd', function() {
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeModeSticky) {
                    // If freeModeSticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeModeSticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeModeMomentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(function() {
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    swiper.emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(function() {
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(function() {
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(function() {
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else {
                swiper.emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
            }
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeModeSticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) swiper.emit('_freeModeNoMomentumRelease');
        if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        return;
    } // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for(var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + _increment] !== 'undefined') {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + _increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    } // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}


function $f7972ff9eec1f4a7$export$2e2bcd8739ae039() {
    var swiper = this;
    var params = swiper.params, el = swiper.el;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    var allowSlideNext = swiper.allowSlideNext, allowSlidePrev = swiper.allowSlidePrev, snapGrid = swiper.snapGrid; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}


function $a73c6a90fa5035d7$export$2e2bcd8739ae039(e) {
    var swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}


function $9302b38f020ecdb7$export$2e2bcd8739ae039() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) {
        if (rtlTranslate) swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
        else swiper.translate = -wrapperEl.scrollLeft;
    } else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === -0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}


var $e38f5349aecfa068$var$dummyEventAttached = false;
function $e38f5349aecfa068$var$dummyEventListener() {}
function $e38f5349aecfa068$var$attachEvents() {
    var swiper = this;
    var document = (0, $98WL7.getDocument)();
    var params = swiper.params, touchEvents = swiper.touchEvents, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device, support = swiper.support;
    swiper.onTouchStart = (0, $9f9d1213ff48fa8b$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchMove = (0, $a3f49624f57f693c$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchEnd = (0, $13a743f967172c67$export$2e2bcd8739ae039).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $9302b38f020ecdb7$export$2e2bcd8739ae039).bind(swiper);
    swiper.onClick = (0, $a73c6a90fa5035d7$export$2e2bcd8739ae039).bind(swiper);
    var capture = !!params.nested; // Touch Events
    if (!support.touch && support.pointerEvents) {
        el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
        document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
        document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
        if (support.touch) {
            var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
                passive: true,
                capture: false
            } : false;
            el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
            el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
                passive: false,
                capture: capture
            } : capture);
            el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
            if (touchEvents.cancel) el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
            if (!$e38f5349aecfa068$var$dummyEventAttached) {
                document.addEventListener('touchstart', $e38f5349aecfa068$var$dummyEventListener);
                $e38f5349aecfa068$var$dummyEventAttached = true;
            }
        }
        if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
            el.addEventListener('mousedown', swiper.onTouchStart, false);
            document.addEventListener('mousemove', swiper.onTouchMove, capture);
            document.addEventListener('mouseup', swiper.onTouchEnd, false);
        }
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el.addEventListener('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl.addEventListener('scroll', swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', (0, $f7972ff9eec1f4a7$export$2e2bcd8739ae039), true);
    else swiper.on('observerUpdate', (0, $f7972ff9eec1f4a7$export$2e2bcd8739ae039), true);
}
function $e38f5349aecfa068$var$detachEvents() {
    var swiper = this;
    var document = (0, $98WL7.getDocument)();
    var params = swiper.params, touchEvents = swiper.touchEvents, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device, support = swiper.support;
    var capture = !!params.nested; // Touch Events
    if (!support.touch && support.pointerEvents) {
        el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
        document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
        if (support.touch) {
            var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
                passive: true,
                capture: false
            } : false;
            el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
            el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
            el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
            if (touchEvents.cancel) el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }
        if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
            el.removeEventListener('mousedown', swiper.onTouchStart, false);
            document.removeEventListener('mousemove', swiper.onTouchMove, capture);
            document.removeEventListener('mouseup', swiper.onTouchEnd, false);
        }
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el.removeEventListener('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl.removeEventListener('scroll', swiper.onScroll);
     // Resize handler
    swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', (0, $f7972ff9eec1f4a7$export$2e2bcd8739ae039));
}
var $e38f5349aecfa068$export$2e2bcd8739ae039 = {
    attachEvents: $e38f5349aecfa068$var$attachEvents,
    detachEvents: $e38f5349aecfa068$var$detachEvents
};



function $2fbb7987969eef87$export$2e2bcd8739ae039() {
    var swiper = this;
    var activeIndex = swiper.activeIndex, initialized = swiper.initialized, _swiper$loopedSlides = swiper.loopedSlides, loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides, params = swiper.params, $el = swiper.$el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    if (breakpointOnlyParams) [
        'slidesPerView',
        'spaceBetween',
        'slidesPerGroup',
        'slidesPerGroupSkip',
        'slidesPerColumn'
    ].forEach(function(param) {
        var paramValue = breakpointOnlyParams[param];
        if (typeof paramValue === 'undefined') return;
        if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) breakpointOnlyParams[param] = 'auto';
        else if (param === 'slidesPerView') breakpointOnlyParams[param] = parseFloat(paramValue);
        else breakpointOnlyParams[param] = parseInt(paramValue, 10);
    });
    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var wasMultiRow = params.slidesPerColumn > 1;
    var isMultiRow = breakpointParams.slidesPerColumn > 1;
    var wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(params.containerModifierClass + "multirow");
        if (breakpointParams.slidesPerColumnFill && breakpointParams.slidesPerColumnFill === 'column' || !breakpointParams.slidesPerColumnFill && params.slidesPerColumnFill === 'column') $el.addClass(params.containerModifierClass + "multirow-column");
        swiper.emitContainerClasses();
    }
    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper.params, breakpointParams);
    var isEnabled = swiper.params.enabled;
    (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit('breakpoint', breakpointParams);
}



var $98WL7 = parcelRequire("98WL7");
function $8c1d55b3699008e4$export$2e2bcd8739ae039(breakpoints, base, containerEl) {
    if (base === void 0) base = 'window';
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    var breakpoint = false;
    var window = (0, $98WL7.getWindow)();
    var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    var points = Object.keys(breakpoints).map(function(point) {
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            var minRatio = parseFloat(point.substr(1));
            var value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort(function(a, b) {
        return parseInt(a.value, 10) - parseInt(b.value, 10);
    });
    for(var i = 0; i < points.length; i += 1){
        var _points$i = points[i], point = _points$i.point, value = _points$i.value;
        if (base === 'window') {
            if (window.matchMedia("(min-width: " + value + "px)").matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}


var $89312d160a28fa6f$export$2e2bcd8739ae039 = {
    setBreakpoint: (0, $2fbb7987969eef87$export$2e2bcd8739ae039),
    getBreakpoint: (0, $8c1d55b3699008e4$export$2e2bcd8739ae039)
};



var $j2WbH = parcelRequire("j2WbH");
function $5bbff81d80862689$var$prepareClasses(entries, prefix) {
    var resultClasses = [];
    entries.forEach(function(item) {
        if ((typeof item === "undefined" ? "undefined" : (0, $j2WbH._)(item)) === 'object') Object.keys(item).forEach(function(classNames) {
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $5bbff81d80862689$export$2e2bcd8739ae039() {
    var swiper = this;
    var classNames = swiper.classNames, params = swiper.params, rtl = swiper.rtl, $el = swiper.$el, device = swiper.device, support = swiper.support; // prettier-ignore
    var suffixes = $5bbff81d80862689$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'pointer-events': support.pointerEvents && !support.touch
        },
        {
            'free-mode': params.freeMode
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'multirow': params.slidesPerColumn > 1
        },
        {
            'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        }
    ], params.containerModifierClass);
    classNames.push.apply(classNames, suffixes);
    $el.addClass([].concat(classNames).join(' '));
    swiper.emitContainerClasses();
}


function $6c0f0606d96383ae$export$2e2bcd8739ae039() {
    var swiper = this;
    var $el = swiper.$el, classNames = swiper.classNames;
    $el.removeClass(classNames.join(' '));
    swiper.emitContainerClasses();
}


var $0ae2dfd64916c920$export$2e2bcd8739ae039 = {
    addClasses: (0, $5bbff81d80862689$export$2e2bcd8739ae039),
    removeClasses: (0, $6c0f0606d96383ae$export$2e2bcd8739ae039)
};



var $98WL7 = parcelRequire("98WL7");

function $2f1bd2d9e7a7a3ca$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    var window = (0, $98WL7.getWindow)();
    var image;
    function onReady() {
        if (callback) callback();
    }
    var isPicture = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(imageEl).parent('picture')[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}


function $f4db8d791f9b45dd$export$2e2bcd8739ae039() {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit('imagesReady');
        }
    }
    for(var i = 0; i < swiper.imagesToLoad.length; i += 1){
        var imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
}


var $075dfd2ddd01cdf5$export$2e2bcd8739ae039 = {
    loadImage: (0, $2f1bd2d9e7a7a3ca$export$2e2bcd8739ae039),
    preloadImages: (0, $f4db8d791f9b45dd$export$2e2bcd8739ae039)
};


function $e162a9e8a268e797$var$checkOverflow() {
    var swiper = this;
    var params = swiper.params;
    var wasLocked = swiper.isLocked;
    var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;
    if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) swiper.isLocked = lastSlidePosition <= swiper.size;
    else swiper.isLocked = swiper.snapGrid.length === 1;
    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked; // events
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
    if (wasLocked && wasLocked !== swiper.isLocked) {
        swiper.isEnd = false;
        if (swiper.navigation) swiper.navigation.update();
    }
}
var $e162a9e8a268e797$export$2e2bcd8739ae039 = {
    checkOverflow: $e162a9e8a268e797$var$checkOverflow
};


var $568cf5e112523d36$export$2e2bcd8739ae039 = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: false,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    // NS
    containerModifierClass: 'swiper-container-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};


function $99b1ac342f8dfa89$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $99b1ac342f8dfa89$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $99b1ac342f8dfa89$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $99b1ac342f8dfa89$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $99b1ac342f8dfa89$var$prototypes = {
    modular: (0, $e21afd2f5f6e17bb$export$2e2bcd8739ae039),
    eventsEmitter: (0, $d18da0a8f6bac2f6$export$2e2bcd8739ae039),
    update: (0, $f368f0aa33154ce2$export$2e2bcd8739ae039),
    translate: (0, $d85fe82d632f33af$export$2e2bcd8739ae039),
    transition: (0, $3b3a31204ce137bc$export$2e2bcd8739ae039),
    slide: (0, $ef984267d7c26b2f$export$2e2bcd8739ae039),
    loop: (0, $c804403d71a8957d$export$2e2bcd8739ae039),
    grabCursor: (0, $d5e28ba00a81d79e$export$2e2bcd8739ae039),
    manipulation: (0, $ba599310417f2937$export$2e2bcd8739ae039),
    events: (0, $e38f5349aecfa068$export$2e2bcd8739ae039),
    breakpoints: (0, $89312d160a28fa6f$export$2e2bcd8739ae039),
    checkOverflow: (0, $e162a9e8a268e797$export$2e2bcd8739ae039),
    classes: (0, $0ae2dfd64916c920$export$2e2bcd8739ae039),
    images: (0, $075dfd2ddd01cdf5$export$2e2bcd8739ae039)
};
var $99b1ac342f8dfa89$var$extendedDefaults = {};
var $99b1ac342f8dfa89$var$Swiper = /*#__PURE__*/ function() {
    function Swiper() {
        var el;
        var params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else {
            el = args[0];
            params = args[1];
        }
        if (!params) params = {};
        params = (0, $60eca45f20c21def$export$8b58be045bf06082)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(params.el).length > 1) {
            var swipers = [];
            (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(params.el).each(function(containerEl) {
                var newParams = (0, $60eca45f20c21def$export$8b58be045bf06082)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            return swipers;
        } // Swiper Instance
        var swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $280c168d4fc5c5c5$export$d61c7b85ff180578)();
        swiper.device = (0, $95873ecabc836cd2$export$30c823bc834d6ab4)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $dac9a46839482ff6$export$89e15fc796a4a429)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        if (typeof swiper.modules === 'undefined') swiper.modules = {};
        Object.keys(swiper.modules).forEach(function(moduleName) {
            var module = swiper.modules[moduleName];
            if (module.params) {
                var moduleParamName = Object.keys(module.params)[0];
                var moduleParams = module.params[moduleParamName];
                if ((typeof moduleParams === "undefined" ? "undefined" : (0, $j2WbH._)(moduleParams)) !== 'object' || moduleParams === null) return;
                if ([
                    'navigation',
                    'pagination',
                    'scrollbar'
                ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
                    auto: true
                };
                if (!(moduleParamName in params && 'enabled' in moduleParams)) return;
                if (params[moduleParamName] === true) params[moduleParamName] = {
                    enabled: true
                };
                if ((0, $j2WbH._)(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
                if (!params[moduleParamName]) params[moduleParamName] = {
                    enabled: false
                };
            }
        }); // Extend defaults with modules params
        var swiperParams = (0, $60eca45f20c21def$export$8b58be045bf06082)({}, (0, $568cf5e112523d36$export$2e2bcd8739ae039));
        swiper.useParams(swiperParams); // Extend defaults with passed params
        swiper.params = (0, $60eca45f20c21def$export$8b58be045bf06082)({}, swiperParams, $99b1ac342f8dfa89$var$extendedDefaults, params);
        swiper.originalParams = (0, $60eca45f20c21def$export$8b58be045bf06082)({}, swiper.params);
        swiper.passedParams = (0, $60eca45f20c21def$export$8b58be045bf06082)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach(function(eventName) {
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $ac668c36e81824b6$export$2e2bcd8739ae039); // Extend Swiper
        (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal: function isHorizontal() {
                return swiper.params.direction === 'horizontal';
            },
            isVertical: function isVertical() {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                var touch = [
                    'touchstart',
                    'touchmove',
                    'touchend',
                    'touchcancel'
                ];
                var desktop = [
                    'mousedown',
                    'mousemove',
                    'mouseup'
                ];
                if (swiper.support.pointerEvents) desktop = [
                    'pointerdown',
                    'pointermove',
                    'pointerup'
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $60eca45f20c21def$export$461939dd4422153)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        }); // Install Modules
        swiper.useModules();
        swiper.emit('_swiper'); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        return swiper;
    }
    var _proto = Swiper.prototype;
    _proto.enable = function enable() {
        var swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    };
    _proto.disable = function disable() {
        var swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    };
    _proto.setProgress = function setProgress(progress, speed) {
        var swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        var min = swiper.minTranslate();
        var max = swiper.maxTranslate();
        var current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    };
    _proto.emitContainerClasses = function emitContainerClasses() {
        var swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        var _$classes = swiper.el.className.split(' ').filter(function(className) {
            return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', _$classes.join(' '));
    };
    _proto.getSlideClasses = function getSlideClasses(slideEl) {
        var swiper = this;
        return slideEl.className.split(' ').filter(function(className) {
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    };
    _proto.emitSlidesClasses = function emitSlidesClasses() {
        var swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        var updates = [];
        swiper.slides.each(function(slideEl) {
            var classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    };
    _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
        var swiper = this;
        var params = swiper.params, slides = swiper.slides, slidesGrid = swiper.slidesGrid, swiperSize = swiper.size, activeIndex = swiper.activeIndex;
        var spv = 1;
        if (params.centeredSlides) {
            var slideSize = slides[activeIndex].swiperSlideSize;
            var breakLoop;
            for(var i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(var _i = activeIndex - 1; _i >= 0; _i -= 1)if (slides[_i] && !breakLoop) {
                slideSize += slides[_i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            for(var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1)if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) spv += 1;
        }
        return spv;
    };
    _proto.update = function update() {
        var swiper = this;
        if (!swiper || swiper.destroyed) return;
        var snapGrid = swiper.snapGrid, params = swiper.params; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        var translated;
        if (swiper.params.freeMode) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    };
    _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        var swiper = this;
        var currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each(function(slideEl) {
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    };
    _proto.mount = function mount(el) {
        var swiper = this;
        if (swiper.mounted) return true; // Find el
        var $el = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        var getWrapperSelector = function getWrapperSelector() {
            return "." + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
        };
        var getWrapper = function getWrapper() {
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                var res = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = function(options) {
                    return $el.children(options);
                };
                return res;
            }
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        var $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            var document = (0, $98WL7.getDocument)();
            var wrapper = document.createElement('div');
            $wrapperEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children("." + swiper.params.slideClass).each(function(slideEl) {
                $wrapperEl.append(slideEl);
            });
        }
        (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
            wrongRTL: $wrapperEl.css('display') === '-webkit-box'
        });
        return true;
    };
    _proto.init = function init(el) {
        var swiper = this;
        if (swiper.initialized) return swiper;
        var mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit'); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    };
    _proto.destroy = function destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        var swiper = this;
        var params = swiper.params, $el = swiper.$el, $wrapperEl = swiper.$wrapperEl, slides = swiper.slides;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy'); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr('style');
            $wrapperEl.removeAttr('style');
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
        swiper.emit('destroy'); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach(function(eventName) {
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $60eca45f20c21def$export$8694e5c03a4df8e6)(swiper);
        }
        swiper.destroyed = true;
        return null;
    };
    Swiper.extendDefaults = function extendDefaults(newDefaults) {
        (0, $60eca45f20c21def$export$8b58be045bf06082)($99b1ac342f8dfa89$var$extendedDefaults, newDefaults);
    };
    Swiper.installModule = function installModule(module) {
        if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
        var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + (0, $60eca45f20c21def$export$461939dd4422153)();
        Swiper.prototype.modules[name] = module;
    };
    Swiper.use = function use(module) {
        if (Array.isArray(module)) {
            module.forEach(function(m) {
                return Swiper.installModule(m);
            });
            return Swiper;
        }
        Swiper.installModule(module);
        return Swiper;
    };
    $99b1ac342f8dfa89$var$_createClass(Swiper, null, [
        {
            key: "extendedDefaults",
            get: function get() {
                return $99b1ac342f8dfa89$var$extendedDefaults;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return 0, $568cf5e112523d36$export$2e2bcd8739ae039;
            }
        }
    ]);
    return Swiper;
}();
Object.keys($99b1ac342f8dfa89$var$prototypes).forEach(function(prototypeGroup) {
    Object.keys($99b1ac342f8dfa89$var$prototypes[prototypeGroup]).forEach(function(protoMethod) {
        $99b1ac342f8dfa89$var$Swiper.prototype[protoMethod] = $99b1ac342f8dfa89$var$prototypes[prototypeGroup][protoMethod];
    });
});
$99b1ac342f8dfa89$var$Swiper.use([
    (0, $41e99189fba40f7f$export$2e2bcd8739ae039),
    (0, $d332dbd3dcf38c14$export$2e2bcd8739ae039)
]);
var $99b1ac342f8dfa89$export$2e2bcd8739ae039 = $99b1ac342f8dfa89$var$Swiper;



var $j2WbH = parcelRequire("j2WbH");


function $fc81ef9e176d3984$var$_extends() {
    $fc81ef9e176d3984$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fc81ef9e176d3984$var$_extends.apply(this, arguments);
}
var $fc81ef9e176d3984$var$Virtual = {
    update: function update(force) {
        var swiper = this;
        var _swiper$params = swiper.params, slidesPerView = _swiper$params.slidesPerView, slidesPerGroup = _swiper$params.slidesPerGroup, centeredSlides = _swiper$params.centeredSlides;
        var _swiper$params$virtua = swiper.params.virtual, addSlidesBefore = _swiper$params$virtua.addSlidesBefore, addSlidesAfter = _swiper$params$virtua.addSlidesAfter;
        var _swiper$virtual = swiper.virtual, previousFrom = _swiper$virtual.from, previousTo = _swiper$virtual.to, slides = _swiper$virtual.slides, previousSlidesGrid = _swiper$virtual.slidesGrid, renderSlide = _swiper$virtual.renderSlide, previousOffset = _swiper$virtual.offset;
        swiper.updateActiveIndex();
        var activeIndex = swiper.activeIndex || 0;
        var offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        var slidesAfter;
        var slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        var from = Math.max((activeIndex || 0) - slidesBefore, 0);
        var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, offset + "px");
            swiper.updateProgress();
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    var slidesToRender = [];
                    for(var i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            return;
        }
        var prependIndexes = [];
        var appendIndexes = [];
        if (force) swiper.$wrapperEl.find("." + swiper.params.slideClass).remove();
        else {
            for(var i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + i + "\"]").remove();
        }
        for(var _i = 0; _i < slides.length; _i += 1)if (_i >= from && _i <= to) {
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(_i);
            else {
                if (_i > previousTo) appendIndexes.push(_i);
                if (_i < previousFrom) prependIndexes.push(_i);
            }
        }
        appendIndexes.forEach(function(index) {
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort(function(a, b) {
            return b - a;
        }).forEach(function(index) {
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, offset + "px");
        onRendered();
    },
    renderSlide: function renderSlide(slide, index) {
        var swiper = this;
        var params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        var $slideEl = params.renderSlide ? (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(params.renderSlide.call(swiper, slide, index)) : (0, $ac668c36e81824b6$export$2e2bcd8739ae039)("<div class=\"" + swiper.params.slideClass + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>");
        if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    },
    appendSlide: function appendSlide(slides) {
        var swiper = this;
        if ((typeof slides === "undefined" ? "undefined" : (0, $j2WbH._)(slides)) === 'object' && 'length' in slides) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        swiper.virtual.update(true);
    },
    prependSlide: function prependSlide(slides) {
        var swiper = this;
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            var cache = swiper.virtual.cache;
            var newCache = {};
            Object.keys(cache).forEach(function(cachedIndex) {
                var $cachedEl = cache[cachedIndex];
                var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
                if (cachedElIndex) $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        swiper.virtual.update(true);
        swiper.slideTo(newActiveIndex, 0);
    },
    removeSlide: function removeSlide(slidesIndexes) {
        var swiper = this;
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        var activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(var i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        swiper.virtual.update(true);
        swiper.slideTo(activeIndex, 0);
    },
    removeAllSlides: function removeAllSlides() {
        var swiper = this;
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        swiper.virtual.update(true);
        swiper.slideTo(0, 0);
    }
};
var $fc81ef9e176d3984$export$2e2bcd8739ae039 = {
    name: 'virtual',
    params: {
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            virtual: $fc81ef9e176d3984$var$_extends({}, $fc81ef9e176d3984$var$Virtual, {
                slides: swiper.params.virtual.slides,
                cache: {}
            })
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            if (!swiper.params.virtual.enabled) return;
            swiper.classNames.push(swiper.params.containerModifierClass + "virtual");
            var overwriteParams = {
                watchSlidesProgress: true
            };
            (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper.params, overwriteParams);
            (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper.originalParams, overwriteParams);
            if (!swiper.params.initialSlide) swiper.virtual.update();
        },
        setTranslate: function setTranslate(swiper) {
            if (!swiper.params.virtual.enabled) return;
            swiper.virtual.update();
        }
    }
};



var $98WL7 = parcelRequire("98WL7");


function $1ae0142fa2584cda$var$_extends() {
    $1ae0142fa2584cda$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1ae0142fa2584cda$var$_extends.apply(this, arguments);
}
var $1ae0142fa2584cda$var$Keyboard = {
    handle: function handle(event) {
        var swiper = this;
        if (!swiper.enabled) return;
        var window = (0, $98WL7.getWindow)();
        var document = (0, $98WL7.getDocument)();
        var rtl = swiper.rtlTranslate;
        var e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var kc = e.keyCode || e.charCode;
        var pageUpDown = swiper.params.keyboard.pageUpDown;
        var isPageUp = pageUpDown && kc === 33;
        var isPageDown = pageUpDown && kc === 34;
        var isArrowLeft = kc === 37;
        var isArrowRight = kc === 39;
        var isArrowUp = kc === 38;
        var isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            var inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents("." + swiper.params.slideClass).length > 0 && swiper.$el.parents("." + swiper.params.slideActiveClass).length === 0) return undefined;
            var $el = swiper.$el;
            var swiperWidth = $el[0].clientWidth;
            var swiperHeight = $el[0].clientHeight;
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            var swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            var swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(var i = 0; i < swiperCoord.length; i += 1){
                var point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        swiper.emit('keyPress', kc);
        return undefined;
    },
    enable: function enable() {
        var swiper = this;
        var document = (0, $98WL7.getDocument)();
        if (swiper.keyboard.enabled) return;
        (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(document).on('keydown', swiper.keyboard.handle);
        swiper.keyboard.enabled = true;
    },
    disable: function disable() {
        var swiper = this;
        var document = (0, $98WL7.getDocument)();
        if (!swiper.keyboard.enabled) return;
        (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(document).off('keydown', swiper.keyboard.handle);
        swiper.keyboard.enabled = false;
    }
};
var $1ae0142fa2584cda$export$2e2bcd8739ae039 = {
    name: 'keyboard',
    params: {
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            keyboard: $1ae0142fa2584cda$var$_extends({
                enabled: false
            }, $1ae0142fa2584cda$var$Keyboard)
        });
    },
    on: {
        init: function init(swiper) {
            if (swiper.params.keyboard.enabled) swiper.keyboard.enable();
        },
        destroy: function destroy(swiper) {
            if (swiper.keyboard.enabled) swiper.keyboard.disable();
        }
    }
};


/* eslint-disable consistent-return */ 
var $98WL7 = parcelRequire("98WL7");


function $21566fbb8143bce7$var$isEventSupported() {
    var document = (0, $98WL7.getDocument)();
    var eventName = 'onwheel';
    var isSupported = eventName in document;
    if (!isSupported) {
        var element = document.createElement('div');
        element.setAttribute(eventName, 'return;');
        isSupported = typeof element[eventName] === 'function';
    }
    if (!isSupported && document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
    document.implementation.hasFeature('', '') !== true) // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
    return isSupported;
}
var $21566fbb8143bce7$var$Mousewheel = {
    lastScrollTime: (0, $60eca45f20c21def$export$461939dd4422153)(),
    lastEventBeforeSnap: undefined,
    recentWheelEvents: [],
    event: function event() {
        var window = (0, $98WL7.getWindow)();
        if (window.navigator.userAgent.indexOf('firefox') > -1) return 'DOMMouseScroll';
        return $21566fbb8143bce7$var$isEventSupported() ? 'wheel' : 'mousewheel';
    },
    normalize: function normalize(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var sX = 0;
        var sY = 0; // spinX, spinY
        var pX = 0;
        var pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    },
    handleMouseEnter: function handleMouseEnter() {
        var swiper = this;
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
        var swiper = this;
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    },
    handle: function handle(event) {
        var e = event;
        var disableParentSwiper = true;
        var swiper = this;
        if (!swiper.enabled) return;
        var params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var data = $21566fbb8143bce7$var$Mousewheel.normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        var positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode) {
            // Register the new event in a variable which stores the relevant data
            var newEvent = {
                time: (0, $60eca45f20c21def$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event
            }; // Keep the most recent events
            var recentWheelEvents = swiper.mousewheel.recentWheelEvents;
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) swiper.mousewheel.animateSlider(newEvent);
            } else swiper.mousewheel.animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (swiper.mousewheel.releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            var _newEvent = {
                time: (0, $60eca45f20c21def$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            var lastEventBeforeSnap = swiper.mousewheel.lastEventBeforeSnap;
            var ignoreWheelEvents = lastEventBeforeSnap && _newEvent.time < lastEventBeforeSnap.time + 500 && _newEvent.delta <= lastEventBeforeSnap.delta && _newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                swiper.mousewheel.lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                var position = swiper.getTranslate() + delta * params.sensitivity;
                var wasBeginning = swiper.isBeginning;
                var wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeModeSticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(swiper.mousewheel.timeout);
                    swiper.mousewheel.timeout = undefined;
                    var _recentWheelEvents = swiper.mousewheel.recentWheelEvents;
                    if (_recentWheelEvents.length >= 15) _recentWheelEvents.shift(); // only store the last N events
                    var _prevEvent = _recentWheelEvents.length ? _recentWheelEvents[_recentWheelEvents.length - 1] : undefined;
                    var firstEvent = _recentWheelEvents[0];
                    _recentWheelEvents.push(_newEvent);
                    if (_prevEvent && (_newEvent.delta > _prevEvent.delta || _newEvent.direction !== _prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    _recentWheelEvents.splice(0);
                    else if (_recentWheelEvents.length >= 15 && _newEvent.time - firstEvent.time < 500 && firstEvent.delta - _newEvent.delta >= 1 && _newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        var snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        swiper.mousewheel.lastEventBeforeSnap = _newEvent;
                        _recentWheelEvents.splice(0);
                        swiper.mousewheel.timeout = (0, $60eca45f20c21def$export$bdd553fddd433dcb)(function() {
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!swiper.mousewheel.timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    swiper.mousewheel.timeout = (0, $60eca45f20c21def$export$bdd553fddd433dcb)(function() {
                        var snapToThreshold = 0.5;
                        swiper.mousewheel.lastEventBeforeSnap = _newEvent;
                        _recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) swiper.emit('scroll', e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    },
    animateSlider: function animateSlider(newEvent) {
        var swiper = this;
        var window = (0, $98WL7.getWindow)();
        if (this.params.mousewheel.thresholdDelta && newEvent.delta < this.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (this.params.mousewheel.thresholdTime && (0, $60eca45f20c21def$export$461939dd4422153)() - swiper.mousewheel.lastScrollTime < this.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $60eca45f20c21def$export$461939dd4422153)() - swiper.mousewheel.lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                swiper.emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            swiper.emit('scroll', newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        swiper.mousewheel.lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    },
    releaseScroll: function releaseScroll(newEvent) {
        var swiper = this;
        var params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    },
    enable: function enable() {
        var swiper = this;
        var event = $21566fbb8143bce7$var$Mousewheel.event();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
            return true;
        }
        if (!event) return false;
        if (swiper.mousewheel.enabled) return false;
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
        target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
        target.on(event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = true;
        return true;
    },
    disable: function disable() {
        var swiper = this;
        var event = $21566fbb8143bce7$var$Mousewheel.event();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
            return true;
        }
        if (!event) return false;
        if (!swiper.mousewheel.enabled) return false;
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        target.off(event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = false;
        return true;
    }
};
var $21566fbb8143bce7$export$2e2bcd8739ae039 = {
    name: 'mousewheel',
    params: {
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            mousewheel: {
                enabled: false,
                lastScrollTime: (0, $60eca45f20c21def$export$461939dd4422153)(),
                lastEventBeforeSnap: undefined,
                recentWheelEvents: [],
                enable: $21566fbb8143bce7$var$Mousewheel.enable,
                disable: $21566fbb8143bce7$var$Mousewheel.disable,
                handle: $21566fbb8143bce7$var$Mousewheel.handle,
                handleMouseEnter: $21566fbb8143bce7$var$Mousewheel.handleMouseEnter,
                handleMouseLeave: $21566fbb8143bce7$var$Mousewheel.handleMouseLeave,
                animateSlider: $21566fbb8143bce7$var$Mousewheel.animateSlider,
                releaseScroll: $21566fbb8143bce7$var$Mousewheel.releaseScroll
            }
        });
    },
    on: {
        init: function init(swiper) {
            if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) swiper.mousewheel.disable();
            if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
        },
        destroy: function destroy(swiper) {
            if (swiper.params.cssMode) swiper.mousewheel.enable();
            if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
        }
    }
};




function $266d7e4421c66895$var$_extends() {
    $266d7e4421c66895$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $266d7e4421c66895$var$_extends.apply(this, arguments);
}
var $266d7e4421c66895$var$Navigation = {
    toggleEl: function toggleEl($el, disabled) {
        $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
        if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
    },
    update: function update() {
        // Update Navigation Buttons
        var swiper = this;
        var params = swiper.params.navigation;
        var toggleEl = swiper.navigation.toggleEl;
        if (swiper.params.loop) return;
        var _swiper$navigation = swiper.navigation, $nextEl = _swiper$navigation.$nextEl, $prevEl = _swiper$navigation.$prevEl;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) toggleEl($prevEl, true);
            else toggleEl($prevEl, false);
            if (swiper.params.watchOverflow && swiper.enabled) $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) toggleEl($nextEl, true);
            else toggleEl($nextEl, false);
            if (swiper.params.watchOverflow && swiper.enabled) $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
    },
    onPrevClick: function onPrevClick(e) {
        var swiper = this;
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop) return;
        swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
        var swiper = this;
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop) return;
        swiper.slideNext();
    },
    init: function init() {
        var swiper = this;
        var params = swiper.params.navigation;
        swiper.params.navigation = (0, $60eca45f20c21def$export$f4bbea1d7959d26b)(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        var $nextEl;
        var $prevEl;
        if (params.nextEl) {
            $nextEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(params.nextEl);
            if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) $nextEl = swiper.$el.find(params.nextEl);
        }
        if (params.prevEl) {
            $prevEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(params.prevEl);
            if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) $prevEl = swiper.$el.find(params.prevEl);
        }
        if ($nextEl && $nextEl.length > 0) $nextEl.on('click', swiper.navigation.onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on('click', swiper.navigation.onPrevClick);
        (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    },
    destroy: function destroy() {
        var swiper = this;
        var _swiper$navigation2 = swiper.navigation, $nextEl = _swiper$navigation2.$nextEl, $prevEl = _swiper$navigation2.$prevEl;
        if ($nextEl && $nextEl.length) {
            $nextEl.off('click', swiper.navigation.onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off('click', swiper.navigation.onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
};
var $266d7e4421c66895$export$2e2bcd8739ae039 = {
    name: 'navigation',
    params: {
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock'
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            navigation: $266d7e4421c66895$var$_extends({}, $266d7e4421c66895$var$Navigation)
        });
    },
    on: {
        init: function init(swiper) {
            swiper.navigation.init();
            swiper.navigation.update();
        },
        toEdge: function toEdge(swiper) {
            swiper.navigation.update();
        },
        fromEdge: function fromEdge(swiper) {
            swiper.navigation.update();
        },
        destroy: function destroy(swiper) {
            swiper.navigation.destroy();
        },
        'enable disable': function enableDisable(swiper) {
            var _swiper$navigation3 = swiper.navigation, $nextEl = _swiper$navigation3.$nextEl, $prevEl = _swiper$navigation3.$prevEl;
            if ($nextEl) $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
            if ($prevEl) $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        },
        click: function click(swiper, e) {
            var _swiper$navigation4 = swiper.navigation, $nextEl = _swiper$navigation4.$nextEl, $prevEl = _swiper$navigation4.$prevEl;
            var targetEl = e.target;
            if (swiper.params.navigation.hideOnClick && !(0, $ac668c36e81824b6$export$2e2bcd8739ae039)(targetEl).is($prevEl) && !(0, $ac668c36e81824b6$export$2e2bcd8739ae039)(targetEl).is($nextEl)) {
                if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
                var isHidden;
                if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
                else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
                if (isHidden === true) swiper.emit('navigationShow');
                else swiper.emit('navigationHide');
                if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
                if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
            }
        }
    }
};




function $395037c38d99d7f5$var$_extends() {
    $395037c38d99d7f5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $395037c38d99d7f5$var$_extends.apply(this, arguments);
}
var $395037c38d99d7f5$var$Pagination = {
    update: function update() {
        // Render || Update Pagination bullets/items
        var swiper = this;
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el; // Current/Total
        var current;
        var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
        } else if (typeof swiper.snapIndex !== 'undefined') current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            var bullets = swiper.pagination.bullets;
            var firstIndex;
            var lastIndex;
            var midIndex;
            if (params.dynamicBullets) {
                swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
                $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;
                    if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (swiper.pagination.dynamicBulletIndex < 0) swiper.pagination.dynamicBulletIndex = 0;
                }
                firstIndex = current - swiper.pagination.dynamicBulletIndex;
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");
            if ($el.length > 1) bullets.each(function(bullet) {
                var $bullet = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(bullet);
                var bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(params.bulletActiveClass + "-main");
                    if (bulletIndex === firstIndex) $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                    if (bulletIndex === lastIndex) $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                }
            });
            else {
                var $bullet = bullets.eq(current);
                var bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    var $firstDisplayedBullet = bullets.eq(firstIndex);
                    var $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(var i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(params.bulletActiveClass + "-main");
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
                            for(var _i = params.dynamicMainBullets; _i >= 0; _i -= 1)bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
                        } else {
                            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                        }
                    } else {
                        $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                        $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                    }
                }
            }
            if (params.dynamicBullets) {
                var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
                var offsetProp = rtl ? 'right' : 'left';
                bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
            }
        }
        if (params.type === 'fraction') {
            $el.find((0, $60eca45f20c21def$export$730a8e2ed4fdbe02)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $60eca45f20c21def$export$730a8e2ed4fdbe02)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === 'progressbar') {
            var progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
            else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
            var scale = (current + 1) / total;
            var scaleX = 1;
            var scaleY = 1;
            if (progressbarDirection === 'horizontal') scaleX = scale;
            else scaleY = scale;
            $el.find((0, $60eca45f20c21def$export$730a8e2ed4fdbe02)(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
        }
        if (params.type === 'custom' && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            swiper.emit('paginationRender', $el[0]);
        } else swiper.emit('paginationUpdate', $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    },
    render: function render() {
        // Render Container
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el;
        var paginationHTML = '';
        if (params.type === 'bullets') {
            var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(var i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $60eca45f20c21def$export$730a8e2ed4fdbe02)(params.bulletClass));
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
            $el.html(paginationHTML);
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
            $el.html(paginationHTML);
        }
        if (params.type !== 'custom') swiper.emit('paginationRender', swiper.pagination.$el[0]);
    },
    init: function init() {
        var swiper = this;
        swiper.params.pagination = (0, $60eca45f20c21def$export$f4bbea1d7959d26b)(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
            el: 'swiper-pagination'
        });
        var params = swiper.params.pagination;
        if (!params.el) return;
        var $el = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) $el = swiper.$el.find(params.el);
        if (params.type === 'bullets' && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        if (params.type === 'bullets' && params.dynamicBullets) {
            $el.addClass("" + params.modifierClass + params.type + "-dynamic");
            swiper.pagination.dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === 'progressbar' && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on('click', (0, $60eca45f20c21def$export$730a8e2ed4fdbe02)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            var index = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    },
    destroy: function destroy() {
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off('click', (0, $60eca45f20c21def$export$730a8e2ed4fdbe02)(params.bulletClass));
    }
};
var $395037c38d99d7f5$export$2e2bcd8739ae039 = {
    name: 'pagination',
    params: {
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: function formatFractionCurrent(number) {
                return number;
            },
            formatFractionTotal: function formatFractionTotal(number) {
                return number;
            },
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
            modifierClass: 'swiper-pagination-',
            // NEW
            currentClass: 'swiper-pagination-current',
            totalClass: 'swiper-pagination-total',
            hiddenClass: 'swiper-pagination-hidden',
            progressbarFillClass: 'swiper-pagination-progressbar-fill',
            progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
            clickableClass: 'swiper-pagination-clickable',
            // NEW
            lockClass: 'swiper-pagination-lock'
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            pagination: $395037c38d99d7f5$var$_extends({
                dynamicBulletIndex: 0
            }, $395037c38d99d7f5$var$Pagination)
        });
    },
    on: {
        init: function init(swiper) {
            swiper.pagination.init();
            swiper.pagination.render();
            swiper.pagination.update();
        },
        activeIndexChange: function activeIndexChange(swiper) {
            if (swiper.params.loop) swiper.pagination.update();
            else if (typeof swiper.snapIndex === 'undefined') swiper.pagination.update();
        },
        snapIndexChange: function snapIndexChange(swiper) {
            if (!swiper.params.loop) swiper.pagination.update();
        },
        slidesLengthChange: function slidesLengthChange(swiper) {
            if (swiper.params.loop) {
                swiper.pagination.render();
                swiper.pagination.update();
            }
        },
        snapGridLengthChange: function snapGridLengthChange(swiper) {
            if (!swiper.params.loop) {
                swiper.pagination.render();
                swiper.pagination.update();
            }
        },
        destroy: function destroy(swiper) {
            swiper.pagination.destroy();
        },
        'enable disable': function enableDisable(swiper) {
            var $el = swiper.pagination.$el;
            if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
        },
        click: function click(swiper, e) {
            var targetEl = e.target;
            if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !(0, $ac668c36e81824b6$export$2e2bcd8739ae039)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
                if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
                var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
                if (isHidden === true) swiper.emit('paginationShow');
                else swiper.emit('paginationHide');
                swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
            }
        }
    }
};



var $98WL7 = parcelRequire("98WL7");


function $8b0a9b5852cbd35d$var$_extends() {
    $8b0a9b5852cbd35d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8b0a9b5852cbd35d$var$_extends.apply(this, arguments);
}
var $8b0a9b5852cbd35d$var$Scrollbar = {
    setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate, progress = swiper.progress;
        var dragSize = scrollbar.dragSize, trackSize = scrollbar.trackSize, $dragEl = scrollbar.$dragEl, $el = scrollbar.$el;
        var params = swiper.params.scrollbar;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
            $dragEl[0].style.width = newSize + "px";
        } else {
            $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
            $dragEl[0].style.height = newSize + "px";
        }
        if (params.hide) {
            clearTimeout(swiper.scrollbar.timeout);
            $el[0].style.opacity = 1;
            swiper.scrollbar.timeout = setTimeout(function() {
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function updateSize() {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar;
        var $dragEl = scrollbar.$dragEl, $el = scrollbar.$el;
        $dragEl[0].style.width = '';
        $dragEl[0].style.height = '';
        var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        var divider = swiper.size / swiper.virtualSize;
        var moveDivider = divider * (trackSize / swiper.size);
        var dragSize;
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = dragSize + "px";
        else $dragEl[0].style.height = dragSize + "px";
        if (divider >= 1) $el[0].style.display = 'none';
        else $el[0].style.display = '';
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        (0, $60eca45f20c21def$export$8b58be045bf06082)(scrollbar, {
            trackSize: trackSize,
            divider: divider,
            moveDivider: moveDivider,
            dragSize: dragSize
        });
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    },
    getPointerPosition: function getPointerPosition(e) {
        var swiper = this;
        if (swiper.isHorizontal()) return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
    },
    setDragPosition: function setDragPosition(e) {
        var swiper = this;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var $el = scrollbar.$el, dragSize = scrollbar.dragSize, trackSize = scrollbar.trackSize, dragStartPos = scrollbar.dragStartPos;
        var positionRatio;
        positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
        var swiper = this;
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el, $dragEl = scrollbar.$dragEl;
        swiper.scrollbar.isTouched = true;
        swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        scrollbar.setDragPosition(e);
        clearTimeout(swiper.scrollbar.dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css('opacity', 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css('scroll-snap-type', 'none');
        swiper.emit('scrollbarDragStart', e);
    },
    onDragMove: function onDragMove(e) {
        var swiper = this;
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el, $dragEl = scrollbar.$dragEl;
        if (!swiper.scrollbar.isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        scrollbar.setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        swiper.emit('scrollbarDragMove', e);
    },
    onDragEnd: function onDragEnd(e) {
        var swiper = this;
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el;
        if (!swiper.scrollbar.isTouched) return;
        swiper.scrollbar.isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css('scroll-snap-type', '');
            $wrapperEl.transition('');
        }
        if (params.hide) {
            clearTimeout(swiper.scrollbar.dragTimeout);
            swiper.scrollbar.dragTimeout = (0, $60eca45f20c21def$export$bdd553fddd433dcb)(function() {
                $el.css('opacity', 0);
                $el.transition(400);
            }, 1000);
        }
        swiper.emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    },
    enableDraggable: function enableDraggable() {
        var swiper = this;
        if (!swiper.params.scrollbar.el) return;
        var document = (0, $98WL7.getDocument)();
        var scrollbar = swiper.scrollbar, touchEventsTouch = swiper.touchEventsTouch, touchEventsDesktop = swiper.touchEventsDesktop, params = swiper.params, support = swiper.support;
        var $el = scrollbar.$el;
        var target = $el[0];
        var activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        var passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        if (!support.touch) {
            target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
            document.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
            document.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
        } else {
            target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
            target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
            target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
        }
    },
    disableDraggable: function disableDraggable() {
        var swiper = this;
        if (!swiper.params.scrollbar.el) return;
        var document = (0, $98WL7.getDocument)();
        var scrollbar = swiper.scrollbar, touchEventsTouch = swiper.touchEventsTouch, touchEventsDesktop = swiper.touchEventsDesktop, params = swiper.params, support = swiper.support;
        var $el = scrollbar.$el;
        var target = $el[0];
        var activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        var passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        if (!support.touch) {
            target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
            document.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
            document.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
        } else {
            target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
            target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
            target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
        }
    },
    init: function init() {
        var swiper = this;
        var scrollbar = swiper.scrollbar, $swiperEl = swiper.$el;
        swiper.params.scrollbar = (0, $60eca45f20c21def$export$f4bbea1d7959d26b)($swiperEl, swiper.params.scrollbar, swiper.params.createElements, {
            el: 'swiper-scrollbar'
        });
        var params = swiper.params.scrollbar;
        if (!params.el) return;
        var $el = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);
        if ($dragEl.length === 0) {
            $dragEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)("<div class=\"" + swiper.params.scrollbar.dragClass + "\"></div>");
            $el.append($dragEl);
        }
        (0, $60eca45f20c21def$export$8b58be045bf06082)(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) scrollbar.enableDraggable();
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    },
    destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.disableDraggable();
    }
};
var $8b0a9b5852cbd35d$export$2e2bcd8739ae039 = {
    name: 'scrollbar',
    params: {
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag'
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            scrollbar: $8b0a9b5852cbd35d$var$_extends({
                isTouched: false,
                timeout: null,
                dragTimeout: null
            }, $8b0a9b5852cbd35d$var$Scrollbar)
        });
    },
    on: {
        init: function init(swiper) {
            swiper.scrollbar.init();
            swiper.scrollbar.updateSize();
            swiper.scrollbar.setTranslate();
        },
        update: function update(swiper) {
            swiper.scrollbar.updateSize();
        },
        resize: function resize(swiper) {
            swiper.scrollbar.updateSize();
        },
        observerUpdate: function observerUpdate(swiper) {
            swiper.scrollbar.updateSize();
        },
        setTranslate: function setTranslate(swiper) {
            swiper.scrollbar.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
            swiper.scrollbar.setTransition(duration);
        },
        'enable disable': function enableDisable(swiper) {
            var $el = swiper.scrollbar.$el;
            if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
        },
        destroy: function destroy(swiper) {
            swiper.scrollbar.destroy();
        }
    }
};




function $9517801b1224dd76$var$_extends() {
    $9517801b1224dd76$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9517801b1224dd76$var$_extends.apply(this, arguments);
}
var $9517801b1224dd76$var$Parallax = {
    setTransform: function setTransform(el, progress) {
        var swiper = this;
        var rtl = swiper.rtl;
        var $el = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(el);
        var rtlFactor = rtl ? -1 : 1;
        var p = $el.attr('data-swiper-parallax') || '0';
        var x = $el.attr('data-swiper-parallax-x');
        var y = $el.attr('data-swiper-parallax-y');
        var scale = $el.attr('data-swiper-parallax-scale');
        var opacity = $el.attr('data-swiper-parallax-opacity');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = parseInt(x, 10) * progress * rtlFactor + "%";
        else x = x * progress * rtlFactor + "px";
        if (y.indexOf('%') >= 0) y = parseInt(y, 10) * progress + "%";
        else y = y * progress + "px";
        if (typeof opacity !== 'undefined' && opacity !== null) {
            var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === 'undefined' || scale === null) $el.transform("translate3d(" + x + ", " + y + ", 0px)");
        else {
            var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")");
        }
    },
    setTranslate: function setTranslate() {
        var swiper = this;
        var $el = swiper.$el, slides = swiper.slides, progress = swiper.progress, snapGrid = swiper.snapGrid;
        $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function(el) {
            swiper.parallax.setTransform(el, progress);
        });
        slides.each(function(slideEl, slideIndex) {
            var slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function(el) {
                swiper.parallax.setTransform(el, slideProgress);
            });
        });
    },
    setTransition: function setTransition(duration) {
        if (duration === void 0) duration = this.params.speed;
        var swiper = this;
        var $el = swiper.$el;
        $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function(parallaxEl) {
            var $parallaxEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(parallaxEl);
            var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    }
};
var $9517801b1224dd76$export$2e2bcd8739ae039 = {
    name: 'parallax',
    params: {
        parallax: {
            enabled: false
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            parallax: $9517801b1224dd76$var$_extends({}, $9517801b1224dd76$var$Parallax)
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            if (!swiper.params.parallax.enabled) return;
            swiper.params.watchSlidesProgress = true;
            swiper.originalParams.watchSlidesProgress = true;
        },
        init: function init(swiper) {
            if (!swiper.params.parallax.enabled) return;
            swiper.parallax.setTranslate();
        },
        setTranslate: function setTranslate(swiper) {
            if (!swiper.params.parallax.enabled) return;
            swiper.parallax.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
            if (!swiper.params.parallax.enabled) return;
            swiper.parallax.setTransition(duration);
        }
    }
};



var $98WL7 = parcelRequire("98WL7");


function $56b0429f8636ab2c$var$_extends() {
    $56b0429f8636ab2c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $56b0429f8636ab2c$var$_extends.apply(this, arguments);
}
var $56b0429f8636ab2c$var$Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        var x1 = e.targetTouches[0].pageX;
        var y1 = e.targetTouches[0].pageY;
        var x2 = e.targetTouches[1].pageX;
        var y2 = e.targetTouches[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
    },
    // Events
    onGestureStart: function onGestureStart(e) {
        var swiper = this;
        var support = swiper.support;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) return;
            zoom.fakeGestureTouched = true;
            gesture.scaleStart = $56b0429f8636ab2c$var$Zoom.getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(e.target).closest("." + swiper.params.slideClass);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
            gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
            gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        swiper.zoom.isScaling = true;
    },
    onGestureChange: function onGestureChange(e) {
        var swiper = this;
        var support = swiper.support;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (!support.gestures) {
            if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) return;
            zoom.fakeGestureMoved = true;
            gesture.scaleMove = $56b0429f8636ab2c$var$Zoom.getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === 'gesturechange') zoom.onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * zoom.currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        gesture.$imageEl.transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
    },
    onGestureEnd: function onGestureEnd(e) {
        var swiper = this;
        var device = swiper.device;
        var support = swiper.support;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (!support.gestures) {
            if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) return;
            if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) return;
            zoom.fakeGestureTouched = false;
            zoom.fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
        zoom.currentScale = zoom.scale;
        zoom.isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    },
    onTouchStart: function onTouchStart(e) {
        var swiper = this;
        var device = swiper.device;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture, image = zoom.image;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function onTouchMove(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture, image = zoom.image, velocity = zoom.velocity;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $60eca45f20c21def$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], 'x') || 0;
            image.startY = (0, $60eca45f20c21def$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], 'y') || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !zoom.isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
    },
    onTouchEnd: function onTouchEnd() {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture, image = zoom.image, velocity = zoom.velocity;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = velocity.x * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocity.y * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
    },
    onTransitionEnd: function onTransitionEnd() {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform('translate3d(0,0,0)');
            zoom.scale = 1;
            zoom.currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    },
    // Toggle Zoom
    toggle: function toggle(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoom.out();
        else // Zoom In
        zoom.in(e);
    },
    in: function _in(e) {
        var swiper = this;
        var window = (0, $98WL7.getWindow)();
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        var gesture = zoom.gesture, image = zoom.image;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(e.target).closest("." + swiper.params.slideClass);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
            gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        gesture.$slideEl.addClass("" + params.zoomedSlideClass);
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform("translate3d(" + translateX + "px, " + translateY + "px,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
    },
    out: function out() {
        var swiper = this;
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        var gesture = zoom.gesture;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
            gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        zoom.scale = 1;
        zoom.currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
        gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
        gesture.$slideEl.removeClass("" + params.zoomedSlideClass);
        gesture.$slideEl = undefined;
    },
    toggleGestures: function toggleGestures(method) {
        var swiper = this;
        var zoom = swiper.zoom;
        var selector = zoom.slideSelector, passive = zoom.passiveListener;
        swiper.$wrapperEl[method]('gesturestart', selector, zoom.onGestureStart, passive);
        swiper.$wrapperEl[method]('gesturechange', selector, zoom.onGestureChange, passive);
        swiper.$wrapperEl[method]('gestureend', selector, zoom.onGestureEnd, passive);
    },
    enableGestures: function enableGestures() {
        if (this.zoom.gesturesEnabled) return;
        this.zoom.gesturesEnabled = true;
        this.zoom.toggleGestures('on');
    },
    disableGestures: function disableGestures() {
        if (!this.zoom.gesturesEnabled) return;
        this.zoom.gesturesEnabled = false;
        this.zoom.toggleGestures('off');
    },
    // Attach/Detach Events
    enable: function enable() {
        var swiper = this;
        var support = swiper.support;
        var zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        var slideSelector = "." + swiper.params.slideClass;
        swiper.zoom.passiveListener = passiveListener;
        swiper.zoom.slideSelector = slideSelector; // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
    },
    disable: function disable() {
        var swiper = this;
        var zoom = swiper.zoom;
        if (!zoom.enabled) return;
        var support = swiper.support;
        swiper.zoom.enabled = false;
        var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        var slideSelector = "." + swiper.params.slideClass; // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
    }
};
var $56b0429f8636ab2c$export$2e2bcd8739ae039 = {
    name: 'zoom',
    params: {
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            zoom: $56b0429f8636ab2c$var$_extends({
                enabled: false,
                scale: 1,
                currentScale: 1,
                isScaling: false,
                gesture: {
                    $slideEl: undefined,
                    slideWidth: undefined,
                    slideHeight: undefined,
                    $imageEl: undefined,
                    $imageWrapEl: undefined,
                    maxRatio: 3
                },
                image: {
                    isTouched: undefined,
                    isMoved: undefined,
                    currentX: undefined,
                    currentY: undefined,
                    minX: undefined,
                    minY: undefined,
                    maxX: undefined,
                    maxY: undefined,
                    width: undefined,
                    height: undefined,
                    startX: undefined,
                    startY: undefined,
                    touchesStart: {},
                    touchesCurrent: {}
                },
                velocity: {
                    x: undefined,
                    y: undefined,
                    prevPositionX: undefined,
                    prevPositionY: undefined,
                    prevTime: undefined
                }
            }, $56b0429f8636ab2c$var$Zoom)
        });
        var scale = 1;
        Object.defineProperty(swiper.zoom, 'scale', {
            get: function get() {
                return scale;
            },
            set: function set(value) {
                if (scale !== value) {
                    var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
                    var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
                    swiper.emit('zoomChange', value, imageEl, slideEl);
                }
                scale = value;
            }
        });
    },
    on: {
        init: function init(swiper) {
            if (swiper.params.zoom.enabled) swiper.zoom.enable();
        },
        destroy: function destroy(swiper) {
            swiper.zoom.disable();
        },
        touchStart: function touchStart(swiper, e) {
            if (!swiper.zoom.enabled) return;
            swiper.zoom.onTouchStart(e);
        },
        touchEnd: function touchEnd(swiper, e) {
            if (!swiper.zoom.enabled) return;
            swiper.zoom.onTouchEnd(e);
        },
        doubleTap: function doubleTap(swiper, e) {
            if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) swiper.zoom.toggle(e);
        },
        transitionEnd: function transitionEnd(swiper) {
            if (swiper.zoom.enabled && swiper.params.zoom.enabled) swiper.zoom.onTransitionEnd();
        },
        slideChange: function slideChange(swiper) {
            if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) swiper.zoom.onTransitionEnd();
        }
    }
};



var $98WL7 = parcelRequire("98WL7");


function $958dffc4ffbac32e$var$_extends() {
    $958dffc4ffbac32e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $958dffc4ffbac32e$var$_extends.apply(this, arguments);
}
var $958dffc4ffbac32e$var$Lazy = {
    loadInSlide: function loadInSlide(index, loadInDuplicate) {
        if (loadInDuplicate === void 0) loadInDuplicate = true;
        var swiper = this;
        var params = swiper.params.lazy;
        if (typeof index === 'undefined') return;
        if (swiper.slides.length === 0) return;
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var $slideEl = isVirtual ? swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + index + "\"]") : swiper.slides.eq(index);
        var $images = $slideEl.find("." + params.elementClass + ":not(." + params.loadedClass + "):not(." + params.loadingClass + ")");
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each(function(imageEl) {
            var $imageEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(imageEl);
            $imageEl.addClass(params.loadingClass);
            var background = $imageEl.attr('data-background');
            var src = $imageEl.attr('data-src');
            var srcset = $imageEl.attr('data-srcset');
            var sizes = $imageEl.attr('data-sizes');
            var $pictureEl = $imageEl.parent('picture');
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function() {
                if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css('background-image', "url(\"" + background + "\")");
                    $imageEl.removeAttr('data-background');
                } else {
                    if (srcset) {
                        $imageEl.attr('srcset', srcset);
                        $imageEl.removeAttr('data-srcset');
                    }
                    if (sizes) {
                        $imageEl.attr('sizes', sizes);
                        $imageEl.removeAttr('data-sizes');
                    }
                    if ($pictureEl.length) $pictureEl.children('source').each(function(sourceEl) {
                        var $source = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(sourceEl);
                        if ($source.attr('data-srcset')) {
                            $source.attr('srcset', $source.attr('data-srcset'));
                            $source.removeAttr('data-srcset');
                        }
                    });
                    if (src) {
                        $imageEl.attr('src', src);
                        $imageEl.removeAttr('data-src');
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find("." + params.preloaderClass).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        var originalSlide = swiper.$wrapperEl.children("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + swiper.params.slideDuplicateClass + ")");
                        swiper.lazy.loadInSlide(originalSlide.index(), false);
                    } else {
                        var duplicatedSlide = swiper.$wrapperEl.children("." + swiper.params.slideDuplicateClass + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]");
                        swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
        });
    },
    load: function load() {
        var swiper = this;
        var $wrapperEl = swiper.$wrapperEl, swiperParams = swiper.params, slides = swiper.slides, activeIndex = swiper.activeIndex;
        var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        var params = swiperParams.lazy;
        var slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === 'auto') slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children("." + swiperParams.slideClass + "[data-swiper-slide-index=\"" + index + "\"]").length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(slideEl).attr('data-swiper-slide-index');
            return (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(slideEl).index();
        }
        if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;
        if (swiper.params.watchSlidesVisibility) $wrapperEl.children("." + swiperParams.slideVisibleClass).each(function(slideEl) {
            var index = isVirtual ? (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(slideEl).attr('data-swiper-slide-index') : (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(slideEl).index();
            swiper.lazy.loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(var i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) swiper.lazy.loadInSlide(i);
        } else swiper.lazy.loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                var amount = params.loadPrevNextAmount;
                var spv = slidesPerView;
                var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(var _i = activeIndex + slidesPerView; _i < maxIndex; _i += 1)if (slideExist(_i)) swiper.lazy.loadInSlide(_i);
                 // Prev Slides
                for(var _i2 = minIndex; _i2 < activeIndex; _i2 += 1)if (slideExist(_i2)) swiper.lazy.loadInSlide(_i2);
            } else {
                var nextSlide = $wrapperEl.children("." + swiperParams.slideNextClass);
                if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));
                var prevSlide = $wrapperEl.children("." + swiperParams.slidePrevClass);
                if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
            }
        }
    },
    checkInViewOnLoad: function checkInViewOnLoad() {
        var window = (0, $98WL7.getWindow)();
        var swiper = this;
        if (!swiper || swiper.destroyed) return;
        var $scrollElement = swiper.params.lazy.scrollingElement ? (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(swiper.params.lazy.scrollingElement) : (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(window);
        var isWindow = $scrollElement[0] === window;
        var scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        var scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        var swiperOffset = swiper.$el.offset();
        var rtl = swiper.rtlTranslate;
        var inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        var swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(var i = 0; i < swiperCoord.length; i += 1){
            var point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        var passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            swiper.lazy.load();
            $scrollElement.off('scroll', swiper.lazy.checkInViewOnLoad, passiveListener);
        } else if (!swiper.lazy.scrollHandlerAttached) {
            swiper.lazy.scrollHandlerAttached = true;
            $scrollElement.on('scroll', swiper.lazy.checkInViewOnLoad, passiveListener);
        }
    }
};
var $958dffc4ffbac32e$export$2e2bcd8739ae039 = {
    name: 'lazy',
    params: {
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: '',
            elementClass: 'swiper-lazy',
            loadingClass: 'swiper-lazy-loading',
            loadedClass: 'swiper-lazy-loaded',
            preloaderClass: 'swiper-lazy-preloader'
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            lazy: $958dffc4ffbac32e$var$_extends({
                initialImageLoaded: false
            }, $958dffc4ffbac32e$var$Lazy)
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
        },
        init: function init(swiper) {
            if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
                if (swiper.params.lazy.checkInView) swiper.lazy.checkInViewOnLoad();
                else swiper.lazy.load();
            }
        },
        scroll: function scroll(swiper) {
            if (swiper.params.freeMode && !swiper.params.freeModeSticky) swiper.lazy.load();
        },
        'scrollbarDragMove resize _freeModeNoMomentumRelease': function lazyLoad(swiper) {
            if (swiper.params.lazy.enabled) swiper.lazy.load();
        },
        transitionStart: function transitionStart(swiper) {
            if (swiper.params.lazy.enabled) {
                if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) swiper.lazy.load();
            }
        },
        transitionEnd: function transitionEnd(swiper) {
            if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) swiper.lazy.load();
        },
        slideChange: function slideChange(swiper) {
            var _swiper$params = swiper.params, lazy = _swiper$params.lazy, cssMode = _swiper$params.cssMode, watchSlidesVisibility = _swiper$params.watchSlidesVisibility, watchSlidesProgress = _swiper$params.watchSlidesProgress, touchReleaseOnEdges = _swiper$params.touchReleaseOnEdges, resistanceRatio = _swiper$params.resistanceRatio;
            if (lazy.enabled && (cssMode || (watchSlidesVisibility || watchSlidesProgress) && (touchReleaseOnEdges || resistanceRatio === 0))) swiper.lazy.load();
        }
    }
};



function $350878292ecce477$var$_extends() {
    $350878292ecce477$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $350878292ecce477$var$_extends.apply(this, arguments);
}
var $350878292ecce477$var$Controller = {
    LinearSpline: function LinearSpline(x, y) {
        var binarySearch = function search() {
            var maxIndex;
            var minIndex;
            var guess;
            return function(array, val) {
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        var i1;
        var i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function getInterpolateFunction(c) {
        var swiper = this;
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new $350878292ecce477$var$Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new $350878292ecce477$var$Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
    },
    setTranslate: function setTranslate(_setTranslate, byController) {
        var swiper = this;
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;
        var Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                swiper.controller.getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(var i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    },
    setTransition: function setTransition(duration, byController) {
        var swiper = this;
        var Swiper = swiper.constructor;
        var controlled = swiper.controller.control;
        var i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $60eca45f20c21def$export$bdd553fddd433dcb)(function() {
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(function() {
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === 'slide') c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
};
var $350878292ecce477$export$2e2bcd8739ae039 = {
    name: 'controller',
    params: {
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            controller: $350878292ecce477$var$_extends({
                control: swiper.params.controller.control
            }, $350878292ecce477$var$Controller)
        });
    },
    on: {
        update: function update(swiper) {
            if (!swiper.controller.control) return;
            if (swiper.controller.spline) {
                swiper.controller.spline = undefined;
                delete swiper.controller.spline;
            }
        },
        resize: function resize(swiper) {
            if (!swiper.controller.control) return;
            if (swiper.controller.spline) {
                swiper.controller.spline = undefined;
                delete swiper.controller.spline;
            }
        },
        observerUpdate: function observerUpdate(swiper) {
            if (!swiper.controller.control) return;
            if (swiper.controller.spline) {
                swiper.controller.spline = undefined;
                delete swiper.controller.spline;
            }
        },
        setTranslate: function setTranslate(swiper, translate, byController) {
            if (!swiper.controller.control) return;
            swiper.controller.setTranslate(translate, byController);
        },
        setTransition: function setTransition(swiper, duration, byController) {
            if (!swiper.controller.control) return;
            swiper.controller.setTransition(duration, byController);
        }
    }
};




function $d85fafb96bce04b2$var$_extends() {
    $d85fafb96bce04b2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d85fafb96bce04b2$var$_extends.apply(this, arguments);
}
var $d85fafb96bce04b2$var$A11y = {
    getRandomNumber: function getRandomNumber(size) {
        if (size === void 0) size = 16;
        var randomChar = function randomChar() {
            return Math.round(16 * Math.random()).toString(16);
        };
        return 'x'.repeat(size).replace(/x/g, randomChar);
    },
    makeElFocusable: function makeElFocusable($el) {
        $el.attr('tabIndex', '0');
        return $el;
    },
    makeElNotFocusable: function makeElNotFocusable($el) {
        $el.attr('tabIndex', '-1');
        return $el;
    },
    addElRole: function addElRole($el, role) {
        $el.attr('role', role);
        return $el;
    },
    addElRoleDescription: function addElRoleDescription($el, description) {
        $el.attr('aria-roledescription', description);
        return $el;
    },
    addElControls: function addElControls($el, controls) {
        $el.attr('aria-controls', controls);
        return $el;
    },
    addElLabel: function addElLabel($el, label) {
        $el.attr('aria-label', label);
        return $el;
    },
    addElId: function addElId($el, id) {
        $el.attr('id', id);
        return $el;
    },
    addElLive: function addElLive($el, live) {
        $el.attr('aria-live', live);
        return $el;
    },
    disableEl: function disableEl($el) {
        $el.attr('aria-disabled', true);
        return $el;
    },
    enableEl: function enableEl($el) {
        $el.attr('aria-disabled', false);
        return $el;
    },
    onEnterOrSpaceKey: function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        var swiper = this;
        var params = swiper.params.a11y;
        var $targetEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) swiper.a11y.notify(params.lastSlideMessage);
            else swiper.a11y.notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) swiper.a11y.notify(params.firstSlideMessage);
            else swiper.a11y.notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $60eca45f20c21def$export$730a8e2ed4fdbe02)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    },
    notify: function notify(message) {
        var swiper = this;
        var notification = swiper.a11y.liveRegion;
        if (notification.length === 0) return;
        notification.html('');
        notification.html(message);
    },
    updateNavigation: function updateNavigation() {
        var swiper = this;
        if (swiper.params.loop || !swiper.navigation) return;
        var _swiper$navigation = swiper.navigation, $nextEl = _swiper$navigation.$nextEl, $prevEl = _swiper$navigation.$prevEl;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                swiper.a11y.disableEl($prevEl);
                swiper.a11y.makeElNotFocusable($prevEl);
            } else {
                swiper.a11y.enableEl($prevEl);
                swiper.a11y.makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                swiper.a11y.disableEl($nextEl);
                swiper.a11y.makeElNotFocusable($nextEl);
            } else {
                swiper.a11y.enableEl($nextEl);
                swiper.a11y.makeElFocusable($nextEl);
            }
        }
    },
    updatePagination: function updatePagination() {
        var swiper = this;
        var params = swiper.params.a11y;
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) swiper.pagination.bullets.each(function(bulletEl) {
            var $bulletEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(bulletEl);
            swiper.a11y.makeElFocusable($bulletEl);
            if (!swiper.params.pagination.renderBullet) {
                swiper.a11y.addElRole($bulletEl, 'button');
                swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
            }
        });
    },
    init: function init() {
        var swiper = this;
        var params = swiper.params.a11y;
        swiper.$el.append(swiper.a11y.liveRegion); // Container
        var $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) swiper.a11y.addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) swiper.a11y.addElLabel($containerEl, params.containerMessage);
         // Wrapper
        var $wrapperEl = swiper.$wrapperEl;
        var wrapperId = $wrapperEl.attr('id') || "swiper-wrapper-" + swiper.a11y.getRandomNumber(16);
        var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        swiper.a11y.addElId($wrapperEl, wrapperId);
        swiper.a11y.addElLive($wrapperEl, live); // Slide
        if (params.itemRoleDescriptionMessage) swiper.a11y.addElRoleDescription((0, $ac668c36e81824b6$export$2e2bcd8739ae039)(swiper.slides), params.itemRoleDescriptionMessage);
        swiper.a11y.addElRole((0, $ac668c36e81824b6$export$2e2bcd8739ae039)(swiper.slides), params.slideRole);
        var slidesLength = swiper.params.loop ? swiper.slides.filter(function(el) {
            return !el.classList.contains(swiper.params.slideDuplicateClass);
        }).length : swiper.slides.length;
        swiper.slides.each(function(slideEl, index) {
            var $slideEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(slideEl);
            var slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
            var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            swiper.a11y.addElLabel($slideEl, ariaLabelMessage);
        }); // Navigation
        var $nextEl;
        var $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) {
            swiper.a11y.makeElFocusable($nextEl);
            if ($nextEl[0].tagName !== 'BUTTON') {
                swiper.a11y.addElRole($nextEl, 'button');
                $nextEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
            }
            swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
            swiper.a11y.addElControls($nextEl, wrapperId);
        }
        if ($prevEl && $prevEl.length) {
            swiper.a11y.makeElFocusable($prevEl);
            if ($prevEl[0].tagName !== 'BUTTON') {
                swiper.a11y.addElRole($prevEl, 'button');
                $prevEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
            }
            swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
            swiper.a11y.addElControls($prevEl, wrapperId);
        } // Pagination
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) swiper.pagination.$el.on('keydown', (0, $60eca45f20c21def$export$730a8e2ed4fdbe02)(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
    },
    destroy: function destroy() {
        var swiper = this;
        if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
        var $nextEl;
        var $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
         // Pagination
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) swiper.pagination.$el.off('keydown', (0, $60eca45f20c21def$export$730a8e2ed4fdbe02)(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
    }
};
var $d85fafb96bce04b2$export$2e2bcd8739ae039 = {
    name: 'a11y',
    params: {
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group'
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            a11y: $d85fafb96bce04b2$var$_extends({}, $d85fafb96bce04b2$var$A11y, {
                liveRegion: (0, $ac668c36e81824b6$export$2e2bcd8739ae039)("<span class=\"" + swiper.params.a11y.notificationClass + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")
            })
        });
    },
    on: {
        afterInit: function afterInit(swiper) {
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.init();
            swiper.a11y.updateNavigation();
        },
        toEdge: function toEdge(swiper) {
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.updateNavigation();
        },
        fromEdge: function fromEdge(swiper) {
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.updateNavigation();
        },
        paginationUpdate: function paginationUpdate(swiper) {
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.updatePagination();
        },
        destroy: function destroy(swiper) {
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.destroy();
        }
    }
};



var $98WL7 = parcelRequire("98WL7");

function $e91948ec80e04cf3$var$_extends() {
    $e91948ec80e04cf3$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e91948ec80e04cf3$var$_extends.apply(this, arguments);
}
var $e91948ec80e04cf3$var$History = {
    init: function init() {
        var swiper = this;
        var window = (0, $98WL7.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        var history = swiper.history;
        history.initialized = true;
        history.paths = $e91948ec80e04cf3$var$History.getPathValues(swiper.params.url);
        if (!history.paths.key && !history.paths.value) return;
        history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', swiper.history.setHistoryPopState);
    },
    destroy: function destroy() {
        var swiper = this;
        var window = (0, $98WL7.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', swiper.history.setHistoryPopState);
    },
    setHistoryPopState: function setHistoryPopState() {
        var swiper = this;
        swiper.history.paths = $e91948ec80e04cf3$var$History.getPathValues(swiper.params.url);
        swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function getPathValues(urlOverride) {
        var window = (0, $98WL7.getWindow)();
        var location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        var pathArray = location.pathname.slice(1).split('/').filter(function(part) {
            return part !== '';
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    },
    setHistory: function setHistory(key, index) {
        var swiper = this;
        var window = (0, $98WL7.getWindow)();
        if (!swiper.history.initialized || !swiper.params.history.enabled) return;
        var location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        var slide = swiper.slides.eq(index);
        var value = $e91948ec80e04cf3$var$History.slugify(slide.attr('data-history'));
        if (swiper.params.history.root.length > 0) {
            var root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = root + "/" + key + "/" + value;
        } else if (!location.pathname.includes(key)) value = key + "/" + value;
        var currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    },
    slugify: function slugify(text) {
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    },
    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
        var swiper = this;
        if (value) for(var i = 0, length = swiper.slides.length; i < length; i += 1){
            var slide = swiper.slides.eq(i);
            var slideHistory = $e91948ec80e04cf3$var$History.slugify(slide.attr('data-history'));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                var index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    }
};
var $e91948ec80e04cf3$export$2e2bcd8739ae039 = {
    name: 'history',
    params: {
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides'
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            history: $e91948ec80e04cf3$var$_extends({}, $e91948ec80e04cf3$var$History)
        });
    },
    on: {
        init: function init(swiper) {
            if (swiper.params.history.enabled) swiper.history.init();
        },
        destroy: function destroy(swiper) {
            if (swiper.params.history.enabled) swiper.history.destroy();
        },
        'transitionEnd _freeModeNoMomentumRelease': function transitionEnd_freeModeNoMomentumRelease(swiper) {
            if (swiper.history.initialized) swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        },
        slideChange: function slideChange(swiper) {
            if (swiper.history.initialized && swiper.params.cssMode) swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
    }
};



var $98WL7 = parcelRequire("98WL7");


function $45ec946dbd9db4b1$var$_extends() {
    $45ec946dbd9db4b1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $45ec946dbd9db4b1$var$_extends.apply(this, arguments);
}
var $45ec946dbd9db4b1$var$HashNavigation = {
    onHashChange: function onHashChange() {
        var swiper = this;
        var document = (0, $98WL7.getDocument)();
        swiper.emit('hashChange');
        var newHash = document.location.hash.replace('#', '');
        var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
        if (newHash !== activeSlideHash) {
            var newIndex = swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-hash=\"" + newHash + "\"]").index();
            if (typeof newIndex === 'undefined') return;
            swiper.slideTo(newIndex);
        }
    },
    setHash: function setHash() {
        var swiper = this;
        var window = (0, $98WL7.getWindow)();
        var document = (0, $98WL7.getDocument)();
        if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, "#" + swiper.slides.eq(swiper.activeIndex).attr('data-hash'));
            swiper.emit('hashSet');
        } else {
            var slide = swiper.slides.eq(swiper.activeIndex);
            var hash = slide.attr('data-hash') || slide.attr('data-history');
            document.location.hash = hash || '';
            swiper.emit('hashSet');
        }
    },
    init: function init() {
        var swiper = this;
        var document = (0, $98WL7.getDocument)();
        var window = (0, $98WL7.getWindow)();
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        swiper.hashNavigation.initialized = true;
        var hash = document.location.hash.replace('#', '');
        if (hash) {
            var speed = 0;
            for(var i = 0, length = swiper.slides.length; i < length; i += 1){
                var slide = swiper.slides.eq(i);
                var slideHash = slide.attr('data-hash') || slide.attr('data-history');
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    var index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(window).on('hashchange', swiper.hashNavigation.onHashChange);
    },
    destroy: function destroy() {
        var swiper = this;
        var window = (0, $98WL7.getWindow)();
        if (swiper.params.hashNavigation.watchState) (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(window).off('hashchange', swiper.hashNavigation.onHashChange);
    }
};
var $45ec946dbd9db4b1$export$2e2bcd8739ae039 = {
    name: 'hash-navigation',
    params: {
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            hashNavigation: $45ec946dbd9db4b1$var$_extends({
                initialized: false
            }, $45ec946dbd9db4b1$var$HashNavigation)
        });
    },
    on: {
        init: function init(swiper) {
            if (swiper.params.hashNavigation.enabled) swiper.hashNavigation.init();
        },
        destroy: function destroy(swiper) {
            if (swiper.params.hashNavigation.enabled) swiper.hashNavigation.destroy();
        },
        'transitionEnd _freeModeNoMomentumRelease': function transitionEnd_freeModeNoMomentumRelease(swiper) {
            if (swiper.hashNavigation.initialized) swiper.hashNavigation.setHash();
        },
        slideChange: function slideChange(swiper) {
            if (swiper.hashNavigation.initialized && swiper.params.cssMode) swiper.hashNavigation.setHash();
        }
    }
};



var $98WL7 = parcelRequire("98WL7");

function $eafe0ff7d0b92efd$var$_extends() {
    $eafe0ff7d0b92efd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eafe0ff7d0b92efd$var$_extends.apply(this, arguments);
}
var $eafe0ff7d0b92efd$var$Autoplay = {
    run: function run() {
        var swiper = this;
        var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        var delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr('data-swiper-autoplay')) delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = (0, $60eca45f20c21def$export$bdd553fddd433dcb)(function() {
            var autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    swiper.emit('autoplay');
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    swiper.emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    swiper.emit('autoplay');
                } else swiper.autoplay.stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                swiper.emit('autoplay');
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                swiper.emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                swiper.emit('autoplay');
            } else swiper.autoplay.stop();
            if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();
            else if (autoplayResult === false) swiper.autoplay.run();
        }, delay);
    },
    start: function start() {
        var swiper = this;
        if (typeof swiper.autoplay.timeout !== 'undefined') return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        swiper.emit('autoplayStart');
        swiper.autoplay.run();
        return true;
    },
    stop: function stop() {
        var swiper = this;
        if (!swiper.autoplay.running) return false;
        if (typeof swiper.autoplay.timeout === 'undefined') return false;
        if (swiper.autoplay.timeout) {
            clearTimeout(swiper.autoplay.timeout);
            swiper.autoplay.timeout = undefined;
        }
        swiper.autoplay.running = false;
        swiper.emit('autoplayStop');
        return true;
    },
    pause: function pause(speed) {
        var swiper = this;
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            swiper.autoplay.run();
        } else [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach(function(event) {
            swiper.$wrapperEl[0].addEventListener(event, swiper.autoplay.onTransitionEnd);
        });
    },
    onVisibilityChange: function onVisibilityChange() {
        var swiper = this;
        var document = (0, $98WL7.getDocument)();
        if (document.visibilityState === 'hidden' && swiper.autoplay.running) swiper.autoplay.pause();
        if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
            swiper.autoplay.run();
            swiper.autoplay.paused = false;
        }
    },
    onTransitionEnd: function onTransitionEnd(e) {
        var swiper = this;
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach(function(event) {
            swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) swiper.autoplay.stop();
        else swiper.autoplay.run();
    },
    onMouseEnter: function onMouseEnter() {
        var swiper = this;
        if (swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
        else swiper.autoplay.pause();
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach(function(event) {
            swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
        });
    },
    onMouseLeave: function onMouseLeave() {
        var swiper = this;
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
    },
    attachMouseEvents: function attachMouseEvents() {
        var swiper = this;
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on('mouseenter', swiper.autoplay.onMouseEnter);
            swiper.$el.on('mouseleave', swiper.autoplay.onMouseLeave);
        }
    },
    detachMouseEvents: function detachMouseEvents() {
        var swiper = this;
        swiper.$el.off('mouseenter', swiper.autoplay.onMouseEnter);
        swiper.$el.off('mouseleave', swiper.autoplay.onMouseLeave);
    }
};
var $eafe0ff7d0b92efd$export$2e2bcd8739ae039 = {
    name: 'autoplay',
    params: {
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            autoplay: $eafe0ff7d0b92efd$var$_extends({}, $eafe0ff7d0b92efd$var$Autoplay, {
                running: false,
                paused: false
            })
        });
    },
    on: {
        init: function init(swiper) {
            if (swiper.params.autoplay.enabled) {
                swiper.autoplay.start();
                var document = (0, $98WL7.getDocument)();
                document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
                swiper.autoplay.attachMouseEvents();
            }
        },
        beforeTransitionStart: function beforeTransitionStart(swiper, speed, internal) {
            if (swiper.autoplay.running) {
                if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
                else swiper.autoplay.stop();
            }
        },
        sliderFirstMove: function sliderFirstMove(swiper) {
            if (swiper.autoplay.running) {
                if (swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                else swiper.autoplay.pause();
            }
        },
        touchEnd: function touchEnd(swiper) {
            if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.run();
        },
        destroy: function destroy(swiper) {
            swiper.autoplay.detachMouseEvents();
            if (swiper.autoplay.running) swiper.autoplay.stop();
            var document = (0, $98WL7.getDocument)();
            document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
        }
    }
};



function $ad586113ad689382$var$_extends() {
    $ad586113ad689382$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ad586113ad689382$var$_extends.apply(this, arguments);
}
var $ad586113ad689382$var$Fade = {
    setTranslate: function setTranslate() {
        var swiper = this;
        var slides = swiper.slides;
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = swiper.slides.eq(i);
            var offset = $slideEl[0].swiperSlideOffset;
            var tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            $slideEl.css({
                opacity: slideOpacity
            }).transform("translate3d(" + tx + "px, " + ty + "px, 0px)");
        }
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        var slides = swiper.slides, $wrapperEl = swiper.$wrapperEl;
        slides.transition(duration);
        if (swiper.params.virtualTranslate && duration !== 0) {
            var eventTriggered = false;
            slides.transitionEnd(function() {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                var triggerEvents = [
                    'webkitTransitionEnd',
                    'transitionend'
                ];
                for(var i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
            });
        }
    }
};
var $ad586113ad689382$export$2e2bcd8739ae039 = {
    name: 'effect-fade',
    params: {
        fadeEffect: {
            crossFade: false
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            fadeEffect: $ad586113ad689382$var$_extends({}, $ad586113ad689382$var$Fade)
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            if (swiper.params.effect !== 'fade') return;
            swiper.classNames.push(swiper.params.containerModifierClass + "fade");
            var overwriteParams = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: true
            };
            (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper.params, overwriteParams);
            (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate(swiper) {
            if (swiper.params.effect !== 'fade') return;
            swiper.fadeEffect.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
            if (swiper.params.effect !== 'fade') return;
            swiper.fadeEffect.setTransition(duration);
        }
    }
};




function $5cf8d3e6903b5902$var$_extends() {
    $5cf8d3e6903b5902$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5cf8d3e6903b5902$var$_extends.apply(this, arguments);
}
var $5cf8d3e6903b5902$var$Cube = {
    setTranslate: function setTranslate() {
        var swiper = this;
        var $el = swiper.$el, $wrapperEl = swiper.$wrapperEl, slides = swiper.slides, swiperWidth = swiper.width, swiperHeight = swiper.height, rtl = swiper.rtlTranslate, swiperSize = swiper.size, browser = swiper.browser;
        var params = swiper.params.cubeEffect;
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var wrapperRotate = 0;
        var $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: swiperWidth + "px"
                });
            } else {
                $cubeShadowEl = $el.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = slides.eq(i);
            var slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
            var slideAngle = slideIndex * 90;
            var round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            var tx = 0;
            var ty = 0;
            var tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) {
                // Set shadows
                var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if (shadowBefore.length === 0) {
                    shadowBefore = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
                    $slideEl.append(shadowBefore);
                }
                if (shadowAfter.length === 0) {
                    shadowAfter = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
                    $slideEl.append(shadowAfter);
                }
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
        }
        $wrapperEl.css({
            '-webkit-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
            '-moz-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
            '-ms-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
            'transform-origin': "50% 50% -" + swiperSize / 2 + "px"
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform("translate3d(0px, " + (swiperWidth / 2 + params.shadowOffset) + "px, " + -swiperWidth / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + params.shadowScale + ")");
            else {
                var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                var scale1 = params.shadowScale;
                var scale2 = params.shadowScale / multiplier;
                var offset = params.shadowOffset;
                $cubeShadowEl.transform("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + (swiperHeight / 2 + offset) + "px, " + -swiperHeight / 2 / scale2 + "px) rotateX(-90deg)");
            }
        }
        var zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)");
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        var $el = swiper.$el, slides = swiper.slides;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find('.swiper-cube-shadow').transition(duration);
    }
};
var $5cf8d3e6903b5902$export$2e2bcd8739ae039 = {
    name: 'effect-cube',
    params: {
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            cubeEffect: $5cf8d3e6903b5902$var$_extends({}, $5cf8d3e6903b5902$var$Cube)
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            if (swiper.params.effect !== 'cube') return;
            swiper.classNames.push(swiper.params.containerModifierClass + "cube");
            swiper.classNames.push(swiper.params.containerModifierClass + "3d");
            var overwriteParams = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            };
            (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper.params, overwriteParams);
            (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate(swiper) {
            if (swiper.params.effect !== 'cube') return;
            swiper.cubeEffect.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
            if (swiper.params.effect !== 'cube') return;
            swiper.cubeEffect.setTransition(duration);
        }
    }
};




function $ff792005d30c1a28$var$_extends() {
    $ff792005d30c1a28$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ff792005d30c1a28$var$_extends.apply(this, arguments);
}
var $ff792005d30c1a28$var$Flip = {
    setTranslate: function setTranslate() {
        var swiper = this;
        var slides = swiper.slides, rtl = swiper.rtlTranslate;
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = slides.eq(i);
            var progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            var offset = $slideEl[0].swiperSlideOffset;
            var rotate = -180 * progress;
            var rotateY = rotate;
            var rotateX = 0;
            var tx = -offset;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (swiper.params.flipEffect.slideShadows) {
                // Set shadows
                var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if (shadowBefore.length === 0) {
                    shadowBefore = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>");
                    $slideEl.append(shadowBefore);
                }
                if (shadowAfter.length === 0) {
                    shadowAfter = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>");
                    $slideEl.append(shadowAfter);
                }
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
            $slideEl.transform("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)");
        }
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        var slides = swiper.slides, activeIndex = swiper.activeIndex, $wrapperEl = swiper.$wrapperEl;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        if (swiper.params.virtualTranslate && duration !== 0) {
            var eventTriggered = false; // eslint-disable-next-line
            slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return; // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
                eventTriggered = true;
                swiper.animating = false;
                var triggerEvents = [
                    'webkitTransitionEnd',
                    'transitionend'
                ];
                for(var i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
            });
        }
    }
};
var $ff792005d30c1a28$export$2e2bcd8739ae039 = {
    name: 'effect-flip',
    params: {
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            flipEffect: $ff792005d30c1a28$var$_extends({}, $ff792005d30c1a28$var$Flip)
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            if (swiper.params.effect !== 'flip') return;
            swiper.classNames.push(swiper.params.containerModifierClass + "flip");
            swiper.classNames.push(swiper.params.containerModifierClass + "3d");
            var overwriteParams = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: true
            };
            (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper.params, overwriteParams);
            (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate(swiper) {
            if (swiper.params.effect !== 'flip') return;
            swiper.flipEffect.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
            if (swiper.params.effect !== 'flip') return;
            swiper.flipEffect.setTransition(duration);
        }
    }
};




function $cd8d354de9a9f797$var$_extends() {
    $cd8d354de9a9f797$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cd8d354de9a9f797$var$_extends.apply(this, arguments);
}
var $cd8d354de9a9f797$var$Coverflow = {
    setTranslate: function setTranslate() {
        var swiper = this;
        var swiperWidth = swiper.width, swiperHeight = swiper.height, slides = swiper.slides, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.coverflowEffect;
        var isHorizontal = swiper.isHorizontal();
        var transform = swiper.translate;
        var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth; // Each slide offset from center
        for(var i = 0, length = slides.length; i < length; i += 1){
            var $slideEl = slides.eq(i);
            var slideSize = slidesSizesGrid[i];
            var slideOffset = $slideEl[0].swiperSlideOffset;
            var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
            var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            var translateZ = -translate * Math.abs(offsetMultiplier);
            var stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg) scale(" + scale + ")";
            $slideEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if ($shadowBeforeEl.length === 0) {
                    $shadowBeforeEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
                    $slideEl.append($shadowBeforeEl);
                }
                if ($shadowAfterEl.length === 0) {
                    $shadowAfterEl = (0, $ac668c36e81824b6$export$2e2bcd8739ae039)("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
                    $slideEl.append($shadowAfterEl);
                }
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    }
};
var $cd8d354de9a9f797$export$2e2bcd8739ae039 = {
    name: 'effect-coverflow',
    params: {
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            coverflowEffect: $cd8d354de9a9f797$var$_extends({}, $cd8d354de9a9f797$var$Coverflow)
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            if (swiper.params.effect !== 'coverflow') return;
            swiper.classNames.push(swiper.params.containerModifierClass + "coverflow");
            swiper.classNames.push(swiper.params.containerModifierClass + "3d");
            swiper.params.watchSlidesProgress = true;
            swiper.originalParams.watchSlidesProgress = true;
        },
        setTranslate: function setTranslate(swiper) {
            if (swiper.params.effect !== 'coverflow') return;
            swiper.coverflowEffect.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
            if (swiper.params.effect !== 'coverflow') return;
            swiper.coverflowEffect.setTransition(duration);
        }
    }
};




function $5a3f9fd480a9c6bc$var$_extends() {
    $5a3f9fd480a9c6bc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5a3f9fd480a9c6bc$var$_extends.apply(this, arguments);
}
var $5a3f9fd480a9c6bc$var$Thumbs = {
    init: function init() {
        var swiper = this;
        var thumbsParams = swiper.params.thumbs;
        if (swiper.thumbs.initialized) return false;
        swiper.thumbs.initialized = true;
        var SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            (0, $60eca45f20c21def$export$8b58be045bf06082)(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $60eca45f20c21def$export$a6cdc56e425d0d0a)(thumbsParams.swiper)) {
            swiper.thumbs.swiper = new SwiperClass((0, $60eca45f20c21def$export$8b58be045bf06082)({}, thumbsParams.swiper, {
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                slideToClickedSlide: false
            }));
            swiper.thumbs.swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
        return true;
    },
    onThumbClick: function onThumbClick() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $ac668c36e81824b6$export$2e2bcd8739ae039)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        var slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $ac668c36e81824b6$export$2e2bcd8739ae039)(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            var currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
            var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
            if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;
            else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    },
    update: function update(initial) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            var currentThumbsIndex = thumbsSwiper.activeIndex;
            var newThumbsIndex;
            var direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
                var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
                if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        } // Activate thumbs
        var thumbsToActivate = 1;
        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(var i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]").addClass(thumbActiveClass);
        else for(var _i = 0; _i < thumbsToActivate; _i += 1)thumbsSwiper.slides.eq(swiper.realIndex + _i).addClass(thumbActiveClass);
    }
};
var $5a3f9fd480a9c6bc$export$2e2bcd8739ae039 = {
    name: 'thumbs',
    params: {
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-container-thumbs'
        }
    },
    create: function create() {
        var swiper = this;
        (0, $60eca45f20c21def$export$d2651194ddf43b70)(swiper, {
            thumbs: $5a3f9fd480a9c6bc$var$_extends({
                swiper: null,
                initialized: false
            }, $5a3f9fd480a9c6bc$var$Thumbs)
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            var thumbs = swiper.params.thumbs;
            if (!thumbs || !thumbs.swiper) return;
            swiper.thumbs.init();
            swiper.thumbs.update(true);
        },
        slideChange: function slideChange(swiper) {
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        update: function update(swiper) {
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        resize: function resize(swiper) {
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        observerUpdate: function observerUpdate(swiper) {
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        setTransition: function setTransition(swiper, duration) {
            var thumbsSwiper = swiper.thumbs.swiper;
            if (!thumbsSwiper) return;
            thumbsSwiper.setTransition(duration);
        },
        beforeDestroy: function beforeDestroy(swiper) {
            var thumbsSwiper = swiper.thumbs.swiper;
            if (!thumbsSwiper) return;
            if (swiper.thumbs.swiperCreated && thumbsSwiper) thumbsSwiper.destroy();
        }
    }
};


// Swiper Class
var $2719ccccefb66d45$var$components = [
    (0, $fc81ef9e176d3984$export$2e2bcd8739ae039),
    (0, $1ae0142fa2584cda$export$2e2bcd8739ae039),
    (0, $21566fbb8143bce7$export$2e2bcd8739ae039),
    (0, $266d7e4421c66895$export$2e2bcd8739ae039),
    (0, $395037c38d99d7f5$export$2e2bcd8739ae039),
    (0, $8b0a9b5852cbd35d$export$2e2bcd8739ae039),
    (0, $9517801b1224dd76$export$2e2bcd8739ae039),
    (0, $56b0429f8636ab2c$export$2e2bcd8739ae039),
    (0, $958dffc4ffbac32e$export$2e2bcd8739ae039),
    (0, $350878292ecce477$export$2e2bcd8739ae039),
    (0, $d85fafb96bce04b2$export$2e2bcd8739ae039),
    (0, $e91948ec80e04cf3$export$2e2bcd8739ae039),
    (0, $45ec946dbd9db4b1$export$2e2bcd8739ae039),
    (0, $eafe0ff7d0b92efd$export$2e2bcd8739ae039),
    (0, $ad586113ad689382$export$2e2bcd8739ae039),
    (0, $5cf8d3e6903b5902$export$2e2bcd8739ae039),
    (0, $ff792005d30c1a28$export$2e2bcd8739ae039),
    (0, $cd8d354de9a9f797$export$2e2bcd8739ae039),
    (0, $5a3f9fd480a9c6bc$export$2e2bcd8739ae039)
];
(0, $99b1ac342f8dfa89$export$2e2bcd8739ae039).use($2719ccccefb66d45$var$components);


function $37e80ca29cd951d6$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $a9846c98c872cb75$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $37e80ca29cd951d6$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


var $9dfdb671d882e02b$exports = {};

var $j2WbH = parcelRequire("j2WbH");
/*! PhotoSwipe - v4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) define(factory);
    else $9dfdb671d882e02b$exports = factory();
})(undefined, function() {
    'use strict';
    var PhotoSwipe = function PhotoSwipe(template, UiClass, items, options) {
        /*>>framework-bridge*/ /**
 *
 * Set of generic functions used by gallery.
 * 
 * You're free to modify anything here as long as functionality is kept.
 * 
 */ var framework = {
            features: null,
            bind: function bind(target, type, listener, unbind) {
                var methodName = (unbind ? 'remove' : 'add') + 'EventListener';
                type = type.split(' ');
                for(var i = 0; i < type.length; i++)if (type[i]) target[methodName](type[i], listener, false);
            },
            isArray: function isArray(obj) {
                return obj instanceof Array;
            },
            createEl: function createEl(classes, tag) {
                var el = document.createElement(tag || 'div');
                if (classes) el.className = classes;
                return el;
            },
            getScrollY: function getScrollY() {
                var yOffset = window.pageYOffset;
                return yOffset !== undefined ? yOffset : document.documentElement.scrollTop;
            },
            unbind: function unbind(target, type, listener) {
                framework.bind(target, type, listener, true);
            },
            removeClass: function removeClass(el, className) {
                var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
                el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
            },
            addClass: function addClass(el, className) {
                if (!framework.hasClass(el, className)) el.className += (el.className ? ' ' : '') + className;
            },
            hasClass: function hasClass(el, className) {
                return el.className && new RegExp('(^|\\s)' + className + '(\\s|$)').test(el.className);
            },
            getChildByClass: function getChildByClass(parentEl, childClassName) {
                var node = parentEl.firstChild;
                while(node){
                    if (framework.hasClass(node, childClassName)) return node;
                    node = node.nextSibling;
                }
            },
            arraySearch: function arraySearch(array, value, key) {
                var i = array.length;
                while(i--){
                    if (array[i][key] === value) return i;
                }
                return -1;
            },
            extend: function extend(o1, o2, preventOverwrite) {
                for(var prop in o2)if (o2.hasOwnProperty(prop)) {
                    if (preventOverwrite && o1.hasOwnProperty(prop)) continue;
                    o1[prop] = o2[prop];
                }
            },
            easing: {
                sine: {
                    out: function out(k) {
                        return Math.sin(k * (Math.PI / 2));
                    },
                    inOut: function inOut(k) {
                        return -(Math.cos(Math.PI * k) - 1) / 2;
                    }
                },
                cubic: {
                    out: function out(k) {
                        return --k * k * k + 1;
                    }
                }
            },
            /**
	 * 
	 * @return {object}
	 * 
	 * {
	 *  raf : request animation frame function
	 *  caf : cancel animation frame function
	 *  transfrom : transform property key (with vendor), or null if not supported
	 *  oldIE : IE8 or below
	 * }
	 * 
	 */ detectFeatures: function detectFeatures() {
                if (framework.features) return framework.features;
                var helperEl = framework.createEl(), helperStyle = helperEl.style, vendor = '', features = {};
                // IE8 and below
                features.oldIE = document.all && !document.addEventListener;
                features.touch = 'ontouchstart' in window;
                if (window.requestAnimationFrame) {
                    features.raf = window.requestAnimationFrame;
                    features.caf = window.cancelAnimationFrame;
                }
                features.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled;
                // fix false-positive detection of old Android in new IE
                // (IE11 ua string contains "Android 4.0")
                if (!features.pointerEvent) {
                    var ua = navigator.userAgent;
                    // Detect if device is iPhone or iPod and if it's older than iOS 8
                    // http://stackoverflow.com/a/14223920
                    // 
                    // This detection is made because of buggy top/bottom toolbars
                    // that don't trigger window.resize event.
                    // For more info refer to _isFixedPosition variable in core.js
                    if (/iP(hone|od)/.test(navigator.platform)) {
                        var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                        if (v && v.length > 0) {
                            v = parseInt(v[1], 10);
                            if (v >= 1 && v < 8) features.isOldIOSPhone = true;
                        }
                    }
                    // Detect old Android (before KitKat)
                    // due to bugs related to position:fixed
                    // http://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript
                    var match = ua.match(/Android\s([0-9\.]*)/);
                    var androidversion = match ? match[1] : 0;
                    androidversion = parseFloat(androidversion);
                    if (androidversion >= 1) {
                        if (androidversion < 4.4) features.isOldAndroid = true; // for fixed position bug & performance
                        features.androidVersion = androidversion; // for touchend bug
                    }
                    features.isMobileOpera = /opera mini|opera mobi/i.test(ua);
                // p.s. yes, yes, UA sniffing is bad, propose your solution for above bugs.
                }
                var styleChecks = [
                    'transform',
                    'perspective',
                    'animationName'
                ], vendors = [
                    '',
                    'webkit',
                    'Moz',
                    'ms',
                    'O'
                ], styleCheckItem, styleName;
                for(var i = 0; i < 4; i++){
                    vendor = vendors[i];
                    for(var a = 0; a < 3; a++){
                        styleCheckItem = styleChecks[a];
                        // uppercase first letter of property name, if vendor is present
                        styleName = vendor + (vendor ? styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) : styleCheckItem);
                        if (!features[styleCheckItem] && styleName in helperStyle) features[styleCheckItem] = styleName;
                    }
                    if (vendor && !features.raf) {
                        vendor = vendor.toLowerCase();
                        features.raf = window[vendor + 'RequestAnimationFrame'];
                        if (features.raf) features.caf = window[vendor + 'CancelAnimationFrame'] || window[vendor + 'CancelRequestAnimationFrame'];
                    }
                }
                if (!features.raf) {
                    var lastTime = 0;
                    features.raf = function(fn) {
                        var currTime = new Date().getTime();
                        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                        var id = window.setTimeout(function() {
                            fn(currTime + timeToCall);
                        }, timeToCall);
                        lastTime = currTime + timeToCall;
                        return id;
                    };
                    features.caf = function(id) {
                        clearTimeout(id);
                    };
                }
                // Detect SVG support
                features.svg = !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;
                framework.features = features;
                return features;
            }
        };
        framework.detectFeatures();
        // Override addEventListener for old versions of IE
        if (framework.features.oldIE) framework.bind = function(target, type, listener, unbind) {
            type = type.split(' ');
            var methodName = (unbind ? 'detach' : 'attach') + 'Event', evName, _handleEv = function _handleEv() {
                listener.handleEvent.call(listener);
            };
            for(var i = 0; i < type.length; i++){
                evName = type[i];
                if (evName) {
                    if ((typeof listener === "undefined" ? "undefined" : (0, $j2WbH._)(listener)) === 'object' && listener.handleEvent) {
                        if (!unbind) listener['oldIE' + evName] = _handleEv;
                        else {
                            if (!listener['oldIE' + evName]) return false;
                        }
                        target[methodName]('on' + evName, listener['oldIE' + evName]);
                    } else target[methodName]('on' + evName, listener);
                }
            }
        };
        /*>>framework-bridge*/ /*>>core*/ //function(template, UiClass, items, options)
        var self = this;
        /**
 * Static vars, don't change unless you know what you're doing.
 */ var DOUBLE_TAP_RADIUS = 25, NUM_HOLDERS = 3;
        /**
 * Options
 */ var _options = {
            allowPanToNext: true,
            spacing: 0.12,
            bgOpacity: 1,
            mouseUsed: false,
            loop: true,
            pinchToClose: true,
            closeOnScroll: true,
            closeOnVerticalDrag: true,
            verticalDragRange: 0.75,
            hideAnimationDuration: 333,
            showAnimationDuration: 333,
            showHideOpacity: false,
            focus: true,
            escKey: true,
            arrowKeys: true,
            mainScrollEndFriction: 0.35,
            panEndFriction: 0.35,
            isClickableElement: function isClickableElement(el) {
                return el.tagName === 'A';
            },
            getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
                if (isMouseClick) return 1;
                else return item.initialZoomLevel < 0.7 ? 1 : 1.33;
            },
            maxSpreadZoom: 1.33,
            modal: true,
            // not fully implemented yet
            scaleMode: 'fit' // TODO
        };
        framework.extend(_options, options);
        /**
 * Private helper variables & functions
 */ var _getEmptyPoint = function _getEmptyPoint() {
            return {
                x: 0,
                y: 0
            };
        };
        var _isOpen, _isDestroying, _closedByScroll, _currentItemIndex, _containerStyle, _containerShiftIndex, _currPanDist = _getEmptyPoint(), _startPanOffset = _getEmptyPoint(), _panOffset = _getEmptyPoint(), _upMoveEvents, _downEvents, _globalEventHandlers, _viewportSize = {}, _currZoomLevel, _startZoomLevel, _translatePrefix, _translateSufix, _updateSizeInterval, _itemsNeedUpdate, _currPositionIndex = 0, _offset = {}, _slideSize = _getEmptyPoint(), _itemHolders, _prevItemIndex, _indexDiff = 0, _dragStartEvent, _dragMoveEvent, _dragEndEvent, _dragCancelEvent, _transformKey, _pointerEventEnabled, _isFixedPosition = true, _likelyTouchDevice, _modules = [], _requestAF, _cancelAF, _initalClassName, _initalWindowScrollY, _oldIE, _currentWindowScrollY, _features, _windowVisibleSize = {}, _renderMaxResolution = false, _orientationChangeTimeout, // Registers PhotoSWipe module (History, Controller ...)
        _registerModule = function _registerModule(name, module1) {
            framework.extend(self, module1.publicMethods);
            _modules.push(name);
        }, _getLoopedId = function _getLoopedId(index) {
            var numSlides = _getNumItems();
            if (index > numSlides - 1) return index - numSlides;
            else if (index < 0) return numSlides + index;
            return index;
        }, // Micro bind/trigger
        _listeners = {}, _listen = function _listen(name, fn) {
            if (!_listeners[name]) _listeners[name] = [];
            return _listeners[name].push(fn);
        }, _shout = function _shout(name) {
            var listeners = _listeners[name];
            if (listeners) {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                for(var i = 0; i < listeners.length; i++)listeners[i].apply(self, args);
            }
        }, _getCurrentTime = function _getCurrentTime() {
            return new Date().getTime();
        }, _applyBgOpacity = function _applyBgOpacity(opacity) {
            _bgOpacity = opacity;
            self.bg.style.opacity = opacity * _options.bgOpacity;
        }, _applyZoomTransform = function _applyZoomTransform(styleObj, x, y, zoom, item) {
            if (!_renderMaxResolution || item && item !== self.currItem) zoom = zoom / (item ? item.fitRatio : self.currItem.fitRatio);
            styleObj[_transformKey] = _translatePrefix + x + 'px, ' + y + 'px' + _translateSufix + ' scale(' + zoom + ')';
        }, _applyCurrentZoomPan = function _applyCurrentZoomPan(allowRenderResolution) {
            if (_currZoomElementStyle) {
                if (allowRenderResolution) {
                    if (_currZoomLevel > self.currItem.fitRatio) {
                        if (!_renderMaxResolution) {
                            _setImageSize(self.currItem, false, true);
                            _renderMaxResolution = true;
                        }
                    } else if (_renderMaxResolution) {
                        _setImageSize(self.currItem);
                        _renderMaxResolution = false;
                    }
                }
                _applyZoomTransform(_currZoomElementStyle, _panOffset.x, _panOffset.y, _currZoomLevel);
            }
        }, _applyZoomPanToItem = function _applyZoomPanToItem(item) {
            if (item.container) _applyZoomTransform(item.container.style, item.initialPosition.x, item.initialPosition.y, item.initialZoomLevel, item);
        }, _setTranslateX = function _setTranslateX(x, elStyle) {
            elStyle[_transformKey] = _translatePrefix + x + 'px, 0px' + _translateSufix;
        }, _moveMainScroll = function _moveMainScroll(x, dragging) {
            if (!_options.loop && dragging) {
                var newSlideIndexOffset = _currentItemIndex + (_slideSize.x * _currPositionIndex - x) / _slideSize.x, delta = Math.round(x - _mainScrollPos.x);
                if (newSlideIndexOffset < 0 && delta > 0 || newSlideIndexOffset >= _getNumItems() - 1 && delta < 0) x = _mainScrollPos.x + delta * _options.mainScrollEndFriction;
            }
            _mainScrollPos.x = x;
            _setTranslateX(x, _containerStyle);
        }, _calculatePanOffset = function _calculatePanOffset(axis, zoomLevel) {
            var m = _midZoomPoint[axis] - _offset[axis];
            return _startPanOffset[axis] + _currPanDist[axis] + m - m * (zoomLevel / _startZoomLevel);
        }, _equalizePoints = function _equalizePoints(p1, p2) {
            p1.x = p2.x;
            p1.y = p2.y;
            if (p2.id) p1.id = p2.id;
        }, _roundPoint = function _roundPoint(p) {
            p.x = Math.round(p.x);
            p.y = Math.round(p.y);
        }, _mouseMoveTimeout = null, _onFirstMouseMove = function _onFirstMouseMove1() {
            // Wait until mouse move event is fired at least twice during 100ms
            // We do this, because some mobile browsers trigger it on touchstart
            if (_mouseMoveTimeout) {
                framework.unbind(document, 'mousemove', _onFirstMouseMove);
                framework.addClass(template, 'pswp--has_mouse');
                _options.mouseUsed = true;
                _shout('mouseUsed');
            }
            _mouseMoveTimeout = setTimeout(function() {
                _mouseMoveTimeout = null;
            }, 100);
        }, _bindEvents = function _bindEvents() {
            framework.bind(document, 'keydown', self);
            if (_features.transform) // don't bind click event in browsers that don't support transform (mostly IE8)
            framework.bind(self.scrollWrap, 'click', self);
            if (!_options.mouseUsed) framework.bind(document, 'mousemove', _onFirstMouseMove);
            framework.bind(window, 'resize scroll orientationchange', self);
            _shout('bindEvents');
        }, _unbindEvents = function _unbindEvents() {
            framework.unbind(window, 'resize scroll orientationchange', self);
            framework.unbind(window, 'scroll', _globalEventHandlers.scroll);
            framework.unbind(document, 'keydown', self);
            framework.unbind(document, 'mousemove', _onFirstMouseMove);
            if (_features.transform) framework.unbind(self.scrollWrap, 'click', self);
            if (_isDragging) framework.unbind(window, _upMoveEvents, self);
            clearTimeout(_orientationChangeTimeout);
            _shout('unbindEvents');
        }, _calculatePanBounds = function _calculatePanBounds(zoomLevel, update) {
            var bounds = _calculateItemSize(self.currItem, _viewportSize, zoomLevel);
            if (update) _currPanBounds = bounds;
            return bounds;
        }, _getMinZoomLevel = function _getMinZoomLevel(item) {
            if (!item) item = self.currItem;
            return item.initialZoomLevel;
        }, _getMaxZoomLevel = function _getMaxZoomLevel(item) {
            if (!item) item = self.currItem;
            return item.w > 0 ? _options.maxSpreadZoom : 1;
        }, // Return true if offset is out of the bounds
        _modifyDestPanOffset = function _modifyDestPanOffset(axis, destPanBounds, destPanOffset, destZoomLevel) {
            if (destZoomLevel === self.currItem.initialZoomLevel) {
                destPanOffset[axis] = self.currItem.initialPosition[axis];
                return true;
            } else {
                destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel);
                if (destPanOffset[axis] > destPanBounds.min[axis]) {
                    destPanOffset[axis] = destPanBounds.min[axis];
                    return true;
                } else if (destPanOffset[axis] < destPanBounds.max[axis]) {
                    destPanOffset[axis] = destPanBounds.max[axis];
                    return true;
                }
            }
            return false;
        }, _setupTransforms = function _setupTransforms() {
            if (_transformKey) {
                // setup 3d transforms
                var allow3dTransform = _features.perspective && !_likelyTouchDevice;
                _translatePrefix = 'translate' + (allow3dTransform ? '3d(' : '(');
                _translateSufix = _features.perspective ? ', 0px)' : ')';
                return;
            }
            // Override zoom/pan/move functions in case old browser is used (most likely IE)
            // (so they use left/top/width/height, instead of CSS transform)
            _transformKey = 'left';
            framework.addClass(template, 'pswp--ie');
            _setTranslateX = function _setTranslateX(x, elStyle) {
                elStyle.left = x + 'px';
            };
            _applyZoomPanToItem = function _applyZoomPanToItem(item) {
                var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio, s = item.container.style, w = zoomRatio * item.w, h = zoomRatio * item.h;
                s.width = w + 'px';
                s.height = h + 'px';
                s.left = item.initialPosition.x + 'px';
                s.top = item.initialPosition.y + 'px';
            };
            _applyCurrentZoomPan = function _applyCurrentZoomPan() {
                if (_currZoomElementStyle) {
                    var s = _currZoomElementStyle, item = self.currItem, zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio, w = zoomRatio * item.w, h = zoomRatio * item.h;
                    s.width = w + 'px';
                    s.height = h + 'px';
                    s.left = _panOffset.x + 'px';
                    s.top = _panOffset.y + 'px';
                }
            };
        }, _onKeyDown = function _onKeyDown(e) {
            var keydownAction = '';
            if (_options.escKey && e.keyCode === 27) keydownAction = 'close';
            else if (_options.arrowKeys) {
                if (e.keyCode === 37) keydownAction = 'prev';
                else if (e.keyCode === 39) keydownAction = 'next';
            }
            if (keydownAction) // don't do anything if special key pressed to prevent from overriding default browser actions
            // e.g. in Chrome on Mac cmd+arrow-left returns to previous page
            {
                if (!e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                    self[keydownAction]();
                }
            }
        }, _onGlobalClick = function _onGlobalClick(e) {
            if (!e) return;
            // don't allow click event to pass through when triggering after drag or some other gesture
            if (_moved || _zoomStarted || _mainScrollAnimating || _verticalDragInitiated) {
                e.preventDefault();
                e.stopPropagation();
            }
        }, _updatePageScrollOffset = function _updatePageScrollOffset() {
            self.setScrollOffset(0, framework.getScrollY());
        };
        // Micro animation engine
        var _animations = {}, _numAnimations = 0, _stopAnimation = function _stopAnimation(name) {
            if (_animations[name]) {
                if (_animations[name].raf) _cancelAF(_animations[name].raf);
                _numAnimations--;
                delete _animations[name];
            }
        }, _registerStartAnimation = function _registerStartAnimation(name) {
            if (_animations[name]) _stopAnimation(name);
            if (!_animations[name]) {
                _numAnimations++;
                _animations[name] = {};
            }
        }, _stopAllAnimations = function _stopAllAnimations() {
            for(var prop in _animations)if (_animations.hasOwnProperty(prop)) _stopAnimation(prop);
        }, _animateProp = function _animateProp(name, b, endProp, d, easingFn, onUpdate, onComplete) {
            var startAnimTime = _getCurrentTime(), t;
            _registerStartAnimation(name);
            var animloop = function animloop1() {
                if (_animations[name]) {
                    t = _getCurrentTime() - startAnimTime; // time diff
                    //b - beginning (start prop)
                    //d - anim duration
                    if (t >= d) {
                        _stopAnimation(name);
                        onUpdate(endProp);
                        if (onComplete) onComplete();
                        return;
                    }
                    onUpdate((endProp - b) * easingFn(t / d) + b);
                    _animations[name].raf = _requestAF(animloop);
                }
            };
            animloop();
        };
        var publicMethods = {
            // make a few local variables and functions public
            shout: _shout,
            listen: _listen,
            viewportSize: _viewportSize,
            options: _options,
            isMainScrollAnimating: function isMainScrollAnimating() {
                return _mainScrollAnimating;
            },
            getZoomLevel: function getZoomLevel() {
                return _currZoomLevel;
            },
            getCurrentIndex: function getCurrentIndex() {
                return _currentItemIndex;
            },
            isDragging: function isDragging() {
                return _isDragging;
            },
            isZooming: function isZooming() {
                return _isZooming;
            },
            setScrollOffset: function setScrollOffset(x, y) {
                _offset.x = x;
                _currentWindowScrollY = _offset.y = y;
                _shout('updateScrollOffset', _offset);
            },
            applyZoomPan: function applyZoomPan(zoomLevel, panX, panY, allowRenderResolution) {
                _panOffset.x = panX;
                _panOffset.y = panY;
                _currZoomLevel = zoomLevel;
                _applyCurrentZoomPan(allowRenderResolution);
            },
            init: function init() {
                if (_isOpen || _isDestroying) return;
                var i;
                self.framework = framework; // basic functionality
                self.template = template; // root DOM element of PhotoSwipe
                self.bg = framework.getChildByClass(template, 'pswp__bg');
                _initalClassName = template.className;
                _isOpen = true;
                _features = framework.detectFeatures();
                _requestAF = _features.raf;
                _cancelAF = _features.caf;
                _transformKey = _features.transform;
                _oldIE = _features.oldIE;
                self.scrollWrap = framework.getChildByClass(template, 'pswp__scroll-wrap');
                self.container = framework.getChildByClass(self.scrollWrap, 'pswp__container');
                _containerStyle = self.container.style; // for fast access
                // Objects that hold slides (there are only 3 in DOM)
                self.itemHolders = _itemHolders = [
                    {
                        el: self.container.children[0],
                        wrap: 0,
                        index: -1
                    },
                    {
                        el: self.container.children[1],
                        wrap: 0,
                        index: -1
                    },
                    {
                        el: self.container.children[2],
                        wrap: 0,
                        index: -1
                    }
                ];
                // hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
                _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'none';
                _setupTransforms();
                // Setup global events
                _globalEventHandlers = {
                    resize: self.updateSize,
                    // Fixes: iOS 10.3 resize event
                    // does not update scrollWrap.clientWidth instantly after resize
                    // https://github.com/dimsemenov/PhotoSwipe/issues/1315
                    orientationchange: function orientationchange() {
                        clearTimeout(_orientationChangeTimeout);
                        _orientationChangeTimeout = setTimeout(function() {
                            if (_viewportSize.x !== self.scrollWrap.clientWidth) self.updateSize();
                        }, 500);
                    },
                    scroll: _updatePageScrollOffset,
                    keydown: _onKeyDown,
                    click: _onGlobalClick
                };
                // disable show/hide effects on old browsers that don't support CSS animations or transforms, 
                // old IOS, Android and Opera mobile. Blackberry seems to work fine, even older models.
                var oldPhone = _features.isOldIOSPhone || _features.isOldAndroid || _features.isMobileOpera;
                if (!_features.animationName || !_features.transform || oldPhone) _options.showAnimationDuration = _options.hideAnimationDuration = 0;
                // init modules
                for(i = 0; i < _modules.length; i++)self['init' + _modules[i]]();
                // init
                if (UiClass) {
                    var ui = self.ui = new UiClass(self, framework);
                    ui.init();
                }
                _shout('firstUpdate');
                _currentItemIndex = _currentItemIndex || _options.index || 0;
                // validate index
                if (isNaN(_currentItemIndex) || _currentItemIndex < 0 || _currentItemIndex >= _getNumItems()) _currentItemIndex = 0;
                self.currItem = _getItemAt(_currentItemIndex);
                if (_features.isOldIOSPhone || _features.isOldAndroid) _isFixedPosition = false;
                template.setAttribute('aria-hidden', 'false');
                if (_options.modal) {
                    if (!_isFixedPosition) {
                        template.style.position = 'absolute';
                        template.style.top = framework.getScrollY() + 'px';
                    } else template.style.position = 'fixed';
                }
                if (_currentWindowScrollY === undefined) {
                    _shout('initialLayout');
                    _currentWindowScrollY = _initalWindowScrollY = framework.getScrollY();
                }
                // add classes to root element of PhotoSwipe
                var rootClasses = 'pswp--open ';
                if (_options.mainClass) rootClasses += _options.mainClass + ' ';
                if (_options.showHideOpacity) rootClasses += 'pswp--animate_opacity ';
                rootClasses += _likelyTouchDevice ? 'pswp--touch' : 'pswp--notouch';
                rootClasses += _features.animationName ? ' pswp--css_animation' : '';
                rootClasses += _features.svg ? ' pswp--svg' : '';
                framework.addClass(template, rootClasses);
                self.updateSize();
                // initial update
                _containerShiftIndex = -1;
                _indexDiff = null;
                for(i = 0; i < NUM_HOLDERS; i++)_setTranslateX((i + _containerShiftIndex) * _slideSize.x, _itemHolders[i].el.style);
                if (!_oldIE) framework.bind(self.scrollWrap, _downEvents, self); // no dragging for old IE
                _listen('initialZoomInEnd', function() {
                    self.setContent(_itemHolders[0], _currentItemIndex - 1);
                    self.setContent(_itemHolders[2], _currentItemIndex + 1);
                    _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'block';
                    if (_options.focus) // focus causes layout, 
                    // which causes lag during the animation, 
                    // that's why we delay it untill the initial zoom transition ends
                    template.focus();
                    _bindEvents();
                });
                // set content for center slide (first time)
                self.setContent(_itemHolders[1], _currentItemIndex);
                self.updateCurrItem();
                _shout('afterInit');
                if (!_isFixedPosition) // On all versions of iOS lower than 8.0, we check size of viewport every second.
                // 
                // This is done to detect when Safari top & bottom bars appear, 
                // as this action doesn't trigger any events (like resize). 
                // 
                // On iOS8 they fixed this.
                // 
                // 10 Nov 2014: iOS 7 usage ~40%. iOS 8 usage 56%.
                _updateSizeInterval = setInterval(function() {
                    if (!_numAnimations && !_isDragging && !_isZooming && _currZoomLevel === self.currItem.initialZoomLevel) self.updateSize();
                }, 1000);
                framework.addClass(template, 'pswp--visible');
            },
            // Close the gallery, then destroy it
            close: function close() {
                if (!_isOpen) return;
                _isOpen = false;
                _isDestroying = true;
                _shout('close');
                _unbindEvents();
                _showOrHide(self.currItem, null, true, self.destroy);
            },
            // destroys the gallery (unbinds events, cleans up intervals and timeouts to avoid memory leaks)
            destroy: function destroy() {
                _shout('destroy');
                if (_showOrHideTimeout) clearTimeout(_showOrHideTimeout);
                template.setAttribute('aria-hidden', 'true');
                template.className = _initalClassName;
                if (_updateSizeInterval) clearInterval(_updateSizeInterval);
                framework.unbind(self.scrollWrap, _downEvents, self);
                // we unbind scroll event at the end, as closing animation may depend on it
                framework.unbind(window, 'scroll', self);
                _stopDragUpdateLoop();
                _stopAllAnimations();
                _listeners = null;
            },
            /**
	 * Pan image to position
	 * @param {Number} x     
	 * @param {Number} y     
	 * @param {Boolean} force Will ignore bounds if set to true.
	 */ panTo: function panTo(x, y, force) {
                if (!force) {
                    if (x > _currPanBounds.min.x) x = _currPanBounds.min.x;
                    else if (x < _currPanBounds.max.x) x = _currPanBounds.max.x;
                    if (y > _currPanBounds.min.y) y = _currPanBounds.min.y;
                    else if (y < _currPanBounds.max.y) y = _currPanBounds.max.y;
                }
                _panOffset.x = x;
                _panOffset.y = y;
                _applyCurrentZoomPan();
            },
            handleEvent: function handleEvent(e) {
                e = e || window.event;
                if (_globalEventHandlers[e.type]) _globalEventHandlers[e.type](e);
            },
            goTo: function goTo(index) {
                index = _getLoopedId(index);
                var diff = index - _currentItemIndex;
                _indexDiff = diff;
                _currentItemIndex = index;
                self.currItem = _getItemAt(_currentItemIndex);
                _currPositionIndex -= diff;
                _moveMainScroll(_slideSize.x * _currPositionIndex);
                _stopAllAnimations();
                _mainScrollAnimating = false;
                self.updateCurrItem();
            },
            next: function next() {
                self.goTo(_currentItemIndex + 1);
            },
            prev: function prev() {
                self.goTo(_currentItemIndex - 1);
            },
            // update current zoom/pan objects
            updateCurrZoomItem: function updateCurrZoomItem(emulateSetContent) {
                if (emulateSetContent) _shout('beforeChange', 0);
                // itemHolder[1] is middle (current) item
                if (_itemHolders[1].el.children.length) {
                    var zoomElement = _itemHolders[1].el.children[0];
                    if (framework.hasClass(zoomElement, 'pswp__zoom-wrap')) _currZoomElementStyle = zoomElement.style;
                    else _currZoomElementStyle = null;
                } else _currZoomElementStyle = null;
                _currPanBounds = self.currItem.bounds;
                _startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
                _panOffset.x = _currPanBounds.center.x;
                _panOffset.y = _currPanBounds.center.y;
                if (emulateSetContent) _shout('afterChange');
            },
            invalidateCurrItems: function invalidateCurrItems() {
                _itemsNeedUpdate = true;
                for(var i = 0; i < NUM_HOLDERS; i++)if (_itemHolders[i].item) _itemHolders[i].item.needsUpdate = true;
            },
            updateCurrItem: function updateCurrItem(beforeAnimation) {
                if (_indexDiff === 0) return;
                var diffAbs = Math.abs(_indexDiff), tempHolder;
                if (beforeAnimation && diffAbs < 2) return;
                self.currItem = _getItemAt(_currentItemIndex);
                _renderMaxResolution = false;
                _shout('beforeChange', _indexDiff);
                if (diffAbs >= NUM_HOLDERS) {
                    _containerShiftIndex += _indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS);
                    diffAbs = NUM_HOLDERS;
                }
                for(var i = 0; i < diffAbs; i++)if (_indexDiff > 0) {
                    tempHolder = _itemHolders.shift();
                    _itemHolders[NUM_HOLDERS - 1] = tempHolder; // move first to last
                    _containerShiftIndex++;
                    _setTranslateX((_containerShiftIndex + 2) * _slideSize.x, tempHolder.el.style);
                    self.setContent(tempHolder, _currentItemIndex - diffAbs + i + 1 + 1);
                } else {
                    tempHolder = _itemHolders.pop();
                    _itemHolders.unshift(tempHolder); // move last to first
                    _containerShiftIndex--;
                    _setTranslateX(_containerShiftIndex * _slideSize.x, tempHolder.el.style);
                    self.setContent(tempHolder, _currentItemIndex + diffAbs - i - 1 - 1);
                }
                // reset zoom/pan on previous item
                if (_currZoomElementStyle && Math.abs(_indexDiff) === 1) {
                    var prevItem = _getItemAt(_prevItemIndex);
                    if (prevItem.initialZoomLevel !== _currZoomLevel) {
                        _calculateItemSize(prevItem, _viewportSize);
                        _setImageSize(prevItem);
                        _applyZoomPanToItem(prevItem);
                    }
                }
                // reset diff after update
                _indexDiff = 0;
                self.updateCurrZoomItem();
                _prevItemIndex = _currentItemIndex;
                _shout('afterChange');
            },
            updateSize: function updateSize(force) {
                if (!_isFixedPosition && _options.modal) {
                    var windowScrollY = framework.getScrollY();
                    if (_currentWindowScrollY !== windowScrollY) {
                        template.style.top = windowScrollY + 'px';
                        _currentWindowScrollY = windowScrollY;
                    }
                    if (!force && _windowVisibleSize.x === window.innerWidth && _windowVisibleSize.y === window.innerHeight) return;
                    _windowVisibleSize.x = window.innerWidth;
                    _windowVisibleSize.y = window.innerHeight;
                    //template.style.width = _windowVisibleSize.x + 'px';
                    template.style.height = _windowVisibleSize.y + 'px';
                }
                _viewportSize.x = self.scrollWrap.clientWidth;
                _viewportSize.y = self.scrollWrap.clientHeight;
                _updatePageScrollOffset();
                _slideSize.x = _viewportSize.x + Math.round(_viewportSize.x * _options.spacing);
                _slideSize.y = _viewportSize.y;
                _moveMainScroll(_slideSize.x * _currPositionIndex);
                _shout('beforeResize'); // even may be used for example to switch image sources
                // don't re-calculate size on inital size update
                if (_containerShiftIndex !== undefined) {
                    var holder, item, hIndex;
                    for(var i = 0; i < NUM_HOLDERS; i++){
                        holder = _itemHolders[i];
                        _setTranslateX((i + _containerShiftIndex) * _slideSize.x, holder.el.style);
                        hIndex = _currentItemIndex + i - 1;
                        if (_options.loop && _getNumItems() > 2) hIndex = _getLoopedId(hIndex);
                        // update zoom level on items and refresh source (if needsUpdate)
                        item = _getItemAt(hIndex);
                        // re-render gallery item if `needsUpdate`,
                        // or doesn't have `bounds` (entirely new slide object)
                        if (item && (_itemsNeedUpdate || item.needsUpdate || !item.bounds)) {
                            self.cleanSlide(item);
                            self.setContent(holder, hIndex);
                            // if "center" slide
                            if (i === 1) {
                                self.currItem = item;
                                self.updateCurrZoomItem(true);
                            }
                            item.needsUpdate = false;
                        } else if (holder.index === -1 && hIndex >= 0) // add content first time
                        self.setContent(holder, hIndex);
                        if (item && item.container) {
                            _calculateItemSize(item, _viewportSize);
                            _setImageSize(item);
                            _applyZoomPanToItem(item);
                        }
                    }
                    _itemsNeedUpdate = false;
                }
                _startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
                _currPanBounds = self.currItem.bounds;
                if (_currPanBounds) {
                    _panOffset.x = _currPanBounds.center.x;
                    _panOffset.y = _currPanBounds.center.y;
                    _applyCurrentZoomPan(true);
                }
                _shout('resize');
            },
            // Zoom current item to
            zoomTo: function zoomTo(destZoomLevel, centerPoint, speed, easingFn, updateFn) {
                /*
			if(destZoomLevel === 'fit') {
				destZoomLevel = self.currItem.fitRatio;
			} else if(destZoomLevel === 'fill') {
				destZoomLevel = self.currItem.fillRatio;
			}
		*/ if (centerPoint) {
                    _startZoomLevel = _currZoomLevel;
                    _midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x;
                    _midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y;
                    _equalizePoints(_startPanOffset, _panOffset);
                }
                var destPanBounds = _calculatePanBounds(destZoomLevel, false), destPanOffset = {};
                _modifyDestPanOffset('x', destPanBounds, destPanOffset, destZoomLevel);
                _modifyDestPanOffset('y', destPanBounds, destPanOffset, destZoomLevel);
                var initialZoomLevel = _currZoomLevel;
                var initialPanOffset = {
                    x: _panOffset.x,
                    y: _panOffset.y
                };
                _roundPoint(destPanOffset);
                var onUpdate = function onUpdate(now) {
                    if (now === 1) {
                        _currZoomLevel = destZoomLevel;
                        _panOffset.x = destPanOffset.x;
                        _panOffset.y = destPanOffset.y;
                    } else {
                        _currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
                        _panOffset.x = (destPanOffset.x - initialPanOffset.x) * now + initialPanOffset.x;
                        _panOffset.y = (destPanOffset.y - initialPanOffset.y) * now + initialPanOffset.y;
                    }
                    if (updateFn) updateFn(now);
                    _applyCurrentZoomPan(now === 1);
                };
                if (speed) _animateProp('customZoomTo', 0, 1, speed, easingFn || framework.easing.sine.inOut, onUpdate);
                else onUpdate(1);
            }
        };
        /*>>core*/ /*>>gestures*/ /**
 * Mouse/touch/pointer event handlers.
 * 
 * separated from @core.js for readability
 */ var MIN_SWIPE_DISTANCE = 30, DIRECTION_CHECK_OFFSET = 10; // amount of pixels to drag to determine direction of swipe
        var _gestureStartTime, _gestureCheckSpeedTime, // pool of objects that are used during dragging of zooming
        p = {}, p2 = {}, delta = {}, _currPoint = {}, _startPoint = {}, _currPointers = [], _startMainScrollPos = {}, _releaseAnimData, _posPoints = [], _tempPoint = {}, _isZoomingIn, _verticalDragInitiated, _oldAndroidTouchEndTimeout, _currZoomedItemIndex = 0, _centerPoint = _getEmptyPoint(), _lastReleaseTime = 0, _isDragging, _isMultitouch, _zoomStarted, _moved, _dragAnimFrame, _mainScrollShifted, _currentPoints, _isZooming, _currPointsDistance, _startPointsDistance, _currPanBounds, _mainScrollPos = _getEmptyPoint(), _currZoomElementStyle, _mainScrollAnimating, _midZoomPoint = _getEmptyPoint(), _currCenterPoint = _getEmptyPoint(), _direction, _isFirstMove, _opacityChanged, _bgOpacity, _wasOverInitialZoom, _isEqualPoints = function _isEqualPoints(p1, p2) {
            return p1.x === p2.x && p1.y === p2.y;
        }, _isNearbyPoints = function _isNearbyPoints(touch0, touch1) {
            return Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS && Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS;
        }, _calculatePointsDistance = function _calculatePointsDistance(p1, p2) {
            _tempPoint.x = Math.abs(p1.x - p2.x);
            _tempPoint.y = Math.abs(p1.y - p2.y);
            return Math.sqrt(_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y);
        }, _stopDragUpdateLoop = function _stopDragUpdateLoop() {
            if (_dragAnimFrame) {
                _cancelAF(_dragAnimFrame);
                _dragAnimFrame = null;
            }
        }, _dragUpdateLoop = function _dragUpdateLoop1() {
            if (_isDragging) {
                _dragAnimFrame = _requestAF(_dragUpdateLoop);
                _renderMovement();
            }
        }, _canPan = function _canPan() {
            return !(_options.scaleMode === 'fit' && _currZoomLevel === self.currItem.initialZoomLevel);
        }, // find the closest parent DOM element
        _closestElement = function _closestElement1(el, fn) {
            if (!el || el === document) return false;
            // don't search elements above pswp__scroll-wrap
            if (el.getAttribute('class') && el.getAttribute('class').indexOf('pswp__scroll-wrap') > -1) return false;
            if (fn(el)) return el;
            return _closestElement(el.parentNode, fn);
        }, _preventObj = {}, _preventDefaultEventBehaviour = function _preventDefaultEventBehaviour(e, isDown) {
            _preventObj.prevent = !_closestElement(e.target, _options.isClickableElement);
            _shout('preventDragEvent', e, isDown, _preventObj);
            return _preventObj.prevent;
        }, _convertTouchToPoint = function _convertTouchToPoint(touch, p) {
            p.x = touch.pageX;
            p.y = touch.pageY;
            p.id = touch.identifier;
            return p;
        }, _findCenterOfPoints = function _findCenterOfPoints(p1, p2, pCenter) {
            pCenter.x = (p1.x + p2.x) * 0.5;
            pCenter.y = (p1.y + p2.y) * 0.5;
        }, _pushPosPoint = function _pushPosPoint(time, x, y) {
            if (time - _gestureCheckSpeedTime > 50) {
                var o = _posPoints.length > 2 ? _posPoints.shift() : {};
                o.x = x;
                o.y = y;
                _posPoints.push(o);
                _gestureCheckSpeedTime = time;
            }
        }, _calculateVerticalDragOpacityRatio = function _calculateVerticalDragOpacityRatio() {
            var yOffset = _panOffset.y - self.currItem.initialPosition.y; // difference between initial and current position
            return 1 - Math.abs(yOffset / (_viewportSize.y / 2));
        }, // points pool, reused during touch events
        _ePoint1 = {}, _ePoint2 = {}, _tempPointsArr = [], _tempCounter, _getTouchPoints = function _getTouchPoints(e) {
            // clean up previous points, without recreating array
            while(_tempPointsArr.length > 0)_tempPointsArr.pop();
            if (!_pointerEventEnabled) {
                if (e.type.indexOf('touch') > -1) {
                    if (e.touches && e.touches.length > 0) {
                        _tempPointsArr[0] = _convertTouchToPoint(e.touches[0], _ePoint1);
                        if (e.touches.length > 1) _tempPointsArr[1] = _convertTouchToPoint(e.touches[1], _ePoint2);
                    }
                } else {
                    _ePoint1.x = e.pageX;
                    _ePoint1.y = e.pageY;
                    _ePoint1.id = '';
                    _tempPointsArr[0] = _ePoint1; //_ePoint1;
                }
            } else {
                _tempCounter = 0;
                // we can use forEach, as pointer events are supported only in modern browsers
                _currPointers.forEach(function(p) {
                    if (_tempCounter === 0) _tempPointsArr[0] = p;
                    else if (_tempCounter === 1) _tempPointsArr[1] = p;
                    _tempCounter++;
                });
            }
            return _tempPointsArr;
        }, _panOrMoveMainScroll = function _panOrMoveMainScroll(axis, delta) {
            var panFriction, overDiff = 0, newOffset = _panOffset[axis] + delta[axis], startOverDiff, dir = delta[axis] > 0, newMainScrollPosition = _mainScrollPos.x + delta.x, mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x, newPanPos, newMainScrollPos;
            // calculate fdistance over the bounds and friction
            if (newOffset > _currPanBounds.min[axis] || newOffset < _currPanBounds.max[axis]) panFriction = _options.panEndFriction;
            else panFriction = 1;
            newOffset = _panOffset[axis] + delta[axis] * panFriction;
            // move main scroll or start panning
            if (_options.allowPanToNext || _currZoomLevel === self.currItem.initialZoomLevel) {
                if (!_currZoomElementStyle) newMainScrollPos = newMainScrollPosition;
                else if (_direction === 'h' && axis === 'x' && !_zoomStarted) {
                    if (dir) {
                        if (newOffset > _currPanBounds.min[axis]) {
                            panFriction = _options.panEndFriction;
                            overDiff = _currPanBounds.min[axis] - newOffset;
                            startOverDiff = _currPanBounds.min[axis] - _startPanOffset[axis];
                        }
                        // drag right
                        if ((startOverDiff <= 0 || mainScrollDiff < 0) && _getNumItems() > 1) {
                            newMainScrollPos = newMainScrollPosition;
                            if (mainScrollDiff < 0 && newMainScrollPosition > _startMainScrollPos.x) newMainScrollPos = _startMainScrollPos.x;
                        } else if (_currPanBounds.min.x !== _currPanBounds.max.x) newPanPos = newOffset;
                    } else {
                        if (newOffset < _currPanBounds.max[axis]) {
                            panFriction = _options.panEndFriction;
                            overDiff = newOffset - _currPanBounds.max[axis];
                            startOverDiff = _startPanOffset[axis] - _currPanBounds.max[axis];
                        }
                        if ((startOverDiff <= 0 || mainScrollDiff > 0) && _getNumItems() > 1) {
                            newMainScrollPos = newMainScrollPosition;
                            if (mainScrollDiff > 0 && newMainScrollPosition < _startMainScrollPos.x) newMainScrollPos = _startMainScrollPos.x;
                        } else if (_currPanBounds.min.x !== _currPanBounds.max.x) newPanPos = newOffset;
                    }
                }
                if (axis === 'x') {
                    if (newMainScrollPos !== undefined) {
                        _moveMainScroll(newMainScrollPos, true);
                        if (newMainScrollPos === _startMainScrollPos.x) _mainScrollShifted = false;
                        else _mainScrollShifted = true;
                    }
                    if (_currPanBounds.min.x !== _currPanBounds.max.x) {
                        if (newPanPos !== undefined) _panOffset.x = newPanPos;
                        else if (!_mainScrollShifted) _panOffset.x += delta.x * panFriction;
                    }
                    return newMainScrollPos !== undefined;
                }
            }
            if (!_mainScrollAnimating) {
                if (!_mainScrollShifted) {
                    if (_currZoomLevel > self.currItem.fitRatio) _panOffset[axis] += delta[axis] * panFriction;
                }
            }
        }, // Pointerdown/touchstart/mousedown handler
        _onDragStart = function _onDragStart(e) {
            // Allow dragging only via left mouse button.
            // As this handler is not added in IE8 - we ignore e.which
            // 
            // http://www.quirksmode.org/js/events_properties.html
            // https://developer.mozilla.org/en-US/docs/Web/API/event.button
            if (e.type === 'mousedown' && e.button > 0) return;
            if (_initialZoomRunning) {
                e.preventDefault();
                return;
            }
            if (_oldAndroidTouchEndTimeout && e.type === 'mousedown') return;
            if (_preventDefaultEventBehaviour(e, true)) e.preventDefault();
            _shout('pointerDown');
            if (_pointerEventEnabled) {
                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
                if (pointerIndex < 0) pointerIndex = _currPointers.length;
                _currPointers[pointerIndex] = {
                    x: e.pageX,
                    y: e.pageY,
                    id: e.pointerId
                };
            }
            var startPointsList = _getTouchPoints(e), numPoints = startPointsList.length;
            _currentPoints = null;
            _stopAllAnimations();
            // init drag
            if (!_isDragging || numPoints === 1) {
                _isDragging = _isFirstMove = true;
                framework.bind(window, _upMoveEvents, self);
                _isZoomingIn = _wasOverInitialZoom = _opacityChanged = _verticalDragInitiated = _mainScrollShifted = _moved = _isMultitouch = _zoomStarted = false;
                _direction = null;
                _shout('firstTouchStart', startPointsList);
                _equalizePoints(_startPanOffset, _panOffset);
                _currPanDist.x = _currPanDist.y = 0;
                _equalizePoints(_currPoint, startPointsList[0]);
                _equalizePoints(_startPoint, _currPoint);
                //_equalizePoints(_startMainScrollPos, _mainScrollPos);
                _startMainScrollPos.x = _slideSize.x * _currPositionIndex;
                _posPoints = [
                    {
                        x: _currPoint.x,
                        y: _currPoint.y
                    }
                ];
                _gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime();
                //_mainScrollAnimationEnd(true);
                _calculatePanBounds(_currZoomLevel, true);
                // Start rendering
                _stopDragUpdateLoop();
                _dragUpdateLoop();
            }
            // init zoom
            if (!_isZooming && numPoints > 1 && !_mainScrollAnimating && !_mainScrollShifted) {
                _startZoomLevel = _currZoomLevel;
                _zoomStarted = false; // true if zoom changed at least once
                _isZooming = _isMultitouch = true;
                _currPanDist.y = _currPanDist.x = 0;
                _equalizePoints(_startPanOffset, _panOffset);
                _equalizePoints(p, startPointsList[0]);
                _equalizePoints(p2, startPointsList[1]);
                _findCenterOfPoints(p, p2, _currCenterPoint);
                _midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x;
                _midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y;
                _currPointsDistance = _startPointsDistance = _calculatePointsDistance(p, p2);
            }
        }, // Pointermove/touchmove/mousemove handler
        _onDragMove = function _onDragMove(e) {
            e.preventDefault();
            if (_pointerEventEnabled) {
                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
                if (pointerIndex > -1) {
                    var p = _currPointers[pointerIndex];
                    p.x = e.pageX;
                    p.y = e.pageY;
                }
            }
            if (_isDragging) {
                var touchesList = _getTouchPoints(e);
                if (!_direction && !_moved && !_isZooming) {
                    if (_mainScrollPos.x !== _slideSize.x * _currPositionIndex) // if main scroll position is shifted – direction is always horizontal
                    _direction = 'h';
                    else {
                        var diff = Math.abs(touchesList[0].x - _currPoint.x) - Math.abs(touchesList[0].y - _currPoint.y);
                        // check the direction of movement
                        if (Math.abs(diff) >= DIRECTION_CHECK_OFFSET) {
                            _direction = diff > 0 ? 'h' : 'v';
                            _currentPoints = touchesList;
                        }
                    }
                } else _currentPoints = touchesList;
            }
        }, // 
        _renderMovement = function _renderMovement() {
            if (!_currentPoints) return;
            var numPoints = _currentPoints.length;
            if (numPoints === 0) return;
            _equalizePoints(p, _currentPoints[0]);
            delta.x = p.x - _currPoint.x;
            delta.y = p.y - _currPoint.y;
            if (_isZooming && numPoints > 1) {
                // Handle behaviour for more than 1 point
                _currPoint.x = p.x;
                _currPoint.y = p.y;
                // check if one of two points changed
                if (!delta.x && !delta.y && _isEqualPoints(_currentPoints[1], p2)) return;
                _equalizePoints(p2, _currentPoints[1]);
                if (!_zoomStarted) {
                    _zoomStarted = true;
                    _shout('zoomGestureStarted');
                }
                // Distance between two points
                var pointsDistance = _calculatePointsDistance(p, p2);
                var zoomLevel = _calculateZoomLevel(pointsDistance);
                // slightly over the of initial zoom level
                if (zoomLevel > self.currItem.initialZoomLevel + self.currItem.initialZoomLevel / 15) _wasOverInitialZoom = true;
                // Apply the friction if zoom level is out of the bounds
                var zoomFriction = 1, minZoomLevel = _getMinZoomLevel(), maxZoomLevel = _getMaxZoomLevel();
                if (zoomLevel < minZoomLevel) {
                    if (_options.pinchToClose && !_wasOverInitialZoom && _startZoomLevel <= self.currItem.initialZoomLevel) {
                        // fade out background if zooming out
                        var minusDiff = minZoomLevel - zoomLevel;
                        var percent = 1 - minusDiff / (minZoomLevel / 1.2);
                        _applyBgOpacity(percent);
                        _shout('onPinchClose', percent);
                        _opacityChanged = true;
                    } else {
                        zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel;
                        if (zoomFriction > 1) zoomFriction = 1;
                        zoomLevel = minZoomLevel - zoomFriction * (minZoomLevel / 3);
                    }
                } else if (zoomLevel > maxZoomLevel) {
                    // 1.5 - extra zoom level above the max. E.g. if max is x6, real max 6 + 1.5 = 7.5
                    zoomFriction = (zoomLevel - maxZoomLevel) / (minZoomLevel * 6);
                    if (zoomFriction > 1) zoomFriction = 1;
                    zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel;
                }
                if (zoomFriction < 0) zoomFriction = 0;
                // distance between touch points after friction is applied
                _currPointsDistance = pointsDistance;
                // _centerPoint - The point in the middle of two pointers
                _findCenterOfPoints(p, p2, _centerPoint);
                // paning with two pointers pressed
                _currPanDist.x += _centerPoint.x - _currCenterPoint.x;
                _currPanDist.y += _centerPoint.y - _currCenterPoint.y;
                _equalizePoints(_currCenterPoint, _centerPoint);
                _panOffset.x = _calculatePanOffset('x', zoomLevel);
                _panOffset.y = _calculatePanOffset('y', zoomLevel);
                _isZoomingIn = zoomLevel > _currZoomLevel;
                _currZoomLevel = zoomLevel;
                _applyCurrentZoomPan();
            } else {
                // handle behaviour for one point (dragging or panning)
                if (!_direction) return;
                if (_isFirstMove) {
                    _isFirstMove = false;
                    // subtract drag distance that was used during the detection direction  
                    if (Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET) delta.x -= _currentPoints[0].x - _startPoint.x;
                    if (Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET) delta.y -= _currentPoints[0].y - _startPoint.y;
                }
                _currPoint.x = p.x;
                _currPoint.y = p.y;
                // do nothing if pointers position hasn't changed
                if (delta.x === 0 && delta.y === 0) return;
                if (_direction === 'v' && _options.closeOnVerticalDrag) {
                    if (!_canPan()) {
                        _currPanDist.y += delta.y;
                        _panOffset.y += delta.y;
                        var opacityRatio = _calculateVerticalDragOpacityRatio();
                        _verticalDragInitiated = true;
                        _shout('onVerticalDrag', opacityRatio);
                        _applyBgOpacity(opacityRatio);
                        _applyCurrentZoomPan();
                        return;
                    }
                }
                _pushPosPoint(_getCurrentTime(), p.x, p.y);
                _moved = true;
                _currPanBounds = self.currItem.bounds;
                var mainScrollChanged = _panOrMoveMainScroll('x', delta);
                if (!mainScrollChanged) {
                    _panOrMoveMainScroll('y', delta);
                    _roundPoint(_panOffset);
                    _applyCurrentZoomPan();
                }
            }
        }, // Pointerup/pointercancel/touchend/touchcancel/mouseup event handler
        _onDragRelease = function _onDragRelease(e) {
            if (_features.isOldAndroid) {
                if (_oldAndroidTouchEndTimeout && e.type === 'mouseup') return;
                // on Android (v4.1, 4.2, 4.3 & possibly older) 
                // ghost mousedown/up event isn't preventable via e.preventDefault,
                // which causes fake mousedown event
                // so we block mousedown/up for 600ms
                if (e.type.indexOf('touch') > -1) {
                    clearTimeout(_oldAndroidTouchEndTimeout);
                    _oldAndroidTouchEndTimeout = setTimeout(function() {
                        _oldAndroidTouchEndTimeout = 0;
                    }, 600);
                }
            }
            _shout('pointerUp');
            if (_preventDefaultEventBehaviour(e, false)) e.preventDefault();
            var releasePoint;
            if (_pointerEventEnabled) {
                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
                if (pointerIndex > -1) {
                    releasePoint = _currPointers.splice(pointerIndex, 1)[0];
                    if (navigator.msPointerEnabled) {
                        var MSPOINTER_TYPES = {
                            4: 'mouse',
                            2: 'touch',
                            3: 'pen' // event.MSPOINTER_TYPE_PEN
                        };
                        releasePoint.type = MSPOINTER_TYPES[e.pointerType];
                        if (!releasePoint.type) releasePoint.type = e.pointerType || 'mouse';
                    } else releasePoint.type = e.pointerType || 'mouse';
                }
            }
            var touchList = _getTouchPoints(e), gestureType, numPoints = touchList.length;
            if (e.type === 'mouseup') numPoints = 0;
            // Do nothing if there were 3 touch points or more
            if (numPoints === 2) {
                _currentPoints = null;
                return true;
            }
            // if second pointer released
            if (numPoints === 1) _equalizePoints(_startPoint, touchList[0]);
            // pointer hasn't moved, send "tap release" point
            if (numPoints === 0 && !_direction && !_mainScrollAnimating) {
                if (!releasePoint) {
                    if (e.type === 'mouseup') releasePoint = {
                        x: e.pageX,
                        y: e.pageY,
                        type: 'mouse'
                    };
                    else if (e.changedTouches && e.changedTouches[0]) releasePoint = {
                        x: e.changedTouches[0].pageX,
                        y: e.changedTouches[0].pageY,
                        type: 'touch'
                    };
                }
                _shout('touchRelease', e, releasePoint);
            }
            // Difference in time between releasing of two last touch points (zoom gesture)
            var releaseTimeDiff = -1;
            // Gesture completed, no pointers left
            if (numPoints === 0) {
                _isDragging = false;
                framework.unbind(window, _upMoveEvents, self);
                _stopDragUpdateLoop();
                if (_isZooming) // Two points released at the same time
                releaseTimeDiff = 0;
                else if (_lastReleaseTime !== -1) releaseTimeDiff = _getCurrentTime() - _lastReleaseTime;
            }
            _lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1;
            if (releaseTimeDiff !== -1 && releaseTimeDiff < 150) gestureType = 'zoom';
            else gestureType = 'swipe';
            if (_isZooming && numPoints < 2) {
                _isZooming = false;
                // Only second point released
                if (numPoints === 1) gestureType = 'zoomPointerUp';
                _shout('zoomGestureEnded');
            }
            _currentPoints = null;
            if (!_moved && !_zoomStarted && !_mainScrollAnimating && !_verticalDragInitiated) // nothing to animate
            return;
            _stopAllAnimations();
            if (!_releaseAnimData) _releaseAnimData = _initDragReleaseAnimationData();
            _releaseAnimData.calculateSwipeSpeed('x');
            if (_verticalDragInitiated) {
                var opacityRatio = _calculateVerticalDragOpacityRatio();
                if (opacityRatio < _options.verticalDragRange) self.close();
                else {
                    var initalPanY = _panOffset.y, initialBgOpacity = _bgOpacity;
                    _animateProp('verticalDrag', 0, 1, 300, framework.easing.cubic.out, function(now) {
                        _panOffset.y = (self.currItem.initialPosition.y - initalPanY) * now + initalPanY;
                        _applyBgOpacity((1 - initialBgOpacity) * now + initialBgOpacity);
                        _applyCurrentZoomPan();
                    });
                    _shout('onVerticalDrag', 1);
                }
                return;
            }
            // main scroll 
            if ((_mainScrollShifted || _mainScrollAnimating) && numPoints === 0) {
                var itemChanged = _finishSwipeMainScrollGesture(gestureType, _releaseAnimData);
                if (itemChanged) return;
                gestureType = 'zoomPointerUp';
            }
            // prevent zoom/pan animation when main scroll animation runs
            if (_mainScrollAnimating) return;
            // Complete simple zoom gesture (reset zoom level if it's out of the bounds)  
            if (gestureType !== 'swipe') {
                _completeZoomGesture();
                return;
            }
            // Complete pan gesture if main scroll is not shifted, and it's possible to pan current image
            if (!_mainScrollShifted && _currZoomLevel > self.currItem.fitRatio) _completePanGesture(_releaseAnimData);
        }, // Returns object with data about gesture
        // It's created only once and then reused
        _initDragReleaseAnimationData = function _initDragReleaseAnimationData() {
            // temp local vars
            var lastFlickDuration, tempReleasePos;
            // s = this
            var s = {
                lastFlickOffset: {},
                lastFlickDist: {},
                lastFlickSpeed: {},
                slowDownRatio: {},
                slowDownRatioReverse: {},
                speedDecelerationRatio: {},
                speedDecelerationRatioAbs: {},
                distanceOffset: {},
                backAnimDestination: {},
                backAnimStarted: {},
                calculateSwipeSpeed: function calculateSwipeSpeed(axis) {
                    if (_posPoints.length > 1) {
                        lastFlickDuration = _getCurrentTime() - _gestureCheckSpeedTime + 50;
                        tempReleasePos = _posPoints[_posPoints.length - 2][axis];
                    } else {
                        lastFlickDuration = _getCurrentTime() - _gestureStartTime; // total gesture duration
                        tempReleasePos = _startPoint[axis];
                    }
                    s.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos;
                    s.lastFlickDist[axis] = Math.abs(s.lastFlickOffset[axis]);
                    if (s.lastFlickDist[axis] > 20) s.lastFlickSpeed[axis] = s.lastFlickOffset[axis] / lastFlickDuration;
                    else s.lastFlickSpeed[axis] = 0;
                    if (Math.abs(s.lastFlickSpeed[axis]) < 0.1) s.lastFlickSpeed[axis] = 0;
                    s.slowDownRatio[axis] = 0.95;
                    s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
                    s.speedDecelerationRatio[axis] = 1;
                },
                calculateOverBoundsAnimOffset: function calculateOverBoundsAnimOffset(axis, speed) {
                    if (!s.backAnimStarted[axis]) {
                        if (_panOffset[axis] > _currPanBounds.min[axis]) s.backAnimDestination[axis] = _currPanBounds.min[axis];
                        else if (_panOffset[axis] < _currPanBounds.max[axis]) s.backAnimDestination[axis] = _currPanBounds.max[axis];
                        if (s.backAnimDestination[axis] !== undefined) {
                            s.slowDownRatio[axis] = 0.7;
                            s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
                            if (s.speedDecelerationRatioAbs[axis] < 0.05) {
                                s.lastFlickSpeed[axis] = 0;
                                s.backAnimStarted[axis] = true;
                                _animateProp('bounceZoomPan' + axis, _panOffset[axis], s.backAnimDestination[axis], speed || 300, framework.easing.sine.out, function(pos) {
                                    _panOffset[axis] = pos;
                                    _applyCurrentZoomPan();
                                });
                            }
                        }
                    }
                },
                // Reduces the speed by slowDownRatio (per 10ms)
                calculateAnimOffset: function calculateAnimOffset(axis) {
                    if (!s.backAnimStarted[axis]) {
                        s.speedDecelerationRatio[axis] = s.speedDecelerationRatio[axis] * (s.slowDownRatio[axis] + s.slowDownRatioReverse[axis] - s.slowDownRatioReverse[axis] * s.timeDiff / 10);
                        s.speedDecelerationRatioAbs[axis] = Math.abs(s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis]);
                        s.distanceOffset[axis] = s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis] * s.timeDiff;
                        _panOffset[axis] += s.distanceOffset[axis];
                    }
                },
                panAnimLoop: function panAnimLoop() {
                    if (_animations.zoomPan) {
                        _animations.zoomPan.raf = _requestAF(s.panAnimLoop);
                        s.now = _getCurrentTime();
                        s.timeDiff = s.now - s.lastNow;
                        s.lastNow = s.now;
                        s.calculateAnimOffset('x');
                        s.calculateAnimOffset('y');
                        _applyCurrentZoomPan();
                        s.calculateOverBoundsAnimOffset('x');
                        s.calculateOverBoundsAnimOffset('y');
                        if (s.speedDecelerationRatioAbs.x < 0.05 && s.speedDecelerationRatioAbs.y < 0.05) {
                            // round pan position
                            _panOffset.x = Math.round(_panOffset.x);
                            _panOffset.y = Math.round(_panOffset.y);
                            _applyCurrentZoomPan();
                            _stopAnimation('zoomPan');
                            return;
                        }
                    }
                }
            };
            return s;
        }, _completePanGesture = function _completePanGesture(animData) {
            // calculate swipe speed for Y axis (paanning)
            animData.calculateSwipeSpeed('y');
            _currPanBounds = self.currItem.bounds;
            animData.backAnimDestination = {};
            animData.backAnimStarted = {};
            // Avoid acceleration animation if speed is too low
            if (Math.abs(animData.lastFlickSpeed.x) <= 0.05 && Math.abs(animData.lastFlickSpeed.y) <= 0.05) {
                animData.speedDecelerationRatioAbs.x = animData.speedDecelerationRatioAbs.y = 0;
                // Run pan drag release animation. E.g. if you drag image and release finger without momentum.
                animData.calculateOverBoundsAnimOffset('x');
                animData.calculateOverBoundsAnimOffset('y');
                return true;
            }
            // Animation loop that controls the acceleration after pan gesture ends
            _registerStartAnimation('zoomPan');
            animData.lastNow = _getCurrentTime();
            animData.panAnimLoop();
        }, _finishSwipeMainScrollGesture = function _finishSwipeMainScrollGesture(gestureType, _releaseAnimData) {
            var itemChanged;
            if (!_mainScrollAnimating) _currZoomedItemIndex = _currentItemIndex;
            var itemsDiff;
            if (gestureType === 'swipe') {
                var totalShiftDist = _currPoint.x - _startPoint.x, isFastLastFlick = _releaseAnimData.lastFlickDist.x < 10;
                // if container is shifted for more than MIN_SWIPE_DISTANCE, 
                // and last flick gesture was in right direction
                if (totalShiftDist > MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData.lastFlickOffset.x > 20)) // go to prev item
                itemsDiff = -1;
                else if (totalShiftDist < -MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData.lastFlickOffset.x < -20)) // go to next item
                itemsDiff = 1;
            }
            var nextCircle;
            if (itemsDiff) {
                _currentItemIndex += itemsDiff;
                if (_currentItemIndex < 0) {
                    _currentItemIndex = _options.loop ? _getNumItems() - 1 : 0;
                    nextCircle = true;
                } else if (_currentItemIndex >= _getNumItems()) {
                    _currentItemIndex = _options.loop ? 0 : _getNumItems() - 1;
                    nextCircle = true;
                }
                if (!nextCircle || _options.loop) {
                    _indexDiff += itemsDiff;
                    _currPositionIndex -= itemsDiff;
                    itemChanged = true;
                }
            }
            var animateToX = _slideSize.x * _currPositionIndex;
            var animateToDist = Math.abs(animateToX - _mainScrollPos.x);
            var finishAnimDuration;
            if (!itemChanged && animateToX > _mainScrollPos.x !== _releaseAnimData.lastFlickSpeed.x > 0) // "return to current" duration, e.g. when dragging from slide 0 to -1
            finishAnimDuration = 333;
            else {
                finishAnimDuration = Math.abs(_releaseAnimData.lastFlickSpeed.x) > 0 ? animateToDist / Math.abs(_releaseAnimData.lastFlickSpeed.x) : 333;
                finishAnimDuration = Math.min(finishAnimDuration, 400);
                finishAnimDuration = Math.max(finishAnimDuration, 250);
            }
            if (_currZoomedItemIndex === _currentItemIndex) itemChanged = false;
            _mainScrollAnimating = true;
            _shout('mainScrollAnimStart');
            _animateProp('mainScroll', _mainScrollPos.x, animateToX, finishAnimDuration, framework.easing.cubic.out, _moveMainScroll, function() {
                _stopAllAnimations();
                _mainScrollAnimating = false;
                _currZoomedItemIndex = -1;
                if (itemChanged || _currZoomedItemIndex !== _currentItemIndex) self.updateCurrItem();
                _shout('mainScrollAnimComplete');
            });
            if (itemChanged) self.updateCurrItem(true);
            return itemChanged;
        }, _calculateZoomLevel = function _calculateZoomLevel(touchesDistance) {
            return 1 / _startPointsDistance * touchesDistance * _startZoomLevel;
        }, // Resets zoom if it's out of bounds
        _completeZoomGesture = function _completeZoomGesture() {
            var destZoomLevel = _currZoomLevel, minZoomLevel = _getMinZoomLevel(), maxZoomLevel = _getMaxZoomLevel();
            if (_currZoomLevel < minZoomLevel) destZoomLevel = minZoomLevel;
            else if (_currZoomLevel > maxZoomLevel) destZoomLevel = maxZoomLevel;
            var destOpacity = 1, onUpdate, initialOpacity = _bgOpacity;
            if (_opacityChanged && !_isZoomingIn && !_wasOverInitialZoom && _currZoomLevel < minZoomLevel) {
                //_closedByScroll = true;
                self.close();
                return true;
            }
            if (_opacityChanged) onUpdate = function onUpdate(now) {
                _applyBgOpacity((destOpacity - initialOpacity) * now + initialOpacity);
            };
            self.zoomTo(destZoomLevel, 0, 200, framework.easing.cubic.out, onUpdate);
            return true;
        };
        _registerModule('Gestures', {
            publicMethods: {
                initGestures: function initGestures() {
                    // helper function that builds touch/pointer/mouse events
                    var addEventNames = function addEventNames(pref, down, move, up, cancel) {
                        _dragStartEvent = pref + down;
                        _dragMoveEvent = pref + move;
                        _dragEndEvent = pref + up;
                        if (cancel) _dragCancelEvent = pref + cancel;
                        else _dragCancelEvent = '';
                    };
                    _pointerEventEnabled = _features.pointerEvent;
                    if (_pointerEventEnabled && _features.touch) // we don't need touch events, if browser supports pointer events
                    _features.touch = false;
                    if (_pointerEventEnabled) {
                        if (navigator.msPointerEnabled) // IE10 pointer events are case-sensitive
                        addEventNames('MSPointer', 'Down', 'Move', 'Up', 'Cancel');
                        else addEventNames('pointer', 'down', 'move', 'up', 'cancel');
                    } else if (_features.touch) {
                        addEventNames('touch', 'start', 'move', 'end', 'cancel');
                        _likelyTouchDevice = true;
                    } else addEventNames('mouse', 'down', 'move', 'up');
                    _upMoveEvents = _dragMoveEvent + ' ' + _dragEndEvent + ' ' + _dragCancelEvent;
                    _downEvents = _dragStartEvent;
                    if (_pointerEventEnabled && !_likelyTouchDevice) _likelyTouchDevice = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1;
                    // make variable public
                    self.likelyTouchDevice = _likelyTouchDevice;
                    _globalEventHandlers[_dragStartEvent] = _onDragStart;
                    _globalEventHandlers[_dragMoveEvent] = _onDragMove;
                    _globalEventHandlers[_dragEndEvent] = _onDragRelease; // the Kraken
                    if (_dragCancelEvent) _globalEventHandlers[_dragCancelEvent] = _globalEventHandlers[_dragEndEvent];
                    // Bind mouse events on device with detected hardware touch support, in case it supports multiple types of input.
                    if (_features.touch) {
                        _downEvents += ' mousedown';
                        _upMoveEvents += ' mousemove mouseup';
                        _globalEventHandlers.mousedown = _globalEventHandlers[_dragStartEvent];
                        _globalEventHandlers.mousemove = _globalEventHandlers[_dragMoveEvent];
                        _globalEventHandlers.mouseup = _globalEventHandlers[_dragEndEvent];
                    }
                    if (!_likelyTouchDevice) // don't allow pan to next slide from zoomed state on Desktop
                    _options.allowPanToNext = false;
                }
            }
        });
        /*>>gestures*/ /*>>show-hide-transition*/ /**
 * show-hide-transition.js:
 *
 * Manages initial opening or closing transition.
 *
 * If you're not planning to use transition for gallery at all,
 * you may set options hideAnimationDuration and showAnimationDuration to 0,
 * and just delete startAnimation function.
 * 
 */ var _showOrHideTimeout, _showOrHide = function _showOrHide(item, img, out, completeFn) {
            if (_showOrHideTimeout) clearTimeout(_showOrHideTimeout);
            _initialZoomRunning = true;
            _initialContentSet = true;
            // dimensions of small thumbnail {x:,y:,w:}.
            // Height is optional, as calculated based on large image.
            var thumbBounds;
            if (item.initialLayout) {
                thumbBounds = item.initialLayout;
                item.initialLayout = null;
            } else thumbBounds = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
            var duration = out ? _options.hideAnimationDuration : _options.showAnimationDuration;
            var onComplete = function onComplete() {
                _stopAnimation('initialZoom');
                if (!out) {
                    _applyBgOpacity(1);
                    if (img) img.style.display = 'block';
                    framework.addClass(template, 'pswp--animated-in');
                    _shout('initialZoom' + (out ? 'OutEnd' : 'InEnd'));
                } else {
                    self.template.removeAttribute('style');
                    self.bg.removeAttribute('style');
                }
                if (completeFn) completeFn();
                _initialZoomRunning = false;
            };
            // if bounds aren't provided, just open gallery without animation
            if (!duration || !thumbBounds || thumbBounds.x === undefined) {
                _shout('initialZoom' + (out ? 'Out' : 'In'));
                _currZoomLevel = item.initialZoomLevel;
                _equalizePoints(_panOffset, item.initialPosition);
                _applyCurrentZoomPan();
                template.style.opacity = out ? 0 : 1;
                _applyBgOpacity(1);
                if (duration) setTimeout(function() {
                    onComplete();
                }, duration);
                else onComplete();
                return;
            }
            var startAnimation = function startAnimation() {
                var closeWithRaf = _closedByScroll, fadeEverything = !self.currItem.src || self.currItem.loadError || _options.showHideOpacity;
                // apply hw-acceleration to image
                if (item.miniImg) item.miniImg.style.webkitBackfaceVisibility = 'hidden';
                if (!out) {
                    _currZoomLevel = thumbBounds.w / item.w;
                    _panOffset.x = thumbBounds.x;
                    _panOffset.y = thumbBounds.y - _initalWindowScrollY;
                    self[fadeEverything ? 'template' : 'bg'].style.opacity = 0.001;
                    _applyCurrentZoomPan();
                }
                _registerStartAnimation('initialZoom');
                if (out && !closeWithRaf) framework.removeClass(template, 'pswp--animated-in');
                if (fadeEverything) {
                    if (out) framework[(closeWithRaf ? 'remove' : 'add') + 'Class'](template, 'pswp--animate_opacity');
                    else setTimeout(function() {
                        framework.addClass(template, 'pswp--animate_opacity');
                    }, 30);
                }
                _showOrHideTimeout = setTimeout(function() {
                    _shout('initialZoom' + (out ? 'Out' : 'In'));
                    if (!out) {
                        // "in" animation always uses CSS transitions (instead of rAF).
                        // CSS transition work faster here, 
                        // as developer may also want to animate other things, 
                        // like ui on top of sliding area, which can be animated just via CSS
                        _currZoomLevel = item.initialZoomLevel;
                        _equalizePoints(_panOffset, item.initialPosition);
                        _applyCurrentZoomPan();
                        _applyBgOpacity(1);
                        if (fadeEverything) template.style.opacity = 1;
                        else _applyBgOpacity(1);
                        _showOrHideTimeout = setTimeout(onComplete, duration + 20);
                    } else {
                        // "out" animation uses rAF only when PhotoSwipe is closed by browser scroll, to recalculate position
                        var destZoomLevel = thumbBounds.w / item.w, initialPanOffset = {
                            x: _panOffset.x,
                            y: _panOffset.y
                        }, initialZoomLevel = _currZoomLevel, initalBgOpacity = _bgOpacity, onUpdate = function onUpdate(now) {
                            if (now === 1) {
                                _currZoomLevel = destZoomLevel;
                                _panOffset.x = thumbBounds.x;
                                _panOffset.y = thumbBounds.y - _currentWindowScrollY;
                            } else {
                                _currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
                                _panOffset.x = (thumbBounds.x - initialPanOffset.x) * now + initialPanOffset.x;
                                _panOffset.y = (thumbBounds.y - _currentWindowScrollY - initialPanOffset.y) * now + initialPanOffset.y;
                            }
                            _applyCurrentZoomPan();
                            if (fadeEverything) template.style.opacity = 1 - now;
                            else _applyBgOpacity(initalBgOpacity - now * initalBgOpacity);
                        };
                        if (closeWithRaf) _animateProp('initialZoom', 0, 1, duration, framework.easing.cubic.out, onUpdate, onComplete);
                        else {
                            onUpdate(1);
                            _showOrHideTimeout = setTimeout(onComplete, duration + 20);
                        }
                    }
                }, out ? 25 : 90); // Main purpose of this delay is to give browser time to paint and
            // create composite layers of PhotoSwipe UI parts (background, controls, caption, arrows).
            // Which avoids lag at the beginning of scale transition.
            };
            startAnimation();
        };
        /*>>show-hide-transition*/ /*>>items-controller*/ /**
*
* Controller manages gallery items, their dimensions, and their content.
* 
*/ var _items, _tempPanAreaSize = {}, _imagesToAppendPool = [], _initialContentSet, _initialZoomRunning, _controllerDefaultOptions = {
            index: 0,
            errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
            forceProgressiveLoading: false,
            preload: [
                1,
                1
            ],
            getNumItemsFn: function getNumItemsFn() {
                return _items.length;
            }
        };
        var _getItemAt, _getNumItems, _initialIsLoop, _getZeroBounds = function _getZeroBounds() {
            return {
                center: {
                    x: 0,
                    y: 0
                },
                max: {
                    x: 0,
                    y: 0
                },
                min: {
                    x: 0,
                    y: 0
                }
            };
        }, _calculateSingleItemPanBounds = function _calculateSingleItemPanBounds(item, realPanElementW, realPanElementH) {
            var bounds = item.bounds;
            // position of element when it's centered
            bounds.center.x = Math.round((_tempPanAreaSize.x - realPanElementW) / 2);
            bounds.center.y = Math.round((_tempPanAreaSize.y - realPanElementH) / 2) + item.vGap.top;
            // maximum pan position
            bounds.max.x = realPanElementW > _tempPanAreaSize.x ? Math.round(_tempPanAreaSize.x - realPanElementW) : bounds.center.x;
            bounds.max.y = realPanElementH > _tempPanAreaSize.y ? Math.round(_tempPanAreaSize.y - realPanElementH) + item.vGap.top : bounds.center.y;
            // minimum pan position
            bounds.min.x = realPanElementW > _tempPanAreaSize.x ? 0 : bounds.center.x;
            bounds.min.y = realPanElementH > _tempPanAreaSize.y ? item.vGap.top : bounds.center.y;
        }, _calculateItemSize = function _calculateItemSize(item, viewportSize, zoomLevel) {
            if (item.src && !item.loadError) {
                var isInitial = !zoomLevel;
                if (isInitial) {
                    if (!item.vGap) item.vGap = {
                        top: 0,
                        bottom: 0
                    };
                    // allows overriding vertical margin for individual items
                    _shout('parseVerticalMargin', item);
                }
                _tempPanAreaSize.x = viewportSize.x;
                _tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom;
                if (isInitial) {
                    var hRatio = _tempPanAreaSize.x / item.w;
                    var vRatio = _tempPanAreaSize.y / item.h;
                    item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
                    //item.fillRatio = hRatio > vRatio ? hRatio : vRatio;
                    var scaleMode = _options.scaleMode;
                    if (scaleMode === 'orig') zoomLevel = 1;
                    else if (scaleMode === 'fit') zoomLevel = item.fitRatio;
                    if (zoomLevel > 1) zoomLevel = 1;
                    item.initialZoomLevel = zoomLevel;
                    if (!item.bounds) // reuse bounds object
                    item.bounds = _getZeroBounds();
                }
                if (!zoomLevel) return;
                _calculateSingleItemPanBounds(item, item.w * zoomLevel, item.h * zoomLevel);
                if (isInitial && zoomLevel === item.initialZoomLevel) item.initialPosition = item.bounds.center;
                return item.bounds;
            } else {
                item.w = item.h = 0;
                item.initialZoomLevel = item.fitRatio = 1;
                item.bounds = _getZeroBounds();
                item.initialPosition = item.bounds.center;
                // if it's not image, we return zero bounds (content is not zoomable)
                return item.bounds;
            }
        }, _appendImage = function _appendImage(index, item, baseDiv, img, preventAnimation, keepPlaceholder) {
            if (item.loadError) return;
            if (img) {
                item.imageAppended = true;
                _setImageSize(item, img, item === self.currItem && _renderMaxResolution);
                baseDiv.appendChild(img);
                if (keepPlaceholder) setTimeout(function() {
                    if (item && item.loaded && item.placeholder) {
                        item.placeholder.style.display = 'none';
                        item.placeholder = null;
                    }
                }, 500);
            }
        }, _preloadImage = function _preloadImage(item) {
            item.loading = true;
            item.loaded = false;
            var img = item.img = framework.createEl('pswp__img', 'img');
            var onComplete = function onComplete() {
                item.loading = false;
                item.loaded = true;
                if (item.loadComplete) item.loadComplete(item);
                else item.img = null; // no need to store image object
                img.onload = img.onerror = null;
                img = null;
            };
            img.onload = onComplete;
            img.onerror = function() {
                item.loadError = true;
                onComplete();
            };
            img.src = item.src; // + '?a=' + Math.random();
            return img;
        }, _checkForError = function _checkForError(item, cleanUp) {
            if (item.src && item.loadError && item.container) {
                if (cleanUp) item.container.innerHTML = '';
                item.container.innerHTML = _options.errorMsg.replace('%url%', item.src);
                return true;
            }
        }, _setImageSize = function _setImageSize(item, img, maxRes) {
            if (!item.src) return;
            if (!img) img = item.container.lastChild;
            var w = maxRes ? item.w : Math.round(item.w * item.fitRatio), h = maxRes ? item.h : Math.round(item.h * item.fitRatio);
            if (item.placeholder && !item.loaded) {
                item.placeholder.style.width = w + 'px';
                item.placeholder.style.height = h + 'px';
            }
            img.style.width = w + 'px';
            img.style.height = h + 'px';
        }, _appendImagesPool = function _appendImagesPool() {
            if (_imagesToAppendPool.length) {
                var poolItem;
                for(var i = 0; i < _imagesToAppendPool.length; i++){
                    poolItem = _imagesToAppendPool[i];
                    if (poolItem.holder.index === poolItem.index) _appendImage(poolItem.index, poolItem.item, poolItem.baseDiv, poolItem.img, false, poolItem.clearPlaceholder);
                }
                _imagesToAppendPool = [];
            }
        };
        _registerModule('Controller', {
            publicMethods: {
                lazyLoadItem: function lazyLoadItem(index) {
                    index = _getLoopedId(index);
                    var item = _getItemAt(index);
                    if (!item || (item.loaded || item.loading) && !_itemsNeedUpdate) return;
                    _shout('gettingData', index, item);
                    if (!item.src) return;
                    _preloadImage(item);
                },
                initController: function initController() {
                    framework.extend(_options, _controllerDefaultOptions, true);
                    self.items = _items = items;
                    _getItemAt = self.getItemAt;
                    _getNumItems = _options.getNumItemsFn; //self.getNumItems;
                    _initialIsLoop = _options.loop;
                    if (_getNumItems() < 3) _options.loop = false; // disable loop if less then 3 items
                    _listen('beforeChange', function(diff) {
                        var p = _options.preload, isNext = diff === null ? true : diff >= 0, preloadBefore = Math.min(p[0], _getNumItems()), preloadAfter = Math.min(p[1], _getNumItems()), i;
                        for(i = 1; i <= (isNext ? preloadAfter : preloadBefore); i++)self.lazyLoadItem(_currentItemIndex + i);
                        for(i = 1; i <= (isNext ? preloadBefore : preloadAfter); i++)self.lazyLoadItem(_currentItemIndex - i);
                    });
                    _listen('initialLayout', function() {
                        self.currItem.initialLayout = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
                    });
                    _listen('mainScrollAnimComplete', _appendImagesPool);
                    _listen('initialZoomInEnd', _appendImagesPool);
                    _listen('destroy', function() {
                        var item;
                        for(var i = 0; i < _items.length; i++){
                            item = _items[i];
                            // remove reference to DOM elements, for GC
                            if (item.container) item.container = null;
                            if (item.placeholder) item.placeholder = null;
                            if (item.img) item.img = null;
                            if (item.preloader) item.preloader = null;
                            if (item.loadError) item.loaded = item.loadError = false;
                        }
                        _imagesToAppendPool = null;
                    });
                },
                getItemAt: function getItemAt(index) {
                    if (index >= 0) return _items[index] !== undefined ? _items[index] : false;
                    return false;
                },
                allowProgressiveImg: function allowProgressiveImg() {
                    // 1. Progressive image loading isn't working on webkit/blink 
                    //    when hw-acceleration (e.g. translateZ) is applied to IMG element.
                    //    That's why in PhotoSwipe parent element gets zoom transform, not image itself.
                    //    
                    // 2. Progressive image loading sometimes blinks in webkit/blink when applying animation to parent element.
                    //    That's why it's disabled on touch devices (mainly because of swipe transition)
                    //    
                    // 3. Progressive image loading sometimes doesn't work in IE (up to 11).
                    // Don't allow progressive loading on non-large touch devices
                    return _options.forceProgressiveLoading || !_likelyTouchDevice || _options.mouseUsed || screen.width > 1200;
                // 1200 - to eliminate touch devices with large screen (like Chromebook Pixel)
                },
                setContent: function setContent(holder, index) {
                    if (_options.loop) index = _getLoopedId(index);
                    var prevItem = self.getItemAt(holder.index);
                    if (prevItem) prevItem.container = null;
                    var item = self.getItemAt(index), img;
                    if (!item) {
                        holder.el.innerHTML = '';
                        return;
                    }
                    // allow to override data
                    _shout('gettingData', index, item);
                    holder.index = index;
                    holder.item = item;
                    // base container DIV is created only once for each of 3 holders
                    var baseDiv = item.container = framework.createEl('pswp__zoom-wrap');
                    if (!item.src && item.html) {
                        if (item.html.tagName) baseDiv.appendChild(item.html);
                        else baseDiv.innerHTML = item.html;
                    }
                    _checkForError(item);
                    _calculateItemSize(item, _viewportSize);
                    if (item.src && !item.loadError && !item.loaded) {
                        item.loadComplete = function(item) {
                            // gallery closed before image finished loading
                            if (!_isOpen) return;
                            // check if holder hasn't changed while image was loading
                            if (holder && holder.index === index) {
                                if (_checkForError(item, true)) {
                                    item.loadComplete = item.img = null;
                                    _calculateItemSize(item, _viewportSize);
                                    _applyZoomPanToItem(item);
                                    if (holder.index === _currentItemIndex) // recalculate dimensions
                                    self.updateCurrZoomItem();
                                    return;
                                }
                                if (!item.imageAppended) {
                                    if (_features.transform && (_mainScrollAnimating || _initialZoomRunning)) _imagesToAppendPool.push({
                                        item: item,
                                        baseDiv: baseDiv,
                                        img: item.img,
                                        index: index,
                                        holder: holder,
                                        clearPlaceholder: true
                                    });
                                    else _appendImage(index, item, baseDiv, item.img, _mainScrollAnimating || _initialZoomRunning, true);
                                } else // remove preloader & mini-img
                                if (!_initialZoomRunning && item.placeholder) {
                                    item.placeholder.style.display = 'none';
                                    item.placeholder = null;
                                }
                            }
                            item.loadComplete = null;
                            item.img = null; // no need to store image element after it's added
                            _shout('imageLoadComplete', index, item);
                        };
                        if (framework.features.transform) {
                            var placeholderClassName = 'pswp__img pswp__img--placeholder';
                            placeholderClassName += item.msrc ? '' : ' pswp__img--placeholder--blank';
                            var placeholder = framework.createEl(placeholderClassName, item.msrc ? 'img' : '');
                            if (item.msrc) placeholder.src = item.msrc;
                            _setImageSize(item, placeholder);
                            baseDiv.appendChild(placeholder);
                            item.placeholder = placeholder;
                        }
                        if (!item.loading) _preloadImage(item);
                        if (self.allowProgressiveImg()) {
                            // just append image
                            if (!_initialContentSet && _features.transform) _imagesToAppendPool.push({
                                item: item,
                                baseDiv: baseDiv,
                                img: item.img,
                                index: index,
                                holder: holder
                            });
                            else _appendImage(index, item, baseDiv, item.img, true, true);
                        }
                    } else if (item.src && !item.loadError) {
                        // image object is created every time, due to bugs of image loading & delay when switching images
                        img = framework.createEl('pswp__img', 'img');
                        img.style.opacity = 1;
                        img.src = item.src;
                        _setImageSize(item, img);
                        _appendImage(index, item, baseDiv, img, true);
                    }
                    if (!_initialContentSet && index === _currentItemIndex) {
                        _currZoomElementStyle = baseDiv.style;
                        _showOrHide(item, img || item.img);
                    } else _applyZoomPanToItem(item);
                    holder.el.innerHTML = '';
                    holder.el.appendChild(baseDiv);
                },
                cleanSlide: function cleanSlide(item) {
                    if (item.img) item.img.onload = item.img.onerror = null;
                    item.loaded = item.loading = item.img = item.imageAppended = false;
                }
            }
        });
        /*>>items-controller*/ /*>>tap*/ /**
 * tap.js:
 *
 * Displatches tap and double-tap events.
 * 
 */ var tapTimer, tapReleasePoint = {}, _dispatchTapEvent = function _dispatchTapEvent(origEvent, releasePoint, pointerType) {
            var e = document.createEvent('CustomEvent'), eDetail = {
                origEvent: origEvent,
                target: origEvent.target,
                releasePoint: releasePoint,
                pointerType: pointerType || 'touch'
            };
            e.initCustomEvent('pswpTap', true, true, eDetail);
            origEvent.target.dispatchEvent(e);
        };
        _registerModule('Tap', {
            publicMethods: {
                initTap: function initTap() {
                    _listen('firstTouchStart', self.onTapStart);
                    _listen('touchRelease', self.onTapRelease);
                    _listen('destroy', function() {
                        tapReleasePoint = {};
                        tapTimer = null;
                    });
                },
                onTapStart: function onTapStart(touchList) {
                    if (touchList.length > 1) {
                        clearTimeout(tapTimer);
                        tapTimer = null;
                    }
                },
                onTapRelease: function onTapRelease(e, releasePoint) {
                    if (!releasePoint) return;
                    if (!_moved && !_isMultitouch && !_numAnimations) {
                        var p0 = releasePoint;
                        if (tapTimer) {
                            clearTimeout(tapTimer);
                            tapTimer = null;
                            // Check if taped on the same place
                            if (_isNearbyPoints(p0, tapReleasePoint)) {
                                _shout('doubleTap', p0);
                                return;
                            }
                        }
                        if (releasePoint.type === 'mouse') {
                            _dispatchTapEvent(e, releasePoint, 'mouse');
                            return;
                        }
                        var clickedTagName = e.target.tagName.toUpperCase();
                        // avoid double tap delay on buttons and elements that have class pswp__single-tap
                        if (clickedTagName === 'BUTTON' || framework.hasClass(e.target, 'pswp__single-tap')) {
                            _dispatchTapEvent(e, releasePoint);
                            return;
                        }
                        _equalizePoints(tapReleasePoint, p0);
                        tapTimer = setTimeout(function() {
                            _dispatchTapEvent(e, releasePoint);
                            tapTimer = null;
                        }, 300);
                    }
                }
            }
        });
        /*>>tap*/ /*>>desktop-zoom*/ /**
 *
 * desktop-zoom.js:
 *
 * - Binds mousewheel event for paning zoomed image.
 * - Manages "dragging", "zoomed-in", "zoom-out" classes.
 *   (which are used for cursors and zoom icon)
 * - Adds toggleDesktopZoom function.
 * 
 */ var _wheelDelta;
        _registerModule('DesktopZoom', {
            publicMethods: {
                initDesktopZoom: function initDesktopZoom() {
                    if (_oldIE) // no zoom for old IE (<=8)
                    return;
                    if (_likelyTouchDevice) // if detected hardware touch support, we wait until mouse is used,
                    // and only then apply desktop-zoom features
                    _listen('mouseUsed', function() {
                        self.setupDesktopZoom();
                    });
                    else self.setupDesktopZoom(true);
                },
                setupDesktopZoom: function setupDesktopZoom(onInit) {
                    _wheelDelta = {};
                    var events = 'wheel mousewheel DOMMouseScroll';
                    _listen('bindEvents', function() {
                        framework.bind(template, events, self.handleMouseWheel);
                    });
                    _listen('unbindEvents', function() {
                        if (_wheelDelta) framework.unbind(template, events, self.handleMouseWheel);
                    });
                    self.mouseZoomedIn = false;
                    var hasDraggingClass, updateZoomable = function updateZoomable() {
                        if (self.mouseZoomedIn) {
                            framework.removeClass(template, 'pswp--zoomed-in');
                            self.mouseZoomedIn = false;
                        }
                        if (_currZoomLevel < 1) framework.addClass(template, 'pswp--zoom-allowed');
                        else framework.removeClass(template, 'pswp--zoom-allowed');
                        removeDraggingClass();
                    }, removeDraggingClass = function removeDraggingClass() {
                        if (hasDraggingClass) {
                            framework.removeClass(template, 'pswp--dragging');
                            hasDraggingClass = false;
                        }
                    };
                    _listen('resize', updateZoomable);
                    _listen('afterChange', updateZoomable);
                    _listen('pointerDown', function() {
                        if (self.mouseZoomedIn) {
                            hasDraggingClass = true;
                            framework.addClass(template, 'pswp--dragging');
                        }
                    });
                    _listen('pointerUp', removeDraggingClass);
                    if (!onInit) updateZoomable();
                },
                handleMouseWheel: function handleMouseWheel(e) {
                    if (_currZoomLevel <= self.currItem.fitRatio) {
                        if (_options.modal) {
                            if (!_options.closeOnScroll || _numAnimations || _isDragging) e.preventDefault();
                            else if (_transformKey && Math.abs(e.deltaY) > 2) {
                                // close PhotoSwipe
                                // if browser supports transforms & scroll changed enough
                                _closedByScroll = true;
                                self.close();
                            }
                        }
                        return true;
                    }
                    // allow just one event to fire
                    e.stopPropagation();
                    // https://developer.mozilla.org/en-US/docs/Web/Events/wheel
                    _wheelDelta.x = 0;
                    if ('deltaX' in e) {
                        if (e.deltaMode === 1 /* DOM_DELTA_LINE */ ) {
                            // 18 - average line height
                            _wheelDelta.x = e.deltaX * 18;
                            _wheelDelta.y = e.deltaY * 18;
                        } else {
                            _wheelDelta.x = e.deltaX;
                            _wheelDelta.y = e.deltaY;
                        }
                    } else if ('wheelDelta' in e) {
                        if (e.wheelDeltaX) _wheelDelta.x = -0.16 * e.wheelDeltaX;
                        if (e.wheelDeltaY) _wheelDelta.y = -0.16 * e.wheelDeltaY;
                        else _wheelDelta.y = -0.16 * e.wheelDelta;
                    } else if ('detail' in e) _wheelDelta.y = e.detail;
                    else return;
                    _calculatePanBounds(_currZoomLevel, true);
                    var newPanX = _panOffset.x - _wheelDelta.x, newPanY = _panOffset.y - _wheelDelta.y;
                    // only prevent scrolling in nonmodal mode when not at edges
                    if (_options.modal || newPanX <= _currPanBounds.min.x && newPanX >= _currPanBounds.max.x && newPanY <= _currPanBounds.min.y && newPanY >= _currPanBounds.max.y) e.preventDefault();
                    // TODO: use rAF instead of mousewheel?
                    self.panTo(newPanX, newPanY);
                },
                toggleDesktopZoom: function toggleDesktopZoom(centerPoint) {
                    centerPoint = centerPoint || {
                        x: _viewportSize.x / 2 + _offset.x,
                        y: _viewportSize.y / 2 + _offset.y
                    };
                    var doubleTapZoomLevel = _options.getDoubleTapZoom(true, self.currItem);
                    var zoomOut = _currZoomLevel === doubleTapZoomLevel;
                    self.mouseZoomedIn = !zoomOut;
                    self.zoomTo(zoomOut ? self.currItem.initialZoomLevel : doubleTapZoomLevel, centerPoint, 333);
                    framework[(!zoomOut ? 'add' : 'remove') + 'Class'](template, 'pswp--zoomed-in');
                }
            }
        });
        /*>>desktop-zoom*/ /*>>history*/ /**
 *
 * history.js:
 *
 * - Back button to close gallery.
 * 
 * - Unique URL for each slide: example.com/&pid=1&gid=3
 *   (where PID is picture index, and GID and gallery index)
 *   
 * - Switch URL when slides change.
 * 
 */ var _historyDefaultOptions = {
            history: true,
            galleryUID: 1
        };
        var _historyUpdateTimeout, _hashChangeTimeout, _hashAnimCheckTimeout, _hashChangedByScript, _hashChangedByHistory, _hashReseted, _initialHash, _historyChanged, _closedFromURL, _urlChangedOnce, _windowLoc, _supportsPushState, _getHash = function _getHash() {
            return _windowLoc.hash.substring(1);
        }, _cleanHistoryTimeouts = function _cleanHistoryTimeouts() {
            if (_historyUpdateTimeout) clearTimeout(_historyUpdateTimeout);
            if (_hashAnimCheckTimeout) clearTimeout(_hashAnimCheckTimeout);
        }, // pid - Picture index
        // gid - Gallery index
        _parseItemIndexFromURL = function _parseItemIndexFromURL() {
            var hash = _getHash(), params = {};
            if (hash.length < 5) return params;
            var i, vars = hash.split('&');
            for(i = 0; i < vars.length; i++){
                if (!vars[i]) continue;
                var pair = vars[i].split('=');
                if (pair.length < 2) continue;
                params[pair[0]] = pair[1];
            }
            if (_options.galleryPIDs) {
                // detect custom pid in hash and search for it among the items collection
                var searchfor = params.pid;
                params.pid = 0; // if custom pid cannot be found, fallback to the first item
                for(i = 0; i < _items.length; i++)if (_items[i].pid === searchfor) {
                    params.pid = i;
                    break;
                }
            } else params.pid = parseInt(params.pid, 10) - 1;
            if (params.pid < 0) params.pid = 0;
            return params;
        }, _updateHash = function _updateHash1() {
            if (_hashAnimCheckTimeout) clearTimeout(_hashAnimCheckTimeout);
            if (_numAnimations || _isDragging) {
                // changing browser URL forces layout/paint in some browsers, which causes noticable lag during animation
                // that's why we update hash only when no animations running
                _hashAnimCheckTimeout = setTimeout(_updateHash, 500);
                return;
            }
            if (_hashChangedByScript) clearTimeout(_hashChangeTimeout);
            else _hashChangedByScript = true;
            var pid = _currentItemIndex + 1;
            var item = _getItemAt(_currentItemIndex);
            if (item.hasOwnProperty('pid')) // carry forward any custom pid assigned to the item
            pid = item.pid;
            var newHash = _initialHash + '&' + 'gid=' + _options.galleryUID + '&' + 'pid=' + pid;
            if (!_historyChanged) {
                if (_windowLoc.hash.indexOf(newHash) === -1) _urlChangedOnce = true;
            }
            var newURL = _windowLoc.href.split('#')[0] + '#' + newHash;
            if (_supportsPushState) {
                if ('#' + newHash !== window.location.hash) history[_historyChanged ? 'replaceState' : 'pushState']('', document.title, newURL);
            } else if (_historyChanged) _windowLoc.replace(newURL);
            else _windowLoc.hash = newHash;
            _historyChanged = true;
            _hashChangeTimeout = setTimeout(function() {
                _hashChangedByScript = false;
            }, 60);
        };
        _registerModule('History', {
            publicMethods: {
                initHistory: function initHistory() {
                    framework.extend(_options, _historyDefaultOptions, true);
                    if (!_options.history) return;
                    _windowLoc = window.location;
                    _urlChangedOnce = false;
                    _closedFromURL = false;
                    _historyChanged = false;
                    _initialHash = _getHash();
                    _supportsPushState = 'pushState' in history;
                    if (_initialHash.indexOf('gid=') > -1) {
                        _initialHash = _initialHash.split('&gid=')[0];
                        _initialHash = _initialHash.split('?gid=')[0];
                    }
                    _listen('afterChange', self.updateURL);
                    _listen('unbindEvents', function() {
                        framework.unbind(window, 'hashchange', self.onHashChange);
                    });
                    var returnToOriginal = function returnToOriginal() {
                        _hashReseted = true;
                        if (!_closedFromURL) {
                            if (_urlChangedOnce) history.back();
                            else {
                                if (_initialHash) _windowLoc.hash = _initialHash;
                                else if (_supportsPushState) // remove hash from url without refreshing it or scrolling to top
                                history.pushState('', document.title, _windowLoc.pathname + _windowLoc.search);
                                else _windowLoc.hash = '';
                            }
                        }
                        _cleanHistoryTimeouts();
                    };
                    _listen('unbindEvents', function() {
                        if (_closedByScroll) // if PhotoSwipe is closed by scroll, we go "back" before the closing animation starts
                        // this is done to keep the scroll position
                        returnToOriginal();
                    });
                    _listen('destroy', function() {
                        if (!_hashReseted) returnToOriginal();
                    });
                    _listen('firstUpdate', function() {
                        _currentItemIndex = _parseItemIndexFromURL().pid;
                    });
                    var index = _initialHash.indexOf('pid=');
                    if (index > -1) {
                        _initialHash = _initialHash.substring(0, index);
                        if (_initialHash.slice(-1) === '&') _initialHash = _initialHash.slice(0, -1);
                    }
                    setTimeout(function() {
                        if (_isOpen) framework.bind(window, 'hashchange', self.onHashChange);
                    }, 40);
                },
                onHashChange: function onHashChange() {
                    if (_getHash() === _initialHash) {
                        _closedFromURL = true;
                        self.close();
                        return;
                    }
                    if (!_hashChangedByScript) {
                        _hashChangedByHistory = true;
                        self.goTo(_parseItemIndexFromURL().pid);
                        _hashChangedByHistory = false;
                    }
                },
                updateURL: function updateURL() {
                    // Delay the update of URL, to avoid lag during transition, 
                    // and to not to trigger actions like "refresh page sound" or "blinking favicon" to often
                    _cleanHistoryTimeouts();
                    if (_hashChangedByHistory) return;
                    if (!_historyChanged) _updateHash(); // first time
                    else _historyUpdateTimeout = setTimeout(_updateHash, 800);
                }
            }
        });
        /*>>history*/ framework.extend(self, publicMethods);
    };
    return PhotoSwipe;
});


var $600a160352c63dd1$exports = {};
/**
*
* UI on top of main sliding area (caption, arrows, close button, etc.).
* Built just using public methods/properties of PhotoSwipe.
* 
*/ (function(root, factory) {
    if (typeof define === 'function' && define.amd) define(factory);
    else $600a160352c63dd1$exports = factory();
})($600a160352c63dd1$exports, function() {
    'use strict';
    var PhotoSwipeUI_Default = function PhotoSwipeUI_Default(pswp, framework) {
        var ui = this;
        var _overlayUIUpdated = false, _controlsVisible = true, _fullscrenAPI, _controls, _captionContainer, _fakeCaptionContainer, _indexIndicator, _shareButton, _shareModal, _shareModalHidden = true, _initalCloseOnScrollValue, _isIdle, _listen, _loadingIndicator, _loadingIndicatorHidden, _loadingIndicatorTimeout, _galleryHasOneSlide, _options, _defaultUIOptions = {
            barsSize: {
                top: 44,
                bottom: 'auto'
            },
            closeElClasses: [
                'item',
                'caption',
                'zoom-wrap',
                'ui',
                'top-bar'
            ],
            timeToIdle: 4000,
            timeToIdleOutside: 1000,
            loadingIndicatorDelay: 1000,
            addCaptionHTMLFn: function addCaptionHTMLFn(item, captionEl /*, isFake */ ) {
                if (!item.title) {
                    captionEl.children[0].innerHTML = '';
                    return false;
                }
                captionEl.children[0].innerHTML = item.title;
                return true;
            },
            closeEl: true,
            captionEl: true,
            fullscreenEl: true,
            zoomEl: true,
            shareEl: true,
            counterEl: true,
            arrowEl: true,
            preloaderEl: true,
            tapToClose: false,
            tapToToggleControls: true,
            clickToCloseNonZoomable: true,
            shareButtons: [
                {
                    id: 'facebook',
                    label: 'Share on Facebook',
                    url: 'https://www.facebook.com/sharer/sharer.php?u={{url}}'
                },
                {
                    id: 'twitter',
                    label: 'Tweet',
                    url: 'https://twitter.com/intent/tweet?text={{text}}&url={{url}}'
                },
                {
                    id: 'pinterest',
                    label: 'Pin it',
                    url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
                },
                {
                    id: 'download',
                    label: 'Download image',
                    url: '{{raw_image_url}}',
                    download: true
                }
            ],
            getImageURLForShare: function getImageURLForShare() {
                return pswp.currItem.src || '';
            },
            getPageURLForShare: function getPageURLForShare() {
                return window.location.href;
            },
            getTextForShare: function getTextForShare() {
                return pswp.currItem.title || '';
            },
            indexIndicatorSep: ' / ',
            fitControlsWidth: 1200
        }, _blockControlsTap, _blockControlsTapTimeout;
        var _onControlsTap = function _onControlsTap(e) {
            if (_blockControlsTap) return true;
            e = e || window.event;
            if (_options.timeToIdle && _options.mouseUsed && !_isIdle) // reset idle timer
            _onIdleMouseMove();
            var target = e.target || e.srcElement, uiElement, clickedClass = target.getAttribute('class') || '', found;
            for(var i = 0; i < _uiElements.length; i++){
                uiElement = _uiElements[i];
                if (uiElement.onTap && clickedClass.indexOf('pswp__' + uiElement.name) > -1) {
                    uiElement.onTap();
                    found = true;
                }
            }
            if (found) {
                if (e.stopPropagation) e.stopPropagation();
                _blockControlsTap = true;
                // Some versions of Android don't prevent ghost click event 
                // when preventDefault() was called on touchstart and/or touchend.
                // 
                // This happens on v4.3, 4.2, 4.1, 
                // older versions strangely work correctly, 
                // but just in case we add delay on all of them)	
                var tapDelay = framework.features.isOldAndroid ? 600 : 30;
                _blockControlsTapTimeout = setTimeout(function() {
                    _blockControlsTap = false;
                }, tapDelay);
            }
        }, _fitControlsInViewport = function _fitControlsInViewport() {
            return !pswp.likelyTouchDevice || _options.mouseUsed || screen.width > _options.fitControlsWidth;
        }, _togglePswpClass = function _togglePswpClass(el, cName, add) {
            framework[(add ? 'add' : 'remove') + 'Class'](el, 'pswp__' + cName);
        }, // add class when there is just one item in the gallery
        // (by default it hides left/right arrows and 1ofX counter)
        _countNumItems = function _countNumItems() {
            var hasOneSlide = _options.getNumItemsFn() === 1;
            if (hasOneSlide !== _galleryHasOneSlide) {
                _togglePswpClass(_controls, 'ui--one-slide', hasOneSlide);
                _galleryHasOneSlide = hasOneSlide;
            }
        }, _toggleShareModalClass = function _toggleShareModalClass() {
            _togglePswpClass(_shareModal, 'share-modal--hidden', _shareModalHidden);
        }, _toggleShareModal = function _toggleShareModal() {
            _shareModalHidden = !_shareModalHidden;
            if (!_shareModalHidden) {
                _toggleShareModalClass();
                setTimeout(function() {
                    if (!_shareModalHidden) framework.addClass(_shareModal, 'pswp__share-modal--fade-in');
                }, 30);
            } else {
                framework.removeClass(_shareModal, 'pswp__share-modal--fade-in');
                setTimeout(function() {
                    if (_shareModalHidden) _toggleShareModalClass();
                }, 300);
            }
            if (!_shareModalHidden) _updateShareURLs();
            return false;
        }, _openWindowPopup = function _openWindowPopup(e) {
            e = e || window.event;
            var target = e.target || e.srcElement;
            pswp.shout('shareLinkClick', e, target);
            if (!target.href) return false;
            if (target.hasAttribute('download')) return true;
            window.open(target.href, 'pswp_share', "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100));
            if (!_shareModalHidden) _toggleShareModal();
            return false;
        }, _updateShareURLs = function _updateShareURLs() {
            var shareButtonOut = '', shareButtonData, shareURL, image_url, page_url, share_text;
            for(var i = 0; i < _options.shareButtons.length; i++){
                shareButtonData = _options.shareButtons[i];
                image_url = _options.getImageURLForShare(shareButtonData);
                page_url = _options.getPageURLForShare(shareButtonData);
                share_text = _options.getTextForShare(shareButtonData);
                shareURL = shareButtonData.url.replace('{{url}}', encodeURIComponent(page_url)).replace('{{image_url}}', encodeURIComponent(image_url)).replace('{{raw_image_url}}', image_url).replace('{{text}}', encodeURIComponent(share_text));
                shareButtonOut += '<a href="' + shareURL + '" target="_blank" ' + 'class="pswp__share--' + shareButtonData.id + '"' + (shareButtonData.download ? 'download' : '') + '>' + shareButtonData.label + '</a>';
                if (_options.parseShareButtonOut) shareButtonOut = _options.parseShareButtonOut(shareButtonData, shareButtonOut);
            }
            _shareModal.children[0].innerHTML = shareButtonOut;
            _shareModal.children[0].onclick = _openWindowPopup;
        }, _hasCloseClass = function _hasCloseClass(target) {
            for(var i = 0; i < _options.closeElClasses.length; i++){
                if (framework.hasClass(target, 'pswp__' + _options.closeElClasses[i])) return true;
            }
        }, _idleInterval, _idleTimer, _idleIncrement = 0, _onIdleMouseMove = function _onIdleMouseMove() {
            clearTimeout(_idleTimer);
            _idleIncrement = 0;
            if (_isIdle) ui.setIdle(false);
        }, _onMouseLeaveWindow = function _onMouseLeaveWindow(e) {
            e = e ? e : window.event;
            var from = e.relatedTarget || e.toElement;
            if (!from || from.nodeName === 'HTML') {
                clearTimeout(_idleTimer);
                _idleTimer = setTimeout(function() {
                    ui.setIdle(true);
                }, _options.timeToIdleOutside);
            }
        }, _setupFullscreenAPI = function _setupFullscreenAPI() {
            if (_options.fullscreenEl && !framework.features.isOldAndroid) {
                if (!_fullscrenAPI) _fullscrenAPI = ui.getFullscreenAPI();
                if (_fullscrenAPI) {
                    framework.bind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
                    ui.updateFullscreen();
                    framework.addClass(pswp.template, 'pswp--supports-fs');
                } else framework.removeClass(pswp.template, 'pswp--supports-fs');
            }
        }, _setupLoadingIndicator = function _setupLoadingIndicator() {
            // Setup loading indicator
            if (_options.preloaderEl) {
                _toggleLoadingIndicator(true);
                _listen('beforeChange', function() {
                    clearTimeout(_loadingIndicatorTimeout);
                    // display loading indicator with delay
                    _loadingIndicatorTimeout = setTimeout(function() {
                        if (pswp.currItem && pswp.currItem.loading) {
                            if (!pswp.allowProgressiveImg() || pswp.currItem.img && !pswp.currItem.img.naturalWidth) // show preloader if progressive loading is not enabled, 
                            // or image width is not defined yet (because of slow connection)
                            _toggleLoadingIndicator(false);
                        // items-controller.js function allowProgressiveImg
                        } else _toggleLoadingIndicator(true); // hide preloader
                    }, _options.loadingIndicatorDelay);
                });
                _listen('imageLoadComplete', function(index, item) {
                    if (pswp.currItem === item) _toggleLoadingIndicator(true);
                });
            }
        }, _toggleLoadingIndicator = function _toggleLoadingIndicator(hide) {
            if (_loadingIndicatorHidden !== hide) {
                _togglePswpClass(_loadingIndicator, 'preloader--active', !hide);
                _loadingIndicatorHidden = hide;
            }
        }, _applyNavBarGaps = function _applyNavBarGaps(item) {
            var gap = item.vGap;
            if (_fitControlsInViewport()) {
                var bars = _options.barsSize;
                if (_options.captionEl && bars.bottom === 'auto') {
                    if (!_fakeCaptionContainer) {
                        _fakeCaptionContainer = framework.createEl('pswp__caption pswp__caption--fake');
                        _fakeCaptionContainer.appendChild(framework.createEl('pswp__caption__center'));
                        _controls.insertBefore(_fakeCaptionContainer, _captionContainer);
                        framework.addClass(_controls, 'pswp__ui--fit');
                    }
                    if (_options.addCaptionHTMLFn(item, _fakeCaptionContainer, true)) {
                        var captionSize = _fakeCaptionContainer.clientHeight;
                        gap.bottom = parseInt(captionSize, 10) || 44;
                    } else gap.bottom = bars.top; // if no caption, set size of bottom gap to size of top
                } else gap.bottom = bars.bottom === 'auto' ? 0 : bars.bottom;
                // height of top bar is static, no need to calculate it
                gap.top = bars.top;
            } else gap.top = gap.bottom = 0;
        }, _setupIdle = function _setupIdle() {
            // Hide controls when mouse is used
            if (_options.timeToIdle) _listen('mouseUsed', function() {
                framework.bind(document, 'mousemove', _onIdleMouseMove);
                framework.bind(document, 'mouseout', _onMouseLeaveWindow);
                _idleInterval = setInterval(function() {
                    _idleIncrement++;
                    if (_idleIncrement === 2) ui.setIdle(true);
                }, _options.timeToIdle / 2);
            });
        }, _setupHidingControlsDuringGestures = function _setupHidingControlsDuringGestures() {
            // Hide controls on vertical drag
            _listen('onVerticalDrag', function(now) {
                if (_controlsVisible && now < 0.95) ui.hideControls();
                else if (!_controlsVisible && now >= 0.95) ui.showControls();
            });
            // Hide controls when pinching to close
            var pinchControlsHidden;
            _listen('onPinchClose', function(now) {
                if (_controlsVisible && now < 0.9) {
                    ui.hideControls();
                    pinchControlsHidden = true;
                } else if (pinchControlsHidden && !_controlsVisible && now > 0.9) ui.showControls();
            });
            _listen('zoomGestureEnded', function() {
                pinchControlsHidden = false;
                if (pinchControlsHidden && !_controlsVisible) ui.showControls();
            });
        };
        var _uiElements = [
            {
                name: 'caption',
                option: 'captionEl',
                onInit: function onInit(el) {
                    _captionContainer = el;
                }
            },
            {
                name: 'share-modal',
                option: 'shareEl',
                onInit: function onInit(el) {
                    _shareModal = el;
                },
                onTap: function onTap() {
                    _toggleShareModal();
                }
            },
            {
                name: 'button--share',
                option: 'shareEl',
                onInit: function onInit(el) {
                    _shareButton = el;
                },
                onTap: function onTap() {
                    _toggleShareModal();
                }
            },
            {
                name: 'button--zoom',
                option: 'zoomEl',
                onTap: pswp.toggleDesktopZoom
            },
            {
                name: 'counter',
                option: 'counterEl',
                onInit: function onInit(el) {
                    _indexIndicator = el;
                }
            },
            {
                name: 'button--close',
                option: 'closeEl',
                onTap: pswp.close
            },
            {
                name: 'button--arrow--left',
                option: 'arrowEl',
                onTap: pswp.prev
            },
            {
                name: 'button--arrow--right',
                option: 'arrowEl',
                onTap: pswp.next
            },
            {
                name: 'button--fs',
                option: 'fullscreenEl',
                onTap: function onTap() {
                    if (_fullscrenAPI.isFullscreen()) _fullscrenAPI.exit();
                    else _fullscrenAPI.enter();
                }
            },
            {
                name: 'preloader',
                option: 'preloaderEl',
                onInit: function onInit(el) {
                    _loadingIndicator = el;
                }
            }
        ];
        var _setupUIElements = function _setupUIElements() {
            var item, classAttr, uiElement;
            var loopThroughChildElements = function loopThroughChildElements(sChildren) {
                if (!sChildren) return;
                var l = sChildren.length;
                for(var i = 0; i < l; i++){
                    item = sChildren[i];
                    classAttr = item.className;
                    for(var a = 0; a < _uiElements.length; a++){
                        uiElement = _uiElements[a];
                        if (classAttr.indexOf('pswp__' + uiElement.name) > -1) {
                            if (_options[uiElement.option]) {
                                framework.removeClass(item, 'pswp__element--disabled');
                                if (uiElement.onInit) uiElement.onInit(item);
                            //item.style.display = 'block';
                            } else framework.addClass(item, 'pswp__element--disabled');
                        }
                    }
                }
            };
            loopThroughChildElements(_controls.children);
            var topBar = framework.getChildByClass(_controls, 'pswp__top-bar');
            if (topBar) loopThroughChildElements(topBar.children);
        };
        ui.init = function() {
            // extend options
            framework.extend(pswp.options, _defaultUIOptions, true);
            // create local link for fast access
            _options = pswp.options;
            // find pswp__ui element
            _controls = framework.getChildByClass(pswp.scrollWrap, 'pswp__ui');
            // create local link
            _listen = pswp.listen;
            _setupHidingControlsDuringGestures();
            // update controls when slides change
            _listen('beforeChange', ui.update);
            // toggle zoom on double-tap
            _listen('doubleTap', function(point) {
                var initialZoomLevel = pswp.currItem.initialZoomLevel;
                if (pswp.getZoomLevel() !== initialZoomLevel) pswp.zoomTo(initialZoomLevel, point, 333);
                else pswp.zoomTo(_options.getDoubleTapZoom(false, pswp.currItem), point, 333);
            });
            // Allow text selection in caption
            _listen('preventDragEvent', function(e, isDown, preventObj) {
                var t = e.target || e.srcElement;
                if (t && t.getAttribute('class') && e.type.indexOf('mouse') > -1 && (t.getAttribute('class').indexOf('__caption') > 0 || /(SMALL|STRONG|EM)/i.test(t.tagName))) preventObj.prevent = false;
            });
            // bind events for UI
            _listen('bindEvents', function() {
                framework.bind(_controls, 'pswpTap click', _onControlsTap);
                framework.bind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
                if (!pswp.likelyTouchDevice) framework.bind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
            });
            // unbind events for UI
            _listen('unbindEvents', function() {
                if (!_shareModalHidden) _toggleShareModal();
                if (_idleInterval) clearInterval(_idleInterval);
                framework.unbind(document, 'mouseout', _onMouseLeaveWindow);
                framework.unbind(document, 'mousemove', _onIdleMouseMove);
                framework.unbind(_controls, 'pswpTap click', _onControlsTap);
                framework.unbind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
                framework.unbind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
                if (_fullscrenAPI) {
                    framework.unbind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
                    if (_fullscrenAPI.isFullscreen()) {
                        _options.hideAnimationDuration = 0;
                        _fullscrenAPI.exit();
                    }
                    _fullscrenAPI = null;
                }
            });
            // clean up things when gallery is destroyed
            _listen('destroy', function() {
                if (_options.captionEl) {
                    if (_fakeCaptionContainer) _controls.removeChild(_fakeCaptionContainer);
                    framework.removeClass(_captionContainer, 'pswp__caption--empty');
                }
                if (_shareModal) _shareModal.children[0].onclick = null;
                framework.removeClass(_controls, 'pswp__ui--over-close');
                framework.addClass(_controls, 'pswp__ui--hidden');
                ui.setIdle(false);
            });
            if (!_options.showAnimationDuration) framework.removeClass(_controls, 'pswp__ui--hidden');
            _listen('initialZoomIn', function() {
                if (_options.showAnimationDuration) framework.removeClass(_controls, 'pswp__ui--hidden');
            });
            _listen('initialZoomOut', function() {
                framework.addClass(_controls, 'pswp__ui--hidden');
            });
            _listen('parseVerticalMargin', _applyNavBarGaps);
            _setupUIElements();
            if (_options.shareEl && _shareButton && _shareModal) _shareModalHidden = true;
            _countNumItems();
            _setupIdle();
            _setupFullscreenAPI();
            _setupLoadingIndicator();
        };
        ui.setIdle = function(isIdle) {
            _isIdle = isIdle;
            _togglePswpClass(_controls, 'ui--idle', isIdle);
        };
        ui.update = function() {
            // Don't update UI if it's hidden
            if (_controlsVisible && pswp.currItem) {
                ui.updateIndexIndicator();
                if (_options.captionEl) {
                    _options.addCaptionHTMLFn(pswp.currItem, _captionContainer);
                    _togglePswpClass(_captionContainer, 'caption--empty', !pswp.currItem.title);
                }
                _overlayUIUpdated = true;
            } else _overlayUIUpdated = false;
            if (!_shareModalHidden) _toggleShareModal();
            _countNumItems();
        };
        ui.updateFullscreen = function(e) {
            if (e) // some browsers change window scroll position during the fullscreen
            // so PhotoSwipe updates it just in case
            setTimeout(function() {
                pswp.setScrollOffset(0, framework.getScrollY());
            }, 50);
            // toogle pswp--fs class on root element
            framework[(_fullscrenAPI.isFullscreen() ? 'add' : 'remove') + 'Class'](pswp.template, 'pswp--fs');
        };
        ui.updateIndexIndicator = function() {
            if (_options.counterEl) _indexIndicator.innerHTML = pswp.getCurrentIndex() + 1 + _options.indexIndicatorSep + _options.getNumItemsFn();
        };
        ui.onGlobalTap = function(e) {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (_blockControlsTap) return;
            if (e.detail && e.detail.pointerType === 'mouse') {
                // close gallery if clicked outside of the image
                if (_hasCloseClass(target)) {
                    pswp.close();
                    return;
                }
                if (framework.hasClass(target, 'pswp__img')) {
                    if (pswp.getZoomLevel() === 1 && pswp.getZoomLevel() <= pswp.currItem.fitRatio) {
                        if (_options.clickToCloseNonZoomable) pswp.close();
                    } else pswp.toggleDesktopZoom(e.detail.releasePoint);
                }
            } else {
                // tap anywhere (except buttons) to toggle visibility of controls
                if (_options.tapToToggleControls) {
                    if (_controlsVisible) ui.hideControls();
                    else ui.showControls();
                }
                // tap to close gallery
                if (_options.tapToClose && (framework.hasClass(target, 'pswp__img') || _hasCloseClass(target))) {
                    pswp.close();
                    return;
                }
            }
        };
        ui.onMouseOver = function(e) {
            e = e || window.event;
            var target = e.target || e.srcElement;
            // add class when mouse is over an element that should close the gallery
            _togglePswpClass(_controls, 'ui--over-close', _hasCloseClass(target));
        };
        ui.hideControls = function() {
            framework.addClass(_controls, 'pswp__ui--hidden');
            _controlsVisible = false;
        };
        ui.showControls = function() {
            _controlsVisible = true;
            if (!_overlayUIUpdated) ui.update();
            framework.removeClass(_controls, 'pswp__ui--hidden');
        };
        ui.supportsFullscreen = function() {
            var d = document;
            return !!(d.exitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen || d.msExitFullscreen);
        };
        ui.getFullscreenAPI = function() {
            var dE = document.documentElement, api, tF = 'fullscreenchange';
            if (dE.requestFullscreen) api = {
                enterK: 'requestFullscreen',
                exitK: 'exitFullscreen',
                elementK: 'fullscreenElement',
                eventK: tF
            };
            else if (dE.mozRequestFullScreen) api = {
                enterK: 'mozRequestFullScreen',
                exitK: 'mozCancelFullScreen',
                elementK: 'mozFullScreenElement',
                eventK: 'moz' + tF
            };
            else if (dE.webkitRequestFullscreen) api = {
                enterK: 'webkitRequestFullscreen',
                exitK: 'webkitExitFullscreen',
                elementK: 'webkitFullscreenElement',
                eventK: 'webkit' + tF
            };
            else if (dE.msRequestFullscreen) api = {
                enterK: 'msRequestFullscreen',
                exitK: 'msExitFullscreen',
                elementK: 'msFullscreenElement',
                eventK: 'MSFullscreenChange'
            };
            if (api) {
                api.enter = function() {
                    // disable close-on-scroll in fullscreen
                    _initalCloseOnScrollValue = _options.closeOnScroll;
                    _options.closeOnScroll = false;
                    if (this.enterK === 'webkitRequestFullscreen') pswp.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
                    else return pswp.template[this.enterK]();
                };
                api.exit = function() {
                    _options.closeOnScroll = _initalCloseOnScrollValue;
                    return document[this.exitK]();
                };
                api.isFullscreen = function() {
                    return document[this.elementK];
                };
            }
            return api;
        };
    };
    return PhotoSwipeUI_Default;
});


function $21b3f89bf1a8b494$export$2e2bcd8739ae039(gallerySelector) {
    // parse slide data (url, title, size ...) from DOM elements
    // (children of gallerySelector)
    var parseThumbnailElements = function parseThumbnailElements(el) {
        var thumbElements = el.childNodes, numNodes = thumbElements.length, items = [], figureEl, linkEl, size, item;
        for(var i = 0; i < numNodes; i++){
            figureEl = thumbElements[i]; // <figure> element
            // include only element nodes
            if (figureEl.nodeType !== 1) continue;
            try {
                linkEl = figureEl.children[0]; // <a> element
                size = linkEl.getAttribute('data-size').split('x');
            } catch (TypeError) {
                continue;
            }
            // create slide object
            item = {
                src: linkEl.getAttribute('href'),
                w: parseInt(size[0], 10),
                h: parseInt(size[1], 10)
            };
            if (figureEl.children.length > 1) // <figcaption> content
            item.title = figureEl.children[1].innerHTML;
            if (linkEl.children.length > 0) // <img> thumbnail element, retrieving thumbnail url
            item.msrc = linkEl.children[0].getAttribute('src');
            item.el = figureEl; // save link to element for getThumbBoundsFn
            items.push(item);
        }
        return items;
    };
    // find nearest parent element
    var closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
    };
    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function onThumbnailsClick(e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
        var eTarget = e.target || e.srcElement;
        // find root element of slide
        var clickedListItem = closest(eTarget, function(el) {
            return el.tagName && el.tagName.toUpperCase() === 'FIGURE';
        });
        if (!clickedListItem) return;
        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        var clickedGallery = clickedListItem.parentNode, childNodes = clickedListItem.parentNode.childNodes, numChildNodes = childNodes.length, nodeIndex = 0, index;
        for(var i = 0; i < numChildNodes; i++){
            if (childNodes[i].nodeType !== 1) continue;
            if (childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }
        if (index >= 0) // open PhotoSwipe if valid index found
        openPhotoSwipe(index, clickedGallery);
        return false;
    };
    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function photoswipeParseHash() {
        var hash = window.location.hash.substring(1), params = {};
        if (hash.length < 5) return params;
        var vars = hash.split('&');
        for(var i = 0; i < vars.length; i++){
            if (!vars[i]) continue;
            var pair = vars[i].split('=');
            if (pair.length < 2) continue;
            params[pair[0]] = pair[1];
        }
        if (params.gid) params.gid = parseInt(params.gid, 10);
        return params;
    };
    var openPhotoSwipe = function openPhotoSwipe(index, galleryElement, disableAnimation, fromURL) {
        var pswpElement = document.querySelectorAll('.pswp')[0], gallery, options, items;
        try {
            var photogalleryOptions = {
                shareButtons: localizedShareButtons
            };
        } catch (ReferenceError) {
            var photogalleryOptions = {};
        }
        items = parseThumbnailElements(galleryElement);
        // define options (if needed)
        options = (0, $a9846c98c872cb75$export$71511d61b312f219)({
            // define gallery index (for URL)
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),
            getThumbBoundsFn: function getThumbBoundsFn(index) {
                // See Options -> getThumbBoundsFn section of documentation for more info
                var thumbnail = items[index].el.getElementsByTagName('img')[0], pageYScroll = window.pageYOffset || document.documentElement.scrollTop, rect = thumbnail.getBoundingClientRect();
                return {
                    x: rect.left,
                    y: rect.top + pageYScroll,
                    w: rect.width
                };
            }
        }, photogalleryOptions);
        // PhotoSwipe opened from URL
        if (fromURL) {
            if (options.galleryPIDs) {
                // parse real index when custom PIDs are used
                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                for(var j = 0; j < items.length; j++)if (items[j].pid == index) {
                    options.index = j;
                    break;
                }
            } else // in URL indexes start from 1
            options.index = parseInt(index, 10) - 1;
        } else options.index = parseInt(index, 10);
        // exit if index not found
        if (isNaN(options.index)) return;
        if (disableAnimation) options.showAnimationDuration = 0;
        options.showHideOpacity = true;
        // Pass data to PhotoSwipe and initialize it
        gallery = new (0, (/*@__PURE__*/$parcel$interopDefault($9dfdb671d882e02b$exports)))(pswpElement, (0, (/*@__PURE__*/$parcel$interopDefault($600a160352c63dd1$exports))), items, options);
        gallery.init();
    };
    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll(gallerySelector);
    for(var i = 0, l = galleryElements.length; i < l; i++){
        galleryElements[i].setAttribute('data-pswp-uid', i + 1);
        galleryElements[i].onclick = onThumbnailsClick;
    }
    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}


var $2e218e1f75469fbf$exports = {};
/**
 * Cookies EU banner v2.0.1 - Manage display of banner to accept/reject cookies from tracking services like Google Analytics
 * ------------------------
 * @link http://alex-d.github.io/Cookies-EU-banner/
 * @license MIT
 * @author Alex-D
 *         Twitter : @AlexandreDemode
 *         Website : alex-d.fr
 */ (function(root, factory, undefined1) {
    'use strict';
    if (typeof define === 'function' && define.amd) define([], factory);
    else $2e218e1f75469fbf$exports = factory();
})(window, function() {
    'use strict';
    var CookiesEuBanner, document = window.document;
    CookiesEuBanner = function(launchFunction, waitAccept, useLocalStorage, undefined1) {
        if (!(this instanceof CookiesEuBanner)) return new CookiesEuBanner(launchFunction);
        this.cookieTimeout = 33696000000; // 13 months in milliseconds
        this.bots = /bot|crawler|spider|crawling/i;
        this.cookieName = 'hasConsent';
        this.trackingCookiesNames = [
            '__utma',
            '__utmb',
            '__utmc',
            '__utmt',
            '__utmv',
            '__utmz',
            '_ga',
            '_gat',
            '_gid'
        ];
        this.launchFunction = launchFunction;
        this.waitAccept = waitAccept || false;
        this.useLocalStorage = useLocalStorage || false;
        this.init();
    };
    CookiesEuBanner.prototype = {
        init: function init() {
            // Detect if the visitor is a bot or not
            // Prevent for search engine take the cookie alert message as main content of the page
            var isBot = this.bots.test(navigator.userAgent);
            // Check if DoNotTrack is activated
            var dnt = navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack;
            var isToTrack = dnt !== null && dnt !== undefined ? dnt && dnt !== 'yes' && dnt !== 1 && dnt !== '1' : true;
            // Do nothing if it is a bot
            // If DoNotTrack is activated, do nothing too
            if (isBot || !isToTrack || this.hasConsent() === false) {
                this.removeBanner(0);
                return false;
            }
            // User has already consent to use cookies to tracking
            if (this.hasConsent() === true) {
                // Launch user custom function
                this.launchFunction();
                return true;
            }
            // If it's not a bot, no DoNotTrack and not already accept, so show banner
            this.showBanner();
            if (!this.waitAccept) // Accept cookies by default for the next page
            this.setConsent(true);
        },
        /*
     * Show banner at the top of the page
     */ showBanner: function showBanner() {
            var _this = this, getElementById = document.getElementById.bind(document), banner = getElementById('cookies-eu-banner'), rejectButton = getElementById('cookies-eu-reject'), acceptButton = getElementById('cookies-eu-accept'), moreLink = getElementById('cookies-eu-more'), waitRemove = banner.dataset.waitRemove === undefined ? 0 : parseInt(banner.dataset.waitRemove), // Variables for minification optimization
            addClickListener = this.addClickListener, removeBanner = _this.removeBanner.bind(_this, waitRemove);
            banner.style.display = 'block';
            if (moreLink) addClickListener(moreLink, function() {
                _this.deleteCookie(_this.cookieName);
            });
            if (acceptButton) addClickListener(acceptButton, function() {
                removeBanner();
                _this.setConsent(true);
                _this.launchFunction();
            });
            if (rejectButton) addClickListener(rejectButton, function() {
                removeBanner();
                _this.setConsent(false);
                // Delete existing tracking cookies
                _this.trackingCookiesNames.map(_this.deleteCookie);
            });
        },
        /*
     * Set consent cookie or localStorage
     */ setConsent: function setConsent(consent) {
            if (this.useLocalStorage) return localStorage.setItem(this.cookieName, consent);
            this.setCookie(this.cookieName, consent);
        },
        /*
     * Check if user already consent
     */ hasConsent: function hasConsent() {
            var cookieName = this.cookieName;
            var isCookieSetTo = function isCookieSetTo(value) {
                return document.cookie.indexOf(cookieName + '=' + value) > -1 || localStorage.getItem(cookieName) === value;
            };
            if (isCookieSetTo('true')) return true;
            else if (isCookieSetTo('false')) return false;
            return null;
        },
        /*
     * Create/update cookie
     */ setCookie: function setCookie(name, value) {
            var date = new Date();
            date.setTime(date.getTime() + this.cookieTimeout);
            document.cookie = name + '=' + value + ';expires=' + date.toGMTString() + ';path=/';
        },
        /*
     * Delete cookie by changing expire
     */ deleteCookie: function deleteCookie(name) {
            var hostname = document.location.hostname.replace(/^www\./, ''), commonSuffix = '; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/';
            document.cookie = name + '=; domain=.' + hostname + commonSuffix;
            document.cookie = name + '=' + commonSuffix;
        },
        addClickListener: function addClickListener(DOMElement, callback) {
            if (DOMElement.attachEvent) return DOMElement.attachEvent('onclick', callback);
            // For all major browsers, except IE 8 and earlier
            DOMElement.addEventListener('click', callback);
        },
        /*
     * Delays removal of banner allowing developers
     * to specify their own transition effects
     */ removeBanner: function removeBanner(wait) {
            setTimeout(function() {
                var banner = document.getElementById('cookies-eu-banner');
                if (banner && banner.parentNode) banner.parentNode.removeChild(banner);
            }, wait);
        }
    };
    return CookiesEuBanner;
});


// packages/alpinejs/src/scheduler.js
function $829c750286ec3a2c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $829c750286ec3a2c$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $829c750286ec3a2c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $829c750286ec3a2c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




function $16953d725958e36c$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $15ce807e88c74d11$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $e257671a377ccc5f$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $1a8d03ca4aff1456$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $fb89105dfd661251$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $1a8d03ca4aff1456$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $1a8d03ca4aff1456$export$71511d61b312f219)(o, minLen);
}


function $2eb6a8c2efe4d1d3$export$71511d61b312f219(arr, i) {
    return (0, $16953d725958e36c$export$71511d61b312f219)(arr) || (0, $15ce807e88c74d11$export$71511d61b312f219)(arr, i) || (0, $fb89105dfd661251$export$71511d61b312f219)(arr, i) || (0, $e257671a377ccc5f$export$71511d61b312f219)();
}


function $ca516d8776d79507$export$71511d61b312f219(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}



function $b5c75a414da7f998$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $1a8d03ca4aff1456$export$71511d61b312f219)(arr);
}


function $a988a5e0c8989e33$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $3c4defe0731b43f6$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $8ea412f19da8a8a2$export$71511d61b312f219(arr) {
    return (0, $b5c75a414da7f998$export$71511d61b312f219)(arr) || (0, $a988a5e0c8989e33$export$71511d61b312f219)(arr) || (0, $fb89105dfd661251$export$71511d61b312f219)(arr) || (0, $3c4defe0731b43f6$export$71511d61b312f219)();
}



var $j2WbH = parcelRequire("j2WbH");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $j2WbH = parcelRequire("j2WbH");
var $15f39fe0df078b1e$var$extendStatics = function extendStatics1(d, b) {
    $15f39fe0df078b1e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $15f39fe0df078b1e$var$extendStatics(d, b);
};
function $15f39fe0df078b1e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $15f39fe0df078b1e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $15f39fe0df078b1e$export$18ce0697a983be9b = function __assign1() {
    $15f39fe0df078b1e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $15f39fe0df078b1e$export$18ce0697a983be9b.apply(this, arguments);
};
function $15f39fe0df078b1e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $15f39fe0df078b1e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $j2WbH._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $15f39fe0df078b1e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $15f39fe0df078b1e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $j2WbH._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $15f39fe0df078b1e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $15f39fe0df078b1e$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $j2WbH._)(x)) === "symbol" ? x : "".concat(x);
}
function $15f39fe0df078b1e$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $j2WbH._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $15f39fe0df078b1e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $j2WbH._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $15f39fe0df078b1e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $15f39fe0df078b1e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $15f39fe0df078b1e$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $15f39fe0df078b1e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $15f39fe0df078b1e$export$45d3717a4c69092e(o, m, p);
}
function $15f39fe0df078b1e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $15f39fe0df078b1e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $15f39fe0df078b1e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($15f39fe0df078b1e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $15f39fe0df078b1e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $15f39fe0df078b1e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $15f39fe0df078b1e$export$10c90e4f7922046c(v) {
    return this instanceof $15f39fe0df078b1e$export$10c90e4f7922046c ? (this.v = v, this) : new $15f39fe0df078b1e$export$10c90e4f7922046c(v);
}
function $15f39fe0df078b1e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $15f39fe0df078b1e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $15f39fe0df078b1e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $15f39fe0df078b1e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $15f39fe0df078b1e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $15f39fe0df078b1e$export$19a8beecd37a4c45 === "function" ? $15f39fe0df078b1e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $15f39fe0df078b1e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $15f39fe0df078b1e$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $15f39fe0df078b1e$var$ownKeys = function ownKeys1(o) {
    $15f39fe0df078b1e$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $15f39fe0df078b1e$var$ownKeys(o);
};
function $15f39fe0df078b1e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $15f39fe0df078b1e$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $15f39fe0df078b1e$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $15f39fe0df078b1e$var$__setModuleDefault(result, mod);
    return result;
}
function $15f39fe0df078b1e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $15f39fe0df078b1e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $15f39fe0df078b1e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $15f39fe0df078b1e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $j2WbH._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $15f39fe0df078b1e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $15f39fe0df078b1e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $15f39fe0df078b1e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $15f39fe0df078b1e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $15f39fe0df078b1e$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $15f39fe0df078b1e$export$2e2bcd8739ae039 = {
    __extends: $15f39fe0df078b1e$export$a8ba968b8961cb8a,
    __assign: $15f39fe0df078b1e$export$18ce0697a983be9b,
    __rest: $15f39fe0df078b1e$export$3c9a16f847548506,
    __decorate: $15f39fe0df078b1e$export$29e00dfd3077644b,
    __param: $15f39fe0df078b1e$export$d5ad3fd78186038f,
    __esDecorate: $15f39fe0df078b1e$export$3a84e1ae4e97e9b0,
    __runInitializers: $15f39fe0df078b1e$export$d831c04e792af3d,
    __propKey: $15f39fe0df078b1e$export$6a2a36740a146cb8,
    __setFunctionName: $15f39fe0df078b1e$export$d1a06452d3489bc7,
    __metadata: $15f39fe0df078b1e$export$f1db080c865becb9,
    __awaiter: $15f39fe0df078b1e$export$1050f835b63b671e,
    __generator: $15f39fe0df078b1e$export$67ebef60e6f28a6,
    __createBinding: $15f39fe0df078b1e$export$45d3717a4c69092e,
    __exportStar: $15f39fe0df078b1e$export$f33643c0debef087,
    __values: $15f39fe0df078b1e$export$19a8beecd37a4c45,
    __read: $15f39fe0df078b1e$export$8d051b38c9118094,
    __spread: $15f39fe0df078b1e$export$afc72e2116322959,
    __spreadArrays: $15f39fe0df078b1e$export$6388937ca91ccae8,
    __spreadArray: $15f39fe0df078b1e$export$1216008129fb82ed,
    __await: $15f39fe0df078b1e$export$10c90e4f7922046c,
    __asyncGenerator: $15f39fe0df078b1e$export$e427f37a30a4de9b,
    __asyncDelegator: $15f39fe0df078b1e$export$bbd80228419bb833,
    __asyncValues: $15f39fe0df078b1e$export$e3b29a3d6162315f,
    __makeTemplateObject: $15f39fe0df078b1e$export$4fb47efe1390b86f,
    __importStar: $15f39fe0df078b1e$export$c21735bcef00d192,
    __importDefault: $15f39fe0df078b1e$export$da59b14a69baef04,
    __classPrivateFieldGet: $15f39fe0df078b1e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $15f39fe0df078b1e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $15f39fe0df078b1e$export$81fdc39f203e4e04,
    __addDisposableResource: $15f39fe0df078b1e$export$88ac25d8e944e405,
    __disposeResources: $15f39fe0df078b1e$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $15f39fe0df078b1e$export$889dfb5d17574b0b
};


function $96cefe9acc8d79bc$var$_templateObject() {
    var _$data = (0, $ca516d8776d79507$export$71511d61b312f219)([
        "Cannot find directive `",
        "`. `",
        "` will use the default order of execution"
    ], [
        "Cannot find directive \\`",
        "\\`. \\`",
        "\\` will use the default order of execution"
    ]);
    $96cefe9acc8d79bc$var$_templateObject = function _templateObject() {
        return _$data;
    };
    return _$data;
}
var $96cefe9acc8d79bc$var$flushPending = false;
var $96cefe9acc8d79bc$var$flushing = false;
var $96cefe9acc8d79bc$var$queue = [];
var $96cefe9acc8d79bc$var$lastFlushedIndex = -1;
function $96cefe9acc8d79bc$var$scheduler(callback) {
    $96cefe9acc8d79bc$var$queueJob(callback);
}
function $96cefe9acc8d79bc$var$queueJob(job) {
    if (!$96cefe9acc8d79bc$var$queue.includes(job)) $96cefe9acc8d79bc$var$queue.push(job);
    $96cefe9acc8d79bc$var$queueFlush();
}
function $96cefe9acc8d79bc$var$dequeueJob(job) {
    var index = $96cefe9acc8d79bc$var$queue.indexOf(job);
    if (index !== -1 && index > $96cefe9acc8d79bc$var$lastFlushedIndex) $96cefe9acc8d79bc$var$queue.splice(index, 1);
}
function $96cefe9acc8d79bc$var$queueFlush() {
    if (!$96cefe9acc8d79bc$var$flushing && !$96cefe9acc8d79bc$var$flushPending) {
        $96cefe9acc8d79bc$var$flushPending = true;
        queueMicrotask($96cefe9acc8d79bc$var$flushJobs);
    }
}
function $96cefe9acc8d79bc$var$flushJobs() {
    $96cefe9acc8d79bc$var$flushPending = false;
    $96cefe9acc8d79bc$var$flushing = true;
    for(var i = 0; i < $96cefe9acc8d79bc$var$queue.length; i++){
        $96cefe9acc8d79bc$var$queue[i]();
        $96cefe9acc8d79bc$var$lastFlushedIndex = i;
    }
    $96cefe9acc8d79bc$var$queue.length = 0;
    $96cefe9acc8d79bc$var$lastFlushedIndex = -1;
    $96cefe9acc8d79bc$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $96cefe9acc8d79bc$var$reactive;
var $96cefe9acc8d79bc$var$effect;
var $96cefe9acc8d79bc$var$release;
var $96cefe9acc8d79bc$var$raw;
var $96cefe9acc8d79bc$var$shouldSchedule = true;
function $96cefe9acc8d79bc$var$disableEffectScheduling(callback) {
    $96cefe9acc8d79bc$var$shouldSchedule = false;
    callback();
    $96cefe9acc8d79bc$var$shouldSchedule = true;
}
function $96cefe9acc8d79bc$var$setReactivityEngine(engine) {
    $96cefe9acc8d79bc$var$reactive = engine.reactive;
    $96cefe9acc8d79bc$var$release = engine.release;
    $96cefe9acc8d79bc$var$effect = function(callback) {
        return engine.effect(callback, {
            scheduler: function(task) {
                if ($96cefe9acc8d79bc$var$shouldSchedule) $96cefe9acc8d79bc$var$scheduler(task);
                else task();
            }
        });
    };
    $96cefe9acc8d79bc$var$raw = engine.raw;
}
function $96cefe9acc8d79bc$var$overrideEffect(override) {
    $96cefe9acc8d79bc$var$effect = override;
}
function $96cefe9acc8d79bc$var$elementBoundEffect(el) {
    var cleanup2 = function() {};
    var wrappedEffect = function(callback) {
        var effectReference = $96cefe9acc8d79bc$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = function() {
                el._x_effects.forEach(function(i) {
                    return i();
                });
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = function() {
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $96cefe9acc8d79bc$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        function() {
            cleanup2();
        }
    ];
}
function $96cefe9acc8d79bc$var$watch(getter, callback) {
    var firstTime = true;
    var oldValue;
    var effectReference = $96cefe9acc8d79bc$var$effect(function() {
        var value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(function() {
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return function() {
        return $96cefe9acc8d79bc$var$release(effectReference);
    };
}
// packages/alpinejs/src/mutation.js
var $96cefe9acc8d79bc$var$onAttributeAddeds = [];
var $96cefe9acc8d79bc$var$onElRemoveds = [];
var $96cefe9acc8d79bc$var$onElAddeds = [];
function $96cefe9acc8d79bc$var$onElAdded(callback) {
    $96cefe9acc8d79bc$var$onElAddeds.push(callback);
}
function $96cefe9acc8d79bc$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $96cefe9acc8d79bc$var$onElRemoveds.push(callback);
    }
}
function $96cefe9acc8d79bc$var$onAttributesAdded(callback) {
    $96cefe9acc8d79bc$var$onAttributeAddeds.push(callback);
}
function $96cefe9acc8d79bc$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $96cefe9acc8d79bc$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(function(param) {
        var _param = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(param, 2), name = _param[0], value = _param[1];
        if (names === void 0 || names.includes(name)) {
            value.forEach(function(i) {
                return i();
            });
            delete el._x_attributeCleanups[name];
        }
    });
}
function $96cefe9acc8d79bc$var$cleanupElement(el) {
    var _el__x_effects, _el__x_cleanups;
    (_el__x_effects = el._x_effects) === null || _el__x_effects === void 0 ? void 0 : _el__x_effects.forEach($96cefe9acc8d79bc$var$dequeueJob);
    while((_el__x_cleanups = el._x_cleanups) === null || _el__x_cleanups === void 0 ? void 0 : _el__x_cleanups.length)el._x_cleanups.pop()();
}
var $96cefe9acc8d79bc$var$observer = new MutationObserver($96cefe9acc8d79bc$var$onMutate);
var $96cefe9acc8d79bc$var$currentlyObserving = false;
function $96cefe9acc8d79bc$var$startObservingMutations() {
    $96cefe9acc8d79bc$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $96cefe9acc8d79bc$var$currentlyObserving = true;
}
function $96cefe9acc8d79bc$var$stopObservingMutations() {
    $96cefe9acc8d79bc$var$flushObserver();
    $96cefe9acc8d79bc$var$observer.disconnect();
    $96cefe9acc8d79bc$var$currentlyObserving = false;
}
var $96cefe9acc8d79bc$var$queuedMutations = [];
function $96cefe9acc8d79bc$var$flushObserver() {
    var records = $96cefe9acc8d79bc$var$observer.takeRecords();
    $96cefe9acc8d79bc$var$queuedMutations.push(function() {
        return records.length > 0 && $96cefe9acc8d79bc$var$onMutate(records);
    });
    var queueLengthWhenTriggered = $96cefe9acc8d79bc$var$queuedMutations.length;
    queueMicrotask(function() {
        if ($96cefe9acc8d79bc$var$queuedMutations.length === queueLengthWhenTriggered) while($96cefe9acc8d79bc$var$queuedMutations.length > 0)$96cefe9acc8d79bc$var$queuedMutations.shift()();
    });
}
function $96cefe9acc8d79bc$var$mutateDom(callback) {
    if (!$96cefe9acc8d79bc$var$currentlyObserving) return callback();
    $96cefe9acc8d79bc$var$stopObservingMutations();
    var result = callback();
    $96cefe9acc8d79bc$var$startObservingMutations();
    return result;
}
var $96cefe9acc8d79bc$var$isCollecting = false;
var $96cefe9acc8d79bc$var$deferredMutations = [];
function $96cefe9acc8d79bc$var$deferMutations() {
    $96cefe9acc8d79bc$var$isCollecting = true;
}
function $96cefe9acc8d79bc$var$flushAndStopDeferringMutations() {
    $96cefe9acc8d79bc$var$isCollecting = false;
    $96cefe9acc8d79bc$var$onMutate($96cefe9acc8d79bc$var$deferredMutations);
    $96cefe9acc8d79bc$var$deferredMutations = [];
}
function $96cefe9acc8d79bc$var$onMutate(mutations) {
    var _loop = function(i) {
        if (mutations[i].target._x_ignoreMutationObserver) return "continue";
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach(function(node) {
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach(function(node) {
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            var el = mutations[i].target;
            var name = mutations[i].attributeName;
            var oldValue = mutations[i].oldValue;
            var add2 = function() {
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            var remove = function() {
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    };
    if ($96cefe9acc8d79bc$var$isCollecting) {
        $96cefe9acc8d79bc$var$deferredMutations = $96cefe9acc8d79bc$var$deferredMutations.concat(mutations);
        return;
    }
    var addedNodes = [];
    var removedNodes = /* @__PURE__ */ new Set();
    var addedAttributes = /* @__PURE__ */ new Map();
    var removedAttributes = /* @__PURE__ */ new Map();
    for(var i = 0; i < mutations.length; i++)_loop(i);
    removedAttributes.forEach(function(attrs, el) {
        $96cefe9acc8d79bc$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach(function(attrs, el) {
        $96cefe9acc8d79bc$var$onAttributeAddeds.forEach(function(i) {
            return i(el, attrs);
        });
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop1 = function() {
            var node = _step.value;
            if (addedNodes.some(function(i) {
                return i.contains(node);
            })) return "continue";
            $96cefe9acc8d79bc$var$onElRemoveds.forEach(function(i) {
                return i(node);
            });
        };
        for(var _iterator = removedNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop1();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        var _loop2 = function() {
            var node = _step1.value;
            if (!node.isConnected) return "continue";
            $96cefe9acc8d79bc$var$onElAddeds.forEach(function(i) {
                return i(node);
            });
        };
        for(var _iterator1 = addedNodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop2();
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $96cefe9acc8d79bc$var$scope(node) {
    return $96cefe9acc8d79bc$var$mergeProxies($96cefe9acc8d79bc$var$closestDataStack(node));
}
function $96cefe9acc8d79bc$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2
    ].concat((0, $8ea412f19da8a8a2$export$71511d61b312f219)($96cefe9acc8d79bc$var$closestDataStack(referenceNode || node)));
    return function() {
        node._x_dataStack = node._x_dataStack.filter(function(i) {
            return i !== data2;
        });
    };
}
function $96cefe9acc8d79bc$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $96cefe9acc8d79bc$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $96cefe9acc8d79bc$var$closestDataStack(node.parentNode);
}
function $96cefe9acc8d79bc$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $96cefe9acc8d79bc$var$mergeProxyTrap);
}
var $96cefe9acc8d79bc$var$mergeProxyTrap = {
    ownKeys: function(param) {
        var objects = param.objects;
        return Array.from(new Set(objects.flatMap(function(i) {
            return Object.keys(i);
        })));
    },
    has: function(param, name) {
        var objects = param.objects;
        if (name == Symbol.unscopables) return false;
        return objects.some(function(obj) {
            return Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name);
        });
    },
    get: function(param, name, thisProxy) {
        var objects = param.objects;
        if (name == "toJSON") return $96cefe9acc8d79bc$var$collapseProxies;
        return Reflect.get(objects.find(function(obj) {
            return Reflect.has(obj, name);
        }) || {}, name, thisProxy);
    },
    set: function(param, name, value, thisProxy) {
        var objects = param.objects;
        var target = objects.find(function(obj) {
            return Object.prototype.hasOwnProperty.call(obj, name);
        }) || objects[objects.length - 1];
        var descriptor = Object.getOwnPropertyDescriptor(target, name);
        if ((descriptor === null || descriptor === void 0 ? void 0 : descriptor.set) && (descriptor === null || descriptor === void 0 ? void 0 : descriptor.get)) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $96cefe9acc8d79bc$var$collapseProxies() {
    var _this = this;
    var keys = Reflect.ownKeys(this);
    return keys.reduce(function(acc, key) {
        acc[key] = Reflect.get(_this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $96cefe9acc8d79bc$var$initInterceptors(data2) {
    var isObject2 = function(val) {
        return (typeof val === "undefined" ? "undefined" : (0, $j2WbH._)(val)) === "object" && !Array.isArray(val) && val !== null;
    };
    var recurse = function(obj) {
        var basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(function(param) {
            var _param = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(param, 2), key = _param[0], _param_ = _param[1], value = _param_.value, enumerable = _param_.enumerable;
            if (enumerable === false || value === void 0) return;
            if ((typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" && value !== null && value.__v_skip) return;
            var path = basePath === "" ? key : "".concat(basePath, ".").concat(key);
            if ((typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $96cefe9acc8d79bc$var$interceptor(callback) {
    var mutateObj = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    var obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize: function(data2, path, key) {
            return callback(this.initialValue, function() {
                return $96cefe9acc8d79bc$var$get(data2, path);
            }, function(value) {
                return $96cefe9acc8d79bc$var$set(data2, path, value);
            }, path, key);
        }
    };
    mutateObj(obj);
    return function(initialValue) {
        if ((typeof initialValue === "undefined" ? "undefined" : (0, $j2WbH._)(initialValue)) === "object" && initialValue !== null && initialValue._x_interceptor) {
            var initialize = obj.initialize.bind(obj);
            obj.initialize = function(data2, path, key) {
                var innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $96cefe9acc8d79bc$var$get(obj, path) {
    return path.split(".").reduce(function(carry, segment) {
        return carry[segment];
    }, obj);
}
function $96cefe9acc8d79bc$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $96cefe9acc8d79bc$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $96cefe9acc8d79bc$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $96cefe9acc8d79bc$var$magics = {};
function $96cefe9acc8d79bc$var$magic(name, callback) {
    $96cefe9acc8d79bc$var$magics[name] = callback;
}
function $96cefe9acc8d79bc$var$injectMagics(obj, el) {
    var memoizedUtilities = $96cefe9acc8d79bc$var$getUtilities(el);
    Object.entries($96cefe9acc8d79bc$var$magics).forEach(function(param) {
        var _param = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(param, 2), name = _param[0], callback = _param[1];
        Object.defineProperty(obj, "$".concat(name), {
            get: function() {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $96cefe9acc8d79bc$var$getUtilities(el) {
    var _getElementBoundUtilities = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)($96cefe9acc8d79bc$var$getElementBoundUtilities(el), 2), utilities = _getElementBoundUtilities[0], cleanup2 = _getElementBoundUtilities[1];
    var utils = (0, $a9846c98c872cb75$export$71511d61b312f219)({
        interceptor: $96cefe9acc8d79bc$var$interceptor
    }, utilities);
    $96cefe9acc8d79bc$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $96cefe9acc8d79bc$var$tryCatch(el, expression, callback) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        args[_key - 3] = arguments[_key];
    }
    try {
        return callback.apply(void 0, (0, $8ea412f19da8a8a2$export$71511d61b312f219)(args));
    } catch (e) {
        $96cefe9acc8d79bc$var$handleError(e, el, expression);
    }
}
function $96cefe9acc8d79bc$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 !== null && error2 !== void 0 ? error2 : {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn("Alpine Expression Error: ".concat(error2.message, "\n\n").concat(expression ? 'Expression: "' + expression + '"\n\n' : ""), el);
    setTimeout(function() {
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $96cefe9acc8d79bc$var$shouldAutoEvaluateFunctions = true;
function $96cefe9acc8d79bc$var$dontAutoEvaluateFunctions(callback) {
    var cache = $96cefe9acc8d79bc$var$shouldAutoEvaluateFunctions;
    $96cefe9acc8d79bc$var$shouldAutoEvaluateFunctions = false;
    var result = callback();
    $96cefe9acc8d79bc$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $96cefe9acc8d79bc$var$evaluate(el, expression) {
    var extras = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var result;
    $96cefe9acc8d79bc$var$evaluateLater(el, expression)(function(value) {
        return result = value;
    }, extras);
    return result;
}
function $96cefe9acc8d79bc$var$evaluateLater() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $96cefe9acc8d79bc$var$theEvaluatorFunction.apply(void 0, (0, $8ea412f19da8a8a2$export$71511d61b312f219)(args));
}
var $96cefe9acc8d79bc$var$theEvaluatorFunction = $96cefe9acc8d79bc$var$normalEvaluator;
function $96cefe9acc8d79bc$var$setEvaluator(newEvaluator) {
    $96cefe9acc8d79bc$var$theEvaluatorFunction = newEvaluator;
}
function $96cefe9acc8d79bc$var$normalEvaluator(el, expression) {
    var overriddenMagics = {};
    $96cefe9acc8d79bc$var$injectMagics(overriddenMagics, el);
    var dataStack = [
        overriddenMagics
    ].concat((0, $8ea412f19da8a8a2$export$71511d61b312f219)($96cefe9acc8d79bc$var$closestDataStack(el)));
    var evaluator = typeof expression === "function" ? $96cefe9acc8d79bc$var$generateEvaluatorFromFunction(dataStack, expression) : $96cefe9acc8d79bc$var$generateEvaluatorFromString(dataStack, expression, el);
    return $96cefe9acc8d79bc$var$tryCatch.bind(null, el, expression, evaluator);
}
function $96cefe9acc8d79bc$var$generateEvaluatorFromFunction(dataStack, func) {
    return function() {
        var receiver = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.scope, scope2 = tmp === void 0 ? {} : tmp, _ref_params = _ref.params, params = _ref_params === void 0 ? [] : _ref_params;
        var result = func.apply($96cefe9acc8d79bc$var$mergeProxies([
            scope2
        ].concat((0, $8ea412f19da8a8a2$export$71511d61b312f219)(dataStack))), params);
        $96cefe9acc8d79bc$var$runIfTypeOfFunction(receiver, result);
    };
}
var $96cefe9acc8d79bc$var$evaluatorMemo = {};
function $96cefe9acc8d79bc$var$generateFunctionFromString(expression, el) {
    if ($96cefe9acc8d79bc$var$evaluatorMemo[expression]) return $96cefe9acc8d79bc$var$evaluatorMemo[expression];
    var AsyncFunction = Object.getPrototypeOf(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $829c750286ec3a2c$export$71511d61b312f219)(function() {
            return (0, $15f39fe0df078b1e$export$67ebef60e6f28a6)(this, function(_state) {
                return [
                    2
                ];
            });
        })();
    }).constructor;
    var rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? "(async()=>{ ".concat(expression, " })()") : expression;
    var safeAsyncFunction = function() {
        try {
            var func2 = new AsyncFunction([
                "__self",
                "scope"
            ], "with (scope) { __self.result = ".concat(rightSideSafeExpression, " }; __self.finished = true; return __self.result;"));
            Object.defineProperty(func2, "name", {
                value: "[Alpine] ".concat(expression)
            });
            return func2;
        } catch (error2) {
            $96cefe9acc8d79bc$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    var func = safeAsyncFunction();
    $96cefe9acc8d79bc$var$evaluatorMemo[expression] = func;
    return func;
}
function $96cefe9acc8d79bc$var$generateEvaluatorFromString(dataStack, expression, el) {
    var func = $96cefe9acc8d79bc$var$generateFunctionFromString(expression, el);
    return function() {
        var receiver = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.scope, scope2 = tmp === void 0 ? {} : tmp, _ref_params = _ref.params, params = _ref_params === void 0 ? [] : _ref_params;
        func.result = void 0;
        func.finished = false;
        var completeScope = $96cefe9acc8d79bc$var$mergeProxies([
            scope2
        ].concat((0, $8ea412f19da8a8a2$export$71511d61b312f219)(dataStack)));
        if (typeof func === "function") {
            var promise = func(func, completeScope).catch(function(error2) {
                return $96cefe9acc8d79bc$var$handleError(error2, el, expression);
            });
            if (func.finished) {
                $96cefe9acc8d79bc$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then(function(result) {
                $96cefe9acc8d79bc$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch(function(error2) {
                return $96cefe9acc8d79bc$var$handleError(error2, el, expression);
            }).finally(function() {
                return func.result = void 0;
            });
        }
    };
}
function $96cefe9acc8d79bc$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($96cefe9acc8d79bc$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        var result = value.apply(scope2, params);
        if (result instanceof Promise) result.then(function(i) {
            return $96cefe9acc8d79bc$var$runIfTypeOfFunction(receiver, i, scope2, params);
        }).catch(function(error2) {
            return $96cefe9acc8d79bc$var$handleError(error2, el, value);
        });
        else receiver(result);
    } else if ((typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" && value instanceof Promise) value.then(function(i) {
        return receiver(i);
    });
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $96cefe9acc8d79bc$var$prefixAsString = "x-";
function $96cefe9acc8d79bc$var$prefix() {
    var subject = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return $96cefe9acc8d79bc$var$prefixAsString + subject;
}
function $96cefe9acc8d79bc$var$setPrefix(newPrefix) {
    $96cefe9acc8d79bc$var$prefixAsString = newPrefix;
}
var $96cefe9acc8d79bc$var$directiveHandlers = {};
function $96cefe9acc8d79bc$var$directive(name, callback) {
    $96cefe9acc8d79bc$var$directiveHandlers[name] = callback;
    return {
        before: function(directive2) {
            if (!$96cefe9acc8d79bc$var$directiveHandlers[directive2]) {
                console.warn(String.raw($96cefe9acc8d79bc$var$_templateObject(), directive2, name));
                return;
            }
            var pos = $96cefe9acc8d79bc$var$directiveOrder.indexOf(directive2);
            $96cefe9acc8d79bc$var$directiveOrder.splice(pos >= 0 ? pos : $96cefe9acc8d79bc$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $96cefe9acc8d79bc$var$directiveExists(name) {
    return Object.keys($96cefe9acc8d79bc$var$directiveHandlers).includes(name);
}
function $96cefe9acc8d79bc$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        var vAttributes = Object.entries(el._x_virtualDirectives).map(function(param) {
            var _param = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(param, 2), name = _param[0], value = _param[1];
            return {
                name: name,
                value: value
            };
        });
        var staticAttributes = $96cefe9acc8d79bc$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map(function(attribute) {
            if (staticAttributes.find(function(attr) {
                return attr.name === attribute.name;
            })) return {
                name: "x-bind:".concat(attribute.name),
                value: '"'.concat(attribute.value, '"')
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    var transformedAttributeMap = {};
    var directives2 = attributes.map($96cefe9acc8d79bc$var$toTransformedAttributes(function(newName, oldName) {
        return transformedAttributeMap[newName] = oldName;
    })).filter($96cefe9acc8d79bc$var$outNonAlpineAttributes).map($96cefe9acc8d79bc$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($96cefe9acc8d79bc$var$byPriority);
    return directives2.map(function(directive2) {
        return $96cefe9acc8d79bc$var$getDirectiveHandler(el, directive2);
    });
}
function $96cefe9acc8d79bc$var$attributesOnly(attributes) {
    return Array.from(attributes).map($96cefe9acc8d79bc$var$toTransformedAttributes()).filter(function(attr) {
        return !$96cefe9acc8d79bc$var$outNonAlpineAttributes(attr);
    });
}
var $96cefe9acc8d79bc$var$isDeferringHandlers = false;
var $96cefe9acc8d79bc$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $96cefe9acc8d79bc$var$currentHandlerStackKey = Symbol();
function $96cefe9acc8d79bc$var$deferHandlingDirectives(callback) {
    $96cefe9acc8d79bc$var$isDeferringHandlers = true;
    var key = Symbol();
    $96cefe9acc8d79bc$var$currentHandlerStackKey = key;
    $96cefe9acc8d79bc$var$directiveHandlerStacks.set(key, []);
    var flushHandlers = function() {
        while($96cefe9acc8d79bc$var$directiveHandlerStacks.get(key).length)$96cefe9acc8d79bc$var$directiveHandlerStacks.get(key).shift()();
        $96cefe9acc8d79bc$var$directiveHandlerStacks.delete(key);
    };
    var stopDeferring = function() {
        $96cefe9acc8d79bc$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $96cefe9acc8d79bc$var$getElementBoundUtilities(el) {
    var cleanups = [];
    var cleanup2 = function(callback) {
        return cleanups.push(callback);
    };
    var _elementBoundEffect = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)($96cefe9acc8d79bc$var$elementBoundEffect(el), 2), effect3 = _elementBoundEffect[0], cleanupEffect = _elementBoundEffect[1];
    cleanups.push(cleanupEffect);
    var utilities = {
        Alpine: $96cefe9acc8d79bc$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $96cefe9acc8d79bc$var$evaluateLater.bind($96cefe9acc8d79bc$var$evaluateLater, el),
        evaluate: $96cefe9acc8d79bc$var$evaluate.bind($96cefe9acc8d79bc$var$evaluate, el)
    };
    var doCleanup = function() {
        return cleanups.forEach(function(i) {
            return i();
        });
    };
    return [
        utilities,
        doCleanup
    ];
}
function $96cefe9acc8d79bc$var$getDirectiveHandler(el, directive2) {
    var noop = function() {};
    var handler4 = $96cefe9acc8d79bc$var$directiveHandlers[directive2.type] || noop;
    var _getElementBoundUtilities = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)($96cefe9acc8d79bc$var$getElementBoundUtilities(el), 2), utilities = _getElementBoundUtilities[0], cleanup2 = _getElementBoundUtilities[1];
    $96cefe9acc8d79bc$var$onAttributeRemoved(el, directive2.original, cleanup2);
    var fullHandler = function() {
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $96cefe9acc8d79bc$var$isDeferringHandlers ? $96cefe9acc8d79bc$var$directiveHandlerStacks.get($96cefe9acc8d79bc$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $96cefe9acc8d79bc$var$startingWith = function(subject, replacement) {
    return function(param) {
        var name = param.name, value = param.value;
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
};
var $96cefe9acc8d79bc$var$into = function(i) {
    return i;
};
function $96cefe9acc8d79bc$var$toTransformedAttributes() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    return function(param) {
        var name = param.name, value = param.value;
        var _attributeTransformers_reduce = $96cefe9acc8d79bc$var$attributeTransformers.reduce(function(carry, transform) {
            return transform(carry);
        }, {
            name: name,
            value: value
        }), newName = _attributeTransformers_reduce.name, newValue = _attributeTransformers_reduce.value;
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $96cefe9acc8d79bc$var$attributeTransformers = [];
function $96cefe9acc8d79bc$var$mapAttributes(callback) {
    $96cefe9acc8d79bc$var$attributeTransformers.push(callback);
}
function $96cefe9acc8d79bc$var$outNonAlpineAttributes(param) {
    var name = param.name;
    return $96cefe9acc8d79bc$var$alpineAttributeRegex().test(name);
}
var $96cefe9acc8d79bc$var$alpineAttributeRegex = function() {
    return new RegExp("^".concat($96cefe9acc8d79bc$var$prefixAsString, "([^:^.]+)\\b"));
};
function $96cefe9acc8d79bc$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return function(param) {
        var name = param.name, value = param.value;
        var typeMatch = name.match($96cefe9acc8d79bc$var$alpineAttributeRegex());
        var valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        var modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        var original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map(function(i) {
                return i.replace(".", "");
            }),
            expression: value,
            original: original
        };
    };
}
var $96cefe9acc8d79bc$var$DEFAULT = "DEFAULT";
var $96cefe9acc8d79bc$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $96cefe9acc8d79bc$var$DEFAULT,
    "teleport"
];
function $96cefe9acc8d79bc$var$byPriority(a, b) {
    var typeA = $96cefe9acc8d79bc$var$directiveOrder.indexOf(a.type) === -1 ? $96cefe9acc8d79bc$var$DEFAULT : a.type;
    var typeB = $96cefe9acc8d79bc$var$directiveOrder.indexOf(b.type) === -1 ? $96cefe9acc8d79bc$var$DEFAULT : b.type;
    return $96cefe9acc8d79bc$var$directiveOrder.indexOf(typeA) - $96cefe9acc8d79bc$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $96cefe9acc8d79bc$var$dispatch(el, name) {
    var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $96cefe9acc8d79bc$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach(function(el2) {
            return $96cefe9acc8d79bc$var$walk(el2, callback);
        });
        return;
    }
    var skip = false;
    callback(el, function() {
        return skip = true;
    });
    if (skip) return;
    var node = el.firstElementChild;
    while(node){
        $96cefe9acc8d79bc$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $96cefe9acc8d79bc$var$warn(message) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _console;
    (_console = console).warn.apply(_console, [
        "Alpine Warning: ".concat(message)
    ].concat((0, $8ea412f19da8a8a2$export$71511d61b312f219)(args)));
}
// packages/alpinejs/src/lifecycle.js
var $96cefe9acc8d79bc$var$started = false;
function $96cefe9acc8d79bc$var$start() {
    if ($96cefe9acc8d79bc$var$started) $96cefe9acc8d79bc$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $96cefe9acc8d79bc$var$started = true;
    if (!document.body) $96cefe9acc8d79bc$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $96cefe9acc8d79bc$var$dispatch(document, "alpine:init");
    $96cefe9acc8d79bc$var$dispatch(document, "alpine:initializing");
    $96cefe9acc8d79bc$var$startObservingMutations();
    $96cefe9acc8d79bc$var$onElAdded(function(el) {
        return $96cefe9acc8d79bc$var$initTree(el, $96cefe9acc8d79bc$var$walk);
    });
    $96cefe9acc8d79bc$var$onElRemoved(function(el) {
        return $96cefe9acc8d79bc$var$destroyTree(el);
    });
    $96cefe9acc8d79bc$var$onAttributesAdded(function(el, attrs) {
        $96cefe9acc8d79bc$var$directives(el, attrs).forEach(function(handle) {
            return handle();
        });
    });
    var outNestedComponents = function(el) {
        return !$96cefe9acc8d79bc$var$closestRoot(el.parentElement, true);
    };
    Array.from(document.querySelectorAll($96cefe9acc8d79bc$var$allSelectors().join(","))).filter(outNestedComponents).forEach(function(el) {
        $96cefe9acc8d79bc$var$initTree(el);
    });
    $96cefe9acc8d79bc$var$dispatch(document, "alpine:initialized");
    setTimeout(function() {
        $96cefe9acc8d79bc$var$warnAboutMissingPlugins();
    });
}
var $96cefe9acc8d79bc$var$rootSelectorCallbacks = [];
var $96cefe9acc8d79bc$var$initSelectorCallbacks = [];
function $96cefe9acc8d79bc$var$rootSelectors() {
    return $96cefe9acc8d79bc$var$rootSelectorCallbacks.map(function(fn) {
        return fn();
    });
}
function $96cefe9acc8d79bc$var$allSelectors() {
    return $96cefe9acc8d79bc$var$rootSelectorCallbacks.concat($96cefe9acc8d79bc$var$initSelectorCallbacks).map(function(fn) {
        return fn();
    });
}
function $96cefe9acc8d79bc$var$addRootSelector(selectorCallback) {
    $96cefe9acc8d79bc$var$rootSelectorCallbacks.push(selectorCallback);
}
function $96cefe9acc8d79bc$var$addInitSelector(selectorCallback) {
    $96cefe9acc8d79bc$var$initSelectorCallbacks.push(selectorCallback);
}
function $96cefe9acc8d79bc$var$closestRoot(el) {
    var includeInitSelectors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return $96cefe9acc8d79bc$var$findClosest(el, function(element) {
        var selectors = includeInitSelectors ? $96cefe9acc8d79bc$var$allSelectors() : $96cefe9acc8d79bc$var$rootSelectors();
        if (selectors.some(function(selector) {
            return element.matches(selector);
        })) return true;
    });
}
function $96cefe9acc8d79bc$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $96cefe9acc8d79bc$var$findClosest(el.parentElement, callback);
}
function $96cefe9acc8d79bc$var$isRoot(el) {
    return $96cefe9acc8d79bc$var$rootSelectors().some(function(selector) {
        return el.matches(selector);
    });
}
var $96cefe9acc8d79bc$var$initInterceptors2 = [];
function $96cefe9acc8d79bc$var$interceptInit(callback) {
    $96cefe9acc8d79bc$var$initInterceptors2.push(callback);
}
var $96cefe9acc8d79bc$var$markerDispenser = 1;
function $96cefe9acc8d79bc$var$initTree(el) {
    var walker = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $96cefe9acc8d79bc$var$walk, intercept = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
    if ($96cefe9acc8d79bc$var$findClosest(el, function(i) {
        return i._x_ignore;
    })) return;
    $96cefe9acc8d79bc$var$deferHandlingDirectives(function() {
        walker(el, function(el2, skip) {
            if (el2._x_marker) return;
            intercept(el2, skip);
            $96cefe9acc8d79bc$var$initInterceptors2.forEach(function(i) {
                return i(el2, skip);
            });
            $96cefe9acc8d79bc$var$directives(el2, el2.attributes).forEach(function(handle) {
                return handle();
            });
            if (!el2._x_ignore) el2._x_marker = $96cefe9acc8d79bc$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $96cefe9acc8d79bc$var$destroyTree(root) {
    var walker = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $96cefe9acc8d79bc$var$walk;
    walker(root, function(el) {
        $96cefe9acc8d79bc$var$cleanupElement(el);
        $96cefe9acc8d79bc$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $96cefe9acc8d79bc$var$warnAboutMissingPlugins() {
    var pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(function(param) {
        var _param = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(param, 3), plugin2 = _param[0], directive2 = _param[1], selectors = _param[2];
        if ($96cefe9acc8d79bc$var$directiveExists(directive2)) return;
        selectors.some(function(selector) {
            if (document.querySelector(selector)) {
                $96cefe9acc8d79bc$var$warn('found "'.concat(selector, '", but missing ').concat(plugin2, " plugin"));
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $96cefe9acc8d79bc$var$tickStack = [];
var $96cefe9acc8d79bc$var$isHolding = false;
function $96cefe9acc8d79bc$var$nextTick() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    queueMicrotask(function() {
        $96cefe9acc8d79bc$var$isHolding || setTimeout(function() {
            $96cefe9acc8d79bc$var$releaseNextTicks();
        });
    });
    return new Promise(function(res) {
        $96cefe9acc8d79bc$var$tickStack.push(function() {
            callback();
            res();
        });
    });
}
function $96cefe9acc8d79bc$var$releaseNextTicks() {
    $96cefe9acc8d79bc$var$isHolding = false;
    while($96cefe9acc8d79bc$var$tickStack.length)$96cefe9acc8d79bc$var$tickStack.shift()();
}
function $96cefe9acc8d79bc$var$holdNextTicks() {
    $96cefe9acc8d79bc$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $96cefe9acc8d79bc$var$setClasses(el, value) {
    if (Array.isArray(value)) return $96cefe9acc8d79bc$var$setClassesFromString(el, value.join(" "));
    else if ((typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" && value !== null) return $96cefe9acc8d79bc$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $96cefe9acc8d79bc$var$setClasses(el, value());
    return $96cefe9acc8d79bc$var$setClassesFromString(el, value);
}
function $96cefe9acc8d79bc$var$setClassesFromString(el, classString) {
    var split = function(classString2) {
        return classString2.split(" ").filter(Boolean);
    };
    var missingClasses = function(classString2) {
        return classString2.split(" ").filter(function(i) {
            return !el.classList.contains(i);
        }).filter(Boolean);
    };
    var addClassesAndReturnUndo = function(classes) {
        var _el_classList;
        (_el_classList = el.classList).add.apply(_el_classList, (0, $8ea412f19da8a8a2$export$71511d61b312f219)(classes));
        return function() {
            var _el_classList;
            (_el_classList = el.classList).remove.apply(_el_classList, (0, $8ea412f19da8a8a2$export$71511d61b312f219)(classes));
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $96cefe9acc8d79bc$var$setClassesFromObject(el, classObject) {
    var split = function(classString) {
        return classString.split(" ").filter(Boolean);
    };
    var forAdd = Object.entries(classObject).flatMap(function(param) {
        var _param = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(param, 2), classString = _param[0], bool = _param[1];
        return bool ? split(classString) : false;
    }).filter(Boolean);
    var forRemove = Object.entries(classObject).flatMap(function(param) {
        var _param = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(param, 2), classString = _param[0], bool = _param[1];
        return !bool ? split(classString) : false;
    }).filter(Boolean);
    var added = [];
    var removed = [];
    forRemove.forEach(function(i) {
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach(function(i) {
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return function() {
        removed.forEach(function(i) {
            return el.classList.add(i);
        });
        added.forEach(function(i) {
            return el.classList.remove(i);
        });
    };
}
// packages/alpinejs/src/utils/styles.js
function $96cefe9acc8d79bc$var$setStyles(el, value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" && value !== null) return $96cefe9acc8d79bc$var$setStylesFromObject(el, value);
    return $96cefe9acc8d79bc$var$setStylesFromString(el, value);
}
function $96cefe9acc8d79bc$var$setStylesFromObject(el, value) {
    var previousStyles = {};
    Object.entries(value).forEach(function(param) {
        var _param = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(param, 2), key = _param[0], value2 = _param[1];
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $96cefe9acc8d79bc$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(function() {
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return function() {
        $96cefe9acc8d79bc$var$setStyles(el, previousStyles);
    };
}
function $96cefe9acc8d79bc$var$setStylesFromString(el, value) {
    var cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return function() {
        el.setAttribute("style", cache || "");
    };
}
function $96cefe9acc8d79bc$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $96cefe9acc8d79bc$var$once(callback) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    var called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$96cefe9acc8d79bc$var$directive("transition", function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, evaluate2 = param1.evaluate;
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $96cefe9acc8d79bc$var$registerTransitionsFromHelper(el, modifiers, value);
    else $96cefe9acc8d79bc$var$registerTransitionsFromClassString(el, expression, value);
});
function $96cefe9acc8d79bc$var$registerTransitionsFromClassString(el, classString, stage) {
    $96cefe9acc8d79bc$var$registerTransitionObject(el, $96cefe9acc8d79bc$var$setClasses, "");
    var directiveStorageMap = {
        "enter": function(classes) {
            el._x_transition.enter.during = classes;
        },
        "enter-start": function(classes) {
            el._x_transition.enter.start = classes;
        },
        "enter-end": function(classes) {
            el._x_transition.enter.end = classes;
        },
        "leave": function(classes) {
            el._x_transition.leave.during = classes;
        },
        "leave-start": function(classes) {
            el._x_transition.leave.start = classes;
        },
        "leave-end": function(classes) {
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $96cefe9acc8d79bc$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $96cefe9acc8d79bc$var$registerTransitionObject(el, $96cefe9acc8d79bc$var$setStyles);
    var doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    var transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    var transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter(function(i, index) {
        return index < modifiers.indexOf("out");
    });
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter(function(i, index) {
        return index > modifiers.indexOf("out");
    });
    var wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    var wantsOpacity = wantsAll || modifiers.includes("opacity");
    var wantsScale = wantsAll || modifiers.includes("scale");
    var opacityValue = wantsOpacity ? 0 : 1;
    var scaleValue = wantsScale ? $96cefe9acc8d79bc$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    var delay = $96cefe9acc8d79bc$var$modifierValue(modifiers, "delay", 0) / 1e3;
    var origin = $96cefe9acc8d79bc$var$modifierValue(modifiers, "origin", "center");
    var property = "opacity, transform";
    var durationIn = $96cefe9acc8d79bc$var$modifierValue(modifiers, "duration", 150) / 1e3;
    var durationOut = $96cefe9acc8d79bc$var$modifierValue(modifiers, "duration", 75) / 1e3;
    var easing = "cubic-bezier(0.4, 0.0, 0.2, 1)";
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: "".concat(delay, "s"),
            transitionProperty: property,
            transitionDuration: "".concat(durationIn, "s"),
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: "scale(".concat(scaleValue, ")")
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: "scale(1)"
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: "".concat(delay, "s"),
            transitionProperty: property,
            transitionDuration: "".concat(durationOut, "s"),
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: "scale(1)"
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: "scale(".concat(scaleValue, ")")
        };
    }
}
function $96cefe9acc8d79bc$var$registerTransitionObject(el, setFunction) {
    var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in: function() {
            var before = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
            $96cefe9acc8d79bc$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out: function() {
            var before = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
            $96cefe9acc8d79bc$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    var nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    var clickAwayCompatibleShow = function() {
        return nextTick2(show);
    };
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise(function(resolve, reject) {
        el._x_transition.out(function() {}, function() {
            return resolve(hide);
        });
        el._x_transitioning && el._x_transitioning.beforeCancel(function() {
            return reject({
                isFromCancelledTransition: true
            });
        });
    }) : Promise.resolve(hide);
    queueMicrotask(function() {
        var closest = $96cefe9acc8d79bc$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(function() {
            var hideAfterChildren = function(el2) {
                var carry = Promise.all([
                    el2._x_hidePromise
                ].concat((0, $8ea412f19da8a8a2$export$71511d61b312f219)((el2._x_hideChildren || []).map(hideAfterChildren)))).then(function(param) {
                    var _param = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(param, 1), i = _param[0];
                    return i === null || i === void 0 ? void 0 : i();
                });
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch(function(e) {
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $96cefe9acc8d79bc$var$closestHide(el) {
    var parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $96cefe9acc8d79bc$var$closestHide(parent);
}
function $96cefe9acc8d79bc$var$transition(el, setFunction) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, during = _ref.during, start2 = _ref.start, end = _ref.end, before = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {}, after = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {};
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    var undoStart, undoDuring, undoEnd;
    $96cefe9acc8d79bc$var$performTransition(el, {
        start: function() {
            undoStart = setFunction(el, start2);
        },
        during: function() {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end: function() {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup: function() {
            undoDuring();
            undoEnd();
        }
    });
}
function $96cefe9acc8d79bc$var$performTransition(el, stages) {
    var interrupted, reachedBefore, reachedEnd;
    var finish = $96cefe9acc8d79bc$var$once(function() {
        $96cefe9acc8d79bc$var$mutateDom(function() {
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $96cefe9acc8d79bc$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel: function(callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $96cefe9acc8d79bc$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $96cefe9acc8d79bc$var$mutateDom(function() {
        stages.start();
        stages.during();
    });
    $96cefe9acc8d79bc$var$holdNextTicks();
    requestAnimationFrame(function() {
        if (interrupted) return;
        var duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        var delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $96cefe9acc8d79bc$var$mutateDom(function() {
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(function() {
            if (interrupted) return;
            $96cefe9acc8d79bc$var$mutateDom(function() {
                stages.end();
            });
            $96cefe9acc8d79bc$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $96cefe9acc8d79bc$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    var rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        var match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $96cefe9acc8d79bc$var$isCloning = false;
function $96cefe9acc8d79bc$var$skipDuringClone(callback) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $96cefe9acc8d79bc$var$isCloning ? fallback.apply(void 0, (0, $8ea412f19da8a8a2$export$71511d61b312f219)(args)) : callback.apply(void 0, (0, $8ea412f19da8a8a2$export$71511d61b312f219)(args));
    };
}
function $96cefe9acc8d79bc$var$onlyDuringClone(callback) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $96cefe9acc8d79bc$var$isCloning && callback.apply(void 0, (0, $8ea412f19da8a8a2$export$71511d61b312f219)(args));
    };
}
var $96cefe9acc8d79bc$var$interceptors = [];
function $96cefe9acc8d79bc$var$interceptClone(callback) {
    $96cefe9acc8d79bc$var$interceptors.push(callback);
}
function $96cefe9acc8d79bc$var$cloneNode(from, to) {
    $96cefe9acc8d79bc$var$interceptors.forEach(function(i) {
        return i(from, to);
    });
    $96cefe9acc8d79bc$var$isCloning = true;
    $96cefe9acc8d79bc$var$dontRegisterReactiveSideEffects(function() {
        $96cefe9acc8d79bc$var$initTree(to, function(el, callback) {
            callback(el, function() {});
        });
    });
    $96cefe9acc8d79bc$var$isCloning = false;
}
var $96cefe9acc8d79bc$var$isCloningLegacy = false;
function $96cefe9acc8d79bc$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $96cefe9acc8d79bc$var$isCloning = true;
    $96cefe9acc8d79bc$var$isCloningLegacy = true;
    $96cefe9acc8d79bc$var$dontRegisterReactiveSideEffects(function() {
        $96cefe9acc8d79bc$var$cloneTree(newEl);
    });
    $96cefe9acc8d79bc$var$isCloning = false;
    $96cefe9acc8d79bc$var$isCloningLegacy = false;
}
function $96cefe9acc8d79bc$var$cloneTree(el) {
    var hasRunThroughFirstEl = false;
    var shallowWalker = function(el2, callback) {
        $96cefe9acc8d79bc$var$walk(el2, function(el3, skip) {
            if (hasRunThroughFirstEl && $96cefe9acc8d79bc$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $96cefe9acc8d79bc$var$initTree(el, shallowWalker);
}
function $96cefe9acc8d79bc$var$dontRegisterReactiveSideEffects(callback) {
    var cache = $96cefe9acc8d79bc$var$effect;
    $96cefe9acc8d79bc$var$overrideEffect(function(callback2, el) {
        var storedEffect = cache(callback2);
        $96cefe9acc8d79bc$var$release(storedEffect);
        return function() {};
    });
    callback();
    $96cefe9acc8d79bc$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $96cefe9acc8d79bc$var$bind(el, name, value) {
    var modifiers = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    if (!el._x_bindings) el._x_bindings = $96cefe9acc8d79bc$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $96cefe9acc8d79bc$var$camelCase(name) : name;
    switch(name){
        case "value":
            $96cefe9acc8d79bc$var$bindInputValue(el, value);
            break;
        case "style":
            $96cefe9acc8d79bc$var$bindStyles(el, value);
            break;
        case "class":
            $96cefe9acc8d79bc$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $96cefe9acc8d79bc$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $96cefe9acc8d79bc$var$bindAttribute(el, name, value);
            break;
    }
}
function $96cefe9acc8d79bc$var$bindInputValue(el, value) {
    if ($96cefe9acc8d79bc$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $96cefe9acc8d79bc$var$safeParseBoolean(el.value) === value;
            else el.checked = $96cefe9acc8d79bc$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($96cefe9acc8d79bc$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some(function(val) {
            return $96cefe9acc8d79bc$var$checkedAttrLooseCompare(val, el.value);
        });
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $96cefe9acc8d79bc$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $96cefe9acc8d79bc$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $96cefe9acc8d79bc$var$setClasses(el, value);
}
function $96cefe9acc8d79bc$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $96cefe9acc8d79bc$var$setStyles(el, value);
}
function $96cefe9acc8d79bc$var$bindAttributeAndProperty(el, name, value) {
    $96cefe9acc8d79bc$var$bindAttribute(el, name, value);
    $96cefe9acc8d79bc$var$setPropertyIfChanged(el, name, value);
}
function $96cefe9acc8d79bc$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $96cefe9acc8d79bc$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($96cefe9acc8d79bc$var$isBooleanAttr(name)) value = name;
        $96cefe9acc8d79bc$var$setIfChanged(el, name, value);
    }
}
function $96cefe9acc8d79bc$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $96cefe9acc8d79bc$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $96cefe9acc8d79bc$var$updateSelect(el, value) {
    var arrayWrappedValue = [].concat(value).map(function(value2) {
        return value2 + "";
    });
    Array.from(el.options).forEach(function(option) {
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $96cefe9acc8d79bc$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, function(match, char) {
        return char.toUpperCase();
    });
}
function $96cefe9acc8d79bc$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $96cefe9acc8d79bc$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $96cefe9acc8d79bc$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $96cefe9acc8d79bc$var$isBooleanAttr(attrName) {
    return $96cefe9acc8d79bc$var$booleanAttributes.has(attrName);
}
function $96cefe9acc8d79bc$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $96cefe9acc8d79bc$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $96cefe9acc8d79bc$var$getAttributeBinding(el, name, fallback);
}
function $96cefe9acc8d79bc$var$extractProp(el, name, fallback) {
    var extract = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        var binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $96cefe9acc8d79bc$var$dontAutoEvaluateFunctions(function() {
            return $96cefe9acc8d79bc$var$evaluate(el, binding.expression);
        });
    }
    return $96cefe9acc8d79bc$var$getAttributeBinding(el, name, fallback);
}
function $96cefe9acc8d79bc$var$getAttributeBinding(el, name, fallback) {
    var attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($96cefe9acc8d79bc$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $96cefe9acc8d79bc$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $96cefe9acc8d79bc$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $96cefe9acc8d79bc$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function later() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $96cefe9acc8d79bc$var$throttle(func, limit) {
    var inThrottle;
    return function() {
        var context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(function() {
                return inThrottle = false;
            }, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $96cefe9acc8d79bc$var$entangle(param, param1) {
    var outerGet = param.get, outerSet = param.set, innerGet = param1.get, innerSet = param1.set;
    var firstRun = true;
    var outerHash;
    var innerHash;
    var reference = $96cefe9acc8d79bc$var$effect(function() {
        var outer = outerGet();
        var inner = innerGet();
        if (firstRun) {
            innerSet($96cefe9acc8d79bc$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            var outerHashLatest = JSON.stringify(outer);
            var innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($96cefe9acc8d79bc$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($96cefe9acc8d79bc$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return function() {
        $96cefe9acc8d79bc$var$release(reference);
    };
}
function $96cefe9acc8d79bc$var$cloneIfObject(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $96cefe9acc8d79bc$var$plugin(callback) {
    var callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach(function(i) {
        return i($96cefe9acc8d79bc$var$alpine_default);
    });
}
// packages/alpinejs/src/store.js
var $96cefe9acc8d79bc$var$stores = {};
var $96cefe9acc8d79bc$var$isReactive = false;
function $96cefe9acc8d79bc$var$store(name, value) {
    if (!$96cefe9acc8d79bc$var$isReactive) {
        $96cefe9acc8d79bc$var$stores = $96cefe9acc8d79bc$var$reactive($96cefe9acc8d79bc$var$stores);
        $96cefe9acc8d79bc$var$isReactive = true;
    }
    if (value === void 0) return $96cefe9acc8d79bc$var$stores[name];
    $96cefe9acc8d79bc$var$stores[name] = value;
    $96cefe9acc8d79bc$var$initInterceptors($96cefe9acc8d79bc$var$stores[name]);
    if ((typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $96cefe9acc8d79bc$var$stores[name].init();
}
function $96cefe9acc8d79bc$var$getStores() {
    return $96cefe9acc8d79bc$var$stores;
}
// packages/alpinejs/src/binds.js
var $96cefe9acc8d79bc$var$binds = {};
function $96cefe9acc8d79bc$var$bind2(name, bindings) {
    var getBindings = typeof bindings !== "function" ? function() {
        return bindings;
    } : bindings;
    if (name instanceof Element) return $96cefe9acc8d79bc$var$applyBindingsObject(name, getBindings());
    else $96cefe9acc8d79bc$var$binds[name] = getBindings;
    return function() {};
}
function $96cefe9acc8d79bc$var$injectBindingProviders(obj) {
    Object.entries($96cefe9acc8d79bc$var$binds).forEach(function(param) {
        var _param = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(param, 2), name = _param[0], callback = _param[1];
        Object.defineProperty(obj, name, {
            get: function() {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return callback.apply(void 0, (0, $8ea412f19da8a8a2$export$71511d61b312f219)(args));
                };
            }
        });
    });
    return obj;
}
function $96cefe9acc8d79bc$var$applyBindingsObject(el, obj, original) {
    var cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    var attributes = Object.entries(obj).map(function(param) {
        var _param = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(param, 2), name = _param[0], value = _param[1];
        return {
            name: name,
            value: value
        };
    });
    var staticAttributes = $96cefe9acc8d79bc$var$attributesOnly(attributes);
    attributes = attributes.map(function(attribute) {
        if (staticAttributes.find(function(attr) {
            return attr.name === attribute.name;
        })) return {
            name: "x-bind:".concat(attribute.name),
            value: '"'.concat(attribute.value, '"')
        };
        return attribute;
    });
    $96cefe9acc8d79bc$var$directives(el, attributes, original).map(function(handle) {
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return function() {
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $96cefe9acc8d79bc$var$datas = {};
function $96cefe9acc8d79bc$var$data(name, callback) {
    $96cefe9acc8d79bc$var$datas[name] = callback;
}
function $96cefe9acc8d79bc$var$injectDataProviders(obj, context) {
    Object.entries($96cefe9acc8d79bc$var$datas).forEach(function(param) {
        var _param = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(param, 2), name = _param[0], callback = _param[1];
        Object.defineProperty(obj, name, {
            get: function() {
                var _this = this;
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return callback.bind(context).apply(_this, (0, $8ea412f19da8a8a2$export$71511d61b312f219)(args));
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $96cefe9acc8d79bc$var$Alpine = {
    get reactive () {
        return $96cefe9acc8d79bc$var$reactive;
    },
    get release () {
        return $96cefe9acc8d79bc$var$release;
    },
    get effect () {
        return $96cefe9acc8d79bc$var$effect;
    },
    get raw () {
        return $96cefe9acc8d79bc$var$raw;
    },
    version: "3.14.8",
    flushAndStopDeferringMutations: $96cefe9acc8d79bc$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $96cefe9acc8d79bc$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $96cefe9acc8d79bc$var$disableEffectScheduling,
    startObservingMutations: $96cefe9acc8d79bc$var$startObservingMutations,
    stopObservingMutations: $96cefe9acc8d79bc$var$stopObservingMutations,
    setReactivityEngine: $96cefe9acc8d79bc$var$setReactivityEngine,
    onAttributeRemoved: $96cefe9acc8d79bc$var$onAttributeRemoved,
    onAttributesAdded: $96cefe9acc8d79bc$var$onAttributesAdded,
    closestDataStack: $96cefe9acc8d79bc$var$closestDataStack,
    skipDuringClone: $96cefe9acc8d79bc$var$skipDuringClone,
    onlyDuringClone: $96cefe9acc8d79bc$var$onlyDuringClone,
    addRootSelector: $96cefe9acc8d79bc$var$addRootSelector,
    addInitSelector: $96cefe9acc8d79bc$var$addInitSelector,
    interceptClone: $96cefe9acc8d79bc$var$interceptClone,
    addScopeToNode: $96cefe9acc8d79bc$var$addScopeToNode,
    deferMutations: $96cefe9acc8d79bc$var$deferMutations,
    mapAttributes: $96cefe9acc8d79bc$var$mapAttributes,
    evaluateLater: $96cefe9acc8d79bc$var$evaluateLater,
    interceptInit: $96cefe9acc8d79bc$var$interceptInit,
    setEvaluator: $96cefe9acc8d79bc$var$setEvaluator,
    mergeProxies: $96cefe9acc8d79bc$var$mergeProxies,
    extractProp: $96cefe9acc8d79bc$var$extractProp,
    findClosest: $96cefe9acc8d79bc$var$findClosest,
    onElRemoved: $96cefe9acc8d79bc$var$onElRemoved,
    closestRoot: $96cefe9acc8d79bc$var$closestRoot,
    destroyTree: $96cefe9acc8d79bc$var$destroyTree,
    interceptor: $96cefe9acc8d79bc$var$interceptor,
    // INTERNAL: not public API and is subject to change without major release.
    transition: $96cefe9acc8d79bc$var$transition,
    // INTERNAL
    setStyles: $96cefe9acc8d79bc$var$setStyles,
    // INTERNAL
    mutateDom: $96cefe9acc8d79bc$var$mutateDom,
    directive: $96cefe9acc8d79bc$var$directive,
    entangle: $96cefe9acc8d79bc$var$entangle,
    throttle: $96cefe9acc8d79bc$var$throttle,
    debounce: $96cefe9acc8d79bc$var$debounce,
    evaluate: $96cefe9acc8d79bc$var$evaluate,
    initTree: $96cefe9acc8d79bc$var$initTree,
    nextTick: $96cefe9acc8d79bc$var$nextTick,
    prefixed: $96cefe9acc8d79bc$var$prefix,
    prefix: $96cefe9acc8d79bc$var$setPrefix,
    plugin: $96cefe9acc8d79bc$var$plugin,
    magic: $96cefe9acc8d79bc$var$magic,
    store: $96cefe9acc8d79bc$var$store,
    start: $96cefe9acc8d79bc$var$start,
    clone: $96cefe9acc8d79bc$var$clone,
    // INTERNAL
    cloneNode: $96cefe9acc8d79bc$var$cloneNode,
    // INTERNAL
    bound: $96cefe9acc8d79bc$var$getBinding,
    $data: $96cefe9acc8d79bc$var$scope,
    watch: $96cefe9acc8d79bc$var$watch,
    walk: $96cefe9acc8d79bc$var$walk,
    data: $96cefe9acc8d79bc$var$data,
    bind: $96cefe9acc8d79bc$var$bind2
};
var $96cefe9acc8d79bc$var$alpine_default = $96cefe9acc8d79bc$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $96cefe9acc8d79bc$var$makeMap(str, expectsLowerCase) {
    var map = /* @__PURE__ */ Object.create(null);
    var list = str.split(",");
    for(var i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? function(val) {
        return !!map[val.toLowerCase()];
    } : function(val) {
        return !!map[val];
    };
}
var $96cefe9acc8d79bc$var$specialBooleanAttrs = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly";
var $96cefe9acc8d79bc$var$isBooleanAttr2 = /* @__PURE__ */ $96cefe9acc8d79bc$var$makeMap($96cefe9acc8d79bc$var$specialBooleanAttrs + ",async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected");
var $96cefe9acc8d79bc$var$EMPTY_OBJ = Object.freeze({});
var $96cefe9acc8d79bc$var$EMPTY_ARR = Object.freeze([]);
var $96cefe9acc8d79bc$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $96cefe9acc8d79bc$var$hasOwn = function(val, key) {
    return $96cefe9acc8d79bc$var$hasOwnProperty.call(val, key);
};
var $96cefe9acc8d79bc$var$isArray = Array.isArray;
var $96cefe9acc8d79bc$var$isMap = function(val) {
    return $96cefe9acc8d79bc$var$toTypeString(val) === "[object Map]";
};
var $96cefe9acc8d79bc$var$isString = function(val) {
    return typeof val === "string";
};
var $96cefe9acc8d79bc$var$isSymbol = function(val) {
    return (typeof val === "undefined" ? "undefined" : (0, $j2WbH._)(val)) === "symbol";
};
var $96cefe9acc8d79bc$var$isObject = function(val) {
    return val !== null && (typeof val === "undefined" ? "undefined" : (0, $j2WbH._)(val)) === "object";
};
var $96cefe9acc8d79bc$var$objectToString = Object.prototype.toString;
var $96cefe9acc8d79bc$var$toTypeString = function(value) {
    return $96cefe9acc8d79bc$var$objectToString.call(value);
};
var $96cefe9acc8d79bc$var$toRawType = function(value) {
    return $96cefe9acc8d79bc$var$toTypeString(value).slice(8, -1);
};
var $96cefe9acc8d79bc$var$isIntegerKey = function(key) {
    return $96cefe9acc8d79bc$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
};
var $96cefe9acc8d79bc$var$cacheStringFunction = function(fn) {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $96cefe9acc8d79bc$var$camelizeRE = /-(\w)/g;
var $96cefe9acc8d79bc$var$camelize = $96cefe9acc8d79bc$var$cacheStringFunction(function(str) {
    return str.replace($96cefe9acc8d79bc$var$camelizeRE, function(_, c) {
        return c ? c.toUpperCase() : "";
    });
});
var $96cefe9acc8d79bc$var$hyphenateRE = /\B([A-Z])/g;
var $96cefe9acc8d79bc$var$hyphenate = $96cefe9acc8d79bc$var$cacheStringFunction(function(str) {
    return str.replace($96cefe9acc8d79bc$var$hyphenateRE, "-$1").toLowerCase();
});
var $96cefe9acc8d79bc$var$capitalize = $96cefe9acc8d79bc$var$cacheStringFunction(function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
var $96cefe9acc8d79bc$var$toHandlerKey = $96cefe9acc8d79bc$var$cacheStringFunction(function(str) {
    return str ? "on".concat($96cefe9acc8d79bc$var$capitalize(str)) : "";
});
var $96cefe9acc8d79bc$var$hasChanged = function(value, oldValue) {
    return value !== oldValue && (value === value || oldValue === oldValue);
};
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $96cefe9acc8d79bc$var$targetMap = /* @__PURE__ */ new WeakMap();
var $96cefe9acc8d79bc$var$effectStack = [];
var $96cefe9acc8d79bc$var$activeEffect;
var $96cefe9acc8d79bc$var$ITERATE_KEY = Symbol("iterate");
var $96cefe9acc8d79bc$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $96cefe9acc8d79bc$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $96cefe9acc8d79bc$var$effect2(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $96cefe9acc8d79bc$var$EMPTY_OBJ;
    if ($96cefe9acc8d79bc$var$isEffect(fn)) fn = fn.raw;
    var effect3 = $96cefe9acc8d79bc$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $96cefe9acc8d79bc$var$stop(effect3) {
    if (effect3.active) {
        $96cefe9acc8d79bc$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $96cefe9acc8d79bc$var$uid = 0;
function $96cefe9acc8d79bc$var$createReactiveEffect(fn, options) {
    var effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$96cefe9acc8d79bc$var$effectStack.includes(effect3)) {
            $96cefe9acc8d79bc$var$cleanup(effect3);
            try {
                $96cefe9acc8d79bc$var$enableTracking();
                $96cefe9acc8d79bc$var$effectStack.push(effect3);
                $96cefe9acc8d79bc$var$activeEffect = effect3;
                return fn();
            } finally{
                $96cefe9acc8d79bc$var$effectStack.pop();
                $96cefe9acc8d79bc$var$resetTracking();
                $96cefe9acc8d79bc$var$activeEffect = $96cefe9acc8d79bc$var$effectStack[$96cefe9acc8d79bc$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $96cefe9acc8d79bc$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $96cefe9acc8d79bc$var$cleanup(effect3) {
    var deps = effect3.deps;
    if (deps.length) {
        for(var i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $96cefe9acc8d79bc$var$shouldTrack = true;
var $96cefe9acc8d79bc$var$trackStack = [];
function $96cefe9acc8d79bc$var$pauseTracking() {
    $96cefe9acc8d79bc$var$trackStack.push($96cefe9acc8d79bc$var$shouldTrack);
    $96cefe9acc8d79bc$var$shouldTrack = false;
}
function $96cefe9acc8d79bc$var$enableTracking() {
    $96cefe9acc8d79bc$var$trackStack.push($96cefe9acc8d79bc$var$shouldTrack);
    $96cefe9acc8d79bc$var$shouldTrack = true;
}
function $96cefe9acc8d79bc$var$resetTracking() {
    var last = $96cefe9acc8d79bc$var$trackStack.pop();
    $96cefe9acc8d79bc$var$shouldTrack = last === void 0 ? true : last;
}
function $96cefe9acc8d79bc$var$track(target, type, key) {
    if (!$96cefe9acc8d79bc$var$shouldTrack || $96cefe9acc8d79bc$var$activeEffect === void 0) return;
    var depsMap = $96cefe9acc8d79bc$var$targetMap.get(target);
    if (!depsMap) $96cefe9acc8d79bc$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    var dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($96cefe9acc8d79bc$var$activeEffect)) {
        dep.add($96cefe9acc8d79bc$var$activeEffect);
        $96cefe9acc8d79bc$var$activeEffect.deps.push(dep);
        if ($96cefe9acc8d79bc$var$activeEffect.options.onTrack) $96cefe9acc8d79bc$var$activeEffect.options.onTrack({
            effect: $96cefe9acc8d79bc$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $96cefe9acc8d79bc$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    var depsMap = $96cefe9acc8d79bc$var$targetMap.get(target);
    if (!depsMap) return;
    var effects = /* @__PURE__ */ new Set();
    var add2 = function(effectsToAdd) {
        if (effectsToAdd) effectsToAdd.forEach(function(effect3) {
            if (effect3 !== $96cefe9acc8d79bc$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $96cefe9acc8d79bc$var$isArray(target)) depsMap.forEach(function(dep, key2) {
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$96cefe9acc8d79bc$var$isArray(target)) {
                    add2(depsMap.get($96cefe9acc8d79bc$var$ITERATE_KEY));
                    if ($96cefe9acc8d79bc$var$isMap(target)) add2(depsMap.get($96cefe9acc8d79bc$var$MAP_KEY_ITERATE_KEY));
                } else if ($96cefe9acc8d79bc$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$96cefe9acc8d79bc$var$isArray(target)) {
                    add2(depsMap.get($96cefe9acc8d79bc$var$ITERATE_KEY));
                    if ($96cefe9acc8d79bc$var$isMap(target)) add2(depsMap.get($96cefe9acc8d79bc$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($96cefe9acc8d79bc$var$isMap(target)) add2(depsMap.get($96cefe9acc8d79bc$var$ITERATE_KEY));
                break;
        }
    }
    var run = function(effect3) {
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $96cefe9acc8d79bc$var$isNonTrackableKeys = /* @__PURE__ */ $96cefe9acc8d79bc$var$makeMap("__proto__,__v_isRef,__isVue");
var $96cefe9acc8d79bc$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map(function(key) {
    return Symbol[key];
}).filter($96cefe9acc8d79bc$var$isSymbol));
var $96cefe9acc8d79bc$var$get2 = /* @__PURE__ */ $96cefe9acc8d79bc$var$createGetter();
var $96cefe9acc8d79bc$var$readonlyGet = /* @__PURE__ */ $96cefe9acc8d79bc$var$createGetter(true);
var $96cefe9acc8d79bc$var$arrayInstrumentations = /* @__PURE__ */ $96cefe9acc8d79bc$var$createArrayInstrumentations();
function $96cefe9acc8d79bc$var$createArrayInstrumentations() {
    var instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _arr, _arr1;
            var arr = $96cefe9acc8d79bc$var$toRaw(this);
            for(var i = 0, l = this.length; i < l; i++)$96cefe9acc8d79bc$var$track(arr, "get", i + "");
            var res = (_arr = arr)[key].apply(_arr, (0, $8ea412f19da8a8a2$export$71511d61b312f219)(args));
            if (res === -1 || res === false) return (_arr1 = arr)[key].apply(_arr1, (0, $8ea412f19da8a8a2$export$71511d61b312f219)(args.map($96cefe9acc8d79bc$var$toRaw)));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            $96cefe9acc8d79bc$var$pauseTracking();
            var res = $96cefe9acc8d79bc$var$toRaw(this)[key].apply(this, args);
            $96cefe9acc8d79bc$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $96cefe9acc8d79bc$var$createGetter() {
    var isReadonly = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, shallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $96cefe9acc8d79bc$var$shallowReadonlyMap : $96cefe9acc8d79bc$var$readonlyMap : shallow ? $96cefe9acc8d79bc$var$shallowReactiveMap : $96cefe9acc8d79bc$var$reactiveMap).get(target)) return target;
        var targetIsArray = $96cefe9acc8d79bc$var$isArray(target);
        if (!isReadonly && targetIsArray && $96cefe9acc8d79bc$var$hasOwn($96cefe9acc8d79bc$var$arrayInstrumentations, key)) return Reflect.get($96cefe9acc8d79bc$var$arrayInstrumentations, key, receiver);
        var res = Reflect.get(target, key, receiver);
        if ($96cefe9acc8d79bc$var$isSymbol(key) ? $96cefe9acc8d79bc$var$builtInSymbols.has(key) : $96cefe9acc8d79bc$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $96cefe9acc8d79bc$var$track(target, "get", key);
        if (shallow) return res;
        if ($96cefe9acc8d79bc$var$isRef(res)) {
            var shouldUnwrap = !targetIsArray || !$96cefe9acc8d79bc$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($96cefe9acc8d79bc$var$isObject(res)) return isReadonly ? $96cefe9acc8d79bc$var$readonly(res) : $96cefe9acc8d79bc$var$reactive2(res);
        return res;
    };
}
var $96cefe9acc8d79bc$var$set2 = /* @__PURE__ */ $96cefe9acc8d79bc$var$createSetter();
function $96cefe9acc8d79bc$var$createSetter() {
    var shallow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return function set3(target, key, value, receiver) {
        var oldValue = target[key];
        if (!shallow) {
            value = $96cefe9acc8d79bc$var$toRaw(value);
            oldValue = $96cefe9acc8d79bc$var$toRaw(oldValue);
            if (!$96cefe9acc8d79bc$var$isArray(target) && $96cefe9acc8d79bc$var$isRef(oldValue) && !$96cefe9acc8d79bc$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        var hadKey = $96cefe9acc8d79bc$var$isArray(target) && $96cefe9acc8d79bc$var$isIntegerKey(key) ? Number(key) < target.length : $96cefe9acc8d79bc$var$hasOwn(target, key);
        var result = Reflect.set(target, key, value, receiver);
        if (target === $96cefe9acc8d79bc$var$toRaw(receiver)) {
            if (!hadKey) $96cefe9acc8d79bc$var$trigger(target, "add", key, value);
            else if ($96cefe9acc8d79bc$var$hasChanged(value, oldValue)) $96cefe9acc8d79bc$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $96cefe9acc8d79bc$var$deleteProperty(target, key) {
    var hadKey = $96cefe9acc8d79bc$var$hasOwn(target, key);
    var oldValue = target[key];
    var result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $96cefe9acc8d79bc$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $96cefe9acc8d79bc$var$has(target, key) {
    var result = Reflect.has(target, key);
    if (!$96cefe9acc8d79bc$var$isSymbol(key) || !$96cefe9acc8d79bc$var$builtInSymbols.has(key)) $96cefe9acc8d79bc$var$track(target, "has", key);
    return result;
}
function $96cefe9acc8d79bc$var$ownKeys(target) {
    $96cefe9acc8d79bc$var$track(target, "iterate", $96cefe9acc8d79bc$var$isArray(target) ? "length" : $96cefe9acc8d79bc$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $96cefe9acc8d79bc$var$mutableHandlers = {
    get: $96cefe9acc8d79bc$var$get2,
    set: $96cefe9acc8d79bc$var$set2,
    deleteProperty: $96cefe9acc8d79bc$var$deleteProperty,
    has: $96cefe9acc8d79bc$var$has,
    ownKeys: $96cefe9acc8d79bc$var$ownKeys
};
var $96cefe9acc8d79bc$var$readonlyHandlers = {
    get: $96cefe9acc8d79bc$var$readonlyGet,
    set: function(target, key) {
        console.warn('Set operation on key "'.concat(String(key), '" failed: target is readonly.'), target);
        return true;
    },
    deleteProperty: function(target, key) {
        console.warn('Delete operation on key "'.concat(String(key), '" failed: target is readonly.'), target);
        return true;
    }
};
var $96cefe9acc8d79bc$var$toReactive = function(value) {
    return $96cefe9acc8d79bc$var$isObject(value) ? $96cefe9acc8d79bc$var$reactive2(value) : value;
};
var $96cefe9acc8d79bc$var$toReadonly = function(value) {
    return $96cefe9acc8d79bc$var$isObject(value) ? $96cefe9acc8d79bc$var$readonly(value) : value;
};
var $96cefe9acc8d79bc$var$toShallow = function(value) {
    return value;
};
var $96cefe9acc8d79bc$var$getProto = function(v) {
    return Reflect.getPrototypeOf(v);
};
function $96cefe9acc8d79bc$var$get$1(target, key) {
    var isReadonly = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isShallow = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    target = target["__v_raw"];
    var rawTarget = $96cefe9acc8d79bc$var$toRaw(target);
    var rawKey = $96cefe9acc8d79bc$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $96cefe9acc8d79bc$var$track(rawTarget, "get", key);
    !isReadonly && $96cefe9acc8d79bc$var$track(rawTarget, "get", rawKey);
    var _getProto = $96cefe9acc8d79bc$var$getProto(rawTarget), has2 = _getProto.has;
    var wrap = isShallow ? $96cefe9acc8d79bc$var$toShallow : isReadonly ? $96cefe9acc8d79bc$var$toReadonly : $96cefe9acc8d79bc$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $96cefe9acc8d79bc$var$has$1(key) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var target = this["__v_raw"];
    var rawTarget = $96cefe9acc8d79bc$var$toRaw(target);
    var rawKey = $96cefe9acc8d79bc$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $96cefe9acc8d79bc$var$track(rawTarget, "has", key);
    !isReadonly && $96cefe9acc8d79bc$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $96cefe9acc8d79bc$var$size(target) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    target = target["__v_raw"];
    !isReadonly && $96cefe9acc8d79bc$var$track($96cefe9acc8d79bc$var$toRaw(target), "iterate", $96cefe9acc8d79bc$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $96cefe9acc8d79bc$var$add(value) {
    value = $96cefe9acc8d79bc$var$toRaw(value);
    var target = $96cefe9acc8d79bc$var$toRaw(this);
    var proto = $96cefe9acc8d79bc$var$getProto(target);
    var hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $96cefe9acc8d79bc$var$trigger(target, "add", value, value);
    }
    return this;
}
function $96cefe9acc8d79bc$var$set$1(key, value) {
    value = $96cefe9acc8d79bc$var$toRaw(value);
    var target = $96cefe9acc8d79bc$var$toRaw(this);
    var _getProto = $96cefe9acc8d79bc$var$getProto(target), has2 = _getProto.has, get3 = _getProto.get;
    var hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $96cefe9acc8d79bc$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $96cefe9acc8d79bc$var$checkIdentityKeys(target, has2, key);
    var oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $96cefe9acc8d79bc$var$trigger(target, "add", key, value);
    else if ($96cefe9acc8d79bc$var$hasChanged(value, oldValue)) $96cefe9acc8d79bc$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $96cefe9acc8d79bc$var$deleteEntry(key) {
    var target = $96cefe9acc8d79bc$var$toRaw(this);
    var _getProto = $96cefe9acc8d79bc$var$getProto(target), has2 = _getProto.has, get3 = _getProto.get;
    var hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $96cefe9acc8d79bc$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $96cefe9acc8d79bc$var$checkIdentityKeys(target, has2, key);
    var oldValue = get3 ? get3.call(target, key) : void 0;
    var result = target.delete(key);
    if (hadKey) $96cefe9acc8d79bc$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $96cefe9acc8d79bc$var$clear() {
    var target = $96cefe9acc8d79bc$var$toRaw(this);
    var hadItems = target.size !== 0;
    var oldTarget = $96cefe9acc8d79bc$var$isMap(target) ? new Map(target) : new Set(target);
    var result = target.clear();
    if (hadItems) $96cefe9acc8d79bc$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $96cefe9acc8d79bc$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        var observed = this;
        var target = observed["__v_raw"];
        var rawTarget = $96cefe9acc8d79bc$var$toRaw(target);
        var wrap = isShallow ? $96cefe9acc8d79bc$var$toShallow : isReadonly ? $96cefe9acc8d79bc$var$toReadonly : $96cefe9acc8d79bc$var$toReactive;
        !isReadonly && $96cefe9acc8d79bc$var$track(rawTarget, "iterate", $96cefe9acc8d79bc$var$ITERATE_KEY);
        return target.forEach(function(value, key) {
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $96cefe9acc8d79bc$var$createIterableMethod(method, isReadonly, isShallow) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _target;
        var target = this["__v_raw"];
        var rawTarget = $96cefe9acc8d79bc$var$toRaw(target);
        var targetIsMap = $96cefe9acc8d79bc$var$isMap(rawTarget);
        var isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        var isKeyOnly = method === "keys" && targetIsMap;
        var innerIterator = (_target = target)[method].apply(_target, (0, $8ea412f19da8a8a2$export$71511d61b312f219)(args));
        var wrap = isShallow ? $96cefe9acc8d79bc$var$toShallow : isReadonly ? $96cefe9acc8d79bc$var$toReadonly : $96cefe9acc8d79bc$var$toReactive;
        !isReadonly && $96cefe9acc8d79bc$var$track(rawTarget, "iterate", isKeyOnly ? $96cefe9acc8d79bc$var$MAP_KEY_ITERATE_KEY : $96cefe9acc8d79bc$var$ITERATE_KEY);
        return(// iterable protocol
        (0, $37e80ca29cd951d6$export$71511d61b312f219)({
            // iterator protocol
            next: function() {
                var _innerIterator_next = innerIterator.next(), value = _innerIterator_next.value, done = _innerIterator_next.done;
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        }, Symbol.iterator, function() {
            return this;
        }));
    };
}
function $96cefe9acc8d79bc$var$createReadonlyMethod(type) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        {
            var key = args[0] ? 'on key "'.concat(args[0], '" ') : "";
            console.warn("".concat($96cefe9acc8d79bc$var$capitalize(type), " operation ").concat(key, "failed: target is readonly."), $96cefe9acc8d79bc$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $96cefe9acc8d79bc$var$createInstrumentations() {
    var mutableInstrumentations2 = {
        get: function(key) {
            return $96cefe9acc8d79bc$var$get$1(this, key);
        },
        get size () {
            return $96cefe9acc8d79bc$var$size(this);
        },
        has: $96cefe9acc8d79bc$var$has$1,
        add: $96cefe9acc8d79bc$var$add,
        set: $96cefe9acc8d79bc$var$set$1,
        delete: $96cefe9acc8d79bc$var$deleteEntry,
        clear: $96cefe9acc8d79bc$var$clear,
        forEach: $96cefe9acc8d79bc$var$createForEach(false, false)
    };
    var shallowInstrumentations2 = {
        get: function(key) {
            return $96cefe9acc8d79bc$var$get$1(this, key, false, true);
        },
        get size () {
            return $96cefe9acc8d79bc$var$size(this);
        },
        has: $96cefe9acc8d79bc$var$has$1,
        add: $96cefe9acc8d79bc$var$add,
        set: $96cefe9acc8d79bc$var$set$1,
        delete: $96cefe9acc8d79bc$var$deleteEntry,
        clear: $96cefe9acc8d79bc$var$clear,
        forEach: $96cefe9acc8d79bc$var$createForEach(false, true)
    };
    var readonlyInstrumentations2 = {
        get: function(key) {
            return $96cefe9acc8d79bc$var$get$1(this, key, true);
        },
        get size () {
            return $96cefe9acc8d79bc$var$size(this, true);
        },
        has: function(key) {
            return $96cefe9acc8d79bc$var$has$1.call(this, key, true);
        },
        add: $96cefe9acc8d79bc$var$createReadonlyMethod("add"),
        set: $96cefe9acc8d79bc$var$createReadonlyMethod("set"),
        delete: $96cefe9acc8d79bc$var$createReadonlyMethod("delete"),
        clear: $96cefe9acc8d79bc$var$createReadonlyMethod("clear"),
        forEach: $96cefe9acc8d79bc$var$createForEach(true, false)
    };
    var shallowReadonlyInstrumentations2 = {
        get: function(key) {
            return $96cefe9acc8d79bc$var$get$1(this, key, true, true);
        },
        get size () {
            return $96cefe9acc8d79bc$var$size(this, true);
        },
        has: function(key) {
            return $96cefe9acc8d79bc$var$has$1.call(this, key, true);
        },
        add: $96cefe9acc8d79bc$var$createReadonlyMethod("add"),
        set: $96cefe9acc8d79bc$var$createReadonlyMethod("set"),
        delete: $96cefe9acc8d79bc$var$createReadonlyMethod("delete"),
        clear: $96cefe9acc8d79bc$var$createReadonlyMethod("clear"),
        forEach: $96cefe9acc8d79bc$var$createForEach(true, true)
    };
    var iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach(function(method) {
        mutableInstrumentations2[method] = $96cefe9acc8d79bc$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $96cefe9acc8d79bc$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $96cefe9acc8d79bc$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $96cefe9acc8d79bc$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var /* @__PURE__ */ $96cefe9acc8d79bc$var$_createInstrumentations = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)($96cefe9acc8d79bc$var$createInstrumentations(), 4), $96cefe9acc8d79bc$var$mutableInstrumentations = $96cefe9acc8d79bc$var$_createInstrumentations[0], $96cefe9acc8d79bc$var$readonlyInstrumentations = $96cefe9acc8d79bc$var$_createInstrumentations[1], $96cefe9acc8d79bc$var$shallowInstrumentations = $96cefe9acc8d79bc$var$_createInstrumentations[2], $96cefe9acc8d79bc$var$shallowReadonlyInstrumentations = $96cefe9acc8d79bc$var$_createInstrumentations[3];
function $96cefe9acc8d79bc$var$createInstrumentationGetter(isReadonly, shallow) {
    var instrumentations = shallow ? isReadonly ? $96cefe9acc8d79bc$var$shallowReadonlyInstrumentations : $96cefe9acc8d79bc$var$shallowInstrumentations : isReadonly ? $96cefe9acc8d79bc$var$readonlyInstrumentations : $96cefe9acc8d79bc$var$mutableInstrumentations;
    return function(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($96cefe9acc8d79bc$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $96cefe9acc8d79bc$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $96cefe9acc8d79bc$var$createInstrumentationGetter(false, false)
};
var $96cefe9acc8d79bc$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $96cefe9acc8d79bc$var$createInstrumentationGetter(true, false)
};
function $96cefe9acc8d79bc$var$checkIdentityKeys(target, has2, key) {
    var rawKey = $96cefe9acc8d79bc$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        var type = $96cefe9acc8d79bc$var$toRawType(target);
        console.warn("Reactive ".concat(type, " contains both the raw and reactive versions of the same object").concat(type === "Map" ? " as keys" : "", ", which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible."));
    }
}
var $96cefe9acc8d79bc$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $96cefe9acc8d79bc$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $96cefe9acc8d79bc$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $96cefe9acc8d79bc$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $96cefe9acc8d79bc$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $96cefe9acc8d79bc$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $96cefe9acc8d79bc$var$targetTypeMap($96cefe9acc8d79bc$var$toRawType(value));
}
function $96cefe9acc8d79bc$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $96cefe9acc8d79bc$var$createReactiveObject(target, false, $96cefe9acc8d79bc$var$mutableHandlers, $96cefe9acc8d79bc$var$mutableCollectionHandlers, $96cefe9acc8d79bc$var$reactiveMap);
}
function $96cefe9acc8d79bc$var$readonly(target) {
    return $96cefe9acc8d79bc$var$createReactiveObject(target, true, $96cefe9acc8d79bc$var$readonlyHandlers, $96cefe9acc8d79bc$var$readonlyCollectionHandlers, $96cefe9acc8d79bc$var$readonlyMap);
}
function $96cefe9acc8d79bc$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$96cefe9acc8d79bc$var$isObject(target)) {
        console.warn("value cannot be made reactive: ".concat(String(target)));
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    var existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    var targetType = $96cefe9acc8d79bc$var$getTargetType(target);
    if (targetType === 0) return target;
    var proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $96cefe9acc8d79bc$var$toRaw(observed) {
    return observed && $96cefe9acc8d79bc$var$toRaw(observed["__v_raw"]) || observed;
}
function $96cefe9acc8d79bc$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$96cefe9acc8d79bc$var$magic("nextTick", function() {
    return $96cefe9acc8d79bc$var$nextTick;
});
// packages/alpinejs/src/magics/$dispatch.js
$96cefe9acc8d79bc$var$magic("dispatch", function(el) {
    return $96cefe9acc8d79bc$var$dispatch.bind($96cefe9acc8d79bc$var$dispatch, el);
});
// packages/alpinejs/src/magics/$watch.js
$96cefe9acc8d79bc$var$magic("watch", function(el, param) {
    var evaluateLater2 = param.evaluateLater, cleanup2 = param.cleanup;
    return function(key, callback) {
        var evaluate2 = evaluateLater2(key);
        var getter = function() {
            var value;
            evaluate2(function(i) {
                return value = i;
            });
            return value;
        };
        var unwatch = $96cefe9acc8d79bc$var$watch(getter, callback);
        cleanup2(unwatch);
    };
});
// packages/alpinejs/src/magics/$store.js
$96cefe9acc8d79bc$var$magic("store", $96cefe9acc8d79bc$var$getStores);
// packages/alpinejs/src/magics/$data.js
$96cefe9acc8d79bc$var$magic("data", function(el) {
    return $96cefe9acc8d79bc$var$scope(el);
});
// packages/alpinejs/src/magics/$root.js
$96cefe9acc8d79bc$var$magic("root", function(el) {
    return $96cefe9acc8d79bc$var$closestRoot(el);
});
// packages/alpinejs/src/magics/$refs.js
$96cefe9acc8d79bc$var$magic("refs", function(el) {
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $96cefe9acc8d79bc$var$mergeProxies($96cefe9acc8d79bc$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $96cefe9acc8d79bc$var$getArrayOfRefObject(el) {
    var refObjects = [];
    $96cefe9acc8d79bc$var$findClosest(el, function(i) {
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $96cefe9acc8d79bc$var$globalIdMemo = {};
function $96cefe9acc8d79bc$var$findAndIncrementId(name) {
    if (!$96cefe9acc8d79bc$var$globalIdMemo[name]) $96cefe9acc8d79bc$var$globalIdMemo[name] = 0;
    return ++$96cefe9acc8d79bc$var$globalIdMemo[name];
}
function $96cefe9acc8d79bc$var$closestIdRoot(el, name) {
    return $96cefe9acc8d79bc$var$findClosest(el, function(element) {
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $96cefe9acc8d79bc$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $96cefe9acc8d79bc$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$96cefe9acc8d79bc$var$magic("id", function(el, param) {
    var cleanup2 = param.cleanup;
    return function(name) {
        var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var cacheKey = "".concat(name).concat(key ? "-".concat(key) : "");
        return $96cefe9acc8d79bc$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, function() {
            var root = $96cefe9acc8d79bc$var$closestIdRoot(el, name);
            var id = root ? root._x_ids[name] : $96cefe9acc8d79bc$var$findAndIncrementId(name);
            return key ? "".concat(name, "-").concat(id, "-").concat(key) : "".concat(name, "-").concat(id);
        });
    };
});
$96cefe9acc8d79bc$var$interceptClone(function(from, to) {
    if (from._x_id) to._x_id = from._x_id;
});
function $96cefe9acc8d79bc$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    var output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(function() {
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$96cefe9acc8d79bc$var$magic("el", function(el) {
    return el;
});
// packages/alpinejs/src/magics/index.js
$96cefe9acc8d79bc$var$warnMissingPluginMagic("Focus", "focus", "focus");
$96cefe9acc8d79bc$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $96cefe9acc8d79bc$var$warnMissingPluginMagic(name, magicName, slug) {
    $96cefe9acc8d79bc$var$magic(magicName, function(el) {
        return $96cefe9acc8d79bc$var$warn("You can't use [$".concat(magicName, '] without first installing the "').concat(name, '" plugin here: https://alpinejs.dev/plugins/').concat(slug), el);
    });
}
// packages/alpinejs/src/directives/x-modelable.js
$96cefe9acc8d79bc$var$directive("modelable", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater, cleanup2 = param1.cleanup;
    var func = evaluateLater2(expression);
    var innerGet = function() {
        var result;
        func(function(i) {
            return result = i;
        });
        return result;
    };
    var evaluateInnerSet = evaluateLater2("".concat(expression, " = __placeholder"));
    var innerSet = function(val) {
        return evaluateInnerSet(function() {}, {
            scope: {
                "__placeholder": val
            }
        });
    };
    var initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(function() {
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        var outerGet = el._x_model.get;
        var outerSet = el._x_model.set;
        var releaseEntanglement = $96cefe9acc8d79bc$var$entangle({
            get: function() {
                return outerGet();
            },
            set: function(value) {
                outerSet(value);
            }
        }, {
            get: function() {
                return innerGet();
            },
            set: function(value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$96cefe9acc8d79bc$var$directive("teleport", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, cleanup2 = param1.cleanup;
    if (el.tagName.toLowerCase() !== "template") $96cefe9acc8d79bc$var$warn("x-teleport can only be used on a <template> tag", el);
    var target = $96cefe9acc8d79bc$var$getTarget(expression);
    var clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach(function(eventName) {
        clone2.addEventListener(eventName, function(e) {
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $96cefe9acc8d79bc$var$addScopeToNode(clone2, {}, el);
    var placeInDom = function(clone3, target2, modifiers2) {
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $96cefe9acc8d79bc$var$mutateDom(function() {
        placeInDom(clone2, target, modifiers);
        $96cefe9acc8d79bc$var$skipDuringClone(function() {
            $96cefe9acc8d79bc$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = function() {
        var target2 = $96cefe9acc8d79bc$var$getTarget(expression);
        $96cefe9acc8d79bc$var$mutateDom(function() {
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(function() {
        return $96cefe9acc8d79bc$var$mutateDom(function() {
            clone2.remove();
            $96cefe9acc8d79bc$var$destroyTree(clone2);
        });
    });
});
var $96cefe9acc8d79bc$var$teleportContainerDuringClone = document.createElement("div");
function $96cefe9acc8d79bc$var$getTarget(expression) {
    var target = $96cefe9acc8d79bc$var$skipDuringClone(function() {
        return document.querySelector(expression);
    }, function() {
        return $96cefe9acc8d79bc$var$teleportContainerDuringClone;
    })();
    if (!target) $96cefe9acc8d79bc$var$warn('Cannot find x-teleport element for selector: "'.concat(expression, '"'));
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $96cefe9acc8d79bc$var$handler = function() {};
$96cefe9acc8d79bc$var$handler.inline = function(el, param, param1) {
    var modifiers = param.modifiers, cleanup2 = param1.cleanup;
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(function() {
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$96cefe9acc8d79bc$var$directive("ignore", $96cefe9acc8d79bc$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$96cefe9acc8d79bc$var$directive("effect", $96cefe9acc8d79bc$var$skipDuringClone(function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect;
    effect3($96cefe9acc8d79bc$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $96cefe9acc8d79bc$var$on(el, event, modifiers, callback) {
    var listenerTarget = el;
    var handler4 = function(e) {
        return callback(e);
    };
    var options = {};
    var wrapHandler = function(callback2, wrapper) {
        return function(e) {
            return wrapper(callback2, e);
        };
    };
    if (modifiers.includes("dot")) event = $96cefe9acc8d79bc$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $96cefe9acc8d79bc$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        var nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        var wait = $96cefe9acc8d79bc$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $96cefe9acc8d79bc$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        var nextModifier1 = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        var wait1 = $96cefe9acc8d79bc$var$isNumeric(nextModifier1.split("ms")[0]) ? Number(nextModifier1.split("ms")[0]) : 250;
        handler4 = $96cefe9acc8d79bc$var$throttle(handler4, wait1);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, function(next, e) {
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, function(next, e) {
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, function(next, e) {
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, function(next, e) {
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, function(next, e) {
        e.target === el && next(e);
    });
    if ($96cefe9acc8d79bc$var$isKeyEvent(event) || $96cefe9acc8d79bc$var$isClickEvent(event)) handler4 = wrapHandler(handler4, function(next, e) {
        if ($96cefe9acc8d79bc$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return function() {
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $96cefe9acc8d79bc$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $96cefe9acc8d79bc$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, function(match, char) {
        return char.toUpperCase();
    });
}
function $96cefe9acc8d79bc$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $96cefe9acc8d79bc$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $96cefe9acc8d79bc$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $96cefe9acc8d79bc$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some(function(i) {
        return event.includes(i);
    });
}
function $96cefe9acc8d79bc$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    var keyModifiers = modifiers.filter(function(i) {
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        var debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $96cefe9acc8d79bc$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        var debounceIndex1 = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex1, $96cefe9acc8d79bc$var$isNumeric((keyModifiers[debounceIndex1 + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $96cefe9acc8d79bc$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    var systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    var selectedSystemKeyModifiers = systemKeyModifiers.filter(function(modifier) {
        return keyModifiers.includes(modifier);
    });
    keyModifiers = keyModifiers.filter(function(i) {
        return !selectedSystemKeyModifiers.includes(i);
    });
    if (selectedSystemKeyModifiers.length > 0) {
        var activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter(function(modifier) {
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e["".concat(modifier, "Key")];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($96cefe9acc8d79bc$var$isClickEvent(e.type)) return false;
            if ($96cefe9acc8d79bc$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $96cefe9acc8d79bc$var$keyToModifiers(key) {
    if (!key) return [];
    key = $96cefe9acc8d79bc$var$kebabCase2(key);
    var modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map(function(modifier) {
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter(function(modifier) {
        return modifier;
    });
}
// packages/alpinejs/src/directives/x-model.js
$96cefe9acc8d79bc$var$directive("model", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    var scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    var evaluateGet = $96cefe9acc8d79bc$var$evaluateLater(scopeTarget, expression);
    var evaluateSet;
    if (typeof expression === "string") evaluateSet = $96cefe9acc8d79bc$var$evaluateLater(scopeTarget, "".concat(expression, " = __placeholder"));
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $96cefe9acc8d79bc$var$evaluateLater(scopeTarget, "".concat(expression(), " = __placeholder"));
    else evaluateSet = function() {};
    var getValue = function() {
        var result;
        evaluateGet(function(value) {
            return result = value;
        });
        return $96cefe9acc8d79bc$var$isGetterSetter(result) ? result.get() : result;
    };
    var setValue = function(value) {
        var result;
        evaluateGet(function(value2) {
            return result = value2;
        });
        if ($96cefe9acc8d79bc$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(function() {}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $96cefe9acc8d79bc$var$mutateDom(function() {
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    var removeListener = $96cefe9acc8d79bc$var$isCloning ? function() {} : $96cefe9acc8d79bc$var$on(el, event, modifiers, function(e) {
        setValue($96cefe9acc8d79bc$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $96cefe9acc8d79bc$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($96cefe9acc8d79bc$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(function() {
        return el._x_removeModelListeners["default"]();
    });
    if (el.form) {
        var removeResetListener = $96cefe9acc8d79bc$var$on(el.form, "reset", [], function(e) {
            $96cefe9acc8d79bc$var$nextTick(function() {
                return el._x_model && el._x_model.set($96cefe9acc8d79bc$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue()));
            });
        });
        cleanup2(function() {
            return removeResetListener();
        });
    }
    el._x_model = {
        get: function() {
            return getValue();
        },
        set: function(value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = function(value) {
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $96cefe9acc8d79bc$var$mutateDom(function() {
            return $96cefe9acc8d79bc$var$bind(el, "value", value);
        });
        delete window.fromModel;
    };
    effect3(function() {
        var value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $96cefe9acc8d79bc$var$getInputValue(el, modifiers, event, currentValue) {
    return $96cefe9acc8d79bc$var$mutateDom(function() {
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($96cefe9acc8d79bc$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                var newValue = null;
                if (modifiers.includes("number")) newValue = $96cefe9acc8d79bc$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $96cefe9acc8d79bc$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter(function(el2) {
                    return !$96cefe9acc8d79bc$var$checkedAttrLooseCompare2(el2, newValue);
                });
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map(function(option) {
                var rawValue = option.value || option.text;
                return $96cefe9acc8d79bc$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map(function(option) {
                var rawValue = option.value || option.text;
                return $96cefe9acc8d79bc$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map(function(option) {
                return option.value || option.text;
            });
        } else {
            var newValue1;
            if ($96cefe9acc8d79bc$var$isRadio(el)) {
                if (event.target.checked) newValue1 = event.target.value;
                else newValue1 = currentValue;
            } else newValue1 = event.target.value;
            if (modifiers.includes("number")) return $96cefe9acc8d79bc$var$safeParseNumber(newValue1);
            else if (modifiers.includes("boolean")) return $96cefe9acc8d79bc$var$safeParseBoolean(newValue1);
            else if (modifiers.includes("trim")) return newValue1.trim();
            else return newValue1;
        }
    });
}
function $96cefe9acc8d79bc$var$safeParseNumber(rawValue) {
    var number = rawValue ? parseFloat(rawValue) : null;
    return $96cefe9acc8d79bc$var$isNumeric2(number) ? number : rawValue;
}
function $96cefe9acc8d79bc$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $96cefe9acc8d79bc$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $96cefe9acc8d79bc$var$isGetterSetter(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$96cefe9acc8d79bc$var$directive("cloak", function(el) {
    return queueMicrotask(function() {
        return $96cefe9acc8d79bc$var$mutateDom(function() {
            return el.removeAttribute($96cefe9acc8d79bc$var$prefix("cloak"));
        });
    });
});
// packages/alpinejs/src/directives/x-init.js
$96cefe9acc8d79bc$var$addInitSelector(function() {
    return "[".concat($96cefe9acc8d79bc$var$prefix("init"), "]");
});
$96cefe9acc8d79bc$var$directive("init", $96cefe9acc8d79bc$var$skipDuringClone(function(el, param, param1) {
    var expression = param.expression, evaluate2 = param1.evaluate;
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$96cefe9acc8d79bc$var$directive("text", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater;
    var evaluate2 = evaluateLater2(expression);
    effect3(function() {
        evaluate2(function(value) {
            $96cefe9acc8d79bc$var$mutateDom(function() {
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$96cefe9acc8d79bc$var$directive("html", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater;
    var evaluate2 = evaluateLater2(expression);
    effect3(function() {
        evaluate2(function(value) {
            $96cefe9acc8d79bc$var$mutateDom(function() {
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $96cefe9acc8d79bc$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$96cefe9acc8d79bc$var$mapAttributes($96cefe9acc8d79bc$var$startingWith(":", $96cefe9acc8d79bc$var$into($96cefe9acc8d79bc$var$prefix("bind:"))));
var $96cefe9acc8d79bc$var$handler2 = function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, original = param.original, effect3 = param1.effect, cleanup2 = param1.cleanup;
    if (!value) {
        var bindingProviders = {};
        $96cefe9acc8d79bc$var$injectBindingProviders(bindingProviders);
        var getBindings = $96cefe9acc8d79bc$var$evaluateLater(el, expression);
        getBindings(function(bindings) {
            $96cefe9acc8d79bc$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $96cefe9acc8d79bc$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    var evaluate2 = $96cefe9acc8d79bc$var$evaluateLater(el, expression);
    effect3(function() {
        return evaluate2(function(result) {
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $96cefe9acc8d79bc$var$mutateDom(function() {
                return $96cefe9acc8d79bc$var$bind(el, value, result, modifiers);
            });
        });
    });
    cleanup2(function() {
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$96cefe9acc8d79bc$var$handler2.inline = function(el, param) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression;
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$96cefe9acc8d79bc$var$directive("bind", $96cefe9acc8d79bc$var$handler2);
function $96cefe9acc8d79bc$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$96cefe9acc8d79bc$var$addRootSelector(function() {
    return "[".concat($96cefe9acc8d79bc$var$prefix("data"), "]");
});
$96cefe9acc8d79bc$var$directive("data", function(el, param, param1) {
    var expression = param.expression, cleanup2 = param1.cleanup;
    if ($96cefe9acc8d79bc$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    var magicContext = {};
    $96cefe9acc8d79bc$var$injectMagics(magicContext, el);
    var dataProviderContext = {};
    $96cefe9acc8d79bc$var$injectDataProviders(dataProviderContext, magicContext);
    var data2 = $96cefe9acc8d79bc$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $96cefe9acc8d79bc$var$injectMagics(data2, el);
    var reactiveData = $96cefe9acc8d79bc$var$reactive(data2);
    $96cefe9acc8d79bc$var$initInterceptors(reactiveData);
    var undo = $96cefe9acc8d79bc$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $96cefe9acc8d79bc$var$evaluate(el, reactiveData["init"]);
    cleanup2(function() {
        reactiveData["destroy"] && $96cefe9acc8d79bc$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$96cefe9acc8d79bc$var$interceptClone(function(from, to) {
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $96cefe9acc8d79bc$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$96cefe9acc8d79bc$var$isCloning) return false;
    if ($96cefe9acc8d79bc$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$96cefe9acc8d79bc$var$directive("show", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, effect3 = param1.effect;
    var evaluate2 = $96cefe9acc8d79bc$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = function() {
        $96cefe9acc8d79bc$var$mutateDom(function() {
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = function() {
        $96cefe9acc8d79bc$var$mutateDom(function() {
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    var hide = function() {
        el._x_doHide();
        el._x_isShown = false;
    };
    var show = function() {
        el._x_doShow();
        el._x_isShown = true;
    };
    var clickAwayCompatibleShow = function() {
        return setTimeout(show);
    };
    var toggle = $96cefe9acc8d79bc$var$once(function(value) {
        return value ? show() : hide();
    }, function(value) {
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    var oldValue;
    var firstTime = true;
    effect3(function() {
        return evaluate2(function(value) {
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        });
    });
});
// packages/alpinejs/src/directives/x-for.js
$96cefe9acc8d79bc$var$directive("for", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    var iteratorNames = $96cefe9acc8d79bc$var$parseForExpression(expression);
    var evaluateItems = $96cefe9acc8d79bc$var$evaluateLater(el, iteratorNames.items);
    var evaluateKey = $96cefe9acc8d79bc$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(function() {
        return $96cefe9acc8d79bc$var$loop(el, iteratorNames, evaluateItems, evaluateKey);
    });
    cleanup2(function() {
        Object.values(el._x_lookup).forEach(function(el2) {
            return $96cefe9acc8d79bc$var$mutateDom(function() {
                $96cefe9acc8d79bc$var$destroyTree(el2);
                el2.remove();
            });
        });
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $96cefe9acc8d79bc$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    var isObject2 = function(i) {
        return (typeof i === "undefined" ? "undefined" : (0, $j2WbH._)(i)) === "object" && !Array.isArray(i);
    };
    var templateEl = el;
    evaluateItems(function(items) {
        var _loop = function(i3) {
            var key = removes[i3];
            if (!(key in lookup)) return "continue";
            $96cefe9acc8d79bc$var$mutateDom(function() {
                $96cefe9acc8d79bc$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }, _loop1 = function(i4) {
            var _moves_i = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(moves[i4], 2), keyInSpot = _moves_i[0], keyForSpot = _moves_i[1];
            var elInSpot = lookup[keyInSpot];
            var elForSpot = lookup[keyForSpot];
            var marker = document.createElement("div");
            $96cefe9acc8d79bc$var$mutateDom(function() {
                if (!elForSpot) $96cefe9acc8d79bc$var$warn('x-for ":key" is undefined or invalid', templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }, _loop2 = function(i5) {
            var _adds_i = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(adds[i5], 2), lastKey2 = _adds_i[0], index = _adds_i[1];
            var lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            var scope2 = scopes[index];
            var key = keys[index];
            var clone2 = document.importNode(templateEl.content, true).firstElementChild;
            var reactiveScope = $96cefe9acc8d79bc$var$reactive(scope2);
            $96cefe9acc8d79bc$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = function(newScope) {
                Object.entries(newScope).forEach(function(param) {
                    var _param = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(param, 2), key2 = _param[0], value = _param[1];
                    reactiveScope[key2] = value;
                });
            };
            $96cefe9acc8d79bc$var$mutateDom(function() {
                lastEl.after(clone2);
                $96cefe9acc8d79bc$var$skipDuringClone(function() {
                    return $96cefe9acc8d79bc$var$initTree(clone2);
                })();
            });
            if ((typeof key === "undefined" ? "undefined" : (0, $j2WbH._)(key)) === "object") $96cefe9acc8d79bc$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        };
        if ($96cefe9acc8d79bc$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), function(i) {
            return i + 1;
        });
        if (items === void 0) items = [];
        var lookup = el._x_lookup;
        var prevKeys = el._x_prevKeys;
        var scopes = [];
        var keys = [];
        if (isObject2(items)) items = Object.entries(items).map(function(param) {
            var _param = (0, $2eb6a8c2efe4d1d3$export$71511d61b312f219)(param, 2), key = _param[0], value = _param[1];
            var scope2 = $96cefe9acc8d79bc$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey(function(value2) {
                if (keys.includes(value2)) $96cefe9acc8d79bc$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: (0, $a9846c98c872cb75$export$71511d61b312f219)({
                    index: key
                }, scope2)
            });
            scopes.push(scope2);
        });
        else for(var i = 0; i < items.length; i++){
            var scope2 = $96cefe9acc8d79bc$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey(function(value) {
                if (keys.includes(value)) $96cefe9acc8d79bc$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: (0, $a9846c98c872cb75$export$71511d61b312f219)({
                    index: i
                }, scope2)
            });
            scopes.push(scope2);
        }
        var adds = [];
        var moves = [];
        var removes = [];
        var sames = [];
        for(var i1 = 0; i1 < prevKeys.length; i1++){
            var key = prevKeys[i1];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter(function(key) {
            return !removes.includes(key);
        });
        var lastKey = "template";
        for(var i2 = 0; i2 < keys.length; i2++){
            var key1 = keys[i2];
            var prevIndex = prevKeys.indexOf(key1);
            if (prevIndex === -1) {
                prevKeys.splice(i2, 0, key1);
                adds.push([
                    lastKey,
                    i2
                ]);
            } else if (prevIndex !== i2) {
                var keyInSpot = prevKeys.splice(i2, 1)[0];
                var keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i2, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key1);
            lastKey = key1;
        }
        for(var i3 = 0; i3 < removes.length; i3++)_loop(i3);
        for(var i4 = 0; i4 < moves.length; i4++)_loop1(i4);
        for(var i5 = 0; i5 < adds.length; i5++)_loop2(i5);
        for(var i6 = 0; i6 < sames.length; i6++)lookup[sames[i6]]._x_refreshXForScope(scopes[keys.indexOf(sames[i6])]);
        templateEl._x_prevKeys = keys;
    });
}
function $96cefe9acc8d79bc$var$parseForExpression(expression) {
    var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    var stripParensRE = /^\s*\(|\)\s*$/g;
    var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    var inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    var res = {};
    res.items = inMatch[2].trim();
    var item = inMatch[1].replace(stripParensRE, "").trim();
    var iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $96cefe9acc8d79bc$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    var scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        var names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map(function(i) {
            return i.trim();
        });
        names.forEach(function(name, i) {
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && (typeof item === "undefined" ? "undefined" : (0, $j2WbH._)(item)) === "object") {
        var names1 = iteratorNames.item.replace("{", "").replace("}", "").split(",").map(function(i) {
            return i.trim();
        });
        names1.forEach(function(name) {
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $96cefe9acc8d79bc$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $96cefe9acc8d79bc$var$handler3() {}
$96cefe9acc8d79bc$var$handler3.inline = function(el, param, param1) {
    var expression = param.expression, cleanup2 = param1.cleanup;
    var root = $96cefe9acc8d79bc$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(function() {
        return delete root._x_refs[expression];
    });
};
$96cefe9acc8d79bc$var$directive("ref", $96cefe9acc8d79bc$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$96cefe9acc8d79bc$var$directive("if", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    if (el.tagName.toLowerCase() !== "template") $96cefe9acc8d79bc$var$warn("x-if can only be used on a <template> tag", el);
    var evaluate2 = $96cefe9acc8d79bc$var$evaluateLater(el, expression);
    var show = function() {
        if (el._x_currentIfEl) return el._x_currentIfEl;
        var clone2 = el.content.cloneNode(true).firstElementChild;
        $96cefe9acc8d79bc$var$addScopeToNode(clone2, {}, el);
        $96cefe9acc8d79bc$var$mutateDom(function() {
            el.after(clone2);
            $96cefe9acc8d79bc$var$skipDuringClone(function() {
                return $96cefe9acc8d79bc$var$initTree(clone2);
            })();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = function() {
            $96cefe9acc8d79bc$var$mutateDom(function() {
                $96cefe9acc8d79bc$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    var hide = function() {
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(function() {
        return evaluate2(function(value) {
            value ? show() : hide();
        });
    });
    cleanup2(function() {
        return el._x_undoIf && el._x_undoIf();
    });
});
// packages/alpinejs/src/directives/x-id.js
$96cefe9acc8d79bc$var$directive("id", function(el, param, param1) {
    var expression = param.expression, evaluate2 = param1.evaluate;
    var names = evaluate2(expression);
    names.forEach(function(name) {
        return $96cefe9acc8d79bc$var$setIdRoot(el, name);
    });
});
$96cefe9acc8d79bc$var$interceptClone(function(from, to) {
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$96cefe9acc8d79bc$var$mapAttributes($96cefe9acc8d79bc$var$startingWith("@", $96cefe9acc8d79bc$var$into($96cefe9acc8d79bc$var$prefix("on:"))));
$96cefe9acc8d79bc$var$directive("on", $96cefe9acc8d79bc$var$skipDuringClone(function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, cleanup2 = param1.cleanup;
    var evaluate2 = expression ? $96cefe9acc8d79bc$var$evaluateLater(el, expression) : function() {};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    var removeListener = $96cefe9acc8d79bc$var$on(el, value, modifiers, function(e) {
        evaluate2(function() {}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(function() {
        return removeListener();
    });
}));
// packages/alpinejs/src/directives/index.js
$96cefe9acc8d79bc$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$96cefe9acc8d79bc$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$96cefe9acc8d79bc$var$warnMissingPluginDirective("Focus", "trap", "focus");
$96cefe9acc8d79bc$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $96cefe9acc8d79bc$var$warnMissingPluginDirective(name, directiveName, slug) {
    $96cefe9acc8d79bc$var$directive(directiveName, function(el) {
        return $96cefe9acc8d79bc$var$warn("You can't use [x-".concat(directiveName, '] without first installing the "').concat(name, '" plugin here: https://alpinejs.dev/plugins/').concat(slug), el);
    });
}
// packages/alpinejs/src/index.js
$96cefe9acc8d79bc$var$alpine_default.setEvaluator($96cefe9acc8d79bc$var$normalEvaluator);
$96cefe9acc8d79bc$var$alpine_default.setReactivityEngine({
    reactive: $96cefe9acc8d79bc$var$reactive2,
    effect: $96cefe9acc8d79bc$var$effect2,
    release: $96cefe9acc8d79bc$var$stop,
    raw: $96cefe9acc8d79bc$var$toRaw
});
var $96cefe9acc8d79bc$export$b7ee041e4ad2afec = $96cefe9acc8d79bc$var$alpine_default;
// packages/alpinejs/builds/module.js
var $96cefe9acc8d79bc$export$2e2bcd8739ae039 = $96cefe9acc8d79bc$export$b7ee041e4ad2afec;




var $j2WbH = parcelRequire("j2WbH");
var $76a61f0a570b1d31$var$__create = Object.create;
var $76a61f0a570b1d31$var$__defProp = Object.defineProperty;
var $76a61f0a570b1d31$var$__getProtoOf = Object.getPrototypeOf;
var $76a61f0a570b1d31$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $76a61f0a570b1d31$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $76a61f0a570b1d31$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $76a61f0a570b1d31$var$__markAsModule = function(target) {
    return $76a61f0a570b1d31$var$__defProp(target, "__esModule", {
        value: true
    });
};
var $76a61f0a570b1d31$var$__commonJS = function(callback, module) {
    return function() {
        if (!module) {
            module = {
                exports: {}
            };
            callback(module.exports, module);
        }
        return module.exports;
    };
};
var $76a61f0a570b1d31$var$__exportStar = function(target, module, desc) {
    if (module && (typeof module === "undefined" ? "undefined" : (0, $j2WbH._)(module)) === "object" || typeof module === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$76a61f0a570b1d31$var$__hasOwnProp.call(target, key) && key !== "default") $76a61f0a570b1d31$var$__defProp(target, key, {
                    get: function() {
                        return module[key];
                    },
                    enumerable: !(desc = $76a61f0a570b1d31$var$__getOwnPropDesc(module, key)) || desc.enumerable
                });
            };
            for(var _iterator = $76a61f0a570b1d31$var$__getOwnPropNames(module)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return target;
};
var $76a61f0a570b1d31$var$__toModule = function(module) {
    return $76a61f0a570b1d31$var$__exportStar($76a61f0a570b1d31$var$__markAsModule($76a61f0a570b1d31$var$__defProp(module != null ? $76a61f0a570b1d31$var$__create($76a61f0a570b1d31$var$__getProtoOf(module)) : {}, "default", module && module.__esModule && "default" in module ? {
        get: function() {
            return module.default;
        },
        enumerable: true
    } : {
        value: module,
        enumerable: true
    })), module);
};
// node_modules/smoothscroll-polyfill/dist/smoothscroll.js
var $76a61f0a570b1d31$var$require_smoothscroll = $76a61f0a570b1d31$var$__commonJS(function(exports, module) {
    (function() {
        "use strict";
        function polyfill() {
            var w = window;
            var d = document;
            if ("scrollBehavior" in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) return;
            var Element2 = w.HTMLElement || w.Element;
            var SCROLL_TIME = 468;
            var original = {
                scroll: w.scroll || w.scrollTo,
                scrollBy: w.scrollBy,
                elementScroll: Element2.prototype.scroll || scrollElement,
                scrollIntoView: Element2.prototype.scrollIntoView
            };
            var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
            function isMicrosoftBrowser(userAgent) {
                var userAgentPatterns = [
                    "MSIE ",
                    "Trident/",
                    "Edge/"
                ];
                return new RegExp(userAgentPatterns.join("|")).test(userAgent);
            }
            var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
            function scrollElement(x, y) {
                this.scrollLeft = x;
                this.scrollTop = y;
            }
            function ease(k) {
                return 0.5 * (1 - Math.cos(Math.PI * k));
            }
            function shouldBailOut(firstArg) {
                if (firstArg === null || (typeof firstArg === "undefined" ? "undefined" : (0, $j2WbH._)(firstArg)) !== "object" || firstArg.behavior === void 0 || firstArg.behavior === "auto" || firstArg.behavior === "instant") return true;
                if ((typeof firstArg === "undefined" ? "undefined" : (0, $j2WbH._)(firstArg)) === "object" && firstArg.behavior === "smooth") return false;
                throw new TypeError("behavior member of ScrollOptions " + firstArg.behavior + " is not a valid value for enumeration ScrollBehavior.");
            }
            function hasScrollableSpace(el, axis) {
                if (axis === "Y") return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
                if (axis === "X") return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
            }
            function canOverflow(el, axis) {
                var overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
                return overflowValue === "auto" || overflowValue === "scroll";
            }
            function isScrollable(el) {
                var isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
                var isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
                return isScrollableY || isScrollableX;
            }
            function findScrollableParent(el) {
                while(el !== d.body && isScrollable(el) === false)el = el.parentNode || el.host;
                return el;
            }
            function step(context) {
                var time = now();
                var value;
                var currentX;
                var currentY;
                var elapsed = (time - context.startTime) / SCROLL_TIME;
                elapsed = elapsed > 1 ? 1 : elapsed;
                value = ease(elapsed);
                currentX = context.startX + (context.x - context.startX) * value;
                currentY = context.startY + (context.y - context.startY) * value;
                context.method.call(context.scrollable, currentX, currentY);
                if (currentX !== context.x || currentY !== context.y) w.requestAnimationFrame(step.bind(w, context));
            }
            function smoothScroll(el, x, y) {
                var scrollable;
                var startX;
                var startY;
                var method;
                var startTime = now();
                if (el === d.body) {
                    scrollable = w;
                    startX = w.scrollX || w.pageXOffset;
                    startY = w.scrollY || w.pageYOffset;
                    method = original.scroll;
                } else {
                    scrollable = el;
                    startX = el.scrollLeft;
                    startY = el.scrollTop;
                    method = scrollElement;
                }
                step({
                    scrollable: scrollable,
                    method: method,
                    startTime: startTime,
                    startX: startX,
                    startY: startY,
                    x: x,
                    y: y
                });
            }
            w.scroll = w.scrollTo = function() {
                if (arguments[0] === void 0) return;
                if (shouldBailOut(arguments[0]) === true) {
                    original.scroll.call(w, arguments[0].left !== void 0 ? arguments[0].left : (0, $j2WbH._)(arguments[0]) !== "object" ? arguments[0] : w.scrollX || w.pageXOffset, arguments[0].top !== void 0 ? arguments[0].top : arguments[1] !== void 0 ? arguments[1] : w.scrollY || w.pageYOffset);
                    return;
                }
                smoothScroll.call(w, d.body, arguments[0].left !== void 0 ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== void 0 ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
            };
            w.scrollBy = function() {
                if (arguments[0] === void 0) return;
                if (shouldBailOut(arguments[0])) {
                    original.scrollBy.call(w, arguments[0].left !== void 0 ? arguments[0].left : (0, $j2WbH._)(arguments[0]) !== "object" ? arguments[0] : 0, arguments[0].top !== void 0 ? arguments[0].top : arguments[1] !== void 0 ? arguments[1] : 0);
                    return;
                }
                smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
            };
            Element2.prototype.scroll = Element2.prototype.scrollTo = function() {
                if (arguments[0] === void 0) return;
                if (shouldBailOut(arguments[0]) === true) {
                    if (typeof arguments[0] === "number" && arguments[1] === void 0) throw new SyntaxError("Value could not be converted");
                    original.elementScroll.call(this, arguments[0].left !== void 0 ? ~~arguments[0].left : (0, $j2WbH._)(arguments[0]) !== "object" ? ~~arguments[0] : this.scrollLeft, arguments[0].top !== void 0 ? ~~arguments[0].top : arguments[1] !== void 0 ? ~~arguments[1] : this.scrollTop);
                    return;
                }
                var left = arguments[0].left;
                var top = arguments[0].top;
                smoothScroll.call(this, this, typeof left === "undefined" ? this.scrollLeft : ~~left, typeof top === "undefined" ? this.scrollTop : ~~top);
            };
            Element2.prototype.scrollBy = function() {
                if (arguments[0] === void 0) return;
                if (shouldBailOut(arguments[0]) === true) {
                    original.elementScroll.call(this, arguments[0].left !== void 0 ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== void 0 ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
                    return;
                }
                this.scroll({
                    left: ~~arguments[0].left + this.scrollLeft,
                    top: ~~arguments[0].top + this.scrollTop,
                    behavior: arguments[0].behavior
                });
            };
            Element2.prototype.scrollIntoView = function() {
                if (shouldBailOut(arguments[0]) === true) {
                    original.scrollIntoView.call(this, arguments[0] === void 0 ? true : arguments[0]);
                    return;
                }
                var scrollableParent = findScrollableParent(this);
                var parentRects = scrollableParent.getBoundingClientRect();
                var clientRects = this.getBoundingClientRect();
                if (scrollableParent !== d.body) {
                    smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);
                    if (w.getComputedStyle(scrollableParent).position !== "fixed") w.scrollBy({
                        left: parentRects.left,
                        top: parentRects.top,
                        behavior: "smooth"
                    });
                } else w.scrollBy({
                    left: clientRects.left,
                    top: clientRects.top,
                    behavior: "smooth"
                });
            };
        }
        if ((typeof exports === "undefined" ? "undefined" : (0, $j2WbH._)(exports)) === "object" && typeof module !== "undefined") module.exports = {
            polyfill: polyfill
        };
        else polyfill();
    })();
});
// packages/$range/src/index.js
function $76a61f0a570b1d31$var$src_default(Alpine) {
    Alpine.magic("range", function() {
        return function(start, stop) {
            var step = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
            if (typeof stop === "undefined") {
                stop = start;
                start = start ? 1 : 0;
            }
            var reverse = start > stop;
            var ref;
            if (reverse) ref = [
                stop,
                start
            ], start = ref[0], stop = ref[1], ref;
            var range = Array.from({
                length: (stop - start) / step + 1
            }, function(_, i) {
                return start + i * step;
            });
            return reverse ? range.reverse() : range;
        };
    });
}
// packages/$scroll/src/index.js
var $76a61f0a570b1d31$var$import_smoothscroll_polyfill = $76a61f0a570b1d31$var$__toModule($76a61f0a570b1d31$var$require_smoothscroll());
function $76a61f0a570b1d31$var$src_default2(Alpine) {
    $76a61f0a570b1d31$var$import_smoothscroll_polyfill.default.polyfill();
    Alpine.magic("scroll", function() {
        return function(target) {
            var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            var originalTarget = target;
            var offset = options.offset ? parseInt(options.offset, 10) : 0;
            delete options.offset;
            if (typeof target === "string" && /^[0-9]+?/g.test(target)) target = parseInt(target, 10);
            if (typeof target === "string") target = document.querySelector(target);
            if (target instanceof Element) target = Math.floor(target.getBoundingClientRect().top + window.pageYOffset);
            if (Number.isInteger(target)) target = {
                top: target - offset,
                behavior: "smooth"
            };
            if ((typeof target === "undefined" ? "undefined" : (0, $j2WbH._)(target)) !== "object") throw Error("Unsupported $scroll target: ", originalTarget);
            Object.assign(target, options);
            window.scroll(target);
        };
    });
}
// packages/$truncate/src/index.js
function $76a61f0a570b1d31$var$src_default3(Alpine) {
    var appendEllipsis = function(string, parameters) {
        if (parameters[0].length <= string.length) return string;
        var ellipsis = "\u2026";
        if (typeof parameters[2] !== "undefined") ellipsis = parameters[2];
        if (Object.prototype.hasOwnProperty.call(parameters[1], "ellipsis")) ellipsis = parameters[1].ellipsis;
        return string + ellipsis;
    };
    Alpine.magic("truncate", function() {
        return function() {
            for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++){
                parameters[_key] = arguments[_key];
            }
            if (typeof parameters[0] !== "string") return parameters[0];
            if (!parameters[1]) return parameters[0];
            if ((0, $j2WbH._)(parameters[1]) !== "object") return appendEllipsis(parameters[0].slice(0, parameters[1]), parameters);
            if (Object.prototype.hasOwnProperty.call(parameters[1], "words") && parameters[1].words) return appendEllipsis(parameters[0].split(" ").splice(0, parameters[1].words).join(" "), parameters);
            if (Object.prototype.hasOwnProperty.call(parameters[1], "characters") && parameters[1].characters) return appendEllipsis(parameters[0].slice(0, parameters[1].characters), parameters);
            return parameters[0];
        };
    });
}
// packages/$dbg/src/index.js
function $76a61f0a570b1d31$var$src_default4(Alpine) {
    Alpine.magic("dbg", function(el) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _console;
            var raw = args.map(function(arg) {
                return Alpine.raw(arg);
            });
            (_console = console).log.apply(_console, (0, $8ea412f19da8a8a2$export$71511d61b312f219)(raw));
        };
    });
}
// packages/$screen/src/index.js
function $76a61f0a570b1d31$var$src_default5(Alpine) {
    var data = Alpine.reactive({
        screensize: window.innerWidth
    });
    var defaultBreakpoints = {
        xs: 0,
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280,
        "2xl": 1536
    };
    var breakpoints = window.AlpineMagicHelpersConfig && window.AlpineMagicHelpersConfig.breakpoints ? window.AlpineMagicHelpersConfig.breakpoints : defaultBreakpoints;
    var update;
    window.addEventListener("resize", function() {
        clearTimeout(update);
        update = setTimeout(function() {
            data.screensize = window.innerWidth;
        }, 150);
    });
    Alpine.magic("screen", function(el) {
        return function(breakpoint) {
            var width = data.screensize;
            if (Number.isInteger(breakpoint)) return breakpoint <= width;
            if (breakpoints[breakpoint] === void 0) throw Error("Undefined $screen property: " + breakpoint + ". Supported properties: " + Object.keys(breakpoints).join(", "));
            return breakpoints[breakpoint] <= width;
        };
    });
}
// packages/$interval/src/index.js
function $76a61f0a570b1d31$var$src_default6(Alpine) {
    Alpine.magic("interval", function() {
        return function() {
            var _this = this;
            for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++){
                parameters[_key] = arguments[_key];
            }
            if (typeof parameters[0] !== "function") return parameters[0];
            var timer = parameters[1];
            var delay = 0;
            var forceInterval = false;
            if ((0, $j2WbH._)(parameters[1]) === "object") {
                if (Object.prototype.hasOwnProperty.call(parameters[1], "timer")) timer = parameters[1].timer;
                if (Object.prototype.hasOwnProperty.call(parameters[1], "delay")) delay = parameters[1].delay;
                if (Object.prototype.hasOwnProperty.call(parameters[1], "forceInterval")) forceInterval = parameters[1].forceInterval;
            }
            var autoIntervalLoop = null;
            var firstTime = true;
            var loop = function() {
                var next = firstTime ? timer + delay : timer;
                firstTime = false;
                autoIntervalLoop = setTimeout(function() {
                    parameters[0].call(_this);
                    forceInterval ? loop() : requestAnimationFrame(loop);
                }, next);
            };
            Alpine.effect(function() {
                if (_this.autoIntervalTest == void 0 || _this.autoIntervalTest) forceInterval ? loop() : requestAnimationFrame(loop);
                else clearTimeout(autoIntervalLoop);
            });
        };
    });
}
// packages/toolkit/src/index.js
function $76a61f0a570b1d31$var$src_default7(Alpine) {
    $76a61f0a570b1d31$var$src_default(Alpine);
    $76a61f0a570b1d31$var$src_default2(Alpine);
    $76a61f0a570b1d31$var$src_default3(Alpine);
    $76a61f0a570b1d31$var$src_default4(Alpine);
    $76a61f0a570b1d31$var$src_default5(Alpine);
    $76a61f0a570b1d31$var$src_default6(Alpine);
}
// packages/toolkit/builds/module.js
var $76a61f0a570b1d31$export$2e2bcd8739ae039 = $76a61f0a570b1d31$var$src_default7;


// packages/persist/src/index.js
function $7b893ccb2c005aae$export$9a6132153fba2e0(Alpine) {
    var persist = function() {
        var alias;
        var storage;
        try {
            storage = localStorage;
        } catch (e) {
            console.error(e);
            console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");
            var dummy = /* @__PURE__ */ new Map();
            storage = {
                getItem: dummy.get.bind(dummy),
                setItem: dummy.set.bind(dummy)
            };
        }
        return Alpine.interceptor(function(initialValue, getter, setter, path, key) {
            var lookup = alias || "_x_".concat(path);
            var initial = $7b893ccb2c005aae$var$storageHas(lookup, storage) ? $7b893ccb2c005aae$var$storageGet(lookup, storage) : initialValue;
            setter(initial);
            Alpine.effect(function() {
                var value = getter();
                $7b893ccb2c005aae$var$storageSet(lookup, value, storage);
                setter(value);
            });
            return initial;
        }, function(func) {
            func.as = function(key) {
                alias = key;
                return func;
            }, func.using = function(target) {
                storage = target;
                return func;
            };
        });
    };
    Object.defineProperty(Alpine, "$persist", {
        get: function() {
            return persist();
        }
    });
    Alpine.magic("persist", persist);
    Alpine.persist = function(key, param) {
        var get = param.get, set = param.set, storage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : localStorage;
        var initial = $7b893ccb2c005aae$var$storageHas(key, storage) ? $7b893ccb2c005aae$var$storageGet(key, storage) : get();
        set(initial);
        Alpine.effect(function() {
            var value = get();
            $7b893ccb2c005aae$var$storageSet(key, value, storage);
            set(value);
        });
    };
}
function $7b893ccb2c005aae$var$storageHas(key, storage) {
    return storage.getItem(key) !== null;
}
function $7b893ccb2c005aae$var$storageGet(key, storage) {
    var value = storage.getItem(key, storage);
    if (value === void 0) return;
    return JSON.parse(value);
}
function $7b893ccb2c005aae$var$storageSet(key, value, storage) {
    storage.setItem(key, JSON.stringify(value));
}
// packages/persist/builds/module.js
var $7b893ccb2c005aae$export$2e2bcd8739ae039 = $7b893ccb2c005aae$export$9a6132153fba2e0;


(0, $96cefe9acc8d79bc$export$2e2bcd8739ae039).plugin((0, $76a61f0a570b1d31$export$2e2bcd8739ae039));
(0, $96cefe9acc8d79bc$export$2e2bcd8739ae039).plugin((0, $7b893ccb2c005aae$export$2e2bcd8739ae039));
(0, $96cefe9acc8d79bc$export$2e2bcd8739ae039).start();
var $276b24eba12f13fb$var$banner = new (0, (/*@__PURE__*/$parcel$interopDefault($2e218e1f75469fbf$exports)))(function() {
    (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        function gtag() {
            dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', i, {
            'anonymize_ip': true
        });
        var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtag/js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'UA-xxx-1');
});
window.fullscreenModal = function() {
    var parser = new DOMParser();
    return {
        parse: function(data) {
            this.open = true;
            var doc = parser.parseFromString(data, "text/html");
            var content = doc.querySelector(".text-page-container");
            this.$refs.container.innerHTML = content.innerHTML;
        },
        open: false
    };
};
document.addEventListener('DOMContentLoaded', function() {
    if (document.getElementsByClassName('gallery-main').length) {
        var galleryThumbs = {};
        if (document.getElementsByClassName('gallery-thumbs').length) galleryThumbs = {
            swiper: new (0, $99b1ac342f8dfa89$export$2e2bcd8739ae039)('.gallery-thumbs', {
                spaceBetween: 20,
                slidesPerView: 4,
                freeMode: true,
                navigation: {
                    nextEl: '.gallery-thumbs-next',
                    prevEl: '.gallery-thumbs-prev'
                },
                loop: false,
                centeredSlides: false,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
                preloadImages: false,
                freeModeSticky: true,
                // Enable lazy loading
                lazy: true,
                breakpoints: {
                }
            })
        };
        var galleryTop = new (0, $99b1ac342f8dfa89$export$2e2bcd8739ae039)('.gallery-main', {
            spaceBetween: 0,
            preloadImages: false,
            pagination: {
                el: '.gallery-main-indicator',
                type: 'fraction'
            },
            // Enable lazy loading
            lazy: true,
            thumbs: galleryThumbs
        });
        (0, $21b3f89bf1a8b494$export$2e2bcd8739ae039)('.gallery-main');
    }
    if (document.getElementsByClassName('gallery-bottom').length) {
        var galleryThumbsVertical = {};
        if (document.getElementsByClassName('gallery-thumbs-vertical').length) galleryThumbsVertical = {
            swiper: new (0, $99b1ac342f8dfa89$export$2e2bcd8739ae039)('.gallery-thumbs-vertical', {
                spaceBetween: 20,
                slidesPerView: 4,
                freeMode: true,
                navigation: {
                    nextEl: '.gallery-thumbs-next',
                    prevEl: '.gallery-thumbs-prev'
                },
                loop: false,
                centeredSlides: false,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
                preloadImages: false,
                freeModeSticky: true,
                // Enable lazy loading
                lazy: true,
                breakpoints: {
                    // others are 640px, 768px, 1024px, 1280px see tailwind.config.js
                    // TODO: import from tailwind
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                        direction: 'vertical'
                    }
                }
            })
        };
        var galleryBottom = new (0, $99b1ac342f8dfa89$export$2e2bcd8739ae039)('.gallery-bottom', {
            spaceBetween: 0,
            preloadImages: false,
            pagination: {
                el: '.gallery-main-indicator',
                type: 'fraction'
            },
            // Enable lazy loading
            lazy: true,
            thumbs: galleryThumbsVertical
        });
        (0, $21b3f89bf1a8b494$export$2e2bcd8739ae039)('.gallery-bottom');
    }
    //.home-hero-slide
    if (document.getElementsByClassName('home-hero-slide').length) {
        var HomeHeroSlide = new (0, $99b1ac342f8dfa89$export$2e2bcd8739ae039)('.home-hero-slide', {
            spaceBetween: 10,
            slidesPerView: 1,
            preloadImages: true,
            pagination: {
                el: '.home-hero-indicator',
                clickable: true
            },
            breakpoints: {
                // others are 640px, 768px, 1024px, 1280px see tailwind.config.js
                // TODO: import from tailwind
                768: {
                    slidesPerView: 2,
                    spaceBetween: 10
                }
            },
            // Enable lazy loading
            lazy: true
        });
        (0, $21b3f89bf1a8b494$export$2e2bcd8739ae039)('.home-hero-slide');
    }
    var spy = new (0, (/*@__PURE__*/$parcel$interopDefault($2f4f2d88bb880910$exports)))('#ScrollMenu a');
});

})();
//# sourceMappingURL=assets.03be681c.js.map
